// Generated by tools/as3-to-ts from work/decomp/main/scripts/classes/new_interf.as; hand-edits allowed (see docs/architecture.md)

import { Bitmap, BitmapData, Event, Mouse, MouseEvent, MovieClip, Point, Rectangle, TextField, TextFieldType, TextFormat, TextFormatAlign } from '@flash';
import * as as3 from '../runtime/as3';
import { accountButton, profilePlate } from '../ui/profile-badge';
import { chatButton } from '../ui/chat-panel';
import { AVATAR_PLATE, AVATAR_ROW, NOBODY, showAvatar } from '../ui/avatar';
import { clearOfBeanstalk, fitText, reflowArticle, setRawText, shrinkToFit, unsqueezeText } from '../ui/controls';
import { ABOUT_MODE, renderAbout } from '../ui/legal-notice';
import { playerName } from '../runtime/i18n';
import { MSG_NICKNAME_POPUP } from '../runtime/auth-texts';
import { tributeCollectedText, wormNameTexts, wormNamesArg } from '../runtime/net-commands';
import { isAllowedNameChar } from '../rules/ops/progress-profile';
import { productTextFor } from '../runtime/product-texts';
import { MSG_ONLINE, MSG_ONLINE_HINT, MSG_SHEET_TIMER_RUNS } from '../runtime/online-texts';
import { TT_SHEET_PICK } from '../runtime/touch-texts';
import { MSG_CLANS, MSG_CLANS_HINT } from '../runtime/clan-texts';
import { NO_EMBLEM_FRAME, emblemFrame } from '../runtime/clan-hub';
import { renderMonetization, renderPayWithoutStore, renderStorePay, renderWinContinue, storeClick, storeOffered, storePopup, storeTabFor } from '../runtime/monetization-ui';
import { placeHint } from '../ui/wide-popups';
import { ROW, emptyNotes, listPitch } from '../ui/wide-lists';
import { MSG_REPLAY_HINT, REPLAY_OFFER_MODE, openReplayOffer, renderReplayOffer, replayOfferShown } from '../runtime/replay-offer';

export class new_interf extends MovieClip {
  FWP: any = undefined;
  mainframe: any = undefined;
  inv_button: any = undefined;
  popup: any = undefined;
  /** PORT: what the hint (popup) shown now tells about: the hovered object (ui/wide-popups.ts placeHint). */
  popup_anchor: any = null;
  MainBitmap: any = new Bitmap();
  MainBitmapData: any = null;
  SecondBitmap: any = new Bitmap();
  SecondBitmapData: any = null;
  ThirdBitmap: any = new Bitmap();
  ThirdBitmapData: any = null;
  BlurBitmap: any = new Bitmap();
  BlurBitmapData: any = null;
  GirderClip: any = undefined;
  CursorClip: any = undefined;
  WindBar: any = undefined;
  CPUFlags: any = undefined;
  BigWP: any = undefined;
  BigCPUWP: any = undefined;
  BigStims: any = undefined;
  BigFlags: any = undefined;
  BigRIPs: any = undefined;
  BigImpls: any = undefined;
  BigObjs: any = undefined;
  GoldIcon: any = undefined;
  DiamIcon: any = undefined;
  WPBox: any = undefined;
  WPBoxActive: any = undefined;
  WPBoxStolen: any = undefined;
  WPBoxCrafted: any = undefined;
  WPAmount: any = undefined;
  WP10Plus: any = undefined;
  WPBlurGray: any = new BitmapData(47, 46, true, 3392353075);
  WPBlur: any = new BitmapData(47, 46, true, 3694467593);
  WPHardBlur: any = new BitmapData(47, 46, true, 4013234697);
  WPAlpha: any = new BitmapData(47, 46, true, 1426063360);
  WPRed: any = new BitmapData(47, 46, true, 3707712256);
  PerksSheet: any = undefined;
  Stims: any = {};
  RadioButton: any = undefined;
  DelayDigits: any = undefined;
  IconCurrent: any = undefined;
  PerkLevels: any = [0, {}];
  minimaps: any = {};
  IconQuestion: any = undefined;
  WormsBitmap: any = undefined;
  AchievBitmap: any = undefined;
  Stars: any = undefined;
  perk_places: any = new Array();
  stim_places: any = new Array<any>("stimpack", "jet", "buffout", "superstimpack", "psycho");
  bitmaps: any = {};
  bitmap_datas: any = {};
  buttons: any = {};
  squares: any = {};
  world_position_x: any = 0;
  world_position_y: any = 0;
  world_left_square: any = 1;
  world_top_square: any = 1;
  map_moving: any = "";
  cur_screen: any = new Array<any>(0, {});
  MAX_HP_WIDTH: any = 130;
  MAX_STIM: any = 4;
  girder1map: any = undefined;
  girder2map: any = undefined;
  girder3map: any = undefined;
  girder4map: any = undefined;
  girder5map: any = undefined;
  girder6map: any = undefined;
  girder7map: any = undefined;
  girder8map: any = undefined;
  girder9map: any = undefined;
  girder10map: any = undefined;
  girder11map: any = undefined;
  girder12map: any = undefined;
  girder13map: any = undefined;
  girder14map: any = undefined;
  girder15map: any = undefined;
  girder16map: any = undefined;
  barracks: any = {
    "teams": 2,
    "worms": 2,
    "bg_mode": "background_wormville",
    "bg_type": "",
    "team1": { "worms": 1, "cpu_level": 0, "color": 2, "name": "Команда #1" },
    "team2": { "worms": 1, "cpu_level": 0, "color": 1, "name": "Команда #2" },
    "team3": { "worms": 0, "cpu_level": 0, "color": 3, "name": "Команда #3" },
    "team4": { "worms": 0, "cpu_level": 0, "color": 4, "name": "Команда #4" }
  };
  weapons_text: any = {};
  perks_text: any = {};
  achiev_text: any = {};
  task_texts: any = [];
  cur_page: any = 1;
  cur_weapon: any = "";
  cur_element: any = 0;
  play_type: any = "career";
  InterfaceText: any = 16763904;
  InterfaceTextHighlight: any = 16777215;
  InterfaceTextBrown: any = 12865280;
  InterfaceTextGreen: any = 65280;
  NormalFormatLeft: any = new TextFormat();
  NormalFormatCenter: any = new TextFormat();
  surprise: any = "";
  last_game: any = 0;
  levels_upg: any = 0;
  top_mode: any = 1;
  top_page: any = 1;
  shop_page: any = 1;
  shop_mode: any = "p";
  shop_type: any = "weapons";
  perks_mode: any = "wptype";
  craft_wp_page: any = 1;
  craft_obj_page: any = 1;
  temp_replay_string: any = "";
  opened_user_uid: any = 0;
  question_mode: any = "";
  // PORT: VK removed: USER_BALANCE / VOTES_TO_DRAW (the VK votes balance of the payment and auction screens).
  DIAM_TO_TRANS: any = 0;
  PLAYER_DIAM: any = 0;
  display_popup_perk: any = 0;
  set_quick_weapon: any = "";
  temp_buys: any = 0;
  slider_control: any = false;
  slider_top: any = 138;
  slider_bottom: any = 448;
  floating_control: any = false;
  tutor_opened_by_user: any = false;
  opened_filter: any = false;
  last_slider_clicked: any = "";
  scaner_mode: any = "teams";
  error_mode: any = "";
  calc_weapon: any = "";
  success_steal: any = false;
  succ_steal_weapon: any = "";
  steal_try_luck: any = false;
  steal_try_merch: any = false;
  steal_state: any = "";
  papa_state: any = "";
  // PORT: design D3 - tomorrow's hour of Papa John from the server's answer (papa.ask), the specialization picked on
  // PORT: the choose_spec screen (sent by finish_choose_spec; the original wrote it into the player at once).
  papa_tomorrow_hour: any = null;
  spec_choice: any = 0;
  wpedia_article: any = "";
  papa_checked: any = false;
  distance_boxes: any = {};
  distance_box_container: any = new MovieClip();
  clicked_grave: any = 0;
  graves_array: any = [];
  last_call_game_mode: any = "";
  weapon_stack: any = [0, {}, {}, {}, {}, {}, {}];
  weapon_diss: any = {};
  floating_weapon: any = {};
  crafting_result: any = {};
  achiev_bonus_text: any = "";
  task_bonus_text: any = "";
  changes_made: any = false;
  mf_shop_frame: any = 1;
  mf_shop_freeze: any = 0;
  success_auc: any = false;
  no_anim_def: any = {
    "skills_main": 0,
    "mainframe": 0,
    "fight": 0,
    "just_play": 0,
    "skills": 0,
    "crafting": 0,
    "assault": 0,
    "tasks": 0,
    "perks": 0,
    "shop": 0,
    "achiev": 0,
    "game": 0,
    "replay": 0,
    "roul": 0,
    "scaner": 0,
    // PORT: item 8 - the clans tab (the screen of the VK friends list, menu_friends) is a tab screen like the others.
    "clan_hub": 0,
    "top": 0,
    "arsenal": 0,
    "user_info": 0,
    "weapon_sheet": 0
  };

  constructor(param1: any) {
    super();
    as3.bindMethods(this, new_interf.prototype);
    this.FWP = param1;
    this.GirderClip = this.FWP.container_interf.get_object("girder_choose");
    this.CursorClip = this.FWP.container_interf.get_object("cursor_clip");
    this.WindBar = this.FWP.container_interf.get_object("wind_bar");
    this.CPUFlags = this.FWP.container_interf.get_object("cpu_flags");
    this.BigWP = this.FWP.container_interf.get_object("big_wp");
    this.BigCPUWP = this.FWP.container_interf.get_object("big_cpu_wp");
    this.BigStims = this.FWP.container_interf.get_object("big_stims");
    this.BigFlags = this.FWP.container_interf.get_object("big_flags");
    this.BigRIPs = this.FWP.container_interf.get_object("big_rips");
    this.BigImpls = this.FWP.container_interf.get_object("big_impls");
    this.BigObjs = this.FWP.container_interf.get_object("big_objs");
    this.GoldIcon = this.FWP.container_interf.get_object("gold");
    this.DiamIcon = this.FWP.container_interf.get_object("diamond");
    this.WPBox = this.FWP.container_interf.get_object("wp_box");
    this.WPBoxActive = this.FWP.container_interf.get_object("wp_box_active");
    this.WPBoxStolen = this.FWP.container_interf.get_object("wp_box_stolen");
    this.WPBoxCrafted = this.FWP.container_interf.get_object("wp_box_crafted");
    this.WPAmount = this.FWP.container_interf.get_object("wp_amount");
    this.WP10Plus = this.FWP.container_interf.get_object("wp_10plus");
    this.PerksSheet = this.FWP.container_interf.get_object("perks_sheet");
    this.Stims = this.FWP.container_interf.get_object("stims");
    this.RadioButton = this.FWP.container_interf.get_object("radio_button");
    this.DelayDigits = this.FWP.container_interf.get_object("delay_digits");
    this.IconCurrent = this.FWP.container_interf.get_object("icon_current");
    this.PerkLevels = this.FWP.container_interf.get_object("perk_levels");
    this.minimaps = this.FWP.container_interf.get_object("minimaps");
    this.IconQuestion = this.FWP.container_interf.get_object("icon_question");
    this.WormsBitmap = this.FWP.container_interf.get_object("skill_worms");
    this.AchievBitmap = this.FWP.container_interf.get_object("achiev_bitmap");
    this.Stars = this.FWP.container_interf.get_object("stars");
    this.girder1map = this.FWP.container_interf.get_object("girder1");
    this.girder2map = this.FWP.container_interf.get_object("girder2");
    this.girder3map = this.FWP.container_interf.get_object("girder3");
    this.girder4map = this.FWP.container_interf.get_object("girder4");
    this.girder5map = this.FWP.container_interf.get_object("girder5");
    this.girder6map = this.FWP.container_interf.get_object("girder6");
    this.girder7map = this.FWP.container_interf.get_object("girder7");
    this.girder8map = this.FWP.container_interf.get_object("girder8");
    this.girder9map = this.FWP.container_interf.get_object("girder9");
    this.girder10map = this.FWP.container_interf.get_object("girder10");
    this.girder11map = this.FWP.container_interf.get_object("girder11");
    this.girder12map = this.FWP.container_interf.get_object("girder12");
    this.girder13map = this.FWP.container_interf.get_object("girder13");
    this.girder14map = this.FWP.container_interf.get_object("girder14");
    this.girder15map = this.FWP.container_interf.get_object("girder15");
    this.girder16map = this.FWP.container_interf.get_object("girder16");
    this.addChild(this.GirderClip);
    this.addChild(this.CursorClip);
    this.GirderClip.visible = false;
    this.CursorClip.visible = false;
    this.popup = this.FWP.container_interf.get_object("popup");
    this.addChild(this.popup);
    this.popup.visible = false;
    this.popup.alpha = 0.9;
    this.popup.x = -1000;
    this.MainBitmap = new Bitmap();
    this.MainBitmapData = new BitmapData(807, 600, true, 0);
    this.MainBitmap.bitmapData = this.MainBitmapData;
    this.BlurBitmap = new Bitmap();
    this.BlurBitmapData = new BitmapData(807, 600, true, 0);
    this.BlurBitmap.bitmapData = this.BlurBitmapData;
    this.init_texts();
    this.init("mainframe");
    if (this.FWP.get_present != 0 && this.FWP.player.view_tutorial == 1) {
      this.init("present");
    }
    if (this.FWP.player.view_tutorial != 1) {
      this.init("view_tutorial");
    }
  }

  init_texts(): any {
    let _loc1_: any = undefined;
    let _loc2_: any = undefined;
    let _loc3_: any = undefined;
    let _loc4_: any = undefined;
    this.NormalFormatLeft.align = TextFormatAlign.LEFT;
    this.NormalFormatLeft.font = "Tahoma";
    this.NormalFormatLeft.size = 11;
    this.NormalFormatLeft.bold = true;
    this.NormalFormatCenter.align = TextFormatAlign.CENTER;
    this.NormalFormatCenter.font = "Tahoma";
    this.NormalFormatCenter.size = 11;
    this.NormalFormatCenter.bold = true;
    for (_loc1_ of as3.keys(this.FWP.WEAPONS_DEF)) {
      this.weapons_text[_loc1_] = "";
    }
    _loc2_ = "Безотказное вооружение хорошо тем, что никогда не дает осечек, а также имеет бонус к шансу критического выстрела +50%.";
    this.weapons_text["bazooka"] = "Базука - одно из самых широкоиспользуемых оружий. Для прицеливания используйте стрелки Вверх и Вниз; для выстрела зажимайте Пробел. Чем дольше вы его держите, тем большей скоростью будет обладать снаряд. Базука подвержена влиянию ветра, на это стоит вводить поправку. Снаряд взрывается при первом же пересечении с землей или с червем.";
    this.weapons_text["unfail_bazooka"] = _loc2_;
    this.weapons_text["fire_bazooka"] = "Благодаря напалму внутри снаряда, после взрыва базука разбрасывает вокруг себя огонь. Изобретение группировки червей, известных под названием Мастера.";
    this.weapons_text["poison_bazooka"] = "Ядовитая базука во всех отношениях похожа на обычную, но при взрыве выпускает облако ядовитого газа, заражающее ближайших червей.";
    this.weapons_text["ap_bazooka"] = "Одно из самых мощных оружий класса Базук. Бронебойная базука снабжена тремя детонаторами и усиленной оболочкой, что позволяет ей взрывать три препятствия подряд.";
    this.weapons_text["howitzer"] = "Кумулятивный снаряд способен нанести огромный урон врагу, хотя радиус взрыва у него небольшой - как у стандартной базуки. Изначально этот снаряд предназначался для использования в стационарных гаубицах, однако, умельцы группировки Мастера переделали его для портативного использования. Единственный минус - при стрельбе из ручного ракетного комплекса таким огромным снарядом выстрелившему червяку наносится достаточный урон реактивной струей снаряда, отнимая при этом около 500 ОЗ.";
    this.weapons_text["rj46"] = "Другое название - RJ46. Эта модификация известной армейской зажигательной базуки включает в себя, помимо огня, несколько осколков с общим уроном до 500 ОЗ в дополнение к урону самого снаряда в 200 ОЗ.";
    this.weapons_text["ap_bazooka2"] = "Благодаря новейшим технологиям Отражения стало возможным создать этот уникальный снаряд. Он незаменим для пробивания бункеров, так как в отличие от стандартной бронейбойной базуки имеет повышенный урон и может пробить насквозь <b>пять</b> препятствий.";
    this.weapons_text["grenade"] = "Граната, как и Базука - одно из самых распространенных оружий в игре. Она не взрывается при первом столкновении с землей, а только когда истчет ее таймер. Учитывая это, есть возможность примерно кинуть Гранату в направлении червя (в случае, если тот сидит в яме) и Граната гарантированно нанесет ему положенный урон. По умолчанию запал Гранаты - 3 секунды, однако его можно менять кнопками 1, 2, 3, 4 и 5. Также кнопки + и - меняют силу отскока снаряда от поверхности, по умолчанию стоит слабый отскок.";
    this.weapons_text["unfail_grenade"] = _loc2_;
    this.weapons_text["plasma_grenade"] = "Плазменная граната отличается от обычной тем, что наносит почти в два с половиной раза больше урона благодаря плазменному детонатору.";
    this.weapons_text["pulse_grenade"] = "Импульсная граната при взрыве испускает мощную волну излучения, парализующую рядом стоящих червяков на два хода.";
    this.weapons_text["holy_hand_grenade"] = "Святая граната наносит большой урон и имеет огромный радиус взрыва - по площади в 4 раза больше Базуки. Единственный недостаток - граната взорвется, только когда улежится на месте.";
    this.weapons_text["super_hhg"] = "Супер святая граната наносит больше урона, парализует червяков и Всегда пробивает броню врага.";
    this.weapons_text["dl19"] = "Отличная граната для поражения множественных целей. Большой урон (200 ОЗ), большой радиус взрыва, горящее топливо при взрыве, а также четыре осколка внутри с общим уроном до 400 ОЗ.";
    this.weapons_text["cluster_bomb"] = "Осколочная граната работает так же, как и обычная Граната, однако она, наподобие Мортиры, после взрыва разбивается на 5 осколков. Опции здесь те же - можно регулировать как запал, так и силу отскока гранаты.";
    this.weapons_text["unfail_cluster_bomb"] = _loc2_;
    this.weapons_text["putty_grenade"] = "Граната-липучка снабжена титановыми иглами с алмазной заточкой, что позволяет ей прилипать к любой поверхности. После взрыва разбрасывает вокург себя восемь осколков с такими же шипами. Урон как гранаты, так и осколков одинаковый - по 100 ОЗ. Запал не регулируется, у гранаты он восьмисекундный; осколки взрываются через три секунды после разбрасывания.";
    this.weapons_text["molotov"] = "Бутылка с зажигательной смесью. Разрывается при первом же столкновении, разбрасывает вокруг себя горящее топливо.";
    this.weapons_text["mortar"] = "Этот снаряд всегда выпускается с одной и той же скоростью, то есть, в отличие от Базуки, вы не можете регулировать силу выстрела. С некоторым приближением можно сказать, что скорость Мортиры такая же, как и Базуки при максимально долгом нажатии Пробела. Особенность этого оружия в том, что после столкновения с землей или червяком она разбивается на пять осколков, которые могут сильно поранить несколько вражеских червей.";
    this.weapons_text["upg_mortar"] = "В отличие от обычной Мортиры у этой можно регулировать силу выстрела, а также она наносит повышенный урон.";
    this.weapons_text["banana_bomb"] = "Мощнейшее оружие (одно из самых сильных типа Снаряды), отнимающее 75 ОЗ при взрыве, а потом разбивающееся еще на три таких же банана. Наносят непоправимый урон карте.";
    this.weapons_text["unfail_banana_bomb"] = _loc2_;
    this.weapons_text["super_banana_bomb"] = "Идеальное орудие убийства. Совмещенное с плазменным детонатором, оно разбивается не на три осколка, а на пять, каждый из которых сносит до 75 ОЗ. Суммарный урон такой бомбой может достигать 450 ОЗ (и это без бонусов от атаки), что сравнимо с очередью из Плазменной винтовки.";
    this.weapons_text["nuclear_bomb"] = "Ядерное оружие. Наносит огромный урон (600 ОЗ), обладает большим радиусом взрыва (по площади в 4 раза больше Базуки), а также при взрыве распространяет вокург себя облако ядовитого газа.";
    this.weapons_text["nuclear_bomb2"] = "Улучшенная версия стандартной ICBM. Увеличен урон, а также вместо обычного ядовитого газа испускается радиоактивный, наносящий в три раза больше урона при заражении червяков.";
    this.weapons_text["multi_bazooka"] = "Великолепное оружие, позволяющее сделать за один ход четыре выстрела снарядами обычной Базуки. Единственный недостаток - невозможность регулировать силу выстрела, снаряды выпускаются с максмальной скоростью (как и Мортира).";
    this.weapons_text["mega_banana_bomb"] = "При взрыве разбивается на четыре стандартных банано-бомбы, каждая из которых сама по себе содержит 3 осколка. Это увеличивает общее количество осколков до 12. Комментарии излишни.";
    this.weapons_text["pistol"] = "Пистолет - самое слабое из Огнестрельного оружия. После прицеливания и нажатия Пробела Пистолет выстреливает очередью из 5 пуль; интервал между выстрелами достаточно большой, можно попытаться достать двух червей одной очередью.";
    this.weapons_text["uzi"] = "Узи - улучшенный вариант Пистолета. Узи выстреливает 10 пуль подряд с достаточно малым интервалом. При удачном раскаладе Узи может нанести урон в 50 очков здоровья (ОЗ) вражескому червяку.";
    this.weapons_text["unfail_uzi"] = _loc2_;
    this.weapons_text["hunting_rifle"] = "Дробовик - мощное оружие ближнего боя. Позволяет сделать два выстрела, за каждый из которых оружие выпускает несколько пуль. На дальних дистанциях малоэффективно.";
    this.weapons_text["sniper_rifle"] = "Снайперская винтовка позволяет вам поражать червей на очень дальних дистанциях, а так же имеет большой поражающий фактор. В комплекте также идет мощный лазерный прицел.";
    this.weapons_text["peacemaker"] = "Миротворец - сверхмощный пистолет, сделаный из обреза винтовки калибра .577. Убойная мощность (урон с одного патрона до 250 ОЗ) обеспечивает победу в любых условиях. Стандартный магазин - 2 патрона - может быть расширен до пяти патронов способностью Магазин средних оружий.";
    this.weapons_text["hearts_ace"] = "Именной пистолет, модифицированная версия Миротворца. Таких пистолетов в мире единицы. Обладает всеми свойствами Миротворца, только более убойный и имеет повышенный шанс пробить броню противника. Стандартный магазин также может быть расшириен до пяти патронов способностью Магазин средних оружий.";
    this.weapons_text["rad_rifle"] = "Сделана на основе армейской снайперской винтовки 7.62мм. Модифицированный корпус для защиты от радиации. Магазин на один патрон заряжен радиевым зарядом, который наносит огромный урон при попадании в червяка. Оснащена лазерным прицелом.";
    this.weapons_text["shotgun"] = "В отличие от большинства Огнестрельного оружия, Двустволка позволяет стрелять не очередью, а отдельно. Количество выстрелов - два. После каждого выстрела вы можете поменять прицел или сменить позицию, насколько хватит времени хода. Внимание, настоятельно не рекомендуем держать Пробел при выстреле - вы можете выстрелить две пули очередью. Лучше используйте однократные нажатия.";
    this.weapons_text["minigun"] = "Огнестрельное оружие ужасающей мощности. Выстреливает очередью из 20 пуль, то есть одно использование Пулемета по факту эквивалентно двум использованиям Узи. В случае, если все пули попали в цель, базовый урон составляет 80 очков здоровья.";
    this.weapons_text["unfail_minigun"] = _loc2_;
    this.weapons_text["air_minigun"] = "Авиационный пулемет имеет больший калибр, чем обычный, а в связке из 30 выстрелов базовый урон составляет около 360 ОЗ.";
    this.weapons_text["bozar"] = "Бозар - чудо инженерной мысли, совмещенные пулемет и снайперская винтовка. Выстреливает очень узко направленной очередью, разброс пуль минимален. В комплекте также идет мощный лазерный прицел. Плюс ко всему, это оружие - единственное в своем роде, на которое распространяются одновременно бонусы к урону винтовок и бонусы к урону пулеметов.";
    this.weapons_text["bozar16"] = "Бозар G16 - оружие, наводящее ужас. Заместитель Де Ляметра сделал Мастерам заказ на стандартный Бозар, но со стволом под больший калибр и повышенной защитой от радиации. После получения заказа он зарядил магазин радиевыми зарядами, и получил чудо снайперской мысли, сносящее до 2000 ОЗ. Идеальная точность даже на большом расстоянии. Как и в случае со стандартным Бозаром G9, на этот распространяются одновременно бонусы к урону винтовок и бонусы к урону пулеметов.";
    this.weapons_text["bozar24s"] = "Модифицированная версия известного Бозара G16. В отличие от предшественника, калибр радиевых пуль увеличен (потребовался магазин большей вместимости). Такие пули всегда пробивают броню, какая бы толстая и мощная она ни была.";
    this.weapons_text["avenger"] = "Авенджер считается самым лучшим пулеметом из когда-либо существовавших. Суммарный урон очереди из 30 пуль может достигать 1200 ОЗ. Правда, есть существенный минус - огромный разброс пуль, без способности Точность вы вообще никуда не попадете.";
    this.weapons_text["air_strike"] = "Пользуясь Авиаударом, вы можете поразить врага, находясь в укрытии. Просто выберите оружие и укажите цель (двойной клик по экрану). Стрелками также можно менять направление удара (откуда прилетят снаряды).";
    this.weapons_text["napalm_strike"] = "После выбора цели с самолета сбрасывается горящий напалм.";
    this.weapons_text["mine_strike"] = "Оружие похоже на обычный Авиаудар, с единственной разницей - с самолета сбрасываются пять мин. Очень мощное оружие в связке со способностью Минер.";
    this.weapons_text["banana_strike"] = "С самолета сбрасываются три Банано-бомбы, одно использование такого оружия способно разнести половину карты, не говоря уж об огромном уроне.";
    this.weapons_text["holy_strike"] = "После выбора цели с самолета сбрасываются три Святых гранаты. После использования Святого удара в живых мало кто остается.";
    this.weapons_text["mine"] = "Мина - базовое оружие типа Взрывчатка. После установки Мина взорвется только в случае, если рядом есть червяк, кстати сказать, любой, не только вражеский. Как только это червяк попадет в поле обнаружения мины, она начинает мигать и взрывается через 3 секунды. Есть два метода использования: либо как банальный снаряд (подойти, поставить и уйти), либо тактически - перекрыть минами важные участки, чтобы враг не смог дойти до вашего укрытия.";
    this.weapons_text["unfail_mine"] = _loc2_;
    this.weapons_text["fire_mine"] = "Мина, начиненная напалмом для большего урона. При взрыве распространяет вокруг себя пламя.";
    this.weapons_text["plasma_mine"] = "Плазменная мина отличается от обычной тем, что наносит почти в два с половиной раза больше урона благодаря плазменному детонатору.";
    this.weapons_text["pulse_mine"] = "Улучшенный вариант Плазменной мины. Помимо увеличенного урона, мина при взрыве испускает мощную волну излучения, парализующую рядом стоящих червяков на два хода.";
    this.weapons_text["nuclear_mine"] = "Тестовый прототип мины с ядерной начинкой - ураном-235. Помимо увеличенного радиуса взрыва и огромного урона, выбрасывает радиоактивный газ. Надпись на упаковке: \"Хранить в темном месте при температуре не выше 40 градусов и относительной влажности не выше 80%. Радиоактивно! Не забудьте надевать костюм радиационной защиты! Или не удивляйтесь при появлении шестого пальца на третей руке.\"";
    this.weapons_text["dynamite"] = "Продвинутое оружие типа Взрывчатка. По сравнению с Миной, наносит базовый урон в 75 ОЗ, однако взрывается по прошествии 5 секунд после установки.";
    this.weapons_text["unfail_dynamite"] = _loc2_;
    this.weapons_text["dynamite_bunch"] = "Связка динамита - довольно мощное оружие типа Взрывчатка. После взрыва разбрасывает вокруг себя еще три упаковки динамита, которые наносят большие повреждения карте. Аналог Банано-бомбы.";
    this.weapons_text["sheep"] = "Овца похожа на Старушку, однако есть существенные различия: двигается Овца в два раза быстрее, и через некоторые препятствия может перепрыгнуть, пусть и прыгает она совершенно случайным образом.";
    this.weapons_text["unfail_sheep"] = _loc2_;
    this.weapons_text["fire_sheep"] = "Новейшая разработка, у Овцы в шерсти спрятано несколько Коктейлей Молотова, и при взрыве они все одновременно активируются, что делает Зажигательную овцу очень опасным оружием.";
    this.weapons_text["poison_sheep"] = "Механика работы этой овцы очень похожа на Зажигательную, однако вместо огня при взрыве выпускается ядовитый газ.";
    this.weapons_text["mine_sheep"] = "Овца, начиненная для большего урона пятью стандартными минами. При взрыве Миновцы (можно пробелом) эти мины выбрасываются в разных направлениях. Особенно эффективна Миновца со способностью Минер третьего уровня. Кстати сказать, на мины, выбрасываемые Миновцой, действуют бонусы к урону Живых бомб, а не Взрывчатки.";
    this.weapons_text["mine_sheep2"] = "Улучшенная версия Миновцы. Вместо пяти стандартных мин несет на себе семь плазменных.";
    this.weapons_text["old_woman"] = "Это первое оружие типа Живая бомба, которые вам встретится в игре. Принцип действия следующий: после выпуска Старушка бежит в одном направлении. Она может преодолевать невысокие препятствия; если на ее пути встретится стена, Старушка развернется и побежит обратно. Старушка взрывается через 20 секунд после выпуска, однако ее можно взорвать раньше, нажав Пробел в нужное вам время.";
    this.weapons_text["unfail_old_woman"] = _loc2_;
    this.weapons_text["prod"] = "Базовое оружие ближнего боя, не наносящее вообще никакого урона, а просто отталкивающее вражеского червяка. Применяется только на очень близком расстоянии. Может быть полезно, когда вражеский червяк стоит на краю карты, а тратить Мину или Гранату жалко. Это оружие уникально тем, что доступно абсолютно везде, во всех миссиях и рангах карьеры.";
    this.weapons_text["firepunch"] = "При использовании Огненного удара червяк подпрыгивает, пробивает над собой ландшафт и наносит урон всем находящимся рядом червям (в отличие от Шара дракона, который при любом раскладе поранит только одного червяка). При низкой гравитации (необх. ур. 3) червяк подпрыгнет гораздо выше, и, следовательно, при удачном раскладе нанесет урон большему количеству червей. Это оружие можно активировать прямо в прыжке.";
    this.weapons_text["fireball"] = "Продвинутое оружие ближнего боя, наносящее базовый урон в 30 ОЗ, в отличие от Тычка. При использовании червяк своей внутренней энергией порождает огненный шар, который при встрече с червем наносит урон и отталкивает его. Шар дракона необязательно использовать впритык к врагу, шар пролетит еще некоторое расстояние, правда, небольшое. На это расстояние влияет способность Шар дракона.";
    this.weapons_text["kamikaze"] = "При использовании Камикадзе вы приносите в жертву вашего червя, и он просто взрывается. Однако, чем больше у него было при жизни здоровья, тем больший урон он нанесет во время смерти, а также - тем больший радиус взрыва будет у жертвенного червя. Особо примечательно использование Камикадзе, если у вашего червяка больше 1000 ОЗ.";
    this.weapons_text["baseball_bat"] = "Продвинутое оружие ближнего боя, в чем то похожее на Тычок, но с существенными различиями: вы можете менять угол биты (стрелки Вверх/Вниз), от этого зависит направление полета атакуемого червя, и к тому же бита наносит базовый урон в 30 ОЗ. Бита может отправить в полет нескольких червей, если они будут расположены рядом. Импульс при использовании Биты большой, а при совместном использовании Низкой гравитации можно выбросить червей через всю карту в воду.";
    this.weapons_text["shocker"] = "Продвинутое оружие ближнего боя, в чем то похожее на Тычок, однако в отличие от него наносит урон в 30 ОЗ и парализует ближайших червяков.";
    this.weapons_text["battle_axe"] = "Данное оружие примечательно тем, что, в отличие от других оружий ближнего боя, отнимает у врага не фиксирванное количество здоровья, а в процентах от текущего. Если здоровье вражеского червяка меньше 400, Топор отнимет ровно половину. Если больше - то Топор отнимает 200 ОЗ.";
    this.weapons_text["power_axe"] = "Силовой топор - версия обычного Топора, усиленная элементом питания от Лазерного пистолета. Помимо увеличенного урона (50% ОЗ, если здоровье врага меньше 600, и 300 ОЗ, если больше), обладает парализующим эффектом.";
    this.weapons_text["power_bat"] = "При совмещении элемента питания от Плазменной винтовки и обычной Бейсбольной биты можно получить этот уникальный вид вооружения. Червяки, задетые этой битой, улетают дальше, чем от обычной, парализуются, и это не считая повышенного урона в 60 ОЗ.";
    this.weapons_text["skip_go"] = "Назначение этой утилиты понятно из названия - вы просто пропускаете свой ход, увеличивая преимущество соперника. Однако, использование Пропуска хода может быть полезно, когда вы и не собирались ничего делать, а, к примеру, ждете, когда станет доступно какое-либо оружие с задержкой использования. Это оружие доступно всегда и в неограниченном количестве.";
    this.weapons_text["laser_sight"] = "Лазерный прицел позволяет точно прицеливаться при использовании оружия типа Огнестрельное или Энергетическое. В подавляющем большинстве случаев эти оружия требуют очень аккуратного прицеливания, и в этом данная утилита утилита сильно помогает. Для активации используйте Пробел, затем выберите нужное оружие. Лазерный прицел будет работать для таких оружий, как Пистолет, Узи, Лазерная винтовка. Огромное влияние на эту утилиту оказывает способность Лазерные прицелы (необх. ур. 4). Не тратит ход.";
    this.weapons_text["low_gravity"] = "При использовании данная утилита понижает гравитацию на время вашего хода, что позволяет червям прыгать выше и дальше, а также отбрасывать вражеских червей на большее расстояние. Для активации нажмите Пробел. Повторное использование этого оружия вернет обычную гравитацию. Не тратит ход.";
    this.weapons_text["fast_walk"] = "Быстрая ходьба ускоряет передвижение вашего червяка по карте на один ход. Она может быть полезна, если вы не успеваете доползти до вражеского червяка, или нужно быстро убраться после утсановки взрывчатки. Не тратит ход, для активации нажмите Пробел.";
    this.weapons_text["ultra_scaner"] = "Позволяет узнать всю информацию о противнике - оружие, навыки, способности. Для использования нажмите на иконку сканера рядом с иконкой рюкзака (она появится, если в арсенале есть хотя бы один такой сканер). Во время использования сканера таймер игры замораживается.";
    this.weapons_text["blow_torch"] = "Это оружие даже сложно назвать собственно оружием, оно не наносит никакого урона. Собственно, именно поэтому оно относится к типу Утилита. С помощью лампы вы можете прорубать туннели в земле. Всего существует 3 положения - горизонтально, под небольшим углом вверх и под небольшим углом вниз. Менять направление можно как до активации, так и во время использования (стрелки Вверх и Вниз). Нажатие Пробела во время использования прекратит действие лампы. Лампа работает в течение примерно 6 секунд.";
    this.weapons_text["pneumatic_drill"] = "Для понимания принципа действия см. описание Паяльной лампы (слева от этого оружия). Единственная разница заключается в следующем: если Лампа прорубает туннели горизонтально или под небольшим углом, то Молоток бурит туннель вертикально вниз.Остановить его также можно в любой момент нажатием Пробела.";
    this.weapons_text["parachute"] = "Парашют позволяет вам совершать мягкую посадку, с какой высоты вы бы ни упали. Если вы не уверены, что сможете приземлиться без последствий или это очевидно - выбирайте Парашют и прыгайте. Он включится автоматически, как только скорость вашего червяка станет достаточной, чтобы нанести ему повреждения. НЕ нажимайте Пробел для активации (хотя это и возможно) - вы можете свернуть Парашют в следующее же мгновение, после того, как он откроется. Можно незначительно управлять полетом стрелками Вверх/Вниз/Влево/Вправо.";
    this.weapons_text["girder"] = "При использовании этой утилиты вы можете поставить балку в любом месте карты (но на определенном расстоянии от активного червя). Балка используется в основном для защиты своих червей и для блокировки вражеских. После выбора Балки вы можете менять ее расположение мышью (главное, чтобы она не соприкасалсь ни с ландшафтом, ни с червяками), а также менять ее направление и длину (стрелками). Для установки Балки кликните по выбранному месту. При ошибочном выборе этого оружия жмите Escape.";
    this.weapons_text["girder_pack"] = "Эта утилита - то же самое, что и обыкновенная Балка, только за один ход у вас есть возможность поставить не одну, а целых пять балок. При ошибочном выборе этого оружия нажмите Escape, а также в случае, если вы поставили одну, две, три или четыре балки, а больше не нужно - в этом случае ваш ход звершается.";
    this.weapons_text["jet_pack"] = "Эта утилита позволяет вам очень быстро перемещаться с одного места в другое; использование Реактивного ранца не тратит ход. Для активации ранца выберите его и нажмите Пробел. Для управления используйте стрелки Вверх, Влево и Вправо. Для того, чтобы снять ранец, нажмите Пробел повторно. Будьте внимательны - у ранца есть конечный запас топлива; после того, как топливо закончится, ваш червяк окажется в свободном полете и может пораниться при приземлении.";
    this.weapons_text["teleport"] = "Утилита позволяет вам мгновенно переноситься с одного места на другое. Для использования (после выбора Телепорта) выберите место, в которое вы хотели бы перенестись, и два раза кликните по экрану.";
    this.weapons_text["upg_teleport"] = "В отличие от обычного Телепорта не тратит ход.";
    this.weapons_text["upg_jet_pack"] = "Предоставляет удвоенный запас топлива, по сравнению с обычным Реактивным ранцем. На эту утилиту также влияет способность Летчик.";
    this.weapons_text["ag_pack"] = "Эта утилита похожа на обычный Реактивный ранец, но с одним существенным отличием - помимо удвоенного запаса топлива, в этот ранец также встроен генератор антигравитации, что позволяет вам не тратить топливо на поддержание скорости и высоты - достаточно задать начальный импульс и двигаться дальше по инерции.";
    this.weapons_text["add_time"] = "Прибавляет 30 секунд к времени хода.";
    this.weapons_text["choose_worm"] = "Утилита позволяет вам выбирать червяка, которым вы хотели бы сделать ход. После активации используйте Enter для переключения между червями, для окончательного выбора нажмите Escape.";
    this.weapons_text["upg_teleport2"] = "Помимо мгновенного перемещения в любую точку карты и возможности продолжить ход после перемещения этот телепорт создает мини-взрыв в выбранной точке телепортации, а значит, позволяет переместить червяка в абсолютно любое место на карте, даже глубоко под землю.";
    this.weapons_text["medikit"] = "При использовании прибавляет некоторое количество ОЗ использовавшему аптечку червяку. На количество ОЗ влияет способность Медик.";
    this.weapons_text["emg_teleport"] = "Этот телепорт нельзя использовать самому - он включится автоматически, когда кому-либо из ваших червяков будет угрожать опасность утопления. В этом случае телепорт перенесет незадачливого червяка в безопасное место. Само собой, телепорт не сработает, если у червя не осталось ОЗ.";
    this.weapons_text["super_medikit"] = "По сравнению с обычной аптечкой количество ОЗ удвоено, плюс эта аптечка излечит использовавшего червяка от яда, радиации и парализующего эффекта.";
    this.weapons_text["gravity_grenade"] = "Эта граната не наносит практически никакого урона, однако снабжена мощнейшими портативными генераторами антигравитации. Умельцы из команды Мастера додумались поменять местами плюс и минус на клеммах генераторов, что позволило превратить генераторы антигравитации в генераторы гравитации ужасающей силы. При взрыве эта граната дает импульс в 10G всем червям на близкой и средней дистанции и позволяет выбросить кучу вражеских червей прямо в воду.";
    this.weapons_text["invisibility"] = "Эта утилита генерирует невидимое поле, и ваших червей сложнее видеть ботам. То есть при применении уменьшается шанс врага точно попасть в вас. Действует два хода. Эффекты от использования нескольких Невидимостей не складываются, и длительность действия не увеличивается. По эффективности примерно равен одному уровню способности \"Ниндзя\". Максимально понизить шанс точного выстрела можно при использовании этой утилиты при способности \"Ниндзя\" на третьем уровне (есть шанс, что промажут даже боты 6 уровня, а боты 4 и ниже уровней будут мазать вообще постоянно).";
    this.weapons_text["laser_pistol"] = "Самый простой вид Энергетического оружия. Стреляет как обычный пистолет, но квантованным лазерным излучением. Наносит довольно большой урон для своих маленьких размеров и маленькой мощности. Очередь из 5 выстрелов. Часто выступает как элемент для создания более мощных видов вооружения.";
    this.weapons_text["laser_pistol2"] = "Модифицированная версия стандартного Лазерного пистолета. Вместо 5 выстрелов делает 7, плюс имеет 15% шанс пробить броню противника благодаря использованию более жесткого типа излучения.";
    this.weapons_text["laser_rifle"] = "Первое серьезное Энергетическое оружие. По сравнению с пистолетом стреляет быстрее, хотя поражающий фактор не меняется. Очередь из 10 выстрелов.";
    this.weapons_text["unfail_laser_rifle"] = _loc2_;
    this.weapons_text["laser_minigun"] = "Лазерный пулемет - симбиоз обычного Пулемета и Лазерной винтовки. Обладает повышенной скорострельностью и большим уроном.";
    this.weapons_text["pulse_pistol"] = "Вид энергетического оружия, совмещающий в себе одновременно генератор лазерного излучения, источник плазмы и Гаусс-катушки для разгона электронов. На выходе получается импульс, наносящий ужасающий урон всему живому, да еще и оставляющий после себя огромную воронку в карте (по диаметру сравнима с воронкой от Святой гранаты). Собран из высококачественных элементов, не дает осечек.";
    this.weapons_text["plasma_pistol"] = "Продвинутая модель Лазерного пистолета. Вместо излучения используются сгустки высокотемпературной плазмы. Наносит больше повреждений.";
    this.weapons_text["plasma_rifle"] = "Плазменная винтовка наносит очередью из 10 плазменных сгустков базовый урон до 350 ОЗ. Почти предел мечтаний, особенно при прокачанном уроне энергетического оружия.";
    this.weapons_text["unfail_plasma_rifle"] = _loc2_;
    this.weapons_text["plasma_minigun"] = "Плазменный пулемет - ужасающее по своей мощи оружие, выстреливающее 20 высокоэнергетических плазменных шаров с большой скоростью. Отнимает до 1200 ОЗ урона.";
    this.weapons_text["luiston"] = "Усиленная версия Стэндиша. После многих неудачных попыток ученые Отражения выпустили тестовый прототип этого оружия (версия 17) с дополнительными сверхъемкими источниками питания. По сравнению со Стэндишом радиус поражения не меняется.";
    this.weapons_text["gauss_pistol"] = "Трудно поверить, что в таком маленьком объеме заключается столь грозная сила - пистолет Гаусса приводит в движение пули за счет электромагнитного поля, придавая им ужасающие скорости, в несколько раз превышающие скорость звука. Один такой снаряд отнимает от 350 ОЗ.";
    this.weapons_text["gauss_pistol2"] = "Улучшенная версия стандартного армейского пистолета PPK12. Благодаря новой системе есть возможность совершить не один выстрел за ход, а два.";
    this.weapons_text["gauss_rifle"] = "Ученые Отражения недавно выпустили прототип этой винтовки, основанный на знаменитом пистолете Гаусса PPK12. За счет удлиненного ствола и дополнительных элементов питания катушки урон от пули составляет 600 ОЗ.";
    this.weapons_text["unfail_gauss_rifle"] = _loc2_;
    this.weapons_text["gauss_minigun"] = "Пулемет Гаусса за счет нескольких стволов и катушек с увеличенной индуктивностью способен выстрелить очередью из 10 пуль с общим уроном до 3750 ОЗ.";
    this.weapons_text["de_lameter"] = "Давным-давно в организации Отражение работал один червяк, известный под именем Де Ляметр. Он помогал выпускать прототипы импульсного энергетического оружия, в частности Льюистон 14. После разлада с главой Отражения он выкрал чертежи и создал свой собственный излучатель на основе Льюистона, назвав его своим именем. В дальнейшем Де Ляметр организовал свою группировку, в настоящее время известную как Мастера. Излучатель Де Ляметра дополнительно использует энергию солнечного излучения, и в светлое время суток он способен пробить насквозь три препятствия. Ночью и в пещерах, однако, его поведение полностью повторяет импульс Льюистона.";
    this.weapons_text["turbo_rifle"] = "После ухода Де Ляметра из Отражения его схемы были применены для создания нового оружия по той же технологии; благодаря понижению убойной мощности единичного импульса стала возможной стрельба очередями, но с минимальным радиусом воздействия. Правда, у этой винтовки достаточно большой разброс, и без способности Точность в цель попасть можно разве что в упор. Более того, вам нужна <b>как минимум Защита 50 или третий уровень Сопротивления яду/радиации</b>, так как иначе ваш червяк погибнет еще на этапе накопления заряда. Несмотря на все это, винтовка наносит урон в 7000 ОЗ даже без бонусов к энергооружию.";
    this.weapons_text["orbit_strike"] = "Удар со спутника. На спутнике установлены пять новейших прототипов Льюистона Mk 17. Ужасающая мощь и возможность расстреливать толпы врагов, находясь в укрытии, не могут не радовать.";
    this.weapons_text["ultra_rifle"] = "Ультраволновая винтовка хороша тем, что ее импульс пролетает сквозь все препятствия, пока не наткнется на червяка. Урон стандартный для ультраволнового оружия - 2000 ОЗ, кратер от взрыва отсутствует. В комплете идет улучшенный лазерный прицел от винтовки Гаусса М72.";
    this.weapons_text["vindicator"] = "Улучшенная версия винтовки самого технологичного направления разработок - основанных на ультраволне. Очередь из 5 выстрелов сносит у врагов до 10000 ОЗ, причем новейшие грави-компенсаторы сводят разброс импульсов на нет. Однако накопители заряда в этой винтовке слишком опасны для обычных червей. Вам необходима <b>Защита не ниже 100, и, при этом, Сопротивление яду/радиации третьего уровня</b>, иначе червяк умрет от воздействия сверхмощных ультра-полей.";
    this.weapons_text["kenton_bazooka"] = "Это оружие создано по особым технологиям Кентона. Никто из инженеров Отражения или Армии Де Ляметра не смог разобрать или улучшить ни одно кентонское оружие. Его класс определяется как восьмой, так как, помимо отличной безотказности и пробивания любой брони, оружие Кентона также генерирует неведомые виды полей, отравляющие, парализающие врагов, а также отнимая у них здоровье, и, при этом, энергия полей так же преобразуется в жизненную силу дружественных чевяков.\n\nПродается оно по очень хорошим ценам, \"отрывают с руками\".";
    this.weapons_text["kenton_grenade"] = this.weapons_text["kenton_bazooka"];
    this.weapons_text["void_melody"] = this.weapons_text["kenton_bazooka"];
    this.weapons_text["annihilator"] = "Аннигилятор А3000 - мощнейшее оружие. Оно обладает огромным радиусом поражения, в полтора раза превышающим радиус взрыва излучателя Де Ляметра, и выбрасывает поток античастиц, испаряющий все объекты, в том числе и червяков.\n\nНадпись на корпусе: \"Осторожно! Цель должна находиться не ближе ста метров! При столкновении с препятствием выбрасывается мощная волна фотонов, на взрыв не смотреть!\".\n\nСнабжен усиленным лазерным прицелом.";
    this.weapons_text["stimpack"] = "Базовый стимулятор. Убирает не очень много усталости, зато дешевый.";
    this.weapons_text["jet"] = "Базовый стимулятор. Обладает разгоняющим действием, и, как следствие, повышает Атаку. Из побочных эффектов - снижение Защиты.";
    this.weapons_text["buffout"] = "Базовый стимулятор. Увеличивает Защиту вашей команды, правда, в ущерб Атаке.";
    this.weapons_text["superstimpack"] = "Стимулятор, дающий поистине большое преимущество в бою, особенно при использовании нескольких образцов одновременно.";
    this.weapons_text["psycho"] = "Психо повышает все параметры вашей команды, а также сильно взбодряет - 4 Психо способны нейтрализовать усталость, накопленную за почти 30 боев.";
    this.weapons_text["fruit"] = "Превращает ваших червяков в племя варваров, начисто вышибая всю усталость, а также дает огромное преимущество по Атаке, Здоровью и Защите.";
    this.weapons_text["std_attack"] = "Стандартный армейский имплантант, повыщающий атаку. Предназначался для солдат, выступающих в роли пушечного мяса на передовой.";
    this.weapons_text["std_protect"] = "Стандартный армейский имплантант, повыщающий защиту. В основном, использовался солдатами-артиллеристами и водителями танков и БТР.";
    this.weapons_text["std_health"] = "Стандартный армейский имплантант, повышающий здоровье. У большинства офицеров были такие чипы, чтобы в случае ранения они остались живы.";
    this.weapons_text["phoenix"] = "Универсальный чип \"Феникс\" с ограниченным выпуском вживляли только членам отрядов специального назначния, выполняющим крайне ответственные задания в тылу у противника.";
    this.weapons_text["phoenix2"] = "Улучшенная версия Феникса была создана в лаборатории Отражения по специальныму секретному заказу. Во всем мире насчитывается не более сотни экземпляров.";
    this.weapons_text["dragon"] = "Серия имплантантов \"Дракон\" - самопальные чипы, сделанные на коленке мастерами армии Де Ляметра. Тем не менее, у них улучшенные параметры и имеются дополнительные свойства.";
    this.weapons_text["dragon2"] = "Серия имплантантов \"Дракон\" - самопальные чипы, сделанные на коленке мастерами армии Де Ляметра. Тем не менее, у них улучшенные параметры и имеются дополнительные свойства.";
    this.weapons_text["obj_barrel"] = "Удлиненный ствол используется как компонент при крафтинге почти всех видов огнестрельного и энергетического оружия.";
    this.weapons_text["obj_middle_clip"] = "Средняя обойма нужна в тех случаях, когда вы хотите сделать из пистолета пистолет-пулемет или автомат. Только для огнестрельного оружия.";
    this.weapons_text["obj_big_clip"] = "Большая обойма применяется при крафтинге тяжелых огнестрельных винтовок типа Бозара и пулеметов.";
    this.weapons_text["obj_small_cell"] = "Малый элемент питания используется для крафтинга энергопистолетов, иногда винтовок, и прочего оружия.";
    this.weapons_text["obj_big_cell"] = "Большой элемент питания необходим при создании энергопулеметов и тяжелых импульсных излучателей.";
    this.weapons_text["obj_rad_lock"] = "Радиевый затвор применяется при модификации обычного оружия в радиевое - например, для создания Бозара G16.";
    this.weapons_text["obj_hard_jacket"] = "Усиленная оболочка нужна для создания тяжелых снарядов класса Базука, в том числе и бронебойных.";
    this.weapons_text["obj_napalm_cont"] = "Контейнер с напалмом применяется при крафтинге огненных модификаций снарядов и взрывчатки.";
    this.weapons_text["obj_poison_cont"] = "Контейнер с ядом нужен для создания базового ядерного оружия, а также ядовитых типов снарядов.";
    this.weapons_text["obj_rad_cont"] = "Контейнер с радиоативным газом необходим при сборке продвинутого ядерного оружия.";
    this.weapons_text["obj_laser_mod"] = "Лазерный модулятор - самый простой преобразователь одного вида энергии в другой. Чаще всего используется по прямому назначению - при создании лазерного оружия, а иногда выступает как дополнительный элемент питания или детонатор (например, нужен для создания Святой гранаты).";
    this.weapons_text["obj_plasma_mod"] = "Плазменный модулятор необходим для плазменного энергооружия, а также плазменных модификаций мины, базуки, и т.д. В некоторых случаях используется как источник питания или детонатор.";
    this.weapons_text["obj_coil"] = "В основном, катушка нужна для создания Гаусс-подобного энергооружия. Иногда применяется просто как базовый элемент какой-либо схемы устройства.";
    this.weapons_text["obj_pulse_mod"] = "Импульсный модулятор - один из самых сложных и дорогих модуляторов. Применяется при крафтинге импульсных энергоизлучателей типа Стэндиш, а также используется как детонатор в оружии с эффектом парализации врага.";
    this.weapons_text["obj_ultra_mod"] = "Преобразователь используется создания для ультравинтовок, генерирует стандартную ультраволну. Был создан в лабораториях Кентона, и, скорее всего, имеет какие-то дополнительные свойства, кроме генерации ультраволн.";
    this.weapons_text["obj_eg_generator"] = "Преобразователь электрической энергии в гравитацию. Применяется как генератор антигравитации или же как источник мощных гравитационных волн.";
    this.weapons_text["obj_fuel"] = "Увеличенные баки с топливом. Применяется для крафтинга реактивных ранцев и некоторых видов снарядов на реактивной тяге.";
    this.weapons_text["obj_small_expl"] = "Усиленная взрывчатка часто используется при создании более мощных версий снарядов, мин, живых бомб. Иногда она также используется при крафтинге слабого огнестрельного оружия как заменитель пороха в патронах.";
    this.weapons_text["obj_radio"] = "В комплекте с радиопередатчиком идет договор на аренду самолета/спутника. С помощью него можно \"создать\" множество оружия типа Авиаудар.";
    this.weapons_text["obj_big_expl"] = "Усиленная взрывчатка этого типа используется только при создании крайне мощного оружия типа Снаряд.";
    _loc3_ = "\nДля открытия этих рецептов купите книгу, зайдите в Арсенал и нажмите \"Использовать\". После использования книга сохраняется.\n\nЕсли вы соберете полный комплект из 9 книг, его можно продать коллекционерам за 3 миллиона золотых (для этого нажмите \"Продать\" напротив любой из книг).";
    this.weapons_text["obj_red_book"] = "Книга рецептов создержит инструкции для приготовления следующего оружия:\n\n" + this.FWP.get_book_recipes("obj_red_book", "text") + _loc3_;
    this.weapons_text["obj_orange_book"] = "Книга рецептов создержит инструкции для приготовления следующего оружия:\n\n" + this.FWP.get_book_recipes("obj_orange_book", "text") + _loc3_;
    this.weapons_text["obj_yellow_book"] = "Книга рецептов создержит инструкции для приготовления следующего оружия:\n\n" + this.FWP.get_book_recipes("obj_yellow_book", "text") + _loc3_;
    this.weapons_text["obj_green_book"] = "Книга рецептов создержит инструкции для приготовления следующего оружия:\n\n" + this.FWP.get_book_recipes("obj_green_book", "text") + _loc3_;
    this.weapons_text["obj_skyblue_book"] = "Книга рецептов создержит инструкции для приготовления следующего оружия:\n\n" + this.FWP.get_book_recipes("obj_skyblue_book", "text") + _loc3_;
    this.weapons_text["obj_blue_book"] = "Книга рецептов создержит инструкции для приготовления следующего оружия:\n\n" + this.FWP.get_book_recipes("obj_blue_book", "text") + _loc3_;
    this.weapons_text["obj_violet_book"] = "Книга рецептов создержит инструкции для приготовления следующего оружия:\n\n" + this.FWP.get_book_recipes("obj_violet_book", "text") + _loc3_;
    this.weapons_text["obj_white_book"] = "Книга рецептов создержит инструкции для приготовления следующего оружия:\n\n" + this.FWP.get_book_recipes("obj_white_book", "text") + _loc3_;
    this.weapons_text["obj_black_book"] = "Книга рецептов создержит инструкции для приготовления следующего оружия:\n\n" + this.FWP.get_book_recipes("obj_black_book", "text") + "\nЭто самая редка книга. Папа продает ее за золото только очень опытным игрокам (необходим уровень не ниже <b>70</b>).\n" + _loc3_;
    _loc4_ = "Сломанные детали после неудачного крафтинга. Применения практически никакого, их сразу можно продавать.";
    this.weapons_text["obj_junk1"] = _loc4_;
    this.weapons_text["obj_junk2"] = _loc4_;
    this.weapons_text["obj_junk3"] = _loc4_;
    this.weapons_text["obj_junk4"] = _loc4_;
    this.weapons_text["obj_junk5"] = _loc4_;
    this.weapons_text["obj_junk6"] = _loc4_;
    this.weapons_text["obj_junk7"] = _loc4_;
    this.weapons_text["obj_junk8"] = _loc4_;
    this.weapons_text["obj_junk9"] = _loc4_;
    this.weapons_text["obj_junk10"] = _loc4_;
    this.perks_text["damage_c"] = "Каждый новый уровень этой способности повышает урон оружия типа Ближний бой на 15%.";
    this.perks_text["dragonball"] = "Эта способность влияет исключительно на Шар дракона. С каждым новым уровнем расстояние его полета увеличивается. Третий уровень также дает прибавку к урону +50%.";
    this.perks_text["builder"] = "Увеличивает продолжительность действия Паяльной лампы и Отбойного молотка. На третьем уровне время действия этих утилит больше обычного в полтора раза.";
    this.perks_text["light_clips"] = "Увеличивает количество выстрелов из следующего оружия и их безотказных аналогов:\n\n<b>Пистолет 10мм\nУзи 9мм\nЛазерный пистолет\nЛазерный пистолет Mk 2\nПлазменный пистолет\nПистолет Гаусса PPK12\nПистолет Гаусса PPK19</b>";
    this.perks_text["medium_clips"] = "Увеличивает количество выстрелов из следующего оружия и их безотказных аналогов:\n\n<b>Двустволка .45\nДробовик .410\nМиротворец .577\nТуз Червей .577\nСнайперская винтовка 7.62мм\nЛазерная винтовка\nПлазменная винтовка\nВинтовка Гаусса М72</b>";
    this.perks_text["heavy_clips"] = "Увеличивает количество выстрелов из следующего оружия и их безотказных аналогов:\n\n<b>Пулемет 5.56мм\nАвиационный пулемет 13мм\nПулемет Авенджер 20мм\nРадиевая винтовка\nБозар G9 12.5мм\nБозар G16 RAD\nБозар G24s RAD\nЛазерный пулемет\nПлазменный пулемет\nГаусс-Пулемет</b>";
    this.perks_text["damage_f"] = "Каждый новый уровень этой способности повышает урон оружия типа Огнестрельное на 15%.";
    this.perks_text["laser_sights"] = "Увеличивает дальность лазерных прицелов. При третьем уровне лазерный прицел включается автоматически.";
    this.perks_text["champion"] = "Повышает количество получаемого золота после каждой победы.";
    this.perks_text["education"] = "Увеличивает количество очков способностей, получаемых при переходе на новый уровень.";
    this.perks_text["damage_e"] = "Каждый новый уровень этой способности повышает урон оружия типа Взрывчатка на 15%.";
    this.perks_text["fire_punch"] = "Увеличивает высоту прыжка при использовании Огненного удара.";
    this.perks_text["engineer"] = "Увеличивает максимальное расстояние от активного червяка, на которое можно поставить Балку.";
    this.perks_text["miner"] = "Уменьшает запал всех ваших мин. При третьем уровне этой способности запал нулевой (мина взрывается сразу после обнаружения червя).";
    this.perks_text["damage_p"] = "Каждый новый уровень этой способности повышает урон оружия типа Снаряды на 15%.";
    this.perks_text["crafting"] = "Позволяет собирать новые виды вооружения из купленных вами. С каждым новым уровнем этой способности открываются дополнительные рецепты.";
    this.perks_text["electrician"] = "Увеличивает урон импульсного оружия (импульcные гранаты/мины, импульсные излучатели типа Стэндиш и их модификации).";
    this.perks_text["surprise"] = "При переходе на новый уровень у вас в арсенале появляется одно случайное оружие. Чем выше уровень этой способности, тем более редкие типы оружия можно получить.";
    this.perks_text["damage_l"] = "Каждый новый уровень этой способности повышает урон оружия типа Живые бомбы на 15%.";
    this.perks_text["merchant"] = "Уменьшает цены на оружие, стимуляторы, журналы и т.п.";
    this.perks_text["medic"] = "Увеличивает здоровье вашей команды.";
    this.perks_text["para_res"] = "Уменьшает вероятность парализации ваших червяков. При третьем уровне парализовать ваших червей невозможно. В этой способности нет смысла, если ваша Защита больше 270.";
    this.perks_text["damage_a"] = "Каждый новый уровень этой способности повышает урон оружия типа Авиаудары на 15%.";
    this.perks_text["luck"] = "Удача влияет на огромное количество параметров - на шанс критического выстрела, на вероятность выпадения хорошего оружия в посылках, на частоту появлений Папы Джона и т.д.";
    this.perks_text["angel"] = "Сильно повышает урон от Святой гранаты и Святого удара.";
    this.perks_text["fire_res"] = "Увеличивает вашу сопротивляемость огню. При третьем уровне огонь не наносит никакого урона. Обычный огонь также не будет наносить вам урона при Защите больше 120.";
    this.perks_text["legioner"] = "Увеличивает количество очков навыков, получаемых при переходе на новый уровень.";
    this.perks_text["comandeer"] = "Первый червяк вашей команды получает улучшенные характеристики (атака, защита, здоровье).";
    this.perks_text["poison_res"] = "Увеличивает вашу сопротивляемость яду и радиации. При третьем уровне вас нельзя заразить и вы не получаете урона от электромагнитных и ультра-полей. Частично эту способность можно заменить Защитой 210 (тогда червей нельзя будет отравить ядовитым газом, но радиоактивным - можно).";
    this.perks_text["damage_h"] = "Каждый новый уровень этой способности повышает урон оружия типа Энергетическое на 15%.";
    this.perks_text["flyer"] = "Увеличивает запас топлива при использовании утилит полета (напр. Реактивного ранца).";
    this.perks_text["sprotsman"] = "Позволяет прыгать выше и дальше, а так же увеличивает импульс (но не урон) при использовании Тычка и Бейсбольной биты.";
    this.perks_text["heavy_guy"] = "Уменьшает \"тормозной путь\" червяка при скольжении по земле.";
    this.perks_text["accuracy"] = "Уменьшает разброс снарядов при стрельбе из любого вида автоматических винтовок и пулеметов.";
    this.perks_text["best_crit"] = "Увеличивает урон при критическом выстреле, однако вероятность такого выстрела не меняется.";
    this.perks_text["stims"] = "Позволяет использовать в одном бою больше стимуляторов (+1 при каждом новом уровне этой способности).";
    this.perks_text["fast_temp"] = "Уменьшает задержку оружия (-1 ход при каждом новом уровне этой способности).";
    this.perks_text["fast_walk"] = "Первый и второй уровни этой способности добавляют соответственно одну и две Быстрые ходьбы в ваш арсенал. При третьем уровне Быстрая ходьба включена всегда и для всех червей вашей команды.";
    this.perks_text["thinker"] = "При каждом новом уровне этой способности время хода увеличивается на 15 секунд.";
    this.perks_text["soft_land"] = "Чем выше уровень этой способности, тем с большей высоты вы можете прыгать, не теряя ОЗ и хода. На третьем уровне можно прыгать с любой возможной высоты (разве что не с орбиты).";
    this.perks_text["regeneration"] = "Позволяет восстанавливать часть здоровья всех ваших червяков перед каждый ходом вашей команды. Однако, Регенерация не поднимет здоровье выше уровня, который был в начале игры.";
    this.perks_text["vampire"] = "При использовании Огненного удара вы прибавляете себе ОЗ в процентах от нанесенного урона. В отличие от Регенерации, Вампиром можно поднять свои ОЗ выше начального уровня.";
    this.perks_text["morale"] = "Первый и второй уровни этой способности добавляют соответственно одну и два Выбора червя в ваш арсенал. При третьем уровне Выбор червя бесконечен.";
    this.perks_text["pe"] = "Первый уровень позволяет видеть, какое оружие находится в посылках, второй позволяет видеть невидимых червей, третий добавляет бесконечное количество ультраволновых сканеров в арсенал.";
    this.perks_text["light_step"] = "При первом уровне этой способности на ваших червей не реагируют обычные мины, при втором обычные и огненные, при третьем абсолютно все виды мин.";
    this.perks_text["luck2"] = "Во всех отношениях повторяет первый навык Удача. Не имеет смысла брать этот, если нет первого. С двумя способностями Удача шанс критического выстрела достигает почти 30%.";
    this.perks_text["bar"] = "Позволяет продавать вещи по большей цене. На третьем уровне можно продать любую вещь практически по рыночной стоимости.";
    this.perks_text["more_exp"] = "Увеличивает бонус опыта при победе. Третий уровень дает прибавку +15%. Эту способность лучше взять пораньше.";
    this.perks_text["god_of_war"] = "Каждый новый уровень этой способности повышает урон оружия всех типов на 15%.";
    this.perks_text["up_pistols"] = "Увеличивает урон всех пистолетов и ПП типа Узи.";
    this.perks_text["up_rifles"] = "Увеличивает урон всех огнестрельных и энергетических винтовок.";
    this.perks_text["up_miniguns"] = "Увеличивает урон всех огнестрельных и энергетических и пулеметов.";
    this.perks_text["less_fail"] = "Уменьшает шанс осечки всех оружий. При максимальной усталости и третьем уровне этой способности шанс осечки составит 20%.";
    this.perks_text["more_fail"] = "У врагов снаряды чаще взрываются прямо в стволе. Проблема в том, что у вас тоже!";
    this.perks_text["less_tired"] = "С каждым новым уровнем этой способности вы меньше устаете после каждого боя.";
    this.perks_text["steal"] = "Повышает вероятность кражи оружия.";
    this.perks_text["dmg_thr"] = "С каждым новым уровнем ваш порог урона (значение, которое вычитается из получаемого урона) увеличивается на 10. Плюс каждый четвертый уровень этой способности увеличивает шанс поглощения урона броней на 1%.";
    this.perks_text["big_guns"] = "Эта способность повышает урон оружия высоких классов - от 5 и выше. Правда, в ущерб урону оружия низких классов.";
    this.perks_text["crates"] = "Увеличивает вероятность, что в посылках будет попадаться лучшее оружие и общую вероятность появления посылок.";
    this.perks_text["ninja"] = "Уменьшает шанс врага точно попасть в ваших червяков.";
    this.perks_text["ap_shots"] = "Каждый уровень этой способности увеличивает шанс пробивного выстрела на 5%.";
    this.perks_text["absorb"] = "Каждый уровень этой способности увеличивает шанс поглощения урона броней на 5%.";
    this.perks_text["gsearch"] = "Каждый уровень этой способности уменьшает время обыска гробиков.";
    this.achiev_text["career"] = "Проходите задания в режиме Карьеры, чтобы открыть это достижение.";
    this.achiev_text["missions"] = "Проходите задания в режиме Миссий, чтобы открыть это достижение.";
    this.achiev_text["survival"] = "Проходите задания в режиме Выживания, чтобы открыть это достижение.";
    this.achiev_text["boss"] = "Побеждайте боссов, чтобы открыть это достижение.";
    this.achiev_text["assault"] = "Зависит от числа успешных захватов вражеских территорий. Режим захват территорий - самая левая кнопка сверху этого меню.";
    this.achiev_text["no_death"] = "Побеждайте в боях, не потеряв ни одного своего червяка!";
    this.achiev_text["no_injure"] = "Достижение для профессионалов - учитываются все бои, где ваши червяки не понесли даже ранения.";
    this.achiev_text["kill_p"] = "Чтобы открыть это достижение, убивайте врагов из оружия типа Снаряд - Баузки, Гранаты и т.д.";
    this.achiev_text["kill_e"] = "Чтобы открыть это достижение, убивайте врагов из оружия типа Взрывчатка - Мины, Динамит и т.д.";
    this.achiev_text["kill_a"] = "Чтобы открыть это достижение, убивайте врагов исключительно ударами сверху.";
    this.achiev_text["kill_c"] = "Чтобы открыть это достижение, убивайте врагов голыми руками или же используйте Шар Дракона, Огненный удар, Камикадзе.";
    this.achiev_text["kill_h"] = "Чтобы открыть это достижение, убивайте врагов из лазерного, плазменного и прочего энергетического оружия.";
    this.achiev_text["kill_f"] = "Чтобы открыть это достижение, убивайте врагов из огнестрельного оружия - пистолеты, винтовки, пулеметы.";
    this.achiev_text["kill_l"] = "Чтобы открыть это достижение, убивайте врагов Живыми бомбами - например, Овцой.";
    this.achiev_text["para"] = "Парализуйте ваших врагов с помощью импульсного оружия!";
    this.achiev_text["annih"] = "Испаряйте вражеских червей с помощью оружия нового поколения - аннигиляторов! Найти их в обычном магазине нельзя.";
    this.achiev_text["recipes"] = "Открывайте новые рецепты для крафтинга, чтобы открыть это достижение.";
    this.achiev_text["stims"] = "Используйте стимуляторы перед боем, чтобы врагу было несладко!.";
    this.achiev_text["buys"] = "Покупайте много оружия, скупите весь стационарный магазин и весь привалок Папы Джона!";
    this.achiev_text["steal"] = "Украдите столько оружия, сколько можете унести, но смотрите не попадитесь!";
    this.achiev_text["crafted"] = "Собирайте новые, более  мощные виды вооружения из компонентов!";
    this.achiev_text["upgraded"] = "Улучшайте свое оружие, сделайте его такой мощности, чтобы враги разбегались, лишь завидев его!";
    this.achiev_text["wins"] = "Выигрывайте в Дартс - удача любит смелых людей!";
    this.achiev_text["days"] = "В зависимости от количества проведенных дней в игре получайте алмазы! Учитываются именно ежедневные заходы.";
    this.task_texts[1] = "Для прохождения карьеры зайдите в бар (в главном меню) и выберите режим игры \"Карьера\", причем при первом заходе в бар этот режим будет выбран автоматически. Ваша задача - уничтожить всех вражеских червяков, и, при этом, сохранить хотя бы одного своего. Оружие можно выбрать кнопкой Q или нажатием на рюкзак в нижней правой части экрана. При наведении на оружие выведется его описание.";
    this.task_texts[2] = "Стимуляторы нужны для того, чтобы сбивать усталость, а так же повышать некоторые ваши навыки, такие как Атака или Защита. Для покупки стимулятора нажмите на Магазин в главном меню, зайдите в раздел \"Помощь\", выберите понравившийся стимулятор и нажмите \"Купить\" в правой нижней части экрана. Если шкала усталости в главном меню (красная) заполнилась до конца, это верный признак того, что нужно или подождать какое-то время, или использовать стимуляторы.";
    this.task_texts[3] = "Для получения нового уровня наберите необходимое количество очков опыта. Узнать, сколько вам еще нужно опыта можно, наведя курсор мыши на зеленую шкалу опыта в главном меню. Опыт дается за победы в бою или за достижения. Перед началом любого боя в описании будет показано, сколько опыта вы за него получите.";
    this.task_texts[4] = "Класс оружия - показатель его мощности. Всего классов восемь, первый класс - самый слабый, восьмой - самый разрушительный. При наведении курсора на оружие в арсенале (или при клике на оружие в магазине) в описании будет указан класс выбранного оружия. Для выполнения этого задания купите оружие 2 класса (или выше).";
    this.task_texts[5] = "Для прохождения выживания зайдите в бар в главном меню и выберите режим игры \"Выживание\". В описании задания к каждому выживанию будет указано количество червяков, которых вам необходимо уничтожить. Например, в первом выживании нужно уничтожить пять червяков. На карте их всего двое, однако при падении в воду или смерти вражеский червяк возродится, и так пять раз.";
    this.task_texts[6] = "Использование стимуляторов может хорошо помочь перед сложным боем. Если у вас нет способности \"Стимуляторы\", перед боем можно использовать всего четыре стимулятора. Зайдите в арсенал, вкладка \"Помощь\", наведите курсор на любой стимулятор, и нажмите \"Использовать\". Если во вкладке пусто, зайдите в магазин и купите стимуляторы. После этого попытайтесь выиграть любой бой. Даже если вы проиграете его, это неважно - задание все равно будет считаться выполненным. Кстати, если зайти во вкладку \"Развитие\" в этом меню, можно посмотреть на эффекты от принятых стимуляторов, они влияют на Атаку, Защиту и Здоровье.";
    this.task_texts[7] = "Зайдите в магазин, раздел \"Флаги\" и купите любой понравившийся. Кстати сказать, некоторые флаги можно купить после определенного достижения.";
    this.task_texts[8] = "Чтобы пройти миссию, зайдите в Бар и откройте режим игры \"Миссии\". Обращаем ваше внимание, что следует читать описание каждой миссии перед началом боя - в некоторых миссиях ставится не только основная задача (разгромить врагов), но еще и второстепенные - например, защитить мирное население или не дать врагам взорвать стратегические объекты.";
    this.task_texts[9] = "Получите еще один уровень, набрав соответствующее количество очков опыта.";
    this.task_texts[10] = "Зайдите в магазин и купите любое оружие третьего класса или выше. Класс оружия показан в информации справа, при клике на оружие.";
    this.task_texts[11] = "Сверху этого меню есть раздел \"Дартс\". Его суть заключается в том, что вы ставите некоторое количество золота или алмазов, и можете выиграть какое-либо оружие. Таблица вероятности по классам оружия показана внизу меню Дартса. Чтобы выполнить это задание, выигрывать оружие необязательно. Достаточно просто один раз сыграть.";
    this.task_texts[12] = "Пройдите еще одно выживание для выполнения этого задания.";
    this.task_texts[13] = "В меню \"Развитие\" есть раздел Способности. Способности оказывают огромное влияние на весь игровой процесс. Взять способность можно, если вам хватает очков способностей. Эти очки выдаются за каждый уровень - по 20 штук. Выберите любую новую способность для выполнения этого задания (для этого следует нажать кнопку с плюсом на любом открытом слоте способностей, а если таковых нет - его можно купить). ";
    this.task_texts[14] = "Пройдите одну миссию для выполнения этого задания.";
    this.task_texts[15] = "Разберите одно оружие на составляющие части и узнайте, из чего оно состоит. Для этого зайдите во вкладку \"Крафтинг\" и поместите оружие на \"верстак\" в разделе \"Разобрать оружие\". В результате вы лишитесь этого экземпляра оружия, но узнаете новый рецепт, который позволит собирать этот тип оружия и составных частей. Если рецепт вам уже известен, вы все равно можете попробовать разобрать оружие для получения его составных частей, но в этом случае вероятность удачного разбора уже не стопроцентная.";
    this.task_texts[16] = "Купите в магазине любое оружие четвертого класса или выше.";
    this.task_texts[17] = "Чтобы улучшить оружие, зайдите в Арсенал и наведите курсор на любое оружие. Рядом появится кнопка \"Улучшить\". Почти все оружие, кроме утилит и оружия ближнего боя, можно улучшать. За улучшения надо платить золотом. Если вы покупаете или крадете оружие, его ранг - 1. С каждым улучшением ранг оружия повышается, и, соответственно, повышается его стоимость при продаже, наносимый урон, отказоустойчивость, шанс критического выстрела и т.д.";
    this.task_texts[18] = "Зайдите в Бар и выберите режим игры \"Боссы\". Советуем вам хорошо подготовиться к битве с боссами - это супер-сильные червяки, которые висят над землей на портативном генераторе антигравитации, поэтому их нельзя сбить в воду.";
    this.task_texts[19] = "Зайдите во вкладку Развитие и увеличьте свое здоровье или добавьте в команду одного червяка. Сделать это можно за очки навыков (так же, как и увеличить Атаку или Защиту). Очки навыков выдаются по 15 за каждый новый уровень.";
    this.task_texts[20] = "У вас наверняка уже есть хотя бы один открытый рецепт (посмотреть можно в Книге рецептов во вкладке Крафтинг). По этим схемам можно собирать оружие - расположите все нужные предметы на \"верстаке\" под надписью \"Собрать оружие\". Для любого оружия требуются менее сильные оружия и предметы. Предметы можно купить в стандартном магазине, но там попадаются далеко не все из них. Большинство предметов, даже самые редкие, есть в магазине Папы Джона, а также их можно найти при обыске гробиков после боя.";
    this.task_texts[21] = "Зайдите в Магазин и купите одно любое оружие типа Энергетическое. Энергооружие самое мощное в игре, у него самый высокий урон и иногда есть некоторые дополнительные свойства, например пролетание сквозь препятствия.";
    this.task_texts[22] = "Выберите новую способность в разделе Развитие.";
    this.task_texts[23] = "Зайдите в Настройки в правом верхнем углу главного меню. Там будет возможность выбрать уровень сложности. Уровень сложности сильно влияет на Атаку, Защиту и Здоровье боссов. Однако, чем выше уровень сложности, тем больше золота и опыта вы получите в случае победы. Поставьте уровень сложности \"Кошмар\" и пройдите любую карьеру, хоть саму первую. Если вам покажется это чересчур сложным - всегда можно поставить уровень сложности обратно на \"Обычный\".";
    this.task_texts[24] = "Зайдите в магазин и украдите любое оружие у продавца. Будьте внимательны - если кража не удастся, и не получится запудрить продавцу мозги в диалоге, вас на один день не будут пускать в магазин, а усталость увеличится на 100%. На вероятность запудрить продавцу мозги влияют много способностей, вот некоторые из них: Образованность (самая важная), Удача, Торговец, Барыга. Подробности можно прочитать в Вормпедии, там есть статья про воровство.";
    this.task_texts[25] = "Зайдите в раздел Крафтинг и соберите любой экземпляр оружия 3 класса или выше.";
    this.task_texts[26] = "Победите еще одного босса.";
    this.task_texts[27] = "Зайдите в раздел Крафтинг и соберите любой экземпляр оружия 4 класса или выше.";
    this.task_texts[28] = "Захватите одну территорию (вкладка \"Захват территорий\"). При захвате территорий вам предстоит сражаться с одним мини-боссом, висящим на генераторе антигравитации, и его командой, обычными червяками. Причем босс неуязвим, пока жив еще хотя бы один червяк из его команды. За захваченные территории вы получаете бонусы золотом.";
    this.task_texts[29] = "Зайдите в Магазин, вкладка \"Имплантанты\", и купите любой чип по желанию. Чипы увеличивают ваши показатели Атаки, Защиты, Здоровья, а также иногда оказывают дополнительную помощь - например, защиту от яда.";
    this.task_texts[30] = "Зайдите в раздел Крафтинг и соберите любой экземпляр оружия 5 класса или выше.";
    this.task_texts[31] = "Вы прошли все тестовые задания. Теперь вы, надеемся, более-менее разобрались в механике игры. Удачи в захвате новых земель!";
  }

  /**
   * PORT: a battle team's name in the scanner: the player's own team carries the player's name (data: shown as typed,
   * never translated), the other teams the game's names (translated like any game text).
   */
  set_team_name(param1: any, param2: any): void {
    const name = String(param2 && param2.name != null ? param2.name : "");
    if (param2 && param2.cpu_level == 0 && name !== "" && name === String(this.FWP.user.name)) {
      setRawText(param1, name);
    } else {
      param1.text = name;
    }
  }

  init(param1: any, param2: any = "", param3: any = ""): any {
    param1 = as3.str(param1);
    param2 = as3.str(param2);
    param3 = as3.str(param3);
    if (param1 in this.no_anim_def) {
      this.init_instant(param1, param2, param3);
      return;
    }
    if (this.FWP.player.settings.no_animation == 0) {
      this.init_bg_blur();
      this.init_instant(param1, param2, param3, true);
      this.FWP.animation = true;
      this.FWP.animation_y = -600;
      this.FWP.animation_mode = "show";
      this.FWP.set_invisible_button(true);
      return;
    }
    this.init_bg_blur();
    this.init_instant(param1, param2, param3, false);
  }

  init_bg_blur(): any {
    let _loc1_: any = this.FWP.container_interf.get_object("menu_bg");
    ++this.cur_screen[0];
    this.cur_screen[this.cur_screen[0]] = { "name": "bg_blur", "link": _loc1_ };
    this.addChild(_loc1_);
  }

  init_instant(param1: any, param2: any = "", param3: any = "", param4: boolean = false): any {
    param1 = as3.str(param1);
    param2 = as3.str(param2);
    param3 = as3.str(param3);
    param4 = Boolean(param4);
    let _loc7_: any = undefined;
    let _loc8_: any = undefined;
    let _loc10_: any = undefined;
    let _loc5_: any = undefined;
    let _loc6_: any = undefined;
    let _loc9_: any = undefined;
    let _loc11_: any = undefined;
    let _loc12_: any = undefined;
    let _loc13_: any = undefined;
    this.opened_filter = false;
    this.papa_checked = false;
    this.success_auc = false;
    this.FWP.interf_mainframe = false;
    if (param1 == "skills_main") {
      param1 = "skills";
    }
    if (param1 != "pay" && param1 != "calc" && param1 != "arsenal_sheet" && param1 != "crafting" && param1 != "error" && param1 != "steal") {
      this.cur_page = 1;
      this.cur_element = -1;
      this.cur_weapon = "";
      this.shop_page = 1;
      this.shop_mode = "all";
    }
    if (param1 == "papa_shop") {
      this.shop_type = "weapons";
    }
    _loc7_ = this.FWP.temp_player;
    _loc8_ = this.FWP.player;
    if (param1 == "mainframe") {
      _loc9_ = this.FWP.container_interf.get_object("_mainframe");
      // PORT: the last battle's replay while its offer is undecided (runtime/replay-offer.ts), not whenever a replay
      // PORT: string is in memory (it saved the same replay again at every press).
      _loc9_.get_replay_clip.visible = replayOfferShown(this.FWP);
      this.FWP.interf_mainframe = true;
    }
    if (param1 == "fight") {
      _loc9_ = this.FWP.container_interf.get_object("menu_fight");
      this.init_slider(param1, "slider");
    }
    if (param1 == "skills") {
      _loc9_ = this.FWP.container_interf.get_object("menu_skills");
      this.changes_made = false;
      this.FWP.refresh_temp_params();
    }
    if (param1 == "tasks") {
      _loc9_ = this.FWP.container_interf.get_object("menu_tasks");
      this.init_slider(param1);
      this.task_bonus_text = "";
    }
    if (param1 == "choose_perk" || param1 == "view_perks") {
      _loc9_ = this.FWP.container_interf.get_object("menu_choose_perk");
    }
    if (param1 == "buy_perk") {
      _loc9_ = this.FWP.container_interf.get_object("menu_buy_perk");
    }
    if (param1 == "arsenal") {
      _loc9_ = this.FWP.container_interf.get_object("menu_arsenal");
      this.FWP.refresh_temp_params();
      this.init_slider(param1);
    }
    if (param1 == "choose_spec") {
      _loc9_ = this.FWP.container_interf.get_object("menu_choose_spec");
    }
    if (param1 == "spec_learn_more") {
      _loc9_ = this.FWP.container_interf.get_object("menu_spec_learn_more");
    }
    if (param1 == "shop") {
      if (this.FWP.player.today_steals >= 8) {
        if (this.FWP.player.today_steals == 8) {
          this.success_steal = false;
          this.steal_state = "get_off";
        } else {
          this.steal_state = "fuck_off";
        }
        this.init("mainframe");
        this.init("steal");
        return;
      }
      _loc9_ = this.FWP.container_interf.get_object("menu_shop");
      this.FWP.refresh_temp_params();
    }
    if (param1 == "rating") {
      _loc9_ = this.FWP.container_interf.get_object("menu_rating");
    }
    if (param1 == "info") {
      _loc9_ = this.FWP.container_interf.get_object("menu_info");
    }
    if (param1 == "achiev") {
      _loc9_ = this.FWP.container_interf.get_object("menu_achiev");
      this.achiev_bonus_text = "";
    }
    if (param1 == "crafting") {
      _loc9_ = this.FWP.container_interf.get_object("menu_crafting");
      this.weapon_stack = [0, {}, {}, {}, {}, {}, {}];
      this.weapon_diss = {};
    }
    if (param1 == "finish_crafting") {
      _loc9_ = this.FWP.container_interf.get_object("menu_finish_crafting");
    }
    if (param1 == "game") {
      _loc9_ = this.FWP.container_interf.get_object("menu_game");
    }
    if (param1 == "replay") {
      _loc9_ = this.FWP.container_interf.get_object("menu_replay");
      _loc9_.go_replay.visible = false;
      _loc9_.replay_info_zone.visible = false;
      // PORT: the original shipped this tab under a plate "the replay service is temporarily unavailable" (sprite 670,
      // PORT: unnamed) that covered the list, the field and the buttons and took every tap; the port's backend stores
      // PORT: replays (replay.list / replay.get), so the plate is hidden (a failed request shows the game's own error).
      for (_loc5_ = 0; _loc5_ < _loc9_.numChildren; _loc5_++) {
        if (_loc9_.getChildAt(_loc5_).$charId == 670) {
          _loc9_.getChildAt(_loc5_).visible = false;
        }
      }
    }
    if (param1 == "roul") {
      _loc9_ = this.FWP.container_interf.get_object("menu_roul");
    }
    if (param1 == "tired") {
      _loc9_ = this.FWP.container_interf.get_object("menu_tired");
    }
    if (param1 == "just_play") {
      this.remove();
      _loc9_ = this.FWP.container_interf.get_object("menu_just_play");
    }
    if (param1 == "end_game_lose") {
      _loc9_ = this.FWP.container_interf.get_object("menu_end_game_lose");
    }
    if (param1 == "end_game_win") {
      _loc9_ = this.FWP.container_interf.get_object("menu_end_game_win");
    }
    if (param1 == "end_game_new_lvl") {
      _loc9_ = this.FWP.container_interf.get_object("menu_end_game_new_lvl");
    }
    if (param1 == "end_game_surprise") {
      _loc9_ = this.FWP.container_interf.get_object("menu_end_game_surprise");
    }
    if (param1 == "what_opened") {
      _loc9_ = this.FWP.container_interf.get_object("menu_what_opened");
    }
    if (param1 == "grave_search") {
      _loc9_ = this.FWP.container_interf.get_object("menu_grave_search");
    }
    if (param1 == "grave_result") {
      _loc9_ = this.FWP.container_interf.get_object("menu_surprise");
    }
    if (param1 == "roul result") {
      _loc9_ = this.FWP.container_interf.get_object("menu_surprise");
    }
    if (param1 == "settings") {
      _loc9_ = this.FWP.container_interf.get_object("menu_settings");
    }
    if (param1 == "question") {
      _loc9_ = this.FWP.container_interf.get_object("menu_question");
      this.question_mode = param2;
    }
    if (param1 == "present") {
      _loc9_ = this.FWP.container_interf.get_object("menu_present");
    }
    if (param1 == "view_tutorial") {
      _loc9_ = this.FWP.container_interf.get_object("menu_view_tutorial");
      _loc9_.stop();
    }
    if (param1 == "weapon_sheet") {
      _loc9_ = this.FWP.container_interf.get_object("menu_weapon_sheet");
      this.init_slider(param1);
      // PORT: the sheet's note (its only unnamed text field) says the timer stops while it is open; an online battle's
      // PORT: timer keeps running (proc.menus_freeze): the note says so, in the same style.
      if (this.FWP._proc && !this.FWP._proc.menus_freeze()) {
        for (let _k: number = 0; _k < _loc9_.numChildren; _k++) {
          const t: any = _loc9_.getChildAt(_k);
          if (t instanceof TextField && /^instance\d+$/.test(t.name)) {
            t.htmlText = '<p align="center"><font face="Arial" size="12" color="#6f370b"><b>' + MSG_SHEET_TIMER_RUNS + "</b></font></p>";
          }
        }
      }
    }
    // PORT: item 8 - the clans of the players (runtime/clan-hub.ts): the clans tab on the screen of the VK friends list
    // PORT: (menu_friends: the VK friends are gone), the card of a clan and the dialogs on the popup of the original's
    // PORT: clan member list (menu_clan_members, which nothing in the original opened).
    if (param1 == "clan_hub") {
      _loc9_ = this.FWP.container_interf.get_object("menu_friends");
      this.init_slider(param1);
    }
    if (param1 == "clan_card" || param1 == "clan_edit") {
      _loc9_ = this.FWP.container_interf.get_object("menu_clan_members");
      this.init_slider(param1);
    }
    if (param1 == "top") {
      _loc9_ = this.FWP.container_interf.get_object("menu_top");
      _loc5_ = 1;
      while (_loc5_ <= 10) {
        _loc9_["clip_top" + _loc5_].clan_icon.visible = false;
        _loc5_++;
      }
      // PORT: the columns' headers (level, rating, captures: fields 278, 277, 279) keep 8 px clear of their column's
      // PORT: sides: a translation longer than the original's word gets a smaller font (uk "Захоплень" ran up to the
      // PORT: list's border).
      for (_loc5_ = 0; _loc5_ < _loc9_.numChildren; _loc5_++) {
        if ([277, 278, 279].indexOf(_loc9_.getChildAt(_loc5_).$charId) != -1) {
          shrinkToFit(_loc9_.getChildAt(_loc5_), 9, 16);
        }
      }
    }
    if (param1 == "clans") {
      _loc9_ = this.FWP.container_interf.get_object("menu_clans");
    }
    if (param1 == "user_info") {
      _loc9_ = this.FWP.container_interf.get_object("menu_user_info");
      this.opened_user_uid = Number(param2);
      _loc9_.award_magnet.visible = false;
      _loc9_.award_contest.visible = false;
      _loc9_.award_tester.visible = false;
      _loc9_.error_message.visible = false;
      this.MainBitmapData.fillRect(new Rectangle(0, 0, this.MainBitmap.width, this.MainBitmap.height), 0);
      // PORT: another player's gold and diamonds are not public (profile.getPublic): their amounts and icons are
      // PORT: hidden; so is the plate of the VK page button (open_page, hidden with it: shape 224).
      _loc9_.gold.visible = false;
      _loc9_.diam.visible = false;
      for (_loc5_ = 0; _loc5_ < _loc9_.numChildren; _loc5_++) {
        _loc6_ = _loc9_.getChildAt(_loc5_);
        if (_loc6_.$charId == 178 || _loc6_.$charId == 180 || _loc6_.$charId == 224) {
          _loc6_.visible = false;
        }
      }
    }
    if (param1 == "error") {
      _loc9_ = this.FWP.container_interf.get_object("menu_error");
      this.error_mode = param2;
    }
    if (param1 == "calc") {
      _loc9_ = this.FWP.container_interf.get_object("menu_calc");
      this.calc_weapon = param2;
    }
    if (param1 == "wormpedia") {
      _loc9_ = this.FWP.container_interf.get_object("menu_wormpedia");
    }
    if (param1 == "recipes") {
      _loc9_ = this.FWP.container_interf.get_object("menu_recipes");
      this.init_slider(param1);
    }
    if (param1 == "assault") {
      _loc9_ = this.FWP.container_interf.get_object("menu_assault");
      _loc5_ = 1;
      while (_loc5_ <= 17) {
        _loc9_["terr_zone_" + _loc5_].clan_icon.gotoAndStop(29);
        _loc5_++;
      }
      _loc9_.my_clan_icon.gotoAndStop(29);
      _loc9_.clip_assault_tribute.gotoAndStop(1);
      _loc9_.assault_zones.gotoAndStop(1);
      _loc9_.assault_zones.zone_common_desc.htmlText = "";
    }
    if (param1 == "how_tribute_calcs") {
      _loc9_ = this.FWP.container_interf.get_object("menu_how_tribute_calcs");
    }
    if (param1 == "papa_john") {
      if (this.FWP.PAPA_HERE) {
        _loc9_ = this.FWP.container_interf.get_object("menu_papa");
      } else {
        _loc9_ = this.FWP.container_interf.get_object("menu_papa_not_here");
      }
    }
    if (param1 == "papa_shop") {
      _loc9_ = this.FWP.container_interf.get_object("menu_papa_shop");
    }
    if (param1 == "upgrade_weapon") {
      _loc9_ = this.FWP.container_interf.get_object("menu_upgrade_weapon");
    }
    if (param1 == "sell_weapon") {
      _loc9_ = this.FWP.container_interf.get_object("menu_sell_weapon");
    }
    if (param1 == "tribute") {
      _loc9_ = this.FWP.container_interf.get_object("menu_tribute");
    }
    if (param1 == "auc") {
      _loc9_ = this.FWP.container_interf.get_object("menu_auc");
    }
    if (param1 == "auc_rules") {
      _loc9_ = this.FWP.container_interf.get_object("menu_auc_rules");
    }
    if (param1 == "steal") {
      if (this.success_steal) {
        _loc9_ = this.FWP.container_interf.get_object("menu_error");
      } else {
        _loc9_ = this.FWP.container_interf.get_object("menu_steal");
      }
    }
    if (param1 == "pay") {
      _loc9_ = this.FWP.container_interf.get_object("menu_pay");
      this.DIAM_TO_TRANS = 0;
      this.PLAYER_DIAM = this.FWP.player.diam.value;
    }
    if (param1 == "scaner") {
      _loc9_ = this.FWP.container_interf.get_object("menu_scaner");
      this.init_slider(param1);
      this.scaner_mode = param2;
    }
    ++this.cur_screen[0];
    this.cur_screen[this.cur_screen[0]] = { "name": param1, "link": _loc9_ };
    this.addChild(_loc9_);
    if (Boolean(_loc9_.bitmap_container) && param1 != "game") {
      _loc9_.bitmap_container.addChild(this.MainBitmap);
    }
    if (Boolean(_loc9_.bitmap_container) && param1 == "game") {
      _loc9_.bitmap_container.addChild(this.SecondBitmap);
    }
    _loc10_ = 0;
    if (_loc9_.weapon_container) {
      _loc5_ = 1;
      while (_loc5_ <= 4) {
        _loc6_ = 1;
        while (_loc6_ <= 6) {
          _loc10_++;
          this.buttons["wp_buy_" + _loc10_] = this.FWP.container_interf.get_object("buy_weapon");
          _loc9_.weapon_container.addChild(this.buttons["wp_buy_" + _loc10_]);
          this.buttons["wp_buy_" + _loc10_].x = 86 + (_loc6_ - 1) * 70;
          this.buttons["wp_buy_" + _loc10_].y = 134 + (_loc5_ - 1) * 100;
          this.bitmaps["shop" + _loc10_] = new Bitmap();
          this.bitmap_datas["shop" + _loc10_] = new BitmapData(50, 50, true, 0);
          this.bitmaps["shop" + _loc10_].bitmapData = this.bitmap_datas["shop" + _loc10_];
          this.buttons["wp_buy_" + _loc10_].addChild(this.bitmaps["shop" + _loc10_]);
          this.bitmaps["shop" + _loc10_].x = 5;
          this.bitmaps["shop" + _loc10_].y = 5;
          // PORT: UNVERIFIED Flash pick order: the click handler selects an item only when the event target is the item
          // PORT: itself ("weapon_<id>" / "clickperk_<id>"), but under AVM2 mouse picking (interactive children before
          // PORT: non-interactive ones, as in Ruffle's mouse_pick_avm2) a click on the icon targets the filled "back"
          // PORT: child and nothing is selected. mouseChildren = false makes the whole slot the target.
          this.buttons["wp_buy_" + _loc10_].mouseChildren = false;
          _loc6_++;
        }
        _loc5_++;
      }
    }
    if (_loc9_.arsenal_weapon_container) {
      _loc5_ = 1;
      while (_loc5_ <= 2000) {
        this.bitmaps["ars_wp" + _loc5_] = new Object();
        this.bitmap_datas["ars_wp" + _loc5_] = new Object();
        _loc5_++;
      }
    }
    if (_loc9_.recipes_container) {
      _loc5_ = 1;
      while (_loc5_ <= 150) {
        this.bitmaps["rcp" + _loc5_] = new Object();
        this.bitmap_datas["rcp" + _loc5_] = new Object();
        _loc5_++;
      }
      this.bitmaps["rec_result"] = new Object();
      this.bitmap_datas["rec_result"] = new Object();
      _loc5_ = 1;
      while (_loc5_ <= 6) {
        this.bitmaps["rec_component" + _loc5_] = new Object();
        this.bitmap_datas["rec_component" + _loc5_] = new Object();
        _loc5_++;
      }
    }
    if (_loc9_.achiev_container) {
      _loc5_ = 1;
      while (_loc5_ <= 4) {
        _loc6_ = 1;
        while (_loc6_ <= 6) {
          _loc10_++;
          this.buttons["ach_" + _loc10_] = this.FWP.container_interf.get_object("clip_achiev");
          _loc9_.achiev_container.addChild(this.buttons["ach_" + _loc10_]);
          this.buttons["ach_" + _loc10_].x = (_loc6_ - 1) * 80;
          this.buttons["ach_" + _loc10_].y = (_loc5_ - 1) * 80;
          this.buttons["ach_" + _loc10_].name = "clip_achiev" + String(_loc10_);
          this.bitmaps["ach_" + _loc10_] = new Bitmap();
          this.bitmap_datas["ach_" + _loc10_] = new BitmapData(50, 50, true, 0);
          this.bitmaps["ach_" + _loc10_].bitmapData = this.bitmap_datas["ach_" + _loc10_];
          _loc6_++;
        }
        _loc5_++;
      }
    }
    if (_loc9_.in_game_weapon_container) {
      _loc5_ = 1;
      while (_loc5_ <= 80) {
        this.bitmaps["ing_wp" + _loc5_] = new Object();
        this.bitmap_datas["ing_wp" + _loc5_] = new Object();
        _loc5_++;
      }
    }
    if (_loc9_.crafting_wp_container) {
      _loc5_ = 1;
      while (_loc5_ <= 11) {
        this.bitmaps["craft_wp" + _loc5_] = new Object();
        this.bitmap_datas["craft_wp" + _loc5_] = new Object();
        _loc5_++;
      }
    }
    if (_loc9_.crafting_obj_container) {
      _loc5_ = 1;
      while (_loc5_ <= 11) {
        this.bitmaps["craft_obj" + _loc5_] = new Object();
        this.bitmap_datas["craft_obj" + _loc5_] = new Object();
        _loc5_++;
      }
    }
    if (_loc9_.crafting_stack_container) {
      _loc5_ = 1;
      while (_loc5_ <= 7) {
        this.bitmaps["craft_stack" + _loc5_] = new Object();
        this.bitmap_datas["craft_stack" + _loc5_] = new Object();
        _loc5_++;
      }
    }
    if (_loc9_.crafting_diss_container) {
      this.bitmaps["craft_diss"] = new Bitmap();
      this.bitmap_datas["craft_diss"] = new BitmapData(50, 50, true, 0);
    }
    if (_loc9_.floating_container) {
      this.bitmaps["float"] = new Bitmap();
      this.bitmap_datas["float"] = new BitmapData(50, 50, true, 0);
    }
    if (_loc9_.craft_result_icon) {
      this.bitmaps["craft_result_icon"] = new Bitmap();
      this.bitmap_datas["craft_result_icon"] = new BitmapData(50, 50, true, 0);
      this.bitmaps["craft_result_icon"].bitmapData = this.bitmap_datas["craft_result_icon"];
      _loc9_.craft_result_icon.addChild(this.bitmaps["craft_result_icon"]);
    }
    if (_loc9_.perks_container) {
      _loc5_ = 1;
      while (_loc5_ <= 4) {
        _loc6_ = 1;
        while (_loc6_ <= 7) {
          _loc10_++;
          this.buttons["pk_buy_" + _loc10_] = this.FWP.container_interf.get_object("clip_new_perk");
          _loc9_.perks_container.addChild(this.buttons["pk_buy_" + _loc10_]);
          this.buttons["pk_buy_" + _loc10_].x = (_loc6_ - 1) * 67;
          this.buttons["pk_buy_" + _loc10_].y = (_loc5_ - 1) * 80;
          this.bitmaps["cperk" + _loc10_] = new Bitmap();
          this.bitmap_datas["cperk" + _loc10_] = new BitmapData(50, 50, true, 0);
          this.bitmaps["cperk" + _loc10_].bitmapData = this.bitmap_datas["cperk" + _loc10_];
          this.buttons["pk_buy_" + _loc10_].addChild(this.bitmaps["cperk" + _loc10_]);
          this.bitmaps["cperk" + _loc10_].x = 5;
          this.bitmaps["cperk" + _loc10_].y = 5;
          // PORT: UNVERIFIED Flash pick order: the click handler selects an item only when the event target is the item
          // PORT: itself ("weapon_<id>" / "clickperk_<id>"), but under AVM2 mouse picking (interactive children before
          // PORT: non-interactive ones, as in Ruffle's mouse_pick_avm2) a click on the icon targets the filled "back"
          // PORT: child and nothing is selected. mouseChildren = false makes the whole slot the target.
          this.buttons["pk_buy_" + _loc10_].mouseChildren = false;
          _loc6_++;
        }
        _loc5_++;
      }
    }
    if (_loc9_.choose_container) {
      this.play_type = param2;
      _loc11_ = 0;
      if (this.play_type == "career") {
        _loc11_ = Math.min(this.FWP.player.career_max, this.FWP.TEAMS_DEF.career_max);
      }
      if (this.play_type == "missions") {
        _loc11_ = Math.min(this.FWP.player.missions_max, this.FWP.TEAMS_DEF.missions_max);
      }
      if (this.play_type == "survival") {
        _loc11_ = Math.min(this.FWP.player.survival_max, this.FWP.TEAMS_DEF.survival_max);
      }
      if (this.play_type == "boss") {
        _loc11_ = Math.min(this.FWP.player.boss_max, this.FWP.TEAMS_DEF.boss_max);
      }
      _loc5_ = 1;
      // PORT (wide screens): a phone's rows a finger's target apart (ui/wide-lists.ts; 20 px as the original elsewhere).
      const pitch: number = listPitch(this.stage);
      while (_loc5_ <= _loc11_) {
        this.buttons["fight" + _loc5_] = this.FWP.container_interf.get_object("choose_task");
        _loc9_.choose_container.addChild(this.buttons["fight" + _loc5_]);
        this.buttons["fight" + _loc5_].x = 0;
        this.buttons["fight" + _loc5_].y = (_loc5_ - 1) * pitch;
        _loc12_ = "";
        if (_loc5_ == _loc11_) {
          _loc12_ = "<b>";
        }
        if (this.play_type == "career") {
          _loc12_ += this.FWP.TEAMS_DEF["career" + _loc5_].name;
        }
        if (this.play_type == "missions") {
          _loc12_ += this.FWP.TEAMS_DEF["mission" + _loc5_].name;
        }
        if (this.play_type == "survival") {
          _loc12_ += this.FWP.TEAMS_DEF["survival" + _loc5_].name;
        }
        if (this.play_type == "boss") {
          _loc12_ += this.FWP.TEAMS_DEF["boss" + _loc5_].name;
        }
        if (_loc5_ == _loc11_) {
          _loc12_ += "</b>";
        }
        this.buttons["fight" + _loc5_].task_name.htmlText = _loc12_;
        this.buttons["fight" + _loc5_].name = _loc5_;
        _loc5_++;
      }
      this.cur_element = _loc11_;
      // PORT: the rows fit the list's 16 rows of 20 px (the original: 16 rows or fewer).
      if (_loc11_ * pitch <= 16 * ROW) {
        _loc9_.slider.visible = false;
      } else {
        // PORT: the fight screen's slider range (init_slider "fight"), not the one of the last slider dragged.
        this.init_slider("fight", "slider");
        _loc9_.choose_container.y = 200 - (_loc9_.choose_container.height - 20 - (this.slider_bottom - this.slider_top));
        _loc9_.slider.y = this.slider_bottom;
      }
      _loc9_[this.play_type].visible = false;
      // PORT: design D5 - the sixth mode "Онлайн" (the 'online' button of the mode board, an asset patch): the fight
      // PORT: screen is the online lobby (runtime/online-lobby.ts): the open rooms in the task list, the chosen room's
      // PORT: map and teams on the left, the controls to create a room or join one by its code below them. They are
      // PORT: added here, before the listeners of the screen's children are set up.
      if (this.play_type == "online" && this.FWP.online) {
        this.FWP.online.build_fight(_loc9_);
      }
    }
    if (_loc9_.papa_container) {
      _loc5_ = 1;
      while (_loc5_ <= 2) {
        _loc6_ = 1;
        while (_loc6_ <= 5) {
          _loc10_++;
          this.buttons["wp_buy_" + _loc10_] = this.FWP.container_interf.get_object("buy_weapon");
          _loc9_.papa_container.addChild(this.buttons["wp_buy_" + _loc10_]);
          this.buttons["wp_buy_" + _loc10_].x = (_loc6_ - 1) * 70;
          this.buttons["wp_buy_" + _loc10_].y = (_loc5_ - 1) * 110;
          this.bitmaps["shop" + _loc10_] = new Bitmap();
          this.bitmap_datas["shop" + _loc10_] = new BitmapData(50, 50, true, 0);
          this.bitmaps["shop" + _loc10_].bitmapData = this.bitmap_datas["shop" + _loc10_];
          this.buttons["wp_buy_" + _loc10_].addChild(this.bitmaps["shop" + _loc10_]);
          this.bitmaps["shop" + _loc10_].x = 5;
          this.bitmaps["shop" + _loc10_].y = 5;
          // PORT: UNVERIFIED Flash pick order: the click handler selects an item only when the event target is the item
          // PORT: itself ("weapon_<id>" / "clickperk_<id>"), but under AVM2 mouse picking (interactive children before
          // PORT: non-interactive ones, as in Ruffle's mouse_pick_avm2) a click on the icon targets the filled "back"
          // PORT: child and nothing is selected. mouseChildren = false makes the whole slot the target.
          this.buttons["wp_buy_" + _loc10_].mouseChildren = false;
          _loc6_++;
        }
        _loc5_++;
      }
    }
    if (_loc9_.what_opened_container) {
      _loc5_ = 1;
      while (_loc5_ <= 5) {
        _loc6_ = 1;
        while (_loc6_ <= 2) {
          _loc10_++;
          this.buttons["what_op_" + _loc10_] = this.FWP.container_interf.get_object("clip_what_opened");
          _loc9_.what_opened_container.addChild(this.buttons["what_op_" + _loc10_]);
          this.buttons["what_op_" + _loc10_].x = (_loc6_ - 1) * 200;
          this.buttons["what_op_" + _loc10_].y = (_loc5_ - 1) * 50;
          this.bitmaps["what_op_" + _loc10_] = new Bitmap();
          this.bitmap_datas["what_op_" + _loc10_] = new BitmapData(50, 50, true, 0);
          this.bitmaps["what_op_" + _loc10_].bitmapData = this.bitmap_datas["what_op_" + _loc10_];
          this.buttons["what_op_" + _loc10_].addChild(this.bitmaps["what_op_" + _loc10_]);
          _loc6_++;
        }
        _loc5_++;
      }
    }
    if (_loc9_.grave_search_container) {
      _loc5_ = 1;
      while (_loc5_ <= 8) {
        _loc6_ = 1;
        while (_loc6_ <= 2) {
          _loc10_++;
          this.buttons["gsearch_" + _loc10_] = this.FWP.container_interf.get_object("clip_grave_search");
          _loc9_.grave_search_container.addChild(this.buttons["gsearch_" + _loc10_]);
          this.buttons["gsearch_" + _loc10_].x = (_loc6_ - 1) * 200;
          this.buttons["gsearch_" + _loc10_].y = (_loc5_ - 1) * 40;
          this.buttons["gsearch_" + _loc10_].name = String("gsearch_" + _loc10_);
          _loc6_++;
        }
        _loc5_++;
      }
    }
    if (_loc9_.roul_or_grave_result_icon) {
      this.bitmaps["roul_or_grave_result_icon"] = new Bitmap();
      this.bitmap_datas["roul_or_grave_result_icon"] = new BitmapData(50, 50, true, 0);
      this.bitmaps["roul_or_grave_result_icon"].bitmapData = this.bitmap_datas["roul_or_grave_result_icon"];
      _loc9_.roul_or_grave_result_icon.addChild(this.bitmaps["roul_or_grave_result_icon"]);
    }
    if (_loc9_.tasks_container) {
      _loc11_ = Math.min(this.FWP.player.cur_task, this.FWP.TASK_DEF[0]);
      _loc5_ = 1;
      // PORT (wide screens): a phone's rows a finger's target apart (ui/wide-lists.ts); the tasks not reached yet (hidden
      // PORT: by render) lie under the last one reached there, so the list's height (its scrolling) is the shown rows'.
      const pitch: number = listPitch(this.stage);
      while (_loc5_ <= this.FWP.TASK_DEF[0]) {
        this.buttons["tsk" + _loc5_] = this.FWP.container_interf.get_object("clip_task");
        _loc9_.tasks_container.addChild(this.buttons["tsk" + _loc5_]);
        this.buttons["tsk" + _loc5_].x = 0;
        this.buttons["tsk" + _loc5_].y = pitch == ROW ? (_loc5_ - 1) * 20 : (Math.min(_loc5_, Math.max(1, _loc11_)) - 1) * pitch;
        this.buttons["tsk" + _loc5_].name = _loc5_;
        _loc5_++;
      }
      if (_loc11_ * pitch <= 22 * ROW) {
        _loc9_.slider.visible = false;
      } else {
        // PORT: the tasks' slider range (init_slider "tasks"), not the one of the last slider dragged.
        this.init_slider("tasks");
        _loc9_.tasks_container.y = 118 - (_loc9_.tasks_container.height - 20 - (this.slider_bottom - this.slider_top));
        _loc9_.slider.y = this.slider_bottom;
      }
    }
    if (_loc9_.replay_info_zone) {
      this.bitmaps["replay_weapons"] = new Bitmap();
      this.bitmap_datas["replay_weapons"] = new BitmapData(250, 100, true, 0);
      this.bitmaps["replay_weapons"].bitmapData = this.bitmap_datas["replay_weapons"];
      _loc9_.replay_info_zone.replay_container.addChild(this.bitmaps["replay_weapons"]);
    }
    if (param1 == "just_play") {
      this.cur_element = 1;
      _loc13_ = new Array<any>(0, 0, 14, 26, 39, 51);
      _loc5_ = 1;
      // PORT (wide screens): a phone's rows a finger's target apart (ui/wide-lists.ts), all five in the list's mask
      // PORT: (182..433: the list has no slider).
      const pitch: number = listPitch(this.stage, 5, 251);
      while (_loc5_ <= 5) {
        this.buttons["just" + _loc5_] = this.FWP.container_interf.get_object("choose_task");
        _loc9_.just_play_container.addChild(this.buttons["just" + _loc5_]);
        this.buttons["just" + _loc5_].x = 0;
        this.buttons["just" + _loc5_].y = (_loc5_ - 1) * pitch;
        this.buttons["just" + _loc5_].task_name.htmlText = "Карта №" + _loc5_;
        this.buttons["just" + _loc5_].name = _loc5_;
        this.buttons["just" + _loc5_].visible = _loc8_.career_max >= _loc13_[_loc5_];
        _loc5_++;
      }
    }
    if (param1 == "game") {
      _loc9_.wind_container.addChild(this.WindBar);
      this.WindBar.x = 704;
      this.WindBar.y = 23;
      this.SecondBitmapData = new BitmapData(153, 89, true, 0);
      this.SecondBitmap.bitmapData = this.SecondBitmapData;
      _loc9_.inv_button.addEventListener(MouseEvent.MOUSE_DOWN, this.click_game_invisible, false, 0, true);
      _loc9_.inv_button.addEventListener(MouseEvent.MOUSE_UP, this.click_game_invisible, false, 0, true);
      _loc9_.inv_button.addEventListener(MouseEvent.DOUBLE_CLICK, this.click_game_invisible, false, 0, true);
      _loc9_.inv_button.doubleClickEnabled = true;
      _loc9_.distance_container.addChild(this.distance_box_container);
    }
    if (param1 == "arsenal") {
      _loc9_.weapon_name.text = "Арсенал";
      _loc9_.weapon_desc.htmlText = "Здесь вы можете посмотреть, какое оружие имеется у вас в наличии, а также собрать из составляющих компонентов новые типы вооружения (кнопка Крафтинг). Однако, для крафтинга вам необходима одноименная способность Крафтинг, которую можно взять с 10 уровня.\n\nПолупрозрачными отмечены те оружия, которые даются вам в виде гуманитарной помощи при прохождении подавляющего большинства заданий.";
      this.ThirdBitmapData = new BitmapData(153, 428, true, 0);
      this.ThirdBitmap.bitmapData = this.ThirdBitmapData;
    }
    // PORT: item 8 - the clan screens (and the best clans, the clan questions) load what they show and add their own
    // PORT: controls, before the screen's children get their click and hover listeners.
    if (this.FWP.clans && (param1 == "clan_hub" || param1 == "clan_card" || param1 == "clan_edit" || param1 == "clans" || (param1 == "question" && String(param2).indexOf("clan_") == 0))) {
      this.FWP.clans.enter(param1, param2);
      this.FWP.clans.build(param1, _loc9_);
    }
    _loc5_ = 0;
    while (_loc5_ <= _loc9_.numChildren - 1) {
      _loc9_.getChildAt(_loc5_).addEventListener(MouseEvent.CLICK, this.click, false, 0, true);
      _loc9_.getChildAt(_loc5_).addEventListener(MouseEvent.MOUSE_OVER, this.mouse_event, false, 0, true);
      _loc9_.getChildAt(_loc5_).addEventListener(MouseEvent.MOUSE_OUT, this.mouse_event, false, 0, true);
      _loc9_.getChildAt(_loc5_).addEventListener(MouseEvent.MOUSE_DOWN, this.mouse_event, false, 0, true);
      _loc9_.getChildAt(_loc5_).addEventListener(MouseEvent.MOUSE_UP, this.mouse_event, false, 0, true);
      _loc5_++;
    }
    if (param1 == "settings") {
      _loc9_.worm_name1.addEventListener(Event.CHANGE, this.check_tf, false, 0, true);
      _loc9_.worm_name2.addEventListener(Event.CHANGE, this.check_tf, false, 0, true);
      _loc9_.worm_name3.addEventListener(Event.CHANGE, this.check_tf, false, 0, true);
      _loc9_.worm_name4.addEventListener(Event.CHANGE, this.check_tf, false, 0, true);
      _loc9_.worm_name5.addEventListener(Event.CHANGE, this.check_tf, false, 0, true);
    }
    // PORT: design D5 - the online mode of the fight screen asks the server for the open rooms (or goes back to the
    // PORT: player's room); the VK friends list this screen's tab once loaded is gone (net_get_friends).
    if (param1 == "fight" && this.play_type == "online" && this.FWP.online) {
      this.FWP.online.enter();
    }
    if (param1 == "top") {
      this.top_mode = 1;
      this.FWP.net_get_top_members();
      _loc9_.top_by_level.visible = false;
    }
    if (param1 == "user_info") {
      this.FWP.net_get_user_info(this.opened_user_uid, param3);
    }
    if (param1 == "replay") {
      this.FWP.net_get_notes();
    }
    if (param1 == "assault") {
      this.FWP.net_get_assault();
    }
    if (param1 != "assault" && param1 != "top" && param1 != "replay" && param1 != "user_info" && param1 != "end_game_surprise") {
      this.render();
    }
    // PORT (touch screens): the weapon sheet opens describing the worm's weapon (sheet_idle_text).
    if (param1 == "weapon_sheet") {
      this.sheet_idle_text(_loc9_);
    }
    // PORT: the new level with the ability "Surprise" is rendered by its caller (init_new_level); its VK wall post is
    // PORT: hidden from the start all the same (render's hide_named_children).
    if (param1 == "end_game_surprise") {
      this.hide_named_children(_loc9_, ["post_new_level", "post_win_game"]);
      this.centre_lone_button(_loc9_, "what_opened", "post_new_level");
    }
    this.setChildIndex(this.popup, this.numChildren - 1);
    this.popup.visible = false;
    if (param4) {
      _loc9_.y = -600;
    }
  }

  mainframe_animation(): any {
    let _loc1_: any = this.cur_screen[this.cur_screen[0]].link;
    if (this.cur_screen[this.cur_screen[0]].name == "mainframe") {
      if (this.mf_shop_freeze == 0) {
        _loc1_.shop_anim.gotoAndStop(Math.round(this.mf_shop_frame));
        this.mf_shop_frame += 0.5;
      }
      if (this.mf_shop_freeze != 0) {
        --this.mf_shop_freeze;
        this.mf_shop_frame = 26;
      }
      if (this.mf_shop_frame == 25) {
        this.mf_shop_freeze = this.FWP.true_random(50, 100);
      }
      if (this.mf_shop_frame == 80) {
        if (this.FWP.true_random(0, 3) == 0) {
          this.mf_shop_frame = 81;
        } else {
          this.mf_shop_frame = 1;
        }
      }
      if (this.mf_shop_frame == 210) {
        this.mf_shop_frame = 1;
      }
    }
  }

  render(param1: boolean = false): any {
    let _loc35_: any = undefined;
    let _loc2_: any = undefined;
    let _loc3_: any = undefined;
    let _loc4_: any = undefined;
    let _loc5_: any = undefined;
    let _loc6_: any = undefined;
    let _loc7_: any = undefined;
    let _loc8_: any = undefined;
    let _loc9_: any = undefined;
    let _loc10_: any = undefined;
    let _loc11_: any = undefined;
    let _loc12_: any = undefined;
    let _loc13_: any = undefined;
    let _loc14_: any = undefined;
    let _loc15_: any = undefined;
    let _loc16_: any = undefined;
    let _loc17_: any = undefined;
    let _loc18_: any = undefined;
    let _loc19_: any = undefined;
    let _loc20_: any = undefined;
    let _loc21_: any = undefined;
    let _loc22_: any = undefined;
    let _loc23_: any = undefined;
    let _loc24_: any = undefined;
    let _loc25_: any = undefined;
    let _loc26_: any = undefined;
    let _loc27_: any = undefined;
    let _loc28_: any = undefined;
    let _loc29_: any = undefined;
    let _loc30_: any = undefined;
    let _loc31_: any = undefined;
    let _loc32_: any = undefined;
    let _loc33_: any = undefined;
    let _loc34_: any = undefined;
    let _loc36_: any = undefined;
    let _loc37_: any = undefined;
    let _loc38_: any = undefined;
    let _loc39_: any = undefined;
    let _loc40_: any = undefined;
    let _loc41_: any = undefined;
    let _loc42_: any = undefined;
    let _loc43_: any = undefined;
    let _loc44_: any = undefined;
    let _loc45_: any = undefined;
    let _loc46_: any = undefined;
    let _loc47_: any = undefined;
    let _loc48_: any = undefined;
    let _loc49_: any = undefined;
    let _loc50_: any = undefined;
    let _loc51_: any = undefined;
    let _loc52_: any = undefined;
    let _loc53_: any = undefined;
    let _loc54_: any = undefined;
    let _loc55_: any = undefined;
    let _loc56_: any = undefined;
    let _loc57_: any = undefined;
    let _loc58_: any = undefined;
    let _loc59_: any = undefined;
    let _loc60_: any = undefined;
    let _loc61_: any = undefined;
    let _loc62_: any = undefined;
    let _loc63_: any = undefined;
    let _loc64_: any = undefined;
    let _loc65_: any = undefined;
    let _loc66_: any = undefined;
    let _loc67_: any = undefined;
    let _loc68_: any = undefined;
    let _loc69_: any = undefined;
    let _loc70_: any = undefined;
    let _loc71_: any = undefined;
    let _loc72_: any = undefined;
    let _loc73_: any = undefined;
    let _loc74_: any = undefined;
    let _loc75_: any = undefined;
    let _loc76_: any = undefined;
    let _loc77_: any = undefined;
    let _loc78_: any = undefined;
    let _loc79_: any = undefined;
    let _loc80_: any = undefined;
    let _loc81_: any = undefined;
    let _loc82_: any = undefined;
    let _loc83_: any = undefined;
    let _loc84_: any = undefined;
    let _loc85_: any = undefined;
    let _loc86_: any = undefined;
    let _loc87_: any = undefined;
    let _loc88_: any = undefined;
    let _loc89_: any = undefined;
    let _loc90_: any = undefined;
    let _loc91_: any = undefined;
    let _loc92_: any = undefined;
    let _loc93_: any = undefined;
    let _loc94_: any = undefined;
    let _loc95_: any = undefined;
    let _loc96_: any = undefined;
    let _loc97_: any = undefined;
    let _loc98_: any = undefined;
    let _loc99_: any = undefined;
    let _loc100_: any = undefined;
    let _loc101_: any = undefined;
    let _loc102_: any = undefined;
    let _loc103_: any = undefined;
    let _loc104_: any = undefined;
    let _loc105_: any = undefined;
    let _loc106_: any = undefined;
    let _loc107_: any = undefined;
    let _loc108_: any = undefined;
    let _loc109_: any = undefined;
    let _loc110_: any = undefined;
    let _loc111_: any = undefined;
    let _loc112_: any = undefined;
    let _loc113_: any = undefined;
    let _loc114_: any = undefined;
    let _loc115_: any = undefined;
    let _loc116_: any = undefined;
    let _loc117_: any = undefined;
    let _loc118_: any = undefined;
    let _loc119_: any = undefined;
    let _loc120_: any = undefined;
    let _loc121_: any = undefined;
    let _loc122_: any = undefined;
    let _loc123_: any = undefined;
    let _loc124_: any = undefined;
    let _loc125_: any = undefined;
    let _loc126_: any = null;
    let _loc127_: any = undefined;
    let _loc128_: any = undefined;
    let _loc129_: any = undefined;
    let _loc130_: any = undefined;
    let _loc131_: any = undefined;
    let _loc132_: any = undefined;
    let _loc133_: any = undefined;
    let _loc134_: any = undefined;
    let _loc135_: any = undefined;
    let _loc136_: any = undefined;
    let _loc137_: any = undefined;
    let _loc138_: any = undefined;
    let _loc139_: any = undefined;
    let _loc140_: any = undefined;
    let _loc141_: any = undefined;
    let _loc142_: any = undefined;
    let _loc143_: any = undefined;
    let _loc144_: any = undefined;
    let _loc145_: any = undefined;
    let _loc146_: any = undefined;
    let _loc147_: any = undefined;
    let _loc148_: any = undefined;
    let _loc149_: any = undefined;
    let _loc150_: any = undefined;
    let _loc151_: any = undefined;
    let _loc152_: any = null;
    let _loc153_: any = undefined;
    let _loc154_: any = undefined;
    let _loc155_: any = undefined;
    let _loc156_: any = undefined;
    let _loc157_: any = undefined;
    let _loc158_: any = undefined;
    let _loc159_: any = undefined;
    let _loc160_: any = undefined;
    let _loc161_: any = undefined;
    let _loc162_: any = undefined;
    let _loc163_: any = undefined;
    let _loc164_: any = undefined;
    let _loc165_: any = undefined;
    let _loc166_: any = undefined;
    let _loc167_: any = undefined;
    let _loc168_: any = undefined;
    let _loc169_: any = undefined;
    let _loc170_: any = undefined;
    let _loc171_: any = undefined;
    let _loc172_: any = undefined;
    let _loc173_: any = undefined;
    let _loc174_: any = null;
    let _loc175_: any = undefined;
    let _loc176_: any = undefined;
    let _loc177_: any = undefined;
    let _loc178_: any = undefined;
    let _loc179_: any = undefined;
    let _loc180_: any = undefined;
    let _loc181_: any = undefined;
    let _loc182_: number = NaN;
    let _loc183_: any = undefined;
    let _loc184_: any = undefined;
    let _loc185_: any = undefined;
    let _loc186_: number = NaN;
    let _loc187_: any = undefined;
    let _loc188_: any = undefined;
    let _loc189_: any = undefined;
    let _loc190_: any = undefined;
    let _loc191_: any = undefined;
    let _loc192_: any = undefined;
    let _loc193_: any = undefined;
    let _loc194_: any = undefined;
    let _loc195_: any = undefined;
    let _loc196_: any = undefined;
    let _loc197_: any = undefined;
    let _loc198_: any = undefined;
    let _loc199_: any = undefined;
    let _loc200_: any = undefined;
    let _loc201_: any = undefined;
    let _loc202_: any = undefined;
    let _loc203_: any = undefined;
    let _loc204_: any = undefined;
    let _loc205_: any = undefined;
    if (this.cur_screen[this.cur_screen[0]].name != "settings" && this.cur_screen[this.cur_screen[0]].name != "buy_perk" && this.cur_screen[this.cur_screen[0]].name != "choose_perk" && this.cur_screen[this.cur_screen[0]].name != "view_perks" && this.cur_screen[this.cur_screen[0]].name != "question") {
      this.MainBitmapData.fillRect(new Rectangle(0, 0, this.MainBitmap.width, this.MainBitmap.height), 0);
    }
    _loc32_ = this.cur_screen[this.cur_screen[0]].link;
    _loc33_ = this.FWP.temp_player;
    _loc34_ = this.FWP.player;
    _loc35_ = {
      "attack": _loc34_.attack.value,
      "protect": _loc34_.protect.value,
      "health": 100 + 50 * _loc34_.health.value,
      "worms": 2 + _loc34_.worms.value,
      "tired": _loc34_.tired,
      "stim_to_fight": _loc34_.stim_to_fight,
      "impl": _loc34_.cur_impl
    };
    _loc36_ = this.FWP.get_affected_skills(_loc35_);
    if (this.cur_screen[this.cur_screen[0]].name == "mainframe") {
      _loc32_.announcement_achiev.visible = this.FWP.get_achiev_bonus().exist;
      _loc32_.announcement_task.visible = !(_loc34_.cur_task == 31 && _loc34_.last_presented_task == 31);
      if (this.FWP.get_task_bonus().exist) {
        _loc32_.announcement_task.gotoAndPlay(1);
      } else {
        _loc32_.announcement_task.gotoAndStop(1);
      }
      _loc32_.my_level.text = _loc34_.level.value;
      _loc32_.gold.text = this.x3SHString(_loc34_.gold.value);
      _loc32_.diam.text = this.x3SHString(_loc34_.diam.value);
      _loc32_.exp_bar.width = (_loc34_.exp.value - this.FWP.LEVEL_THRESHOLD[_loc34_.level.value]) / (this.FWP.LEVEL_THRESHOLD[_loc34_.level.value + 1] - this.FWP.LEVEL_THRESHOLD[_loc34_.level.value]) * 111;
      _loc32_.tired_bar.width = 111 * Math.min(100, _loc36_.tired) / 100;
      // PORT: LOCAL_TEST (the developer's offline switch of the VK build) removed.
      if (Boolean(this.FWP.image_loaders["id" + this.FWP.user.user_id])) {
        _loc32_.avatar_container.addChild(this.FWP.image_loaders["id" + this.FWP.user.user_id]);
      }
      // PORT: no VK photo any more: the portrait of the player's specialisation (a team of worms before one) in the
      // PORT: plate's picture frame (ui/avatar.ts), not an empty white square.
      showAvatar(this.FWP, _loc32_.avatar_container, _loc34_.spec, AVATAR_PLATE);
      // PORT: diamonds are bought where the game has a store's offers (runtime/monetization-ui.ts; the skeleton of the
      // PORT: shop without payments too): without them the "+" beside them is hidden; the one beside the gold opens
      // PORT: the exchange of diamonds for gold (with the store: its gold packs).
      // PORT: (a child of the screen, or of the HUD group the wide screen gathered it into: ui/wide-screen.ts)
      for (let k: number = 0; k < _loc32_.numChildren; k++) {
        const c: any = _loc32_.getChildAt(k);
        const group: any = String(c.name).indexOf("$wide_hud_") == 0 ? c : null;
        for (let j: number = 0; j < (group ? group.numChildren : 1); j++) {
          const b: any = group ? group.getChildAt(j) : c;
          if (b.name == "donate" && b.x > 700) {
            b.visible = storeOffered(this.FWP);
          }
        }
      }
      _loc32_.music.gotoAndStop(this.FWP.MUSIC ? 1 : 2);
      _loc32_.sound.gotoAndStop(this.FWP.SOUND ? 1 : 2);
      _loc32_.init_papa_john_active.visible = this.FWP.PAPA_HERE;
      // PORT: the signed-in player's nickname next to the level box (ui/profile-badge.ts; the level stays in my_level
      // PORT: only); hovering it shows the full nickname in the hover popup (popup_modify "my_nickname").
      profilePlate(_loc32_, this.FWP, this.mouse_event);
      // PORT: the chat button with its unread badge (ui/chat-panel.ts; a HUD group of its own on a wide screen).
      chatButton(_loc32_, this.FWP);
    }
    if (this.cur_screen[this.cur_screen[0]].name == "present") {
      _loc32_.main.text = "Вы получили : ";
      _loc2_ = 1;
      while (_loc2_ <= 10) {
        _loc32_["present" + _loc2_].gotoAndStop(_loc2_ <= this.FWP.player.tween ? 2 : 1);
        _loc2_++;
      }
      // PORT: VK removed: the "add the admin as a VK friend for a double bonus" hint and button.
      _loc32_.admin_bonus.text = "";
      _loc32_.open_admin.visible = false;
      // PORT: fixed defect: the button's grey plate (an unnamed shape of the timeline under it) stayed, an inactive
      // PORT: button at the window's corner; it goes with the button. The window's own "Accept" (and on a phone the
      // PORT: opt-in ad that doubles the present) is runtime/monetization-ui.ts renderPresent.
      const _ab: any = _loc32_.open_admin.getBounds(_loc32_);
      for (let _k: number = 0; _k < _loc32_.numChildren; _k++) {
        const _c: any = _loc32_.getChildAt(_k);
        if (_c === _loc32_.open_admin || !/^instance\d+$/.test(String(_c.name))) {
          continue;
        }
        const _b: any = _c.getBounds(_loc32_);
        if (Math.abs(_b.x - _ab.x) < 2 && Math.abs(_b.y - _ab.y) < 2 && Math.abs(_b.width - _ab.width) < 2 && Math.abs(_b.height - _ab.height) < 2) {
          _c.visible = false;
        }
      }
      // PORT: VK removed: the x2 present of an ADMIN_FRIEND (the admin's VK friend); the present is always x1.
      if (this.FWP.player.tween == 1) {
        _loc32_.main.text += "50 золота !";
      }
      if (this.FWP.player.tween == 2) {
        _loc32_.main.text += "100 золота !";
      }
      if (this.FWP.player.tween == 3) {
        _loc32_.main.text += "150 золота !";
      }
      if (this.FWP.player.tween == 4) {
        _loc32_.main.text += "200 золота !";
      }
      if (this.FWP.player.tween == 5) {
        _loc32_.main.text += "250 золота !";
      }
      if (this.FWP.player.tween == 6) {
        _loc32_.main.text += "300 золота !";
      }
      if (this.FWP.player.tween == 7) {
        _loc32_.main.text += "400 золота !";
      }
      if (this.FWP.player.tween == 8) {
        _loc32_.main.text += "500 золота !";
      }
      if (this.FWP.player.tween == 9) {
        _loc32_.main.text += "1 алмаз !";
      }
      if (this.FWP.player.tween >= 10) {
        _loc32_.main.text += "5 очков навыков !";
      }
    }
    if (this.cur_screen[this.cur_screen[0]].name == "skills") {
      _loc38_ = {
        "attack": _loc33_.attack.value,
        "protect": _loc33_.protect.value,
        "health": 100 + 50 * _loc33_.health.value,
        "worms": 2 + _loc33_.worms.value,
        "tired": _loc34_.tired,
        "stim_to_fight": _loc34_.stim_to_fight,
        "impl": _loc34_.cur_impl
      };
      _loc39_ = this.FWP.get_affected_skills(_loc38_);
      _loc32_.skill_attack.htmlText = "<b><font color=" + this.FWP.get_var_color(_loc33_.attack.value, _loc39_.attack) + ">" + _loc39_.attack + "</font></b>";
      _loc32_.skill_protect.htmlText = "<b><font color=" + this.FWP.get_var_color(_loc33_.protect.value, _loc39_.protect) + ">" + _loc39_.protect + "</font></b>";
      _loc32_.skill_health.htmlText = "<b><font color=" + this.FWP.get_var_color(_loc33_.health.value * 50 + 100, _loc39_.health) + ">" + _loc39_.health + "</font></b>";
      _loc32_.skill_worms.text = _loc33_.worms.value + 2;
      _loc32_.skill_pts.text = _loc33_.skill_pts.value;
      _loc32_.add_attack.visible = _loc33_.skill_pts.value >= this.FWP.get_attack_cost(_loc33_.attack.value);
      _loc32_.add_protect.visible = _loc33_.skill_pts.value >= this.FWP.get_attack_cost(_loc33_.protect.value);
      _loc32_.add_health.visible = _loc33_.skill_pts.value >= 30;
      _loc32_.add_team_worm.visible = _loc33_.skill_pts.value >= 150 && _loc33_.worms.value < 3;
      _loc32_.spec.text = this.FWP.spec_to_name(_loc33_.spec);
      _loc32_.choose_spec.visible = _loc33_.spec == 0;
      _loc40_ = "";
      if (this.FWP.get_attack_cost(_loc33_.attack.value) == 1) {
        _loc40_ = "о";
      } else if (this.FWP.get_attack_cost(_loc33_.attack.value) < 5) {
        _loc40_ = "а";
      } else {
        _loc40_ = "ов";
      }
      _loc41_ = "";
      if (this.FWP.get_attack_cost(_loc33_.protect.value) == 1) {
        _loc41_ = "о";
      } else if (this.FWP.get_attack_cost(_loc33_.protect.value) < 5) {
        _loc41_ = "а";
      } else {
        _loc41_ = "ов";
      }
      _loc32_.desc_attack.htmlText = "Влияет на урон врагу, наносимый вашими червяками. Повышение Атаки на <b>1</b> пункт стоит <b>" + this.FWP.get_attack_cost(_loc33_.attack.value) + "</b> очк" + _loc40_ + " навыков.";
      _loc32_.desc_protect.htmlText = "Чем больше Защита, тем меньший урон вы получаете от снарядов врага. Повышение Защиты на <b>1</b> пункт стоит <b>" + this.FWP.get_attack_cost(_loc33_.protect.value) + "</b> очк" + _loc41_ + " навыков.";
      _loc32_.perk_pts.text = _loc33_.perk_pts.value;
      _loc2_ = 1;
      while (_loc2_ <= 9) {
        _loc32_["buy_perk" + String(_loc2_)].visible = _loc33_.perk_slots < _loc2_;
        _loc32_["add_perk" + String(_loc2_)].visible = _loc33_.perk_slots < _loc2_;
        _loc32_["upg_perk" + String(_loc2_)].visible = false;
        _loc32_["upg_inact_perk" + String(_loc2_)].visible = false;
        _loc2_++;
      }
      _loc42_ = new Array();
      _loc43_ = 0;
      for (_loc14_ of as3.keys(_loc33_.perks)) {
        _loc42_[_loc43_] = new Array<any>(this.FWP.PERKS_DEF[_loc14_].id, _loc14_);
        _loc43_++;
      }
      as3.sortOn(_loc42_, "0", as3.ArrayFlags.NUMERIC);
      _loc44_ = 0;
      this.perk_places = new Array();
      _loc15_ = 0;
      _loc16_ = 0;
      _loc2_ = 1;
      while (_loc2_ <= _loc43_) {
        _loc14_ = _loc42_[_loc2_ - 1][1];
        this.perk_places[_loc2_] = _loc14_;
        this.MainBitmapData.copyPixels(this.PerksSheet, new Rectangle(0, (this.FWP.PERKS_DEF[_loc14_].id - 1) * 47, 47, 47), new Point(_loc15_, _loc16_));
        this.MainBitmapData.copyPixels(this.PerkLevels[_loc33_.perks[_loc14_]], new Rectangle(0, 0, 47, 47), new Point(_loc15_, _loc16_), null, null, true);
        this.MainBitmapData.copyPixels(this.WPBox, new Rectangle(0, 0, 47, 46), new Point(_loc15_, _loc16_), null, null, true);
        _loc32_["upg_perk" + String(_loc2_)].visible = _loc33_.perks[_loc14_] >= 1 && _loc33_.perks[_loc14_] < this.FWP.PERKS_DEF[_loc14_].max_lim && _loc33_.perk_pts.value >= this.FWP.PERKS_DEF[_loc14_].upg[_loc33_.perks[_loc14_]];
        _loc32_["upg_inact_perk" + String(_loc2_)].visible = true;
        _loc15_ += 130;
        if (_loc15_ >= 390) {
          _loc15_ = 0;
          _loc16_ += 54;
        }
        _loc2_++;
      }
      _loc2_ = _loc43_ + 1;
      while (_loc2_ <= 9) {
        _loc32_["add_perk" + String(_loc2_)].visible = _loc33_.perk_slots >= _loc2_;
        this.MainBitmapData.copyPixels(this.WPBox, new Rectangle(0, 0, 47, 46), new Point(_loc15_, _loc16_), null, null, true);
        _loc15_ += 130;
        if (_loc15_ >= 390) {
          _loc15_ = 0;
          _loc16_ += 54;
        }
        _loc2_++;
      }
      _loc32_.restore.visible = this.changes_made;
      _loc32_.svtemp.visible = this.changes_made;
    }
    if (this.cur_screen[this.cur_screen[0]].name == "choose_perk" || this.cur_screen[this.cur_screen[0]].name == "view_perks") {
      _loc32_.perk_pts.text = _loc33_.perk_pts.value;
      _loc46_ = new Array();
      _loc47_ = 0;
      _loc46_[0] = new Array<any>(0, "");
      for (_loc48_ of as3.keys(this.FWP.PERKS_DEF)) {
        if (this.perks_mode == this.FWP.PERKS_DEF[_loc48_].mode || this.perks_mode == "all") {
          _loc46_[_loc47_] = new Array<any>(this.FWP.PERKS_DEF[_loc48_].id, _loc48_, this.FWP.PERKS_DEF[_loc48_].upg[0]);
          _loc47_++;
        }
      }
      _loc49_ = (this.shop_page - 1) * 28 + 1;
      _loc50_ = Math.min(_loc47_, _loc49_ + 27);
      _loc51_ = Math.ceil(_loc47_ / 28);
      _loc32_.choose_page.gotoAndStop(_loc51_);
      as3.sortOn(_loc46_, "2", as3.ArrayFlags.NUMERIC);
      _loc52_ = new Array<any>({ "id": "all", "name": "Все способности" }, { "id": "wptype", "name": "Урон по типам оружия" }, { "id": "wpmode", "name": "Урон по режимам оружия" }, { "id": "dother", "name": "Урон (прочее)" }, { "id": "dres", "name": "Сопротивление урону" }, { "id": "crit", "name": "Критический выстрел" }, { "id": "fail", "name": "Шанс осечки" }, { "id": "char", "name": "Улучшение характеристик" }, { "id": "int", "name": "Обучаемость" }, { "id": "other", "name": "Прочее небоевое" });
      _loc32_.filt.gotoAndStop(this.opened_filter ? 2 : 1);
      for (_loc53_ of as3.keys(_loc52_)) {
        if (this.perks_mode == _loc52_[_loc53_].id) {
          _loc32_.filt.cur_filt.text = _loc52_[_loc53_].name;
        }
      }
      if (this.opened_filter) {
        for (_loc53_ of as3.keys(_loc52_)) {
          _loc55_ = _loc52_[_loc53_].name;
          if (this.perks_mode == _loc52_[_loc53_].id) {
            _loc55_ = "<b>" + _loc52_[_loc53_].name + "</b>";
          }
          _loc32_.filt["perk_mode_" + _loc52_[_loc53_].id].htmlText = _loc55_;
          _loc32_.filt["perk_mode_" + _loc52_[_loc53_].id].textColor = this.perks_mode == _loc52_[_loc53_].id ? 16711680 : 0;
        }
      }
      _loc2_ = 1;
      while (_loc2_ <= _loc51_) {
        _loc32_.choose_page["page" + _loc2_].textColor = 7417088;
        _loc2_++;
      }
      _loc32_.choose_page["page" + this.shop_page].textColor = 16750848;
      _loc4_ = 0;
      _loc54_ = _loc49_;
      while (_loc54_ <= _loc50_) {
        _loc4_++;
        _loc14_ = _loc46_[_loc54_ - 1][1];
        this.buttons["pk_buy_" + _loc4_].visible = true;
        this.buttons["pk_buy_" + _loc4_].name = "clickperk_" + _loc14_;
        this.buttons["pk_buy_" + _loc4_].pts.text = this.FWP.PERKS_DEF[_loc14_].upg[0] + " очк.";
        this.bitmap_datas["cperk" + _loc4_].copyPixels(this.PerksSheet, new Rectangle(0, (this.FWP.PERKS_DEF[_loc14_].id - 1) * 47, 47, 47), new Point(0, 0));
        this.bitmap_datas["cperk" + _loc4_].copyPixels(this.WPBox, new Rectangle(0, 0, 47, 46), new Point(0, 0), null, null, true);
        this.buttons["pk_buy_" + _loc4_].back.gotoAndStop(1);
        if (_loc46_[_loc54_ - 1][0] == this.cur_element) {
          this.buttons["pk_buy_" + _loc4_].back.gotoAndStop(2);
        } else if (this.cur_screen[this.cur_screen[0]].name == "choose_perk" && (Boolean(_loc33_.perk_pts.value < this.FWP.PERKS_DEF[_loc14_].upg[0]) || Boolean(_loc33_.perks[_loc14_] && _loc33_.perks[_loc14_] > 0))) {
          this.bitmap_datas["cperk" + _loc4_].copyPixels(this.WPBlurGray, new Rectangle(0, 0, 47, 46), new Point(0, 0), null, null, true);
          this.buttons["pk_buy_" + _loc4_].back.gotoAndStop(3);
        }
        _loc54_++;
      }
      _loc54_ = _loc50_ + 1;
      while (_loc54_ <= _loc49_ + 27) {
        _loc4_++;
        this.buttons["pk_buy_" + _loc4_].visible = false;
        _loc54_++;
      }
      if (this.FWP.PERKS_DEF[this.cur_weapon]) {
        _loc32_.perk_name.text = this.FWP.PERKS_DEF[this.cur_weapon].name;
        _loc56_ = "";
        if (Boolean(_loc33_.perks[this.cur_weapon]) && _loc33_.perks[this.cur_weapon] > 0) {
          _loc56_ += "<font color=\"#660000\"><b>У вас уже есть эта способность</b></font>\n";
        }
        if (_loc33_.spec != 0) {
          _loc57_ = 0;
          while (_loc57_ <= 1) {
            if (this.FWP.SPEC_DEF[_loc33_.spec][_loc57_] == this.cur_weapon) {
              _loc56_ += "<font color=\"#660000\"><b>Эта способность уже предоставлена вам специальностью.</b></font>\n";
            }
            _loc57_++;
          }
        }
        _loc56_ += "<b>Уровней: </b>" + this.FWP.PERKS_DEF[this.cur_weapon].max_lim + "\n";
        _loc56_ = _loc56_ + ("<b>Стоимость: </b>" + this.FWP.PERKS_DEF[this.cur_weapon].upg[0] + " очк.\n");
        _loc56_ = _loc56_ + ("\n" + (this.perks_text[this.cur_weapon] ? this.perks_text[this.cur_weapon] : ""));
        _loc32_.perk_desc.htmlText = _loc56_;
      }
      if (this.cur_element <= 0) {
        _loc32_.perk_name.text = "Способности";
        _loc32_.perk_desc.htmlText = "Здесь вы можете выбрать себе любую способность. Механизм такой же, как в магазине: при клике на иконку способности здесь выведется ее описание; если у вас достаточно очков способностей, кнопка внизу станет активной.";
        _loc32_.add_p.visible = false;
      }
      if (this.cur_element > 0) {
        _loc58_ = false;
        for (_loc59_ of as3.keys(_loc33_.perks)) {
          if (_loc59_ == this.cur_weapon) {
            _loc58_ = true;
          }
        }
        _loc45_ = false;
        if (_loc33_.spec != 0) {
          _loc57_ = 0;
          while (_loc57_ <= 1) {
            if (this.FWP.SPEC_DEF[_loc33_.spec][_loc57_] == this.cur_weapon) {
              _loc45_ = true;
            }
            _loc57_++;
          }
        }
        _loc32_.add_p.visible = !_loc58_ && !_loc45_ && _loc33_.perk_pts.value >= this.FWP.PERKS_DEF[this.cur_weapon].upg[0];
      }
      _loc32_.view_perks_hide.visible = this.cur_screen[this.cur_screen[0]].name == "view_perks";
    }
    if (this.cur_screen[this.cur_screen[0]].name == "buy_perk") {
      _loc60_ = 0;
      _loc61_ = 0;
      if (_loc33_.perk_slots == 2) {
        _loc60_ = 500;
        _loc61_ = 1;
      }
      if (_loc33_.perk_slots == 3) {
        _loc60_ = 1000;
        _loc61_ = 1;
      }
      if (_loc33_.perk_slots == 4) {
        _loc60_ = 5000;
        _loc61_ = 5;
      }
      if (_loc33_.perk_slots == 5) {
        _loc60_ = 10000;
        _loc61_ = 10;
      }
      if (_loc33_.perk_slots == 6) {
        _loc60_ = 20000;
        _loc61_ = 20;
      }
      if (_loc33_.perk_slots == 7) {
        _loc60_ = 40000;
        _loc61_ = 40;
      }
      if (_loc33_.perk_slots == 8) {
        _loc60_ = 60000;
        _loc61_ = 60;
      }
      _loc32_.price_gold.text = this.x3String(_loc60_);
      _loc32_.price_diam.text = this.x3String(_loc61_);
      _loc32_.buy_gold.visible = _loc33_.gold.value >= _loc60_;
      _loc32_.buy_diam.visible = _loc33_.diam.value >= _loc61_;
    }
    if (this.cur_screen[this.cur_screen[0]].name == "arsenal") {
      _loc62_ = 0;
      while (_loc32_.arsenal_weapon_container.numChildren != 0) {
        if (++_loc62_ > 100000) {
          break;
        }
        _loc32_.arsenal_weapon_container.getChildAt(0).removeEventListener(MouseEvent.CLICK, this.click);
        _loc32_.arsenal_weapon_container.getChildAt(0).removeEventListener(MouseEvent.MOUSE_OVER, this.mouse_event);
        _loc32_.arsenal_weapon_container.getChildAt(0).removeEventListener(MouseEvent.MOUSE_OUT, this.mouse_event);
        _loc32_.arsenal_weapon_container.getChildAt(0).removeEventListener(MouseEvent.MOUSE_UP, this.mouse_event);
        _loc32_.arsenal_weapon_container.getChildAt(0).removeEventListener(MouseEvent.MOUSE_DOWN, this.mouse_event);
        _loc66_ = _loc32_.arsenal_weapon_container.getChildAt(0);
        _loc32_.arsenal_weapon_container.removeChildAt(0);
        _loc66_ = null;
      }
      if (this.shop_type == "weapons") {
        _loc30_ = this.FWP.WEAPONS_DEF;
        _loc31_ = _loc34_.weapons;
      }
      if (this.shop_type == "help") {
        _loc30_ = this.FWP.STIM_DEF;
        _loc31_ = _loc34_.stim_behave;
      }
      if (this.shop_type == "flags") {
        _loc30_ = this.FWP.FLAGS_DEF;
        _loc31_ = _loc34_.flags;
      }
      if (this.shop_type == "rip") {
        _loc30_ = this.FWP.RIPS_DEF;
        _loc31_ = _loc34_.rip;
      }
      if (this.shop_type == "impl") {
        _loc30_ = this.FWP.IMPL_DEF;
        _loc31_ = _loc34_.impl;
      }
      if (this.shop_type == "objs") {
        _loc30_ = this.FWP.OBJ_DEF;
        _loc31_ = _loc34_.objs;
      }
      _loc63_ = new Array();
      _loc64_ = 0;
      for (_loc65_ of as3.keys(_loc31_)) {
        if (this.shop_type == "weapons") {
          if (_loc31_[_loc65_][0] != 0 && _loc65_ != "skip_go") {
            _loc67_ = 0;
            _loc68_ = 0;
            for (_loc69_ of as3.keys(this.FWP.WP_PLACES_SORT)) {
              if (_loc65_ == this.FWP.WP_PLACES_SORT[_loc69_]) {
                break;
              }
            }
            _loc67_ = _loc69_;
            _loc70_ = 1;
            while (_loc70_ <= _loc31_[_loc65_][0]) {
              _loc71_ = true;
              _loc72_ = 0;
              while (_loc72_ < _loc64_) {
                if (_loc63_[_loc72_][0] == _loc30_[_loc65_].id && _loc63_[_loc72_][1] == _loc65_ && _loc63_[_loc72_][3].range == _loc31_[_loc65_][_loc70_].range && _loc63_[_loc72_][3].stolen == _loc31_[_loc65_][_loc70_].stolen && _loc63_[_loc72_][3].crafted == _loc31_[_loc65_][_loc70_].crafted) {
                  _loc71_ = false;
                  ++_loc63_[_loc72_][4];
                }
                _loc72_++;
              }
              if (_loc71_) {
                _loc63_[_loc64_] = new Array<any>(_loc30_[_loc65_].id, _loc65_, _loc67_, {
                  "range": _loc31_[_loc65_][_loc70_].range,
                  "stolen": _loc31_[_loc65_][_loc70_].stolen,
                  "crafted": _loc31_[_loc65_][_loc70_].crafted
                }, 1);
                _loc64_++;
              }
              _loc70_++;
            }
          }
        } else if (_loc31_[_loc65_] != 0 && _loc65_ != "flag_russia" && _loc65_ != "flag_ussr") {
          // PORT: product change - a profile that already owns one of these flags cannot equip it either.
          _loc63_[_loc64_] = new Array<any>(_loc30_[_loc65_].id, _loc65_, _loc30_[_loc65_].id, {});
          _loc64_++;
        }
      }
      as3.sortOn(_loc63_, "2", as3.ArrayFlags.NUMERIC);
      _loc24_ = 0;
      if (this.shop_type == "weapons") {
        if (this.FWP.win_auc_weapons.annihilator != 0 || this.FWP.auc_weapons.annihilator != 0) {
          _loc63_[_loc64_] = [123, "annihilator", 100500, { "range": 1, "stolen": false, "crafted": false }, this.FWP.win_auc_weapons.annihilator + this.FWP.auc_weapons.annihilator];
          _loc64_++;
        }
      }
      _loc2_ = 0;
      while (_loc2_ <= _loc64_ - 1) {
        _loc65_ = _loc63_[_loc2_][1];
        _loc73_ = "%";
        if (this.shop_type == "weapons") {
          if (_loc63_[_loc2_][3].stolen) {
            _loc73_ += "s";
          } else if (_loc63_[_loc2_][3].crafted) {
            _loc73_ += "c";
          }
          _loc73_ += "%" + _loc63_[_loc2_][3].range;
        }
        _loc74_ = _loc32_.arsenal_weapon_container.addChild(this.FWP.container_interf.get_object("clip_weapon_arsenal"));
        _loc74_.weapon_functions.visible = false;
        if (this.shop_type == "weapons") {
          if (Boolean(_loc30_[_loc65_].allow_upg) && _loc63_[_loc2_][3].range != 10) {
            _loc74_.weapon_functions.gotoAndStop(1);
          } else {
            _loc74_.weapon_functions.gotoAndStop(2);
          }
          if (_loc65_ == "annihilator") {
            _loc74_.weapon_functions.gotoAndStop(5);
          }
        } else if (this.shop_type == "impl") {
          _loc74_.weapon_functions.gotoAndStop(4);
        } else if (this.shop_type == "objs") {
          if (_loc30_[_loc65_].usable) {
            _loc74_.weapon_functions.gotoAndStop(4);
          } else {
            _loc74_.weapon_functions.gotoAndStop(2);
          }
        } else {
          _loc74_.weapon_functions.gotoAndStop(3);
        }
        _loc74_.name = "weapon_" + _loc65_ + _loc73_;
        this.bitmaps["ars_wp" + _loc2_] = new Bitmap();
        this.bitmap_datas["ars_wp" + _loc2_] = new BitmapData(50, 50, true, 0);
        _loc74_.wp_name.text = _loc30_[_loc65_].name;
        if (this.shop_type == "weapons") {
          _loc75_ = this.FWP.get_wpij(_loc30_[_loc65_].id).i;
          _loc76_ = this.FWP.get_wpij(_loc30_[_loc65_].id).j;
          this.bitmap_datas["ars_wp" + _loc2_].copyPixels(this.BigWP, new Rectangle(1 + 45 * (_loc76_ - 1), 1 + 44 * (_loc75_ - 1), 44, 43), new Point(2, 2));
        } else if (this.shop_type == "help") {
          _loc3_ = _loc30_[_loc65_].id;
          this.bitmap_datas["ars_wp" + _loc2_].copyPixels(this.BigStims, new Rectangle(1 + 45 * (_loc3_ - 1), 1, 44, 43), new Point(2, 2));
          _loc77_ = 0;
          if (_loc34_.perks["stims"]) {
            _loc77_ = this.FWP.get_perk_effect("stims", _loc34_.perks.stims, "");
          }
          _loc78_ = 0;
          for (_loc79_ of as3.keys(this.FWP.STIM_DEF)) {
            if (_loc34_.stim_to_fight[_loc79_]) {
              _loc78_ += _loc34_.stim_to_fight[_loc79_];
            }
          }
          if (_loc78_ >= this.MAX_STIM + _loc77_) {
            _loc74_.weapon_functions.gotoAndStop(5);
          }
        } else if (this.shop_type == "flags") {
          _loc3_ = _loc30_[_loc65_].id;
          this.bitmap_datas["ars_wp" + _loc2_].copyPixels(this.BigFlags, new Rectangle(1 + 45 * (_loc3_ - 1), 1, 44, 43), new Point(2, 2));
          if (_loc63_[_loc2_][0] == _loc34_.cur_flag) {
            this.bitmap_datas["ars_wp" + _loc2_].copyPixels(this.IconCurrent, new Rectangle(0, 0, 44, 43), new Point(0, 2), null, null, true);
            _loc74_.weapon_functions.gotoAndStop(5);
          }
        } else if (this.shop_type == "rip") {
          _loc3_ = _loc30_[_loc65_].id;
          this.bitmap_datas["ars_wp" + _loc2_].copyPixels(this.BigRIPs, new Rectangle(1 + 45 * (_loc3_ - 1), 1, 44, 43), new Point(2, 2));
          if (_loc63_[_loc2_][0] == _loc34_.cur_rip) {
            this.bitmap_datas["ars_wp" + _loc2_].copyPixels(this.IconCurrent, new Rectangle(0, 0, 44, 43), new Point(0, 2), null, null, true);
            _loc74_.weapon_functions.gotoAndStop(5);
          }
        } else if (this.shop_type == "impl") {
          _loc3_ = _loc30_[_loc65_].id;
          this.bitmap_datas["ars_wp" + _loc2_].copyPixels(this.BigImpls, new Rectangle(1 + 45 * (_loc3_ - 1), 1, 44, 43), new Point(2, 2));
          if (_loc63_[_loc2_][0] == _loc34_.cur_impl) {
            this.bitmap_datas["ars_wp" + _loc2_].copyPixels(this.IconCurrent, new Rectangle(0, 0, 44, 43), new Point(0, 2), null, null, true);
            _loc74_.weapon_functions.gotoAndStop(2);
          }
        } else if (this.shop_type == "objs") {
          _loc3_ = _loc30_[_loc65_].id;
          this.bitmap_datas["ars_wp" + _loc2_].copyPixels(this.BigObjs, new Rectangle(1 + 45 * (_loc3_ - 1), 1, 44, 43), new Point(2, 2));
        }
        if (this.shop_type != "weapons") {
          if (_loc31_[_loc65_] > 1 && _loc31_[_loc65_] <= 10) {
            this.bitmap_datas["ars_wp" + _loc2_].copyPixels(this.WPAmount, new Rectangle(0, (_loc31_[_loc65_] - 2) * 10, 21, 9), new Point(3 - 1 + 44 - 16 - 7, 3 - 1 + 43 - 11), null, null, true);
          }
          if (_loc31_[_loc65_] > 10) {
            this.bitmap_datas["ars_wp" + _loc2_].copyPixels(this.WP10Plus, new Rectangle(0, 0, 21, 9), new Point(3 - 1 + 44 - 16 - 7, 3 - 1 + 43 - 11), null, null, true);
          }
          if (this.shop_type == "impl" || this.shop_type == "objs") {
            _loc74_.wp_range_and_status.htmlText = "Стоимость: <b>" + this.x3String(this.get_sell_price(_loc65_)) + "</b>";
          }
        } else {
          this.bitmap_datas["ars_wp" + _loc2_].copyPixels(this.PerkLevels[_loc63_[_loc2_][3].range], new Rectangle(0, 0, 47, 47), new Point(0, 0), null, null, true);
          _loc80_ = "";
          if (_loc63_[_loc2_][3].stolen) {
            _loc80_ += "<b>(Украдено)</b> ";
          }
          if (_loc63_[_loc2_][3].crafted) {
            _loc80_ += "<b>(Скрафтено)</b> ";
          }
          _loc74_.wp_range_and_status.htmlText = _loc80_ + "Ранг оружия: <b>" + _loc63_[_loc2_][3].range + "</b>";
          // PORT: "(Украдено) (Скрафтено) Ранг оружия: 10" wraps in its one visible line (and more so translated):
          // the font shrinks so that the rank stays visible.
          shrinkToFit(_loc74_.wp_range_and_status, 8);
          if (_loc63_[_loc2_][4] > 1) {
            this.bitmap_datas["ars_wp" + _loc2_].copyPixels(this.WPAmount, new Rectangle(0, (_loc63_[_loc2_][4] - 2) * 10, 21, 9), new Point(3 - 1 + 44 - 16 - 7, 3 - 1 + 43 - 11), null, null, true);
          }
        }
        this.bitmap_datas["ars_wp" + _loc2_].copyPixels(this.WPBox, new Rectangle(0, 0, 47, 46), new Point(0, 0), null, null, true);
        this.bitmaps["ars_wp" + _loc2_].bitmapData = this.bitmap_datas["ars_wp" + _loc2_];
        _loc74_.bitmap_container.addChild(this.bitmaps["ars_wp" + _loc2_]);
        _loc74_.y = _loc24_;
        _loc24_ += 55;
        _loc2_++;
      }
      _loc32_.slider.visible = _loc32_.arsenal_weapon_container.height > 440;
      if (this.shop_type == "weapons") {
        _loc32_.shop_types.gotoAndStop(1);
      }
      if (this.shop_type == "help") {
        _loc32_.shop_types.gotoAndStop(2);
      }
      if (this.shop_type == "flags") {
        _loc32_.shop_types.gotoAndStop(3);
      }
      if (this.shop_type == "rip") {
        _loc32_.shop_types.gotoAndStop(4);
      }
      if (this.shop_type == "impl") {
        _loc32_.shop_types.gotoAndStop(5);
      }
      if (this.shop_type == "objs") {
        _loc32_.shop_types.gotoAndStop(6);
      }
    }
    if (this.cur_screen[this.cur_screen[0]].name == "info") {
      _loc81_ = new Array<any>("p", "e", "a", "c", "h", "f", "l");
      _loc2_ = 0;
      while (_loc2_ <= 6) {
        _loc91_ = this.FWP.get_peachful_bonus({
          "spec": _loc34_.spec,
          "wptype": _loc81_[_loc2_],
          "attack": _loc36_.attack,
          "perks": _loc34_.perks,
          "spec_mod": "",
          "wpclass": 0
        });
        _loc19_ = "<b>" + Math.round(100 + 100 * _loc91_.damage) + "%</b> (";
        if (_loc91_.damage == 0) {
          _loc19_ += "нет модификаторов";
        } else {
          _loc92_ = false;
          if (_loc91_.attack < 0) {
            _loc19_ += Math.round(_loc91_.attack * 100) + " УСТ";
            _loc92_ = true;
          }
          if (_loc91_.attack > 0) {
            _loc19_ += "+" + Math.round(_loc91_.attack * 100) + " АТ";
            _loc92_ = true;
          }
          if (_loc91_.spec != 0) {
            if (_loc92_) {
              _loc19_ += ", ";
            }
            _loc19_ += "+" + Math.round(_loc91_.spec * 100) + " СПЦ";
            _loc92_ = true;
          }
          if (_loc91_.perks != 0) {
            if (_loc92_) {
              _loc19_ += ", ";
            }
            _loc19_ += "+" + Math.round(_loc91_.perks * 100) + " СП";
          }
        }
        _loc19_ += ")";
        _loc32_["damage_" + _loc81_[_loc2_]].htmlText = _loc19_;
        _loc2_++;
      }
      _loc82_ = Math.round(this.FWP.get_damage_resistance(_loc36_.protect));
      if (_loc82_ == 100) {
        _loc32_.damage_res.htmlText = "<b>" + _loc82_ + "%</b> (нет модификаторов)";
      } else if (_loc82_ > 100) {
        _loc32_.damage_res.htmlText = "<b>" + _loc82_ + "%</b> (+" + (_loc82_ - 100) + " УСТ)";
      } else {
        _loc32_.damage_res.htmlText = "<b>" + _loc82_ + "%</b> (" + (_loc82_ - 100) + " ЗЩ)";
      }
      _loc83_ = 0;
      if (_loc34_.perks["dmg_thr"]) {
        _loc83_ = this.FWP.get_perk_effect("dmg_thr", _loc34_.perks.dmg_thr, "");
      }
      _loc32_.damage_thr.htmlText = "<b>" + _loc83_ + "</b>" + (_loc83_ > 0 ? " (+" + _loc83_ + " СП)" : "");
      _loc84_ = 1;
      if (_loc34_.perks["luck"]) {
        _loc84_ += this.FWP.get_perk_effect("luck", _loc34_.perks.luck, "") * 100;
      }
      if (_loc34_.perks["luck2"]) {
        _loc84_ += this.FWP.get_perk_effect("luck2", _loc34_.perks.luck2, "") * 100;
      }
      _loc84_ = Math.round(_loc84_);
      if (_loc84_ == 1) {
        _loc32_.crit.htmlText = "<b>" + _loc84_ + "%</b> (нет модификаторов)";
      } else {
        _loc32_.crit.htmlText = "<b>" + _loc84_ + "%</b> (+" + (_loc84_ - 1) + " СП)";
      }
      _loc85_ = 1;
      _loc86_ = 0;
      if (_loc34_.perks["less_fail"]) {
        _loc85_ = this.FWP.get_perk_effect("less_fail", _loc34_.perks.less_fail, "");
      }
      if (_loc34_.perks["more_fail"]) {
        _loc86_ = this.FWP.get_perk_effect("more_fail", _loc34_.perks.more_fail, "");
      }
      _loc87_ = this.FWP.get_fail_chance(_loc36_.tired, _loc85_, _loc86_, false);
      _loc88_ = "<b>" + Math.round(_loc87_.fail * 100) + "%</b> (";
      if (Math.ceil(_loc87_.fail * 100) == 0) {
        _loc88_ += "нет модификаторов";
      } else {
        if (Math.ceil(_loc87_.tired * 100) != 0) {
          _loc88_ += "+" + (Math.ceil(_loc87_.tired * 100) - 1) + " УСТ";
        }
        if (Math.ceil(_loc87_.perks * 100) != 0) {
          _loc88_ += (Math.ceil(_loc87_.tired * 100) != 0 ? ", " : "") + (Math.ceil(_loc87_.perks * 100) > 0 ? "+" : "") + Math.ceil(_loc87_.perks * 100) + " СП";
        }
      }
      _loc88_ += ")";
      _loc32_.fail.htmlText = _loc88_;
      _loc89_ = this.FWP.get_ap_chance(_loc34_.perks, { "attack": _loc36_.attack });
      _loc89_.ap = Math.round(100 * _loc89_.ap);
      if (_loc89_.ap == 0) {
        _loc32_.ap.htmlText = "<b>0%</b> (нет модификаторов)";
      } else {
        _loc32_.ap.htmlText = "<b>" + _loc89_.ap + "%</b> (";
        if (_loc89_.skills != 0) {
          _loc32_.ap.htmlText += "+" + _loc89_.skills + " АТ";
        }
        if (_loc89_.skills != 0 && _loc89_.perks != 0) {
          _loc32_.ap.htmlText += ", ";
        }
        if (_loc89_.perks != 0) {
          _loc32_.ap.htmlText += "+" + _loc89_.perks + " СП";
        }
        _loc32_.ap.htmlText += ")";
      }
      _loc90_ = this.FWP.get_absorb_chance(_loc34_.perks, { "protect": _loc36_.protect });
      _loc90_.absorb = Math.round(100 * _loc90_.absorb);
      if (_loc90_.absorb == 0) {
        _loc32_.absorb.htmlText = "<b>0%</b> (нет модификаторов)";
      } else {
        _loc32_.absorb.htmlText = "<b>" + _loc90_.absorb + "%</b> (";
        if (_loc90_.skills != 0) {
          _loc32_.absorb.htmlText += "+" + _loc90_.skills + " ЗЩ";
        }
        if (_loc90_.skills != 0 && _loc90_.perks != 0) {
          _loc32_.absorb.htmlText += ", ";
        }
        if (_loc90_.perks != 0) {
          _loc32_.absorb.htmlText += "+" + _loc90_.perks + " СП";
        }
        _loc32_.absorb.htmlText += ")";
      }
    }
    _loc37_ = 1;
    if (_loc34_.perks["merchant"]) {
      _loc37_ = this.FWP.get_perk_effect("merchant", _loc34_.perks.merchant, "");
    }
    if (this.cur_screen[this.cur_screen[0]].name == "shop") {
      if (this.shop_type == "weapons") {
        _loc30_ = this.FWP.WEAPONS_DEF;
        _loc31_ = _loc34_.weapons;
      }
      if (this.shop_type == "help") {
        _loc30_ = this.FWP.STIM_DEF;
        _loc31_ = _loc34_.stim_behave;
      }
      if (this.shop_type == "flags") {
        _loc30_ = this.FWP.FLAGS_DEF;
        _loc31_ = _loc34_.flags;
      }
      if (this.shop_type == "rip") {
        _loc30_ = this.FWP.RIPS_DEF;
        _loc31_ = _loc34_.rip;
      }
      if (this.shop_type == "impl") {
        _loc30_ = this.FWP.IMPL_DEF;
        _loc31_ = _loc34_.impl;
      }
      if (this.shop_type == "objs") {
        _loc30_ = this.FWP.OBJ_DEF;
        _loc31_ = _loc34_.objs;
      }
      if (this.shop_type == "impl") {
        _loc37_ = 1;
      }
      _loc63_ = new Array();
      _loc64_ = 0;
      for (_loc65_ of as3.keys(_loc30_)) {
        if (this.shop_type == "weapons" && _loc30_[_loc65_].level != -1 && _loc30_[_loc65_].id <= 200 && _loc65_ != "skip_go" && Boolean(_loc30_[_loc65_].shown)) {
          if (this.shop_mode == "p" && _loc30_[_loc65_].wptype == "p" || this.shop_mode == "e" && _loc30_[_loc65_].wptype == "e" || this.shop_mode == "a" && _loc30_[_loc65_].wptype == "a" || this.shop_mode == "c" && _loc30_[_loc65_].wptype == "c" || this.shop_mode == "h" && _loc30_[_loc65_].wptype == "h" || this.shop_mode == "f" && _loc30_[_loc65_].wptype == "f" || this.shop_mode == "u" && _loc30_[_loc65_].wptype == "u" || this.shop_mode == "l" && _loc30_[_loc65_].wptype == "l" || this.shop_mode == "1" && _loc30_[_loc65_].wpclass == 1 || this.shop_mode == "2" && _loc30_[_loc65_].wpclass == 2 || this.shop_mode == "3" && _loc30_[_loc65_].wpclass == 3 || this.shop_mode == "4" && _loc30_[_loc65_].wpclass == 4 || this.shop_mode == "5" && _loc30_[_loc65_].wpclass == 5 || this.shop_mode == "6" && _loc30_[_loc65_].wpclass == 6 || this.shop_mode == "7" && _loc30_[_loc65_].wpclass == 7 || this.shop_mode == "all" || this.shop_mode == "available" && _loc30_[_loc65_].level != 0 && (Math.round(_loc30_[_loc65_].gold * _loc37_) <= _loc34_.gold.value && _loc30_[_loc65_].level <= _loc34_.level.value && this.get_req_params(_loc34_, _loc30_[_loc65_]) || Math.round(_loc30_[_loc65_].diam * _loc37_) <= _loc34_.diam.value) || this.shop_mode == "craft" && _loc30_[_loc65_].level == 0 || this.shop_mode == "unfail" && _loc30_[_loc65_].unfail >= 100) {
            _loc96_ = 0;
            _loc97_ = 0;
            for (_loc98_ of as3.keys(this.FWP.WP_PLACES_SORT)) {
              if (_loc65_ == this.FWP.WP_PLACES_SORT[_loc98_]) {
                break;
              }
            }
            _loc96_ = _loc98_;
            _loc63_[_loc64_] = new Array<any>(_loc30_[_loc65_].id, _loc65_, _loc96_);
            _loc64_++;
          }
        }
        if (this.shop_type == "flags" || this.shop_type == "rip" || this.shop_type == "help" || this.shop_type == "impl") {
          // PORT: product change - the Russian and Soviet flags are not offered. Their FLAGS_DEF entries, ids and
          // PORT: save slots stay, so prices, pagination and profiles that already own them keep working.
          if (_loc65_ != "flag_russia" && _loc65_ != "flag_ussr") {
            _loc63_[_loc64_] = new Array<any>(_loc30_[_loc65_].id, _loc65_, _loc30_[_loc65_].id);
            _loc64_++;
          }
        }
        if (this.shop_type == "objs" && Boolean(_loc30_[_loc65_].show_shop)) {
          _loc63_[_loc64_] = new Array<any>(_loc30_[_loc65_].id, _loc65_, _loc30_[_loc65_].id);
          _loc64_++;
        }
      }
      as3.sortOn(_loc63_, "2", as3.ArrayFlags.NUMERIC);
      _loc93_ = (this.shop_page - 1) * 24 + 1;
      _loc94_ = Math.min(_loc64_, _loc93_ + 23);
      _loc51_ = Math.ceil(_loc64_ / 24);
      _loc32_.choose_page.gotoAndStop(_loc51_);
      if (this.shop_type == "weapons") {
        _loc32_.shop_types.gotoAndStop(1);
      }
      if (this.shop_type == "help") {
        _loc32_.shop_types.gotoAndStop(2);
      }
      if (this.shop_type == "flags") {
        _loc32_.shop_types.gotoAndStop(3);
      }
      if (this.shop_type == "rip") {
        _loc32_.shop_types.gotoAndStop(4);
      }
      if (this.shop_type == "impl") {
        _loc32_.shop_types.gotoAndStop(5);
      }
      if (this.shop_type == "objs") {
        _loc32_.shop_types.gotoAndStop(6);
      }
      _loc32_.filt.gotoAndStop(this.opened_filter ? 2 : 1);
      _loc95_ = new Array<any>({ "id": "all", "name": "Все оружие" }, { "id": "available", "name": "Только доступное" }, { "id": "craft", "name": "Только крафтинг" }, { "id": "unfail", "name": "Только безотказн." }, { "id": "p", "name": "Снаряды" }, { "id": "e", "name": "Взрывчатка" }, { "id": "a", "name": "Авиаудары" }, { "id": "c", "name": "Ближний бой" }, { "id": "h", "name": "Энергооружие" }, { "id": "f", "name": "Огнестрельное" }, { "id": "u", "name": "Утилиты" }, { "id": "l", "name": "Живые бомбы" }, { "id": "1", "name": "1 класс" }, { "id": "2", "name": "2 класс" }, { "id": "3", "name": "3 класс" }, { "id": "4", "name": "4 класс" }, { "id": "5", "name": "5 класс" }, { "id": "6", "name": "6 класс" }, { "id": "7", "name": "7 класс" });
      if (this.shop_type == "weapons") {
        for (_loc99_ of as3.keys(_loc95_)) {
          if (this.shop_mode == _loc95_[_loc99_].id) {
            _loc32_.filt.cur_filt.text = _loc95_[_loc99_].name;
          }
        }
        _loc32_.filt.visible = true;
      } else {
        _loc32_.filt.visible = false;
      }
      if (this.opened_filter) {
        for (_loc99_ of as3.keys(_loc95_)) {
          _loc100_ = _loc95_[_loc99_].name;
          if (this.shop_mode == _loc95_[_loc99_].id) {
            _loc100_ = "<b>" + _loc95_[_loc99_].name + "</b>";
          }
          _loc32_.filt["shop_mode_" + _loc95_[_loc99_].id].htmlText = _loc100_;
          _loc32_.filt["shop_mode_" + _loc95_[_loc99_].id].textColor = this.shop_mode == _loc95_[_loc99_].id ? 16711680 : 0;
          // PORT: the list's fields are placed at 0.61 x 1 (sprite 539), which drew their glyphs squeezed: the text
          // PORT: keeps its proportions in the same box, a longer line (a translation, the bold current filter) gets a
          // PORT: smaller font (ui/controls.ts unsqueezeText).
          unsqueezeText(_loc32_.filt["shop_mode_" + _loc95_[_loc99_].id], 9);
        }
      }
      _loc2_ = 1;
      while (_loc2_ <= _loc51_) {
        _loc32_.choose_page["page" + _loc2_].textColor = 7417088;
        _loc2_++;
      }
      _loc32_.choose_page["page" + this.shop_page].textColor = 16750848;
      _loc4_ = 0;
      _loc54_ = _loc93_;
      while (_loc54_ <= _loc94_) {
        _loc4_++;
        _loc65_ = _loc63_[_loc54_ - 1][1];
        this.buttons["wp_buy_" + _loc4_].visible = true;
        this.buttons["wp_buy_" + _loc4_].name = "weapon_" + _loc65_;
        if (_loc30_[_loc65_].level != 0) {
          if (_loc30_[_loc65_].gold * _loc37_ < 10000) {
            this.buttons["wp_buy_" + _loc4_].gold.text = this.x3String(Math.round(_loc30_[_loc65_].gold * _loc37_));
          } else {
            this.buttons["wp_buy_" + _loc4_].gold.text = this.xKString(Math.round(_loc30_[_loc65_].gold * _loc37_));
          }
          this.buttons["wp_buy_" + _loc4_].diam.text = Math.round(_loc30_[_loc65_].diam * _loc37_);
        } else {
          this.buttons["wp_buy_" + _loc4_].gold.text = "-";
          this.buttons["wp_buy_" + _loc4_].diam.text = "-";
        }
        if (this.shop_type == "weapons") {
          _loc2_ = this.FWP.get_wpij(_loc30_[_loc65_].id).i;
          _loc3_ = this.FWP.get_wpij(_loc30_[_loc65_].id).j;
          this.bitmap_datas["shop" + _loc4_].copyPixels(this.BigWP, new Rectangle(1 + 45 * (_loc3_ - 1), 1 + 44 * (_loc2_ - 1), 44, 43), new Point(2, 2));
        } else if (this.shop_type == "help") {
          _loc3_ = _loc30_[_loc65_].id;
          this.bitmap_datas["shop" + _loc4_].copyPixels(this.BigStims, new Rectangle(1 + 45 * (_loc3_ - 1), 1, 44, 43), new Point(2, 2));
        } else if (this.shop_type == "flags") {
          _loc3_ = _loc30_[_loc65_].id;
          this.bitmap_datas["shop" + _loc4_].copyPixels(this.BigFlags, new Rectangle(1 + 45 * (_loc3_ - 1), 1, 44, 43), new Point(2, 2));
        } else if (this.shop_type == "rip") {
          _loc3_ = _loc30_[_loc65_].id;
          this.bitmap_datas["shop" + _loc4_].copyPixels(this.BigRIPs, new Rectangle(1 + 45 * (_loc3_ - 1), 1, 44, 43), new Point(2, 2));
        } else if (this.shop_type == "impl") {
          _loc3_ = _loc30_[_loc65_].id;
          this.bitmap_datas["shop" + _loc4_].copyPixels(this.BigImpls, new Rectangle(1 + 45 * (_loc3_ - 1), 1, 44, 43), new Point(2, 2));
        } else if (this.shop_type == "objs") {
          _loc3_ = _loc30_[_loc65_].id;
          this.bitmap_datas["shop" + _loc4_].copyPixels(this.BigObjs, new Rectangle(1 + 45 * (_loc3_ - 1), 1, 44, 43), new Point(2, 2));
        }
        this.bitmap_datas["shop" + _loc4_].copyPixels(this.WPBox, new Rectangle(0, 0, 47, 46), new Point(0, 0), null, null, true);
        this.buttons["wp_buy_" + _loc4_].back.gotoAndStop(1);
        if (_loc63_[_loc54_ - 1][0] == this.cur_element) {
          this.buttons["wp_buy_" + _loc4_].back.gotoAndStop(2);
        } else if (_loc30_[_loc65_].level == 0 || !(Math.round(_loc30_[_loc65_].gold * _loc37_) <= _loc34_.gold.value && _loc30_[_loc65_].level <= _loc34_.level.value && this.get_req_params(_loc34_, _loc30_[_loc65_])) && Math.round(_loc30_[_loc65_].diam * _loc37_) > _loc34_.diam.value) {
          this.bitmap_datas["shop" + _loc4_].copyPixels(this.WPBlurGray, new Rectangle(0, 0, 47, 46), new Point(0, 0), null, null, true);
          this.buttons["wp_buy_" + _loc4_].back.gotoAndStop(3);
        }
        _loc54_++;
      }
      _loc54_ = _loc94_ + 1;
      while (_loc54_ <= _loc93_ + 23) {
        _loc4_++;
        this.buttons["wp_buy_" + _loc4_].visible = false;
        _loc54_++;
      }
      if (_loc30_[this.cur_weapon]) {
        _loc32_.weapon_name.text = _loc30_[this.cur_weapon].name;
        _loc101_ = "";
        if (this.shop_type != "weapons") {
          if (_loc31_[this.cur_weapon]) {
            if (_loc31_[this.cur_weapon] != 0) {
              _loc32_.weapon_name.text += " (" + _loc31_[this.cur_weapon] + ")";
            }
          }
        } else if (_loc31_[this.cur_weapon]) {
          if (_loc31_[this.cur_weapon][0] != 0) {
            _loc32_.weapon_name.text += " (" + _loc31_[this.cur_weapon][0] + ")";
          }
        }
        _loc32_.weapon_desc.htmlText = this.return_weapon_desc(this.cur_weapon, this.shop_type) + _loc101_ + (this.weapons_text[this.cur_weapon] ? this.weapons_text[this.cur_weapon] : "");
      }
      if (this.cur_element <= 0) {
        if (this.shop_type == "weapons") {
          _loc32_.weapon_name.text = "Оружие";
          _loc32_.weapon_desc.htmlText = "Здесь вы можете купить самое разнообразное вооружение - как наступательное, так и оборонительное. Если вы хотите продать купленое ранее оружие, то это можно сделать в разделе Арсенал.\n\nДля покупки большинства оружия необходимо иметь требуемый уровень. Если ваш уровень не удовлетворяет требованиям, покупка оружия возможна только за алмазы.\n\nИконка оружия серая, если вам не хватает ни золота, ни алмазов на выбранное оружие.";
        }
        if (this.shop_type == "help") {
          _loc32_.weapon_name.text = "Помощь";
          _loc32_.weapon_desc.htmlText = "В разделе Помощь у вас есть возможность купить вещи, сильно помогающие в бою. Для использования этих вещей (после покупки) зайдите в соответствующий раздел в Арсенале.";
        }
        if (this.shop_type == "flags") {
          _loc32_.weapon_name.text = "Флаги";
          _loc32_.weapon_desc.htmlText = "Каждая команда уникальна, а поэтому осмотрите весь ассортимент флагов в нашем магазине и выберите себе подходящий!";
        }
        if (this.shop_type == "rip") {
          _loc32_.weapon_name.text = "Гробики";
          _loc32_.weapon_desc.htmlText = "После смерти вашего червяка можно оставить памятный подарок врагам.";
        }
        if (this.shop_type == "impl") {
          _loc32_.weapon_name.text = "Имплантанты";
          _loc32_.weapon_desc.htmlText = "Улучшают разнообразные характеристики вашей команды.\n\nТак как имплантантов нет у продавца под прилавком (они заказываются отдельно), ваша способность Торговец не оказывает никакого влияния на стоимость.\n\nХотя есть и обратная сторона - из-за бешеной стоимости их, как правило, отрывают с руками, поэтому имплантанты вы можете продать всегда по абсолютно той же цене, по какой и покупали.";
        }
        if (this.shop_type == "objs") {
          _loc32_.weapon_name.text = "Предметы";
          _loc32_.weapon_desc.htmlText = "Предметы используются, как правило, как компоненты для крафтинга более мощного оружия. Некоторые предметы имеют отдельные, уникальные свойства, например повышают Удачу и т.д. Большинство предметов найти можно только в магазине Папы Джона или при обыске гробиков, в нашем магазине ассортимент маленький.";
        }
      }
      _loc32_.try_steal.visible = false;
      if (this.cur_element > 0 && _loc30_[this.cur_weapon].level != 0) {
        _loc32_.buy_gold.visible = Math.round(_loc30_[this.cur_weapon].gold * _loc37_) <= _loc34_.gold.value && _loc30_[this.cur_weapon].level <= _loc34_.level.value && this.get_req_params(_loc34_, _loc30_[this.cur_weapon]);
        _loc32_.buy_diam.visible = Math.round(_loc30_[this.cur_weapon].diam * _loc37_) <= _loc34_.diam.value;
        _loc32_.weapon_gold.text = this.x3String(Math.round(_loc30_[this.cur_weapon].gold * _loc37_));
        _loc32_.weapon_diam.text = this.x3String(Math.round(_loc30_[this.cur_weapon].diam * _loc37_));
        _loc32_.weapon_gold.visible = true;
        _loc32_.weapon_diam.visible = true;
        _loc32_.try_steal.visible = this.shop_type == "weapons";
      } else {
        _loc32_.buy_gold.visible = false;
        _loc32_.buy_diam.visible = false;
        _loc32_.weapon_gold.visible = false;
        _loc32_.weapon_diam.visible = false;
      }
      if (_loc31_[this.cur_weapon]) {
        if (this.shop_type != "weapons") {
          if (_loc31_[this.cur_weapon] >= _loc30_[this.cur_weapon].limit) {
            _loc32_.buy_gold.visible = false;
            _loc32_.buy_diam.visible = false;
            _loc32_.try_steal.visible = false;
          }
        } else if (_loc31_[this.cur_weapon][0] >= _loc30_[this.cur_weapon].limit) {
          _loc32_.buy_gold.visible = false;
          _loc32_.buy_diam.visible = false;
          _loc32_.try_steal.visible = false;
        }
      }
      _loc32_.gold.text = this.x3SHString(_loc34_.gold.value);
      _loc32_.diam.text = this.x3SHString(_loc34_.diam.value);
    }
    // PORT: design D5 - the fight screen in the online mode is the lobby (runtime/online-lobby.ts): it has no tasks.
    if (this.cur_screen[this.cur_screen[0]].name == "fight" && this.play_type == "online") {
      if (this.FWP.online) {
        this.FWP.online.render_fight(_loc32_);
      }
    } else if (this.cur_screen[this.cur_screen[0]].name == "fight") {
      if (this.play_type == "career") {
        _loc102_ = Math.min(this.FWP.player.career_max, this.FWP.TEAMS_DEF.career_max);
      }
      if (this.play_type == "missions") {
        _loc102_ = Math.min(this.FWP.player.missions_max, this.FWP.TEAMS_DEF.missions_max);
      }
      if (this.play_type == "survival") {
        _loc102_ = Math.min(this.FWP.player.survival_max, this.FWP.TEAMS_DEF.survival_max);
      }
      if (this.play_type == "boss") {
        _loc102_ = Math.min(this.FWP.player.boss_max, this.FWP.TEAMS_DEF.boss_max);
      }
      _loc2_ = 1;
      while (_loc2_ <= _loc102_) {
        this.buttons["fight" + _loc2_].task_name.textColor = 0;
        _loc2_++;
      }
      this.buttons["fight" + this.cur_element].task_name.textColor = 16711680;
      this.MainBitmapData.copyPixels(this.CPUFlags, new Rectangle(0, 0, 19, 17), new Point(91, 173));
      // PORT: the player's name is data, not game text: shown as typed (ui/controls.ts setRawText); only a guest's
      // default name "Игрок-XXXX" is game text and gets the prefix of the active language (i18n playerName).
      setRawText(_loc32_["team_name1"], playerName(String(this.FWP.user.name)));
      _loc32_["attack1"].text = _loc36_.attack;
      _loc32_["protect1"].text = _loc36_.protect;
      _loc32_["health1"].text = _loc36_.health;
      if (this.play_type == "career") {
        _loc32_["worms1"].text = Math.min(_loc34_.worms.value + 2, this.FWP.TEAMS_DEF["career" + this.cur_element].worm_limit);
      }
      if (this.play_type == "missions") {
        _loc32_["worms1"].text = Math.min(_loc34_.worms.value + 2, this.FWP.TEAMS_DEF["mission" + this.cur_element].worm_limit);
      }
      if (this.play_type == "survival") {
        _loc32_["worms1"].text = Math.min(_loc34_.worms.value + 2, this.FWP.TEAMS_DEF["survival" + this.cur_element].worm_limit);
      }
      if (this.play_type == "boss") {
        _loc32_["worms1"].text = Math.min(_loc34_.worms.value + 2, this.FWP.TEAMS_DEF["boss" + this.cur_element].worm_limit);
      }
      _loc32_["team_name1"].textColor = this.game_get_color(2);
      _loc32_["attack1"].textColor = this.game_get_color(2);
      _loc32_["protect1"].textColor = this.game_get_color(2);
      _loc32_["health1"].textColor = this.game_get_color(2);
      _loc32_["worms1"].textColor = this.game_get_color(2);
      if (this.play_type == "career") {
        _loc103_ = this.FWP.TEAMS_DEF["career" + this.cur_element];
      }
      if (this.play_type == "missions") {
        _loc103_ = this.FWP.TEAMS_DEF["mission" + this.cur_element];
      }
      if (this.play_type == "survival") {
        _loc103_ = this.FWP.TEAMS_DEF["survival" + this.cur_element];
      }
      if (this.play_type == "boss") {
        _loc103_ = this.FWP.TEAMS_DEF["boss" + this.cur_element];
      }
      _loc2_ = 2;
      while (_loc2_ <= _loc103_.teams + 1) {
        this.MainBitmapData.copyPixels(this.CPUFlags, new Rectangle(20 * _loc103_["team" + _loc2_].cpu_level, 0, 19, 17), new Point(91, 173 + 20 * (_loc2_ - 1)));
        _loc32_["team_name" + String(_loc2_)].text = _loc103_["team" + _loc2_].name;
        _loc32_["attack" + String(_loc2_)].text = _loc103_["team" + _loc2_].worm1.attack;
        _loc32_["protect" + String(_loc2_)].text = _loc103_["team" + _loc2_].worm1.protect;
        _loc32_["health" + String(_loc2_)].text = _loc103_["team" + _loc2_].worm1.health;
        _loc32_["worms" + String(_loc2_)].text = _loc103_["team" + _loc2_].worms;
        _loc109_ = _loc103_["team" + _loc2_].color;
        _loc32_["team_name" + String(_loc2_)].textColor = this.game_get_color(_loc109_);
        _loc32_["attack" + String(_loc2_)].textColor = this.game_get_color(_loc109_);
        _loc32_["protect" + String(_loc2_)].textColor = this.game_get_color(_loc109_);
        _loc32_["health" + String(_loc2_)].textColor = this.game_get_color(_loc109_);
        _loc32_["worms" + String(_loc2_)].textColor = this.game_get_color(_loc109_);
        _loc2_++;
      }
      _loc2_ = _loc103_.teams + 2;
      while (_loc2_ <= 4) {
        _loc32_["team_name" + String(_loc2_)].text = "";
        _loc32_["attack" + String(_loc2_)].text = "";
        _loc32_["protect" + String(_loc2_)].text = "";
        _loc32_["health" + String(_loc2_)].text = "";
        _loc32_["worms" + String(_loc2_)].text = "";
        _loc2_++;
      }
      _loc9_ = "";
      _loc106_ = 1;
      _loc107_ = 1;
      if (_loc34_.perks["more_exp"]) {
        _loc107_ = this.FWP.get_perk_effect("more_exp", _loc34_.perks.more_exp, "");
      }
      if (_loc34_.spec == 4) {
        _loc107_ = this.FWP.get_perk_effect("more_exp", 3, "");
      }
      if (this.play_type == "career") {
        if (_loc34_.career_attempt == 0 && this.cur_element == _loc34_.career_max) {
          _loc106_ = 1.2;
        }
        if (this.cur_element < _loc34_.career_max) {
          _loc106_ = 0.15;
        }
        _loc104_ = this.x3String(Math.round(_loc103_.exp * _loc106_ * _loc107_ * this.FWP.get_skill_multi("exp") * this.FWP.get_hardcore_multi(this.cur_element, _loc34_.career_max)));
        _loc105_ = this.x3String(Math.round(_loc103_.gold * _loc106_ * this.FWP.get_skill_multi("gold") * this.FWP.get_hardcore_multi(this.cur_element, _loc34_.career_max)));
        _loc32_.go.visible = true;
        _loc9_ += "С присвоением этого ранга вы получите <b>" + _loc105_ + "</b> золота и <b>" + _loc104_ + "</b> опыта.";
        if (_loc106_ > 1) {
          _loc9_ += " Вознаграждение увеличено - это первая попытка получить данный ранг.";
        }
        if (_loc106_ < 1) {
          _loc9_ += " Вознаграждение уменьшено - вы уже получили этот ранг.";
        }
      } else if (this.play_type == "missions") {
        if (_loc34_.missions_attempt == 0 && this.cur_element == _loc34_.missions_max) {
          _loc106_ = 1.2;
        }
        if (this.cur_element < _loc34_.missions_max) {
          _loc106_ = 0.15;
        }
        _loc104_ = this.x3String(Math.round(_loc103_.exp * _loc106_ * _loc107_ * this.FWP.get_skill_multi("exp") * this.FWP.get_hardcore_multi(this.cur_element, _loc34_.missions_max)));
        _loc105_ = this.x3String(Math.round(_loc103_.gold * _loc106_ * this.FWP.get_skill_multi("gold") * this.FWP.get_hardcore_multi(this.cur_element, _loc34_.missions_max)));
        _loc32_.go.visible = true;
        if (_loc103_.level <= _loc34_.level.value) {
          _loc9_ = this.FWP.MISSION_DESC[this.cur_element];
          _loc9_ = _loc9_ + ("\n\nЗа успешное прохождение этой миссии вы получите <b>" + _loc105_ + "</b> золота и <b>" + _loc104_ + "</b> опыта.");
          if (_loc106_ > 1) {
            _loc9_ += " Вознаграждение увеличено - это первая попытка пройти данную миссию.";
          }
          if (_loc106_ < 1) {
            _loc9_ += " Вознаграждение уменьшено - вы уже прошли эту миссию.";
          }
        } else {
          _loc9_ = "Для прохождения этой миссии вам необходим " + _loc103_.level + " уровень.";
          _loc32_.go.visible = false;
        }
        if (this.cur_element == this.FWP.TEAMS_DEF.missions_max) {
          _loc9_ = "Далеко забрались, поздравляем! Подождите некоторое время, данная миссия в разработке.";
          _loc32_.go.visible = false;
        }
      } else if (this.play_type == "survival") {
        if (_loc34_.survival_attempt == 0 && this.cur_element == _loc34_.survival_max) {
          _loc106_ = 1.2;
        }
        if (this.cur_element < _loc34_.survival_max) {
          _loc106_ = 0.15;
        }
        _loc104_ = this.x3String(Math.round(_loc103_.exp * _loc106_ * _loc107_ * this.FWP.get_skill_multi("exp") * this.FWP.get_hardcore_multi(this.cur_element, _loc34_.survival_max)));
        _loc105_ = this.x3String(Math.round(_loc103_.gold * _loc106_ * this.FWP.get_skill_multi("gold") * this.FWP.get_hardcore_multi(this.cur_element, _loc34_.survival_max)));
        _loc32_.go.visible = true;
        _loc9_ = "Вам необходимо убить <b>" + _loc103_.kills + "</b> червяков. После убийтва данного количества червей они перестанут возрождаться.\n\n";
        _loc9_ = _loc9_ + ("С прохождением этого этапа вы получите <b>" + _loc105_ + "</b> золота и <b>" + _loc104_ + "</b> опыта.");
        if (_loc106_ > 1) {
          _loc9_ += " Вознаграждение увеличено - это первая попытка пройти данный этап.";
        }
        if (_loc106_ < 1) {
          _loc9_ += " Вознаграждение уменьшено - вы уже прошли данный этап.";
        }
        if (this.cur_element == this.FWP.TEAMS_DEF.survival_max) {
          _loc9_ = "Далеко забрались, поздравляем! Подождите некоторое время, данный этап выживания в разработке.";
          _loc32_.go.visible = false;
        }
      } else if (this.play_type == "boss") {
        if (_loc34_.boss_attempt == 0 && this.cur_element == _loc34_.boss_max) {
          _loc106_ = 1.2;
        }
        _loc104_ = this.x3String(Math.round(_loc103_.exp * _loc106_ * _loc107_ * this.FWP.get_skill_multi("exp") * this.FWP.get_hardcore_multi(this.cur_element, _loc34_.boss_max)));
        _loc105_ = this.x3String(Math.round(_loc103_.gold * _loc106_ * this.FWP.get_skill_multi("gold") * this.FWP.get_hardcore_multi(this.cur_element, _loc34_.boss_max)));
        _loc32_.go.visible = true;
        if (_loc103_.level <= _loc34_.level.value) {
          _loc9_ = "Боссы - крайне опасные, тренированные и хорошо вооруженные червяки. Плюс ко всему этому у них есть походный генератор антигравитации, который позволяет им висеть в воздухе - боссов невозможно утопить. Еще одно устройтсво, которое поставляет боссам Отражение - дезинтегратор материи. На снаряды и пули он действовать не успевает, однако запросто расщепляет балки, если их поставить близко к червяку. ";
          _loc9_ = _loc9_ + ("После победы этого босса вы получите <b>" + _loc105_ + "</b> золота и <b>" + _loc104_ + "</b> опыта.");
          if (_loc106_ > 1) {
            _loc9_ += " Вознаграждение увеличено - это первая попытка победить данного босса.";
          }
          if (this.cur_element < _loc34_.boss_max) {
            _loc9_ = "<b>Вы уже победили этого босса.</b>";
            _loc32_.go.visible = false;
          }
        } else {
          _loc9_ = "Для того, чтобы биться с этим боссом, вам необходим " + _loc103_.level + " уровень.";
          _loc32_.go.visible = false;
        }
        if (this.cur_element == this.FWP.TEAMS_DEF.boss_max) {
          _loc9_ = "Далеко забрались, поздравляем! Подождите некоторое время, данный босс в разработке.";
          _loc32_.go.visible = false;
        }
      }
      if (_loc36_.tired >= this.FWP.TIRED_THRESHOLD) {
        _loc9_ = "Вы очень устали ( усталость выше <b>" + this.FWP.TIRED_THRESHOLD + "</b>% ) . Подождите или купите стимулятор.";
        _loc32_.go.visible = false;
      }
      _loc108_ = "";
      if (this.play_type == "career" || this.play_type == "survival" || this.play_type == "boss") {
        _loc108_ = "";
      } else {
        _loc108_ = this.get_episode(this.cur_element) + "\n\n";
      }
      _loc32_.fight_text.htmlText = _loc108_ + _loc9_;
      _loc17_ = this.get_minimap_coords(this.play_type, this.cur_element);
      this.MainBitmapData.copyPixels(_loc17_, new Rectangle(0, 0, 342, 154), new Point(10, 10));
      _loc17_.dispose();
      _loc17_ = null;
    }
    // PORT: design D5 - the barracks screen of an online room shows (and for the host edits) the room's settings.
    if (this.cur_screen[this.cur_screen[0]].name == "just_play" && !(this.FWP.online && this.FWP.online.render_room(_loc32_))) {
      _loc2_ = 1;
      while (_loc2_ <= 5) {
        this.buttons["just" + _loc2_].task_name.textColor = 0;
        _loc2_++;
      }
      this.buttons["just" + this.cur_element].task_name.textColor = 16711680;
      _loc17_ = this.get_minimap_coords(this.play_type, this.cur_element, true);
      this.MainBitmapData.copyPixels(_loc17_, new Rectangle(0, 0, 342, 154), new Point(10, 10));
      _loc17_.dispose();
      _loc17_ = null;
      _loc32_.teams.text = this.barracks.teams;
      _loc32_.add_team.visible = this.barracks.teams < 4 && this.barracks.worms < 12;
      _loc32_.remove_team.visible = this.barracks.teams > 2;
      _loc2_ = 1;
      while (_loc2_ <= 4) {
        _loc32_["team" + _loc2_].visible = _loc2_ <= this.barracks.teams;
        _loc32_["worms" + _loc2_].visible = _loc2_ <= this.barracks.teams;
        _loc32_["worms" + _loc2_].text = this.barracks["team" + _loc2_].worms;
        _loc32_["team" + _loc2_].textColor = this.game_get_color(this.barracks["team" + _loc2_].color);
        _loc32_["worms" + _loc2_].textColor = this.game_get_color(this.barracks["team" + _loc2_].color);
        _loc32_["remove_worm" + _loc2_].visible = _loc2_ <= this.barracks.teams && this.barracks["team" + _loc2_].worms > 1;
        _loc32_["add_worm" + _loc2_].visible = _loc2_ <= this.barracks.teams && this.barracks["team" + _loc2_].worms < 8 && this.barracks.worms < 12;
        _loc2_++;
      }
    }
    if (this.cur_screen[this.cur_screen[0]].name == "weapon_sheet") {
      _loc62_ = 0;
      while (_loc32_.in_game_weapon_container.numChildren != 0) {
        if (++_loc62_ > 100000) {
          break;
        }
        _loc32_.in_game_weapon_container.getChildAt(0).removeEventListener(MouseEvent.CLICK, this.click);
        _loc32_.in_game_weapon_container.getChildAt(0).removeEventListener(MouseEvent.MOUSE_OVER, this.mouse_event);
        _loc32_.in_game_weapon_container.getChildAt(0).removeEventListener(MouseEvent.MOUSE_OUT, this.mouse_event);
        _loc32_.in_game_weapon_container.getChildAt(0).removeEventListener(MouseEvent.MOUSE_UP, this.mouse_event);
        _loc32_.in_game_weapon_container.getChildAt(0).removeEventListener(MouseEvent.MOUSE_DOWN, this.mouse_event);
        _loc66_ = _loc32_.in_game_weapon_container.getChildAt(0);
        _loc32_.in_game_weapon_container.removeChildAt(0);
        _loc66_ = null;
      }
      _loc110_ = this.FWP._proc.teams;
      _loc111_ = this.FWP._proc.cur_team;
      _loc112_ = 0;
      if (_loc34_.perks["fast_temp"]) {
        _loc112_ = this.FWP.get_perk_effect("fast_temp", _loc34_.perks.fast_temp, "");
      }
      _loc63_ = new Array();
      _loc64_ = 0;
      for (_loc23_ of as3.keys(_loc110_[_loc111_].weapons)) {
        _loc67_ = 0;
        _loc68_ = 0;
        for (_loc69_ of as3.keys(this.FWP.WP_PLACES_SORT)) {
          if (_loc23_ == this.FWP.WP_PLACES_SORT[_loc69_]) {
            break;
          }
        }
        _loc67_ = _loc69_;
        _loc70_ = 1;
        while (_loc70_ <= 10) {
          if (_loc110_[_loc111_].weapons[_loc23_][_loc70_] > 0) {
            _loc63_[_loc64_] = new Array<any>(this.FWP.WEAPONS_DEF[_loc23_].id, _loc23_, _loc67_, { "range": _loc70_ }, _loc110_[_loc111_].weapons[_loc23_][_loc70_]);
            _loc64_++;
          }
          _loc70_++;
        }
      }
      as3.sortOn(_loc63_, "2", as3.ArrayFlags.NUMERIC);
      // PORT (touch screens): as many weapons per page as the sheet's touch layout shows (sheet_page_size).
      const _per: number = this.sheet_page_size(_loc64_);
      _loc51_ = Math.ceil(_loc64_ / _per);
      if (this.FWP.sheet_layout()) {
        // (the grid of another screen shape: its pages kept in range)
        _loc51_ = Math.max(1, _loc51_);
        if (this.shop_page > _loc51_) {
          this.shop_page = _loc51_;
        }
      }
      _loc93_ = (this.shop_page - 1) * _per + 1;
      _loc94_ = Math.min(_loc64_, _loc93_ + _per - 1);
      if (_loc51_ > 1) {
        _loc32_.in_game_next_page.visible = true;
        _loc32_.in_game_prev_page.visible = true;
      }
      if (this.shop_page == 1) {
        _loc32_.in_game_prev_page.visible = false;
      }
      if (this.shop_page == _loc51_) {
        _loc32_.in_game_next_page.visible = false;
      }
      _loc113_ = 0;
      _loc114_ = 0;
      _loc2_ = _loc93_;
      while (_loc2_ <= _loc94_) {
        _loc23_ = _loc63_[_loc2_ - 1][1];
        _loc73_ = "%%" + _loc63_[_loc2_ - 1][3].range;
        _loc74_ = _loc32_.in_game_weapon_container.addChild(this.FWP.container_interf.get_object("clip_weapon_in_game"));
        _loc74_.name = "ingame_weapon_" + _loc23_ + _loc73_;
        _loc74_.weapon_functions.visible = false;
        this.bitmaps["ing_wp" + _loc2_] = new Bitmap();
        this.bitmap_datas["ing_wp" + _loc2_] = new BitmapData(50, 50, true, 0);
        _loc75_ = this.FWP.get_wpij(this.FWP.WEAPONS_DEF[_loc23_].id).i;
        _loc76_ = this.FWP.get_wpij(this.FWP.WEAPONS_DEF[_loc23_].id).j;
        this.bitmap_datas["ing_wp" + _loc2_].copyPixels(this.BigWP, new Rectangle(1 + 45 * (_loc76_ - 1), 1 + 44 * (_loc75_ - 1), 44, 43), new Point(2, 2));
        this.bitmap_datas["ing_wp" + _loc2_].copyPixels(this.PerkLevels[_loc63_[_loc2_ - 1][3].range], new Rectangle(0, 0, 47, 47), new Point(0, 0), null, null, true);
        if (_loc63_[_loc2_ - 1][4] == 100) {
          this.bitmap_datas["ing_wp" + _loc2_].copyPixels(this.WPAmount, new Rectangle(0, (11 - 2) * 10, 21, 9), new Point(3 - 1 + 44 - 16 - 7, 3 - 1 + 43 - 11), null, null, true);
        } else if (_loc63_[_loc2_ - 1][4] > 1) {
          this.bitmap_datas["ing_wp" + _loc2_].copyPixels(this.WPAmount, new Rectangle(0, (_loc63_[_loc2_ - 1][4] - 2) * 10, 21, 9), new Point(3 - 1 + 44 - 16 - 7, 3 - 1 + 43 - 11), null, null, true);
        }
        this.bitmap_datas["ing_wp" + _loc2_].copyPixels(this.WPBox, new Rectangle(0, 0, 47, 46), new Point(0, 0), null, null, true);
        if (this.FWP.WEAPONS_DEF[_loc23_].delay - _loc110_[_loc111_].turns - _loc112_ > 0) {
          this.bitmap_datas["ing_wp" + _loc2_].copyPixels(this.WPBlur, new Rectangle(0, 0, 47, 46), new Point(0, 0), null, null, true);
          this.bitmap_datas["ing_wp" + _loc2_].copyPixels(this.DelayDigits, new Rectangle(0, (this.FWP.WEAPONS_DEF[_loc23_].delay - _loc110_[_loc111_].turns - _loc112_ - 1) * 10, 14, 9), new Point(3, 3), null, null, true);
        }
        this.bitmaps["ing_wp" + _loc2_].bitmapData = this.bitmap_datas["ing_wp" + _loc2_];
        _loc74_.bitmap_container.addChild(this.bitmaps["ing_wp" + _loc2_]);
        _loc74_.x = _loc113_;
        _loc74_.y = _loc114_;
        _loc113_ += 50;
        if (_loc113_ >= 400) {
          _loc113_ = 0;
          _loc114_ += 50;
        }
        _loc2_++;
      }
    }
    if (this.cur_screen[this.cur_screen[0]].name == "crafting") {
      _loc62_ = 0;
      while (_loc32_.crafting_wp_container.numChildren != 0) {
        if (++_loc62_ > 100000) {
          break;
        }
        _loc32_.crafting_wp_container.getChildAt(0).removeEventListener(MouseEvent.CLICK, this.click);
        _loc32_.crafting_wp_container.getChildAt(0).removeEventListener(MouseEvent.MOUSE_OVER, this.mouse_event);
        _loc32_.crafting_wp_container.getChildAt(0).removeEventListener(MouseEvent.MOUSE_OUT, this.mouse_event);
        _loc32_.crafting_wp_container.getChildAt(0).removeEventListener(MouseEvent.MOUSE_UP, this.mouse_event);
        _loc32_.crafting_wp_container.getChildAt(0).removeEventListener(MouseEvent.MOUSE_DOWN, this.mouse_event);
        _loc66_ = _loc32_.crafting_wp_container.getChildAt(0);
        _loc32_.crafting_wp_container.removeChildAt(0);
        _loc66_ = null;
      }
      _loc62_ = 0;
      while (_loc32_.crafting_obj_container.numChildren != 0) {
        if (++_loc62_ > 100000) {
          break;
        }
        _loc32_.crafting_obj_container.getChildAt(0).removeEventListener(MouseEvent.CLICK, this.click);
        _loc32_.crafting_obj_container.getChildAt(0).removeEventListener(MouseEvent.MOUSE_OVER, this.mouse_event);
        _loc32_.crafting_obj_container.getChildAt(0).removeEventListener(MouseEvent.MOUSE_OUT, this.mouse_event);
        _loc32_.crafting_obj_container.getChildAt(0).removeEventListener(MouseEvent.MOUSE_UP, this.mouse_event);
        _loc32_.crafting_obj_container.getChildAt(0).removeEventListener(MouseEvent.MOUSE_DOWN, this.mouse_event);
        _loc66_ = _loc32_.crafting_obj_container.getChildAt(0);
        _loc32_.crafting_obj_container.removeChildAt(0);
        _loc66_ = null;
      }
      _loc62_ = 0;
      while (_loc32_.crafting_stack_container.numChildren != 0) {
        if (++_loc62_ > 100000) {
          break;
        }
        _loc32_.crafting_stack_container.getChildAt(0).removeEventListener(MouseEvent.CLICK, this.click);
        _loc32_.crafting_stack_container.getChildAt(0).removeEventListener(MouseEvent.MOUSE_OVER, this.mouse_event);
        _loc32_.crafting_stack_container.getChildAt(0).removeEventListener(MouseEvent.MOUSE_OUT, this.mouse_event);
        _loc32_.crafting_stack_container.getChildAt(0).removeEventListener(MouseEvent.MOUSE_UP, this.mouse_event);
        _loc32_.crafting_stack_container.getChildAt(0).removeEventListener(MouseEvent.MOUSE_DOWN, this.mouse_event);
        _loc66_ = _loc32_.crafting_stack_container.getChildAt(0);
        _loc32_.crafting_stack_container.removeChildAt(0);
        _loc66_ = null;
      }
      _loc62_ = 0;
      while (_loc32_.crafting_diss_container.numChildren != 0) {
        if (++_loc62_ > 100000) {
          break;
        }
        _loc32_.crafting_diss_container.getChildAt(0).removeEventListener(MouseEvent.CLICK, this.click);
        _loc32_.crafting_diss_container.getChildAt(0).removeEventListener(MouseEvent.MOUSE_OVER, this.mouse_event);
        _loc32_.crafting_diss_container.getChildAt(0).removeEventListener(MouseEvent.MOUSE_OUT, this.mouse_event);
        _loc32_.crafting_diss_container.getChildAt(0).removeEventListener(MouseEvent.MOUSE_UP, this.mouse_event);
        _loc32_.crafting_diss_container.getChildAt(0).removeEventListener(MouseEvent.MOUSE_DOWN, this.mouse_event);
        _loc66_ = _loc32_.crafting_diss_container.getChildAt(0);
        _loc32_.crafting_diss_container.removeChildAt(0);
        _loc66_ = null;
      }
      _loc115_ = [0, false, false, false, false, false, false];
      _loc116_ = false;
      _loc117_ = false;
      _loc63_ = new Array();
      _loc64_ = 0;
      _loc31_ = _loc34_.weapons;
      _loc30_ = this.FWP.WEAPONS_DEF;
      for (_loc65_ of as3.keys(_loc31_)) {
        if (_loc31_[_loc65_][0] != 0 && _loc65_ != "skip_go") {
          _loc67_ = 0;
          for (_loc69_ of as3.keys(this.FWP.WP_PLACES_SORT)) {
            if (_loc65_ == this.FWP.WP_PLACES_SORT[_loc69_]) {
              break;
            }
          }
          _loc67_ = _loc69_;
          _loc70_ = 1;
          while (_loc70_ <= _loc31_[_loc65_][0]) {
            _loc130_ = true;
            if (Boolean((_loc130_) && !_loc117_ && this.floating_weapon.id == _loc65_ && Number(this.floating_weapon.range) == _loc31_[_loc65_][_loc70_].range && this.floating_weapon.stolen == _loc31_[_loc65_][_loc70_].stolen) && Boolean(this.floating_weapon.crafted == _loc31_[_loc65_][_loc70_].crafted) && this.floating_weapon.tp == "weapon") {
              _loc117_ = true;
              _loc130_ = false;
            }
            _loc131_ = 1;
            while (_loc131_ <= 6) {
              if (this.weapon_stack[_loc131_]["id"]) {
                if (Boolean(_loc130_ && !_loc115_[_loc131_] && this.weapon_stack[_loc131_].id == _loc65_ && Number(this.weapon_stack[_loc131_].range) == _loc31_[_loc65_][_loc70_].range && this.weapon_stack[_loc131_].stolen == _loc31_[_loc65_][_loc70_].stolen) && Boolean(this.weapon_stack[_loc131_].crafted == _loc31_[_loc65_][_loc70_].crafted) && this.weapon_stack[_loc131_].tp == "weapon") {
                  _loc115_[_loc131_] = true;
                  _loc130_ = false;
                }
              }
              _loc131_++;
            }
            if (Boolean(_loc130_ && !_loc116_ && this.weapon_diss.id == _loc65_ && Number(this.weapon_diss.range) == _loc31_[_loc65_][_loc70_].range && this.weapon_diss.stolen == _loc31_[_loc65_][_loc70_].stolen) && Boolean(this.weapon_diss.crafted == _loc31_[_loc65_][_loc70_].crafted) && this.weapon_diss.tp == "weapon") {
              _loc116_ = true;
              _loc130_ = false;
            }
            if (_loc130_) {
              _loc71_ = true;
              _loc72_ = 0;
              while (_loc72_ < _loc64_) {
                if (_loc63_[_loc72_][0] == _loc30_[_loc65_].id && _loc63_[_loc72_][1] == _loc65_ && _loc63_[_loc72_][3].range == _loc31_[_loc65_][_loc70_].range && _loc63_[_loc72_][3].stolen == _loc31_[_loc65_][_loc70_].stolen && _loc63_[_loc72_][3].crafted == _loc31_[_loc65_][_loc70_].crafted) {
                  _loc71_ = false;
                  ++_loc63_[_loc72_][4];
                }
                _loc72_++;
              }
              if (_loc71_) {
                _loc63_[_loc64_] = new Array<any>(_loc30_[_loc65_].id, _loc65_, _loc67_, {
                  "range": _loc31_[_loc65_][_loc70_].range,
                  "stolen": _loc31_[_loc65_][_loc70_].stolen,
                  "crafted": _loc31_[_loc65_][_loc70_].crafted
                }, 1);
                _loc64_++;
              }
            }
            _loc70_++;
          }
        }
      }
      as3.sortOn(_loc63_, "2", as3.ArrayFlags.NUMERIC);
      _loc118_ = new Array();
      _loc119_ = 0;
      _loc31_ = _loc34_.objs;
      _loc30_ = this.FWP.OBJ_DEF;
      for (_loc120_ of as3.keys(_loc31_)) {
        if (_loc31_[_loc120_] != 0) {
          _loc132_ = 0;
          if (!_loc117_ && this.floating_weapon.id == _loc120_ && this.floating_weapon.tp == "object") {
            _loc117_ = true;
            _loc132_++;
          }
          _loc131_ = 1;
          while (_loc131_ <= 6) {
            if (this.weapon_stack[_loc131_]["id"]) {
              if (!_loc115_[_loc131_] && this.weapon_stack[_loc131_].id == _loc120_ && this.weapon_stack[_loc131_].tp == "object") {
                _loc115_[_loc131_] = true;
                _loc132_++;
              }
            }
            _loc131_++;
          }
          if (_loc31_[_loc120_] > _loc132_) {
            _loc118_[_loc119_] = new Array<any>(this.FWP.OBJ_DEF[_loc120_].id, _loc120_, this.FWP.OBJ_DEF[_loc120_].id, {}, _loc31_[_loc120_] - _loc132_);
            _loc119_++;
          }
        }
      }
      as3.sortOn(_loc118_, "2", as3.ArrayFlags.NUMERIC);
      _loc93_ = (this.craft_wp_page - 1) * 11 + 1;
      _loc94_ = Math.min(_loc64_, _loc93_ + 10);
      _loc121_ = Math.ceil(_loc64_ / 11);
      if (_loc121_ > 1) {
        _loc32_.craft_wp_prev_page.visible = true;
        _loc32_.craft_wp_next_page.visible = true;
      }
      if (this.craft_wp_page == 1) {
        _loc32_.craft_wp_prev_page.visible = false;
      }
      if (this.craft_wp_page >= _loc121_) {
        _loc32_.craft_wp_next_page.visible = false;
      }
      _loc122_ = (this.craft_obj_page - 1) * 11 + 1;
      _loc123_ = Math.min(_loc119_, _loc122_ + 10);
      _loc124_ = Math.ceil(_loc119_ / 11);
      if (_loc124_ > 1) {
        _loc32_.craft_obj_prev_page.visible = true;
        _loc32_.craft_obj_next_page.visible = true;
      }
      if (this.craft_obj_page == 1) {
        _loc32_.craft_obj_prev_page.visible = false;
      }
      if (this.craft_obj_page >= _loc124_) {
        _loc32_.craft_obj_next_page.visible = false;
      }
      _loc113_ = 0;
      _loc114_ = 0;
      _loc2_ = _loc93_;
      while (_loc2_ <= _loc94_) {
        _loc23_ = _loc63_[_loc2_ - 1][1];
        _loc73_ = "%";
        if (_loc63_[_loc2_ - 1][3].stolen) {
          _loc73_ += "s";
        } else if (_loc63_[_loc2_ - 1][3].crafted) {
          _loc73_ += "c";
        }
        _loc73_ += "%" + _loc63_[_loc2_ - 1][3].range;
        _loc74_ = _loc32_.crafting_wp_container.addChild(this.FWP.container_interf.get_object("clip_weapon_in_game"));
        _loc74_.name = "craft_weapon_" + _loc23_ + _loc73_;
        _loc74_.weapon_functions.visible = false;
        this.bitmaps["craft_wp" + _loc2_] = new Bitmap();
        this.bitmap_datas["craft_wp" + _loc2_] = new BitmapData(50, 50, true, 0);
        _loc75_ = this.FWP.get_wpij(this.FWP.WEAPONS_DEF[_loc23_].id).i;
        _loc76_ = this.FWP.get_wpij(this.FWP.WEAPONS_DEF[_loc23_].id).j;
        this.bitmap_datas["craft_wp" + _loc2_].copyPixels(this.BigWP, new Rectangle(1 + 45 * (_loc76_ - 1), 1 + 44 * (_loc75_ - 1), 44, 43), new Point(2, 2));
        this.bitmap_datas["craft_wp" + _loc2_].copyPixels(this.PerkLevels[_loc63_[_loc2_ - 1][3].range], new Rectangle(0, 0, 47, 47), new Point(0, 0), null, null, true);
        if (_loc63_[_loc2_ - 1][4] == 100) {
          this.bitmap_datas["craft_wp" + _loc2_].copyPixels(this.WPAmount, new Rectangle(0, (11 - 2) * 10, 21, 9), new Point(3 - 1 + 44 - 16 - 7, 3 - 1 + 43 - 11), null, null, true);
        } else if (_loc63_[_loc2_ - 1][4] > 1) {
          this.bitmap_datas["craft_wp" + _loc2_].copyPixels(this.WPAmount, new Rectangle(0, (_loc63_[_loc2_ - 1][4] - 2) * 10, 21, 9), new Point(3 - 1 + 44 - 16 - 7, 3 - 1 + 43 - 11), null, null, true);
        }
        this.bitmap_datas["craft_wp" + _loc2_].copyPixels(this.WPBox, new Rectangle(0, 0, 47, 46), new Point(0, 0), null, null, true);
        this.bitmaps["craft_wp" + _loc2_].bitmapData = this.bitmap_datas["craft_wp" + _loc2_];
        _loc74_.bitmap_container.addChild(this.bitmaps["craft_wp" + _loc2_]);
        _loc74_.x = _loc113_;
        _loc113_ += 50;
        _loc2_++;
      }
      _loc113_ = 0;
      _loc2_ = _loc122_;
      while (_loc2_ <= _loc123_) {
        _loc23_ = _loc118_[_loc2_ - 1][1];
        _loc74_ = _loc32_.crafting_obj_container.addChild(this.FWP.container_interf.get_object("clip_weapon_in_game"));
        _loc74_.name = "craft_object_" + _loc23_;
        _loc74_.weapon_functions.visible = false;
        this.bitmaps["craft_obj" + _loc2_] = new Bitmap();
        this.bitmap_datas["craft_obj" + _loc2_] = new BitmapData(50, 50, true, 0);
        this.bitmap_datas["craft_obj" + _loc2_].copyPixels(this.BigObjs, new Rectangle(1 + 45 * (this.FWP.OBJ_DEF[_loc23_].id - 1), 1, 44, 43), new Point(2, 2));
        if (_loc118_[_loc2_ - 1][4] > 10) {
          this.bitmap_datas["craft_obj" + _loc2_].copyPixels(this.WP10Plus, new Rectangle(0, 0, 21, 9), new Point(3 - 1 + 44 - 16 - 7, 3 - 1 + 43 - 11), null, null, true);
        } else if (_loc118_[_loc2_ - 1][4] > 1) {
          this.bitmap_datas["craft_obj" + _loc2_].copyPixels(this.WPAmount, new Rectangle(0, (_loc118_[_loc2_ - 1][4] - 2) * 10, 21, 9), new Point(3 - 1 + 44 - 16 - 7, 3 - 1 + 43 - 11), null, null, true);
        }
        this.bitmap_datas["craft_obj" + _loc2_].copyPixels(this.WPBox, new Rectangle(0, 0, 47, 46), new Point(0, 0), null, null, true);
        this.bitmaps["craft_obj" + _loc2_].bitmapData = this.bitmap_datas["craft_obj" + _loc2_];
        _loc74_.bitmap_container.addChild(this.bitmaps["craft_obj" + _loc2_]);
        _loc74_.x = _loc113_;
        _loc113_ += 50;
        _loc2_++;
      }
      _loc113_ = 0;
      _loc114_ = 0;
      _loc2_ = 1;
      while (_loc2_ <= 6) {
        _loc74_ = _loc32_.crafting_stack_container.addChild(this.FWP.container_interf.get_object("clip_weapon_in_game"));
        _loc74_.name = "craft_stack_" + _loc2_;
        _loc74_.weapon_functions.visible = false;
        this.bitmaps["craft_stack" + _loc2_] = new Bitmap();
        this.bitmap_datas["craft_stack" + _loc2_] = new BitmapData(50, 50, true, 0);
        if (this.weapon_stack[_loc2_].tp) {
          if (this.weapon_stack[_loc2_].tp == "weapon") {
            _loc75_ = this.FWP.get_wpij(this.FWP.WEAPONS_DEF[this.weapon_stack[_loc2_].id].id).i;
            _loc76_ = this.FWP.get_wpij(this.FWP.WEAPONS_DEF[this.weapon_stack[_loc2_].id].id).j;
            this.bitmap_datas["craft_stack" + _loc2_].copyPixels(this.BigWP, new Rectangle(1 + 45 * (_loc76_ - 1), 1 + 44 * (_loc75_ - 1), 44, 43), new Point(2, 2));
            this.bitmap_datas["craft_stack" + _loc2_].copyPixels(this.PerkLevels[this.weapon_stack[_loc2_].range], new Rectangle(0, 0, 47, 47), new Point(0, 0), null, null, true);
          } else {
            this.bitmap_datas["craft_stack" + _loc2_].copyPixels(this.BigObjs, new Rectangle(1 + 45 * (this.FWP.OBJ_DEF[this.weapon_stack[_loc2_].id].id - 1), 1, 44, 43), new Point(2, 2));
          }
        }
        this.bitmap_datas["craft_stack" + _loc2_].copyPixels(this.WPBox, new Rectangle(0, 0, 47, 46), new Point(0, 0), null, null, true);
        this.bitmaps["craft_stack" + _loc2_].bitmapData = this.bitmap_datas["craft_stack" + _loc2_];
        _loc74_.bitmap_container.addChild(this.bitmaps["craft_stack" + _loc2_]);
        _loc74_.x = _loc113_;
        _loc74_.y = _loc114_;
        _loc113_ += 60;
        if (_loc113_ > 120) {
          _loc113_ = 0;
          _loc114_ += 60;
        }
        _loc2_++;
      }
      _loc74_ = _loc32_.crafting_stack_container.addChild(this.FWP.container_interf.get_object("clip_weapon_in_game"));
      _loc74_.name = "craft_stack_7";
      _loc74_.weapon_functions.visible = false;
      this.bitmaps["craft_stack7"] = new Bitmap();
      this.bitmap_datas["craft_stack7"] = new BitmapData(50, 50, true, 0);
      _loc125_ = 0;
      if (this.FWP.player.perks["crafting"]) {
        _loc125_ = this.FWP.player.perks["crafting"];
      }
      if (this.FWP.player.spec == 4) {
        _loc125_ = 3;
      }
      _loc126_ = this.check_recipe(this.weapon_stack, _loc34_.recipes, _loc125_);
      _loc127_ = false;
      _loc128_ = 0;
      _loc129_ = 0;
      _loc2_ = 1;
      while (_loc2_ <= 6) {
        if (this.weapon_stack[_loc2_].tp == "weapon") {
          _loc128_++;
        }
        if (this.weapon_stack[_loc2_].id) {
          _loc129_++;
        }
        _loc2_++;
      }
      if (_loc129_ > 1 && _loc128_ > 0) {
        _loc127_ = true;
      }
      if (_loc126_.id != "" && _loc126_.prob == 100) {
        _loc75_ = this.FWP.get_wpij(this.FWP.WEAPONS_DEF[_loc126_.id].id).i;
        _loc76_ = this.FWP.get_wpij(this.FWP.WEAPONS_DEF[_loc126_.id].id).j;
        this.bitmap_datas["craft_stack7"].copyPixels(this.BigWP, new Rectangle(1 + 45 * (_loc76_ - 1), 1 + 44 * (_loc75_ - 1), 44, 43), new Point(2, 2));
        this.bitmap_datas["craft_stack7"].copyPixels(this.PerkLevels[_loc126_.range], new Rectangle(0, 0, 47, 47), new Point(0, 0), null, null, true);
      } else if (_loc127_) {
        this.bitmap_datas["craft_stack7"].copyPixels(this.IconQuestion, new Rectangle(0, 0, 45, 45), new Point(2, 2));
      }
      _loc32_.craft_assemble.visible = _loc127_;
      this.bitmap_datas["craft_stack7"].copyPixels(this.WPBox, new Rectangle(0, 0, 47, 46), new Point(0, 0), null, null, true);
      this.bitmaps["craft_stack7"].bitmapData = this.bitmap_datas["craft_stack7"];
      _loc74_.bitmap_container.addChild(this.bitmaps["craft_stack7"]);
      _loc74_.x = 215;
      _loc74_.y = 30;
      _loc74_ = _loc32_.crafting_diss_container.addChild(this.FWP.container_interf.get_object("clip_weapon_in_game"));
      _loc74_.name = "craft_diss";
      _loc74_.weapon_functions.visible = false;
      this.bitmaps["craft_diss"] = new Bitmap();
      this.bitmap_datas["craft_diss"] = new BitmapData(50, 50, true, 0);
      if (this.weapon_diss.tp) {
        this.bitmaps["craft_diss"] = new Bitmap();
        this.bitmap_datas["craft_diss"] = new BitmapData(50, 50, true, 0);
        _loc75_ = this.FWP.get_wpij(this.FWP.WEAPONS_DEF[this.weapon_diss.id].id).i;
        _loc76_ = this.FWP.get_wpij(this.FWP.WEAPONS_DEF[this.weapon_diss.id].id).j;
        this.bitmap_datas["craft_diss"].copyPixels(this.BigWP, new Rectangle(1 + 45 * (_loc76_ - 1), 1 + 44 * (_loc75_ - 1), 44, 43), new Point(2, 2));
        this.bitmap_datas["craft_diss"].copyPixels(this.PerkLevels[this.weapon_diss.range], new Rectangle(0, 0, 47, 47), new Point(0, 0), null, null, true);
      }
      _loc32_.craft_disassemble.visible = this.weapon_diss.tp;
      this.bitmap_datas["craft_diss"].copyPixels(this.WPBox, new Rectangle(0, 0, 47, 46), new Point(0, 0), null, null, true);
      this.bitmaps["craft_diss"].bitmapData = this.bitmap_datas["craft_diss"];
      _loc74_.bitmap_container.addChild(this.bitmaps["craft_diss"]);
    }
    if (this.cur_screen[this.cur_screen[0]].name == "finish_crafting") {
      if (this.crafting_result.error != "") {
        _loc32_.header.text = "Вы не можете собрать это оружие";
        _loc32_.main.text = "Вам необходима способность\n\"Крафтинг\" уровня " + this.crafting_result.error.split("req")[1] + ".";
      } else if (!this.crafting_result.success) {
        _loc32_.header.text = "У вас не получилось собрать оружие";
        _loc32_.main.text = "Попробуйте разобрать нужное\nоружие или купить нужный рецепт.";
        if (this.crafting_result.junk[0] != 0) {
          _loc32_.recipe_opened.text = "В инвентарь добавлены сломанные детали (" + this.crafting_result.junk[0] + ").";
        }
      } else if (this.crafting_result.mode == "disassemble") {
        _loc32_.header.text = "Вы успешно разобрали оружие!";
        _loc32_.main.text = this.FWP.WEAPONS_DEF[this.crafting_result.id].name;
        if (this.crafting_result.new_recipe) {
          _loc32_.recipe_opened.text = "Открыт новый рецепт.";
        } else if (this.crafting_result.new_object) {
          _loc32_.recipe_opened.text = "Добавлен компонент: " + this.FWP.OBJ_DEF[this.crafting_result.new_object].name;
        } else {
          _loc32_.recipe_opened.text = "Не получилось достать новых компонентов.";
        }
      } else {
        _loc32_.header.text = "Вы успешно собрали оружие!";
        _loc32_.main.text = this.FWP.WEAPONS_DEF[this.crafting_result.id].name;
        if (this.crafting_result.new_recipe) {
          _loc32_.recipe_opened.text = "Открыт новый рецепт.";
        }
      }
      if (Boolean(this.crafting_result.success) || this.crafting_result.mode == "disassemble") {
        _loc2_ = this.FWP.get_wpij(this.FWP.WEAPONS_DEF[this.crafting_result.id].id).i;
        _loc3_ = this.FWP.get_wpij(this.FWP.WEAPONS_DEF[this.crafting_result.id].id).j;
        this.bitmap_datas["craft_result_icon"].copyPixels(this.BigWP, new Rectangle(1 + 45 * (_loc3_ - 1), 1 + 44 * (_loc2_ - 1), 44, 43), new Point(2, 2));
        this.bitmap_datas["craft_result_icon"].copyPixels(this.PerkLevels[this.crafting_result.range], new Rectangle(0, 0, 47, 47), new Point(0, 0), null, null, true);
      } else {
        this.bitmap_datas["craft_result_icon"].copyPixels(this.IconQuestion, new Rectangle(0, 0, 45, 45), new Point(2, 2));
      }
      this.bitmap_datas["craft_result_icon"].copyPixels(this.WPBox, new Rectangle(0, 0, 47, 46), new Point(0, 0), null, null, true);
    }
    if (this.cur_screen[this.cur_screen[0]].name == "recipes") {
      _loc24_ = 0;
      _loc133_ = 0;
      _loc134_ = [0, 0];
      _loc2_ = 1;
      while (_loc2_ <= this.FWP.CRAFT_DEF[0]) {
        if (_loc34_.recipes[_loc2_] == 1) {
          ++_loc134_[0];
          _loc134_[_loc134_[0]] = _loc2_;
        }
        _loc2_++;
      }
      _loc2_ = 1;
      while (_loc2_ <= this.FWP.CRAFT_DEF[0]) {
        if (_loc34_.recipes[_loc2_] != 1) {
          ++_loc134_[0];
          _loc134_[_loc134_[0]] = _loc2_;
        }
        _loc2_++;
      }
      _loc3_ = 1;
      while (_loc3_ <= this.FWP.CRAFT_DEF[0]) {
        _loc2_ = _loc134_[_loc3_];
        _loc135_ = _loc32_.recipes_container.addChild(this.FWP.container_interf.get_object("clip_weapon_recipes"));
        _loc135_.name = "recipe_clip_" + String(_loc2_);
        this.bitmaps["rcp" + _loc2_] = new Bitmap();
        this.bitmap_datas["rcp" + _loc2_] = new BitmapData(50, 50, true, 0);
        _loc135_.wp_name.text = this.FWP.WEAPONS_DEF[this.FWP.CRAFT_DEF[_loc2_].result].name;
        _loc75_ = this.FWP.get_wpij(this.FWP.WEAPONS_DEF[this.FWP.CRAFT_DEF[_loc2_].result].id).i;
        _loc76_ = this.FWP.get_wpij(this.FWP.WEAPONS_DEF[this.FWP.CRAFT_DEF[_loc2_].result].id).j;
        this.bitmap_datas["rcp" + _loc2_].copyPixels(this.BigWP, new Rectangle(1 + 45 * (_loc76_ - 1), 1 + 44 * (_loc75_ - 1), 44, 43), new Point(2, 2));
        this.bitmap_datas["rcp" + _loc2_].copyPixels(this.WPBox, new Rectangle(0, 0, 47, 46), new Point(0, 0), null, null, true);
        this.bitmaps["rcp" + _loc2_].bitmapData = this.bitmap_datas["rcp" + _loc2_];
        _loc135_.bitmap_container.addChild(this.bitmaps["rcp" + _loc2_]);
        _loc135_.y = _loc24_;
        _loc24_ += 55;
        if (_loc34_.recipes[_loc2_] != 1) {
          _loc135_.alpha = 0.3;
        } else {
          _loc133_++;
        }
        _loc3_++;
      }
      _loc32_.slider.visible = _loc32_.recipes_container.height > 489;
      _loc32_.recipes_opened.text = String(_loc133_) + " / " + String(this.FWP.CRAFT_DEF[0]);
      _loc32_.recipes_text.visible = false;
      _loc32_.component_result.visible = false;
      _loc2_ = 1;
      while (_loc2_ <= 6) {
        _loc32_["component" + String(_loc2_)].visible = false;
        _loc2_++;
      }
    }
    if (this.cur_screen[this.cur_screen[0]].name == "pay") {
      // PORT: VK removed: buying diamonds for VK "votes" (the offline build granted them for free). menu_pay has one
      // PORT: "votes"/"diam_from_votes" TextField per donate button (same instance names), so every child is hidden.
      // PORT: With the game's own store (Google Play in the Android app) the block shows its packs instead
      // PORT: (runtime/monetization-ui.ts renderStorePay).
      if (renderStorePay(this, _loc32_)) {
        renderPayWithoutStore(this, _loc32_, false);
      } else {
        this.hide_named_children(_loc32_, ["votes", "diam_from_votes", "donate1", "donate3", "donate10", "donate25", "donate50", "donate100"]);
        // PORT: VK removed: the rest of the "Купить алмазы" block (its title, the frame and the diamond/vote icons above
        // PORT: the exchange); diamonds come from the game itself and from operator gifts. The exchange stays; the
        // PORT: block's band says where the diamonds come from (runtime/monetization-ui.ts).
        this.hide_unnamed_in_band(_loc32_, 100, 320, 200);
        renderPayWithoutStore(this, _loc32_);
      }
      _loc32_.diam_to_gold.text = this.PLAYER_DIAM - this.DIAM_TO_TRANS;
      _loc32_.gold.text = this.DIAM_TO_TRANS * 1100;
      _loc32_.gold_add.visible = this.PLAYER_DIAM - this.DIAM_TO_TRANS > 0;
      _loc32_.gold_all.visible = this.PLAYER_DIAM - this.DIAM_TO_TRANS > 0;
      _loc32_.gold_pay.visible = this.DIAM_TO_TRANS > 0;
    }
    if (this.cur_screen[this.cur_screen[0]].name == "settings") {
      // PORT: the game's accounts and the language switch (the original was Russian only): one full-size button of the
      // PORT: screen opens their dialog (FWP.net_account_dialog: the languages, sign out, delete the account; a pick of
      // PORT: a language restarts the game, signing out and deleting restart into the sign-in screen).
      accountButton(_loc32_, this.FWP, () => this.FWP.net_account_dialog());
      _loc136_ = _loc34_.settings.skill;
      _loc137_ = _loc136_ >= 10 ? _loc136_ - 10 : _loc136_;
      _loc32_.skill0.htmlText = "Обычный (1х)";
      _loc32_.skill1.htmlText = "Сложный (1.15х)";
      _loc32_.skill2.htmlText = "Очень сложный (1.3х)";
      _loc32_.skill3.htmlText = "Невозможный (1.6х)";
      _loc32_.skill4.htmlText = "Кошмар (2х)";
      _loc32_["skill" + _loc137_].htmlText = "<b>" + _loc32_["skill" + _loc137_].htmlText + "</b>";
      _loc32_.hardcore_clip.gotoAndStop(_loc136_ >= 10 ? 2 : 1);
      _loc32_.animation_clip.gotoAndStop(_loc34_.settings.no_animation == 0 ? 2 : 1);
      _loc2_ = 0;
      while (_loc2_ <= 4) {
        _loc32_["skill" + _loc2_].textColor = _loc137_ == _loc2_ ? 3394560 : 0;
        _loc2_++;
      }
      _loc2_ = 1;
      while (_loc2_ <= 5) {
        _loc32_["worm_name" + _loc2_].text = _loc34_["worm_name" + _loc2_] ? _loc34_["worm_name" + _loc2_] : "Червь #" + _loc2_;
        if (_loc2_ <= _loc34_.worms.value + 2) {
          _loc32_["worm_name" + _loc2_].type = TextFieldType.INPUT;
          _loc32_["worm_name" + _loc2_].selectable = true;
          _loc32_["worm_name" + _loc2_].backgroundColor = 16777215;
          _loc32_["worm_name" + _loc2_].borderColor = 0;
          _loc32_["worm_name" + _loc2_].textColor = 0;
        } else {
          _loc32_["worm_name" + _loc2_].type = TextFieldType.DYNAMIC;
          _loc32_["worm_name" + _loc2_].selectable = false;
          _loc32_["worm_name" + _loc2_].backgroundColor = 10066329;
          _loc32_["worm_name" + _loc2_].borderColor = 6710886;
          _loc32_["worm_name" + _loc2_].textColor = 6710886;
        }
        _loc2_++;
      }
    }
    if (this.cur_screen[this.cur_screen[0]].name == "question") {
      // PORT: design D5 - the result of an online battle (runtime/online-lobby.ts).
      if (this.question_mode == "online_result" && this.FWP.online) {
        this.FWP.online.render_result(_loc32_);
      }
      // PORT: item 8 - the confirmations of the clans screen (leave, kick, hand the leadership over, disband).
      if (String(this.question_mode).indexOf("clan_") == 0 && this.FWP.clans) {
        this.FWP.clans.render("question", _loc32_);
      }
      // PORT: the offer to save the last battle's replay (runtime/replay-offer.ts).
      if (this.question_mode == REPLAY_OFFER_MODE) {
        renderReplayOffer(this, _loc32_);
      }
      if (this.question_mode == "reset_perks") {
        _loc32_.header.text = "Сбросить навыки и способности ?";
        _loc32_.main.text = "Стоимость сброса навыков и способностей - 10 алмазов. При сбросе ВСЕ потраченные очки навыков и способностей вам возвращаются. Купленные места для способностей сохраняются." + (_loc34_.last_reset == 0 ? "" : " Вы сможете еще раз сбросить навыки и способности на " + (_loc34_.last_reset + 5) + " уровне.");
        _loc32_.proceed.visible = _loc34_.diam.value >= 10 && (_loc34_.last_reset == 0 || _loc34_.level.value >= _loc34_.last_reset + 5);
      }
      if (this.question_mode == "null_all") {
        _loc32_.header.text = "Начать игру заново ?";
        _loc32_.main.text = "Все ваши достижения будут обнулены. Это действие нельзя будет отменить. Вам необходим как минимум пятый уровень для этого действия.";
        _loc32_.proceed.visible = _loc34_.level.value >= 5;
      }
    }
    if (this.cur_screen[this.cur_screen[0]].name == "tired") {
      _loc138_ = "Текущая усталость: <b>" + _loc36_.tired + "%</b>\n\n";
      _loc139_ = _loc36_.attack - _loc34_.attack.value;
      _loc140_ = _loc36_.protect - _loc34_.protect.value;
      _loc141_ = _loc36_.health - (100 + 50 * _loc34_.health.value);
      if (_loc139_ >= 0 && _loc140_ >= 0 && _loc141_ >= 0) {
        _loc138_ += "нет эффектов";
      } else {
        if (_loc139_ < 0) {
          _loc138_ += "Атака <b>" + _loc139_ + "</b>\n";
        }
        if (_loc140_ < 0) {
          _loc138_ += "Защита <b>" + _loc140_ + "</b>\n";
        }
        if (_loc141_ < 0) {
          _loc138_ += "Здоровье <b>" + _loc141_ + "</b>\n";
        }
      }
      _loc32_.main.htmlText = _loc138_;
    }
    if (this.cur_screen[this.cur_screen[0]].name == "achiev") {
      _loc142_ = this.FWP.get_achiev_bonus();
      _loc32_.clip_get_achiev_bonus.visible = _loc142_.exist;
      if (this.achiev_bonus_text == "") {
        _loc32_.achiev_desc.htmlText = "За разнообразные достижения в игре предусмотрены награды в виде опыта, золота, алмазов и рейтинга. Для подробностей кликните по иконке любого достижения.";
      } else {
        _loc32_.achiev_desc.htmlText = this.achiev_bonus_text;
      }
      _loc2_ = 1;
      while (_loc2_ <= this.FWP.ACHIEV_DEF[0]) {
        this.bitmaps["ach" + _loc2_] = new Bitmap();
        this.bitmap_datas["ach" + _loc2_] = new BitmapData(50, 50, true, 0);
        this.bitmaps["ach" + _loc2_].bitmapData = this.bitmap_datas["ach" + _loc2_];
        this.buttons["ach_" + _loc2_].bitmap_container.addChild(this.bitmaps["ach" + _loc2_]);
        this.buttons["ach_" + _loc2_].back.gotoAndStop(1);
        _loc143_ = this.FWP.player.achiev[this.FWP.ACHIEV_DEF[_loc2_].id];
        if (!_loc143_) {
          _loc143_ = 0;
        }
        _loc144_ = this.FWP.get_achiev_level(this.FWP.ACHIEV_DEF[_loc2_].id, _loc143_);
        if (_loc144_ > 0) {
          this.bitmap_datas["ach" + _loc2_].copyPixels(this.AchievBitmap, new Rectangle((_loc2_ - 1) * 47, 0, 47, 47), new Point(0, 0));
          this.bitmap_datas["ach" + _loc2_].copyPixels(this.PerkLevels[_loc144_], new Rectangle(0, 0, 47, 47), new Point(0, 0), null, null, true);
        } else {
          this.bitmap_datas["ach" + _loc2_].copyPixels(this.AchievBitmap, new Rectangle((_loc2_ - 1) * 47, 47, 47, 47), new Point(0, 0));
        }
        this.bitmap_datas["ach" + _loc2_].copyPixels(this.WPBox, new Rectangle(0, 0, 47, 46), new Point(0, 0), null, null, true);
        _loc2_++;
      }
      _loc32_.achiev_range.text = _loc34_.last_achiev_range;
      _loc32_.achiev_rating_bonus.text = _loc34_.achiev_rating_bonus;
    }
    if (this.cur_screen[this.cur_screen[0]].name == "roul") {
      _loc32_.gold.text = this.x3SHString(_loc34_.gold.value);
      _loc32_.diam.text = this.x3SHString(_loc34_.diam.value);
      _loc32_.bet_gold_500.textColor = _loc34_.gold.value >= 500 ? 6710784 : 10066329;
      _loc32_.bet_gold_3000.textColor = _loc34_.gold.value >= 3000 ? 6710784 : 10066329;
      _loc32_.bet_gold_10000.textColor = _loc34_.gold.value >= 10000 ? 6710784 : 10066329;
      _loc32_.bet_diam_5.textColor = _loc34_.diam.value >= 5 ? 16486 : 10066329;
      _loc32_.bet_diam_25.textColor = _loc34_.diam.value >= 25 ? 16486 : 10066329;
      _loc32_.bet_diam_50.textColor = _loc34_.diam.value >= 50 ? 16486 : 10066329;
    }
    if (this.cur_screen[this.cur_screen[0]].name == "roul result") {
      if (this.FWP.roul_weapon != "") {
        _loc32_.header.text = "Вы выиграли оружие:";
        _loc32_.main.text = this.FWP.WEAPONS_DEF[this.FWP.roul_weapon].name;
        _loc2_ = this.FWP.get_wpij(this.FWP.WEAPONS_DEF[this.FWP.roul_weapon].id).i;
        _loc3_ = this.FWP.get_wpij(this.FWP.WEAPONS_DEF[this.FWP.roul_weapon].id).j;
        this.bitmap_datas["roul_or_grave_result_icon"].copyPixels(this.BigWP, new Rectangle(1 + 45 * (_loc3_ - 1), 1 + 44 * (_loc2_ - 1), 44, 43), new Point(2, 2));
        this.bitmap_datas["roul_or_grave_result_icon"].copyPixels(this.WPBox, new Rectangle(0, 0, 47, 46), new Point(0, 0), null, null, true);
      } else {
        _loc32_.header.text = "К сожалению, вы ничего не выиграли.";
        _loc32_.main.text = "";
      }
      this.surprise = "";
    }
    if (this.cur_screen[this.cur_screen[0]].name == "grave_result") {
      if (this.FWP.grave_found != "") {
        _loc32_.header.text = "Вы нашли:";
        if (this.FWP.grave_found_type == "weapon") {
          _loc32_.main.text = this.FWP.WEAPONS_DEF[this.FWP.grave_found].name;
          _loc2_ = this.FWP.get_wpij(this.FWP.WEAPONS_DEF[this.FWP.grave_found].id).i;
          _loc3_ = this.FWP.get_wpij(this.FWP.WEAPONS_DEF[this.FWP.grave_found].id).j;
          this.bitmap_datas["roul_or_grave_result_icon"].copyPixels(this.BigWP, new Rectangle(1 + 45 * (_loc3_ - 1), 1 + 44 * (_loc2_ - 1), 44, 43), new Point(2, 2));
          this.bitmap_datas["roul_or_grave_result_icon"].copyPixels(this.WPBox, new Rectangle(0, 0, 47, 46), new Point(0, 0), null, null, true);
        }
        if (this.FWP.grave_found_type == "obj") {
          _loc32_.main.text = this.FWP.OBJ_DEF[this.FWP.grave_found].name;
          this.bitmap_datas["roul_or_grave_result_icon"].copyPixels(this.BigObjs, new Rectangle(1 + 45 * (this.FWP.OBJ_DEF[this.FWP.grave_found].id - 1), 1, 44, 43), new Point(2, 2));
          this.bitmap_datas["roul_or_grave_result_icon"].copyPixels(this.WPBox, new Rectangle(0, 0, 47, 46), new Point(0, 0), null, null, true);
        }
        if (this.FWP.grave_found_type == "stim") {
          _loc32_.main.text = this.FWP.STIM_DEF[this.FWP.grave_found].name;
          _loc3_ = this.FWP.STIM_DEF[this.FWP.grave_found].id;
          this.bitmap_datas["roul_or_grave_result_icon"].copyPixels(this.BigStims, new Rectangle(1 + 45 * (_loc3_ - 1), 1, 44, 43), new Point(2, 2));
          this.bitmap_datas["roul_or_grave_result_icon"].copyPixels(this.WPBox, new Rectangle(0, 0, 47, 46), new Point(0, 0), null, null, true);
        }
        if (this.FWP.grave_found_type == "gold") {
          _loc32_.main.text = this.FWP.grave_found + " золота";
          this.bitmap_datas["roul_or_grave_result_icon"].copyPixels(this.GoldIcon, new Rectangle(0, 0, 45, 45), new Point(2, 2));
          this.bitmap_datas["roul_or_grave_result_icon"].copyPixels(this.WPBox, new Rectangle(0, 0, 47, 46), new Point(0, 0), null, null, true);
        }
        if (this.FWP.grave_found_type == "diam") {
          _loc32_.main.text = this.FWP.grave_found + " алмаз" + (this.FWP.grave_found > 1 ? "а" : "");
          this.bitmap_datas["roul_or_grave_result_icon"].copyPixels(this.DiamIcon, new Rectangle(0, 0, 45, 45), new Point(2, 2));
          this.bitmap_datas["roul_or_grave_result_icon"].copyPixels(this.WPBox, new Rectangle(0, 0, 47, 46), new Point(0, 0), null, null, true);
        }
        // PORT: a long item name ("Плазменная противотанковая винтовка") wraps in the one-line field: shrink it.
        shrinkToFit(_loc32_.main, 8);
      } else {
        _loc32_.header.text = "К сожалению, вы ничего не нашли.";
        _loc32_.main.text = "";
      }
    }
    // PORT: item 8 - the clans of the players (runtime/clan-hub.ts): the clans tab, the card of a clan, its dialogs.
    if ((this.cur_screen[this.cur_screen[0]].name == "clan_hub" || this.cur_screen[this.cur_screen[0]].name == "clan_card" || this.cur_screen[this.cur_screen[0]].name == "clan_edit") && this.FWP.clans) {
      this.FWP.clans.render(this.cur_screen[this.cur_screen[0]].name, _loc32_);
    }
    if (this.cur_screen[this.cur_screen[0]].name == "top") {
      _loc32_.my_rating.text = this.x3String(_loc34_.rating + _loc34_.achiev_rating_bonus);
      if (this.top_mode == 1) {
        _loc146_ = this.FWP.TOP_BY_LEVEL;
      }
      if (this.top_mode == 2) {
        _loc146_ = this.FWP.TOP_BY_RATING;
      }
      if (this.top_mode == 3) {
        _loc146_ = this.FWP.TOP_BY_ASSAULT;
      }
      _loc32_.top_by_level.visible = this.top_mode != 1;
      _loc32_.top_by_rating.visible = this.top_mode != 2;
      _loc32_.top_by_assault.visible = this.top_mode != 3;
      _loc32_.top_prev_page.visible = this.top_page != 1;
      _loc32_.top_next_page.visible = this.top_page != 10;
      _loc147_ = (this.top_page - 1) * 10;
      _loc2_ = 0;
      while (_loc2_ <= 9) {
        // PORT: item 8 - the player's clan comes with the top's entry (FWP.clan_of_uid): its emblem, none without a clan.
        _loc148_ = this.FWP.clan_of_uid["id" + _loc146_[_loc2_ + _loc147_].uid];
        _loc32_["clip_top" + (_loc2_ + 1)].clan_icon.visible = Boolean(_loc148_);
        if (_loc148_) {
          _loc32_["clip_top" + (_loc2_ + 1)].clan_icon.gotoAndStop(emblemFrame(_loc148_.emblem));
        }
        _loc32_["clip_top" + (_loc2_ + 1)].id_container.text = _loc146_[_loc2_ + _loc147_].uid;
        for (_loc10_ of as3.keys(this.FWP.top_names)) {
          if (this.FWP.top_names[_loc10_].uid == _loc146_[_loc2_ + _loc147_].uid) {
            setRawText(_loc32_["clip_top" + (_loc2_ + 1)].user_name, playerName(String(this.FWP.top_names[_loc10_].first_name)) + " " + this.FWP.top_names[_loc10_].last_name); // PORT: a player's name, never translated (a guest's default name: playerName)
          }
        }
        _loc32_["clip_top" + (_loc2_ + 1)].level.text = this.FWP.get_player_level(_loc146_[_loc2_ + _loc147_].exp);
        _loc32_["clip_top" + (_loc2_ + 1)].user_rating.text = this.x3String(_loc146_[_loc2_ + _loc147_].rating);
        _loc32_["clip_top" + (_loc2_ + 1)].ass.text = this.x3String(_loc146_[_loc2_ + _loc147_].assaults);
        _loc32_["clip_top" + (_loc2_ + 1)].place.text = String(_loc2_ + _loc147_ + 1);
        // PORT: the portrait of the player's specialisation (ui/avatar.ts) instead of the checkerboard of the VK photo
        // PORT: that never loads (the original added another bitmap at each render); an empty row has none.
        // PORT: an empty row (no player on this place yet) shows no level, rating and captures (they read 1, 0, 0 as
        // PORT: if a player were there): only its place and the dash; its columns right of the name are hidden.
        _loc151_ = _loc32_["clip_top" + (_loc2_ + 1)];
        for (_loc10_ = 0; _loc10_ < _loc151_.numChildren; _loc10_++) {
          if (_loc151_.getChildAt(_loc10_) != _loc151_.user_info && _loc151_.getChildAt(_loc10_) != _loc151_.id_container && _loc151_.getChildAt(_loc10_).getBounds(_loc151_).x >= _loc151_.user_name.x + _loc151_.user_name.width - 2) {
            _loc151_.getChildAt(_loc10_).visible = _loc146_[_loc2_ + _loc147_].uid > 0;
          }
        }
        _loc151_ = _loc32_["clip_top" + (_loc2_ + 1)].avatar;
        if (_loc146_[_loc2_ + _loc147_].uid > 0) {
          showAvatar(this.FWP, _loc151_, _loc146_[_loc2_ + _loc147_].uid == this.FWP.user.user_id ? _loc34_.spec : _loc146_[_loc2_ + _loc147_].spec, AVATAR_ROW);
        } else {
          while (_loc151_.numChildren > 0) {
            _loc151_.removeChildAt(0);
          }
        }
        _loc2_++;
      }
    }
    if (this.cur_screen[this.cur_screen[0]].name == "user_info") {
      // PORT: the card has the server's data (get_info_ready): a new player's experience is 0 too.
      if (this.FWP.get_info.exp.value != 0 || this.FWP.get_info_ready) {
        _loc32_.error_message.visible = false;
        _loc32_.level.text = this.FWP.get_player_level(this.FWP.get_info.exp.value);
        _loc32_.progress.text = "Текущая карьера : " + this.FWP.get_info.career_max + "\nТекущая миссия : " + this.FWP.get_info.missions_max + "\nТекущее выживание : " + this.FWP.get_info.survival_max + "\nТекущий босс : " + this.FWP.get_info.boss_max;
        _loc32_.attack.text = this.FWP.get_info.attack.value;
        _loc32_.protect.text = this.FWP.get_info.protect.value;
        _loc32_.health.text = 100 + 50 * this.FWP.get_info.health.value;
        _loc32_.worms.text = 2 + this.FWP.get_info.worms.value;
        _loc32_.gold.text = this.FWP.get_info.gold.value;
        _loc32_.diam.text = this.FWP.get_info.diam.value;
        _loc152_ = new Date(this.FWP.get_info.last_enter * 1000);
        _loc153_ = _loc152_.getDate();
        _loc154_ = _loc152_.getMonth() + 1;
        _loc155_ = _loc152_.getFullYear();
        _loc32_.last_visit.text = "Последний раз был здесь : ";
        if (this.FWP.get_info.last_enter == 0) {
          _loc32_.last_visit.text += "неизвестно";
        } else {
          _loc32_.last_visit.text += _loc153_ + "." + _loc154_ + "." + _loc155_;
        }
        for (_loc10_ of as3.keys(this.FWP.top_names)) {
          if (this.FWP.top_names[_loc10_].uid == this.FWP.get_info_uid) {
            setRawText(_loc32_.user_name, playerName(String(this.FWP.top_names[_loc10_].first_name)) + " " + this.FWP.top_names[_loc10_].last_name); // PORT: a player's name, never translated (a guest's default name: playerName)
          }
        }
        for (_loc10_ of as3.keys(this.FWP.friends_names)) {
          if (this.FWP.friends_names[_loc10_].uid == this.FWP.get_info_uid) {
            setRawText(_loc32_.user_name, playerName(String(this.FWP.friends_names[_loc10_].first_name)) + " " + this.FWP.friends_names[_loc10_].last_name); // PORT: a player's name, never translated (a guest's default name: playerName)
          }
        }
        // PORT: item 8 - no clans_names: the member lists of the fixed clans (net_get_clan_members) are gone.
        // PORT: VK removed: `|| get_info_uid == 134819803` also showed the award for one hardcoded VK user id.
        _loc32_.award_magnet.visible = this.FWP.get_info.diam_magnet == 1;
        _loc32_.award_contest.visible = this.FWP.get_award(this.FWP.get_info_uid, "contest");
        _loc32_.award_tester.visible = this.FWP.get_award(this.FWP.get_info_uid, "tester");
        _loc32_.awards_none.visible = !_loc32_.award_magnet.visible && !_loc32_.award_contest.visible && !_loc32_.award_tester.visible;
        // PORT: VK removed: the developer's VK id hid his perks from other players.
        if (true) {
          _loc2_ = 0;
          for (_loc14_ of as3.keys(this.FWP.get_info.perks)) {
            _loc2_++;
            _loc15_ = _loc2_ < 5 ? 4 : 55;
            _loc16_ = _loc2_ < 5 ? (_loc2_ - 1) % 4 * 50 : (_loc2_ - 5) % 4 * 50;
            this.MainBitmapData.copyPixels(this.PerksSheet, new Rectangle(0, (this.FWP.PERKS_DEF[_loc14_].id - 1) * 47, 47, 47), new Point(_loc15_, _loc16_));
            this.MainBitmapData.copyPixels(this.PerkLevels[this.FWP.get_info.perks[_loc14_]], new Rectangle(0, 0, 47, 47), new Point(_loc15_, _loc16_), null, null, true);
          }
          _loc2_ = 0;
          _loc25_ = 0;
          _loc26_ = new Array();
          for (_loc23_ of as3.keys(this.FWP.get_info.weapons)) {
            if (this.FWP.get_info.weapons[_loc23_][0] > 0 && _loc23_ != "skip_go") {
              _loc26_[_loc25_] = {
                "id": _loc23_,
                "diam": (this.FWP.WEAPONS_DEF[_loc23_].diam == 0 ? 30 : this.FWP.WEAPONS_DEF[_loc23_].diam)
              };
              _loc25_++;
            }
          }
          as3.sortOn(_loc26_, "diam", as3.ArrayFlags.DESCENDING | as3.ArrayFlags.NUMERIC);
          _loc27_ = 0;
          while (_loc27_ < _loc25_) {
            _loc23_ = _loc26_[_loc27_].id;
            if (this.FWP.get_info.weapons[_loc23_][0] > 0) {
              _loc2_++;
              if (_loc2_ > 28) {
                break;
              }
              if (_loc2_ < 8) {
                _loc28_ = 146 + (_loc2_ - 1) * 50;
                _loc29_ = 2;
              } else if (_loc2_ < 15) {
                _loc28_ = 146 + (_loc2_ - 8) * 50;
                _loc29_ = 52;
              } else if (_loc2_ < 22) {
                _loc28_ = 146 + (_loc2_ - 15) * 50;
                _loc29_ = 102;
              } else {
                _loc28_ = 146 + (_loc2_ - 22) * 50;
                _loc29_ = 152;
              }
              _loc7_ = this.FWP.get_wpij(this.FWP.WEAPONS_DEF[_loc23_].id).i;
              _loc8_ = this.FWP.get_wpij(this.FWP.WEAPONS_DEF[_loc23_].id).j;
              this.MainBitmapData.copyPixels(this.BigWP, new Rectangle(1 + 45 * (_loc8_ - 1), 1 + 44 * (_loc7_ - 1), 43, 42), new Point(_loc28_, _loc29_));
              this.MainBitmapData.copyPixels(this.WPBox, new Rectangle(0, 0, 47, 46), new Point(_loc28_ - 2, _loc29_ - 2), null, null, true);
              if (this.FWP.get_info.weapons[_loc23_][0] > 1) {
                this.MainBitmapData.copyPixels(this.WPAmount, new Rectangle(0, (this.FWP.get_info.weapons[_loc23_][0] - 2) * 10, 21, 9), new Point(_loc28_ + 44 - 16 - 7, _loc29_ + 43 - 11), null, null, true);
              }
            }
            _loc27_++;
          }
        } else {
          _loc32_.gold.text = 0;
          _loc32_.diam.text = 0;
          _loc32_.level.text = "?";
          _loc32_.attack.text = "100";
          _loc32_.protect.text = "100";
          _loc32_.health.text = "150";
          _loc32_.worms.text = "2";
        }
      } else {
        _loc32_.error_message.visible = true;
      }
    }
    // PORT: item 8 - the best clans are the first page of the server's clan list by rating (the original sorted the 14
    // PORT: fixed clans of CLANS_DEF); rows without a clan are hidden, a row opens the card of its clan.
    if (this.cur_screen[this.cur_screen[0]].name == "clans") {
      if (this.FWP.clans) {
        this.FWP.clans.render("clans", _loc32_);
      } else {
        _loc2_ = 1;
        while (_loc2_ <= 14) {
          _loc32_["clan" + _loc2_].visible = false;
          _loc2_++;
        }
      }
    }
    if (this.cur_screen[this.cur_screen[0]].name == "replay") {
      _loc24_ = 0;
      _loc2_ = 1;
      // PORT (wide screens): a phone's rows a finger's target apart as far as all of them fit the page (23 rows of
      // PORT: 20 px; ui/wide-lists.ts), 20 px as the original elsewhere.
      const pitch: number = listPitch(this.stage, Math.min(23, this.FWP.USER_NOTES[0]), 23 * ROW);
      while (_loc2_ <= Math.min(23, this.FWP.USER_NOTES[0])) {
        _loc160_ = _loc32_.note_container.addChild(this.FWP.container_interf.get_object("clip_note"));
        _loc160_.name = _loc2_;
        _loc160_.x = 0;
        _loc160_.y = _loc24_;
        _loc24_ += pitch;
        _loc160_.note_name.text = this.FWP.USER_NOTES[_loc2_].title;
        _loc2_++;
      }
      // PORT: an empty page of saved replays says why it is empty and where replays come from.
      emptyNotes(_loc32_.note_container, this.FWP.USER_NOTES[0] == 0);
    }
    if (this.cur_screen[this.cur_screen[0]].name == "scaner") {
      _loc32_.slider.visible = this.scaner_mode == "worms";
      _loc32_.scaner_teams.visible = this.scaner_mode != "teams";
      _loc32_.scaner_worms.visible = this.scaner_mode != "worms";
      if (this.scaner_mode == "teams") {
        _loc24_ = 118;
        _loc2_ = 2;
        while (_loc2_ <= this.FWP._proc.teams[0]) {
          _loc161_ = _loc32_.addChild(this.FWP.container_interf.get_object("clip_scaner_team"));
          this.bitmaps["sc_team" + _loc2_] = new Bitmap();
          this.bitmap_datas["sc_team" + _loc2_] = new BitmapData(247, 96, true, 0);
          _loc3_ = 0;
          _loc25_ = 0;
          _loc26_ = new Array();
          for (_loc23_ of as3.keys(this.FWP._proc.teams[_loc2_].weapons)) {
            if (this.FWP._proc.teams[_loc2_].weapons[_loc23_][1] > 0 && _loc23_ != "skip_go") {
              _loc26_[_loc25_] = {
                "id": _loc23_,
                "diam": (this.FWP.WEAPONS_DEF[_loc23_].diam == 0 ? 30 : this.FWP.WEAPONS_DEF[_loc23_].diam)
              };
              _loc25_++;
            }
          }
          as3.sortOn(_loc26_, "diam", as3.ArrayFlags.DESCENDING | as3.ArrayFlags.NUMERIC);
          _loc27_ = 0;
          while (_loc27_ < _loc25_) {
            _loc23_ = _loc26_[_loc27_].id;
            if (this.FWP._proc.teams[_loc2_].weapons[_loc23_][1] > 0) {
              _loc3_++;
              if (_loc3_ > 10) {
                break;
              }
              if (_loc3_ < 6) {
                _loc28_ = 2 + (_loc3_ - 1) * 50;
                _loc29_ = 2;
              } else {
                _loc28_ = 2 + (_loc3_ - 6) * 50;
                _loc29_ = 52;
              }
              _loc162_ = this.FWP.WEAPONS_DEF[_loc23_].id;
              _loc7_ = this.FWP.get_wpij(_loc162_ > 200 ? _loc162_ - 200 : _loc162_).i;
              _loc8_ = this.FWP.get_wpij(_loc162_ > 200 ? _loc162_ - 200 : _loc162_).j;
              this.bitmap_datas["sc_team" + _loc2_].copyPixels(_loc162_ > 200 ? this.BigCPUWP : this.BigWP, new Rectangle(1 + 45 * (_loc8_ - 1), 1 + 44 * (_loc7_ - 1), 43, 42), new Point(_loc28_, _loc29_));
              this.bitmap_datas["sc_team" + _loc2_].copyPixels(this.WPBox, new Rectangle(0, 0, 47, 46), new Point(_loc28_ - 2, _loc29_ - 2), null, null, true);
              if (this.FWP._proc.teams[_loc2_].weapons[_loc23_][1] >= 100) {
                this.bitmap_datas["sc_team" + _loc2_].copyPixels(this.WPAmount, new Rectangle(0, 9 * 10, 21, 9), new Point(_loc28_ + 44 - 16 - 7, _loc29_ + 43 - 11), null, null, true);
              } else if (this.FWP._proc.teams[_loc2_].weapons[_loc23_][1] > 1) {
                this.bitmap_datas["sc_team" + _loc2_].copyPixels(this.WPAmount, new Rectangle(0, (this.FWP._proc.teams[_loc2_].weapons[_loc23_][1] - 2) * 10, 21, 9), new Point(_loc28_ + 44 - 16 - 7, _loc29_ + 43 - 11), null, null, true);
              }
            }
            _loc27_++;
          }
          this.bitmaps["sc_team" + _loc2_].bitmapData = this.bitmap_datas["sc_team" + _loc2_];
          _loc161_.bitmap_container.addChild(this.bitmaps["sc_team" + _loc2_]);
          this.set_team_name(_loc161_.team_name, this.FWP._proc.teams[_loc2_]);
          _loc161_.x = 181;
          _loc161_.y = _loc24_;
          _loc24_ += 120;
          _loc2_++;
        }
      } else {
        _loc24_ = 0;
        _loc163_ = 0;
        _loc2_ = 1;
        while (_loc2_ <= this.FWP._proc.worms[0]) {
          if (this.FWP._proc.worms[_loc2_].state == "ok") {
            if (this.FWP._obj[this.FWP._proc.worms[_loc2_].fid].wteam != 1) {
              _loc164_ = _loc32_.scaner_container.addChild(this.FWP.container_interf.get_object("clip_scaner_worm"));
              this.bitmaps["sc_worm" + _loc2_] = new Bitmap();
              this.bitmap_datas["sc_worm" + _loc2_] = new BitmapData(197, 96, true, 0);
              _loc165_ = 0;
              for (_loc14_ of as3.keys(this.FWP._obj[this.FWP._proc.worms[_loc2_].fid].perks)) {
                _loc15_ = ++_loc165_ < 5 ? (_loc165_ - 1) * 50 : (_loc165_ - 5) * 50;
                _loc16_ = _loc165_ < 5 ? 0 : 50;
                this.bitmap_datas["sc_worm" + _loc2_].copyPixels(this.PerksSheet, new Rectangle(0, (this.FWP.PERKS_DEF[_loc14_].id - 1) * 47, 47, 47), new Point(_loc15_, _loc16_));
                this.bitmap_datas["sc_worm" + _loc2_].copyPixels(this.PerkLevels[this.FWP._obj[this.FWP._proc.worms[_loc2_].fid].perks[_loc14_]], new Rectangle(0, 0, 47, 47), new Point(_loc15_, _loc16_), null, null, true);
              }
              this.bitmaps["sc_worm" + _loc2_].bitmapData = this.bitmap_datas["sc_worm" + _loc2_];
              _loc164_.bitmap_container.addChild(this.bitmaps["sc_worm" + _loc2_]);
              this.set_team_name(_loc164_.team_name, this.FWP._proc.teams[this.FWP._obj[this.FWP._proc.worms[_loc2_].fid].wteam]);
              _loc164_.worm_name.text = this.FWP._obj[this.FWP._proc.worms[_loc2_].fid].wname;
              _loc164_.worm_attack.text = this.FWP._obj[this.FWP._proc.worms[_loc2_].fid].skills.attack;
              _loc164_.worm_protect.text = this.FWP._obj[this.FWP._proc.worms[_loc2_].fid].skills.protect;
              _loc164_.worm_health.text = this.FWP._obj[this.FWP._proc.worms[_loc2_].fid].vars.health;
              _loc164_.x = 0;
              _loc164_.y = _loc24_;
              _loc24_ += 120;
              _loc163_++;
            }
          }
          _loc2_++;
        }
        _loc32_.slider.visible = _loc163_ > 3;
      }
    }
    if (this.cur_screen[this.cur_screen[0]].name == "error") {
      if (this.error_mode == "craft_limit") {
        _loc166_ = "Невозможно добавить в арсенал еще одно такое оружие - ограничение достигнуто.";
        if (this.crafting_result.new_recipe) {
          _loc166_ += " Однако, при сборке вы открыли новый рецепт (" + this.FWP.WEAPONS_DEF[this.crafting_result.id].name + ").";
        }
        _loc32_.error_text.text = _loc166_;
      }
      if (this.error_mode == "craft_too_diff") {
        _loc166_ = "Это оружие слишком сложно для вас. Необходим уровень " + this.crafting_result.error.split("req")[1] + " способности Крафтинг.";
        if (this.crafting_result.new_recipe) {
          _loc166_ += " Однако, при сборке вы открыли новый рецепт (" + this.FWP.WEAPONS_DEF[this.crafting_result.id].name + ").";
        }
        _loc32_.error_text.text = _loc166_;
      }
      if (this.error_mode == "calc") {
        _loc32_.error_text.text = "Вам необходима способность Образованность хотя бы базового уровня.";
      }
      if (this.error_mode == "what_opened") {
        _loc32_.error_text.text = "На этом уровне не открылось ни одного нового оружия.";
      }
      if (this.error_mode == "grave_search") {
        _loc32_.error_text.text = "Вы утопили всех врагов и все вражеские гробики. Нечего обыскивать.";
      }
      if (this.error_mode == "grave_search_assault") {
        _loc32_.error_text.text = "В режиме захвата территорий обыскивать гробики нельзя.";
      }
      if (this.error_mode == "new_recipes") {
        _loc32_.error_text.text = "Вы узнали новые рецепты (можно посмотреть в книге рецептов в разделе Крафтинг).";
      }
      if (this.error_mode == "new_recipes_fail") {
        _loc32_.error_text.text = "Вы не узнали ничего нового.";
      }
      if (this.error_mode == "collect_all_books") {
        _loc32_.error_text.text = "Соберите всю коллекцию из 9 книг рецептов - сможете продать ее за 3 000 000 золота. Неполная коллекция мало кому нужна.";
      }
      // PORT: VK removed: the modes "wait_few_days" (the VK friends service is off) and "auc_not_enough" (too few VK
      // PORT: votes on the balance). The auction is paid in diamonds on the server (FWP.net_auction_buy): a refusal
      // PORT: ("auc_fail" of the VK payment) is a notice with the server's reason.
      if (this.error_mode == "auc_success") {
        this.success_auc = true;
        _loc32_.error_text.text = "Поздравляем! Вы приобрели Аннигилятор.";
      }
      // PORT: "About" of the account dialog: the game's name and the trademark notice (ui/legal-notice.ts).
      if (this.error_mode == ABOUT_MODE) {
        renderAbout(_loc32_);
      }
      if (this.error_mode == "fail_server") {
        _loc32_.error_text.text = "Приложение немного ограничено в функциональности из-за упавшего сервера. Скоро исправим.";
      }
    }
    if (this.cur_screen[this.cur_screen[0]].name == "steal") {
      if (this.success_steal) {
        _loc32_.error_text.htmlText = "Вы успешно украли оружие <b>" + this.FWP.WEAPONS_DEF[this.succ_steal_weapon].name + "</b>.";
      } else {
        if (this.steal_state == "") {
          _loc32_.speech.text = "\"Эй, что это у тебя в руках? Хотел украсть?\"";
        }
        if (this.steal_state == "luck_fail") {
          _loc32_.speech.text = "\"Ну конечно, так я тебе и поверил. Сразу видно, настоящий жулик и вор.\"";
        }
        if (this.steal_state == "merch_fail") {
          _loc32_.speech.text = "\"Ты меня за идиота держишь? Сейчас, погоди, где мой излучатель...\"";
        }
        if (this.steal_state == "good_bye") {
          _loc32_.speech.text = "\"Ладно, иди отсюда.\"";
        }
        if (this.steal_state == "fuck_off") {
          _loc32_.speech.text = "\"Опять ты! Я же тебе сказал - не приходи ко мне больше!\"";
        }
        if (this.steal_state == "get_off") {
          _loc32_.speech.text = "\"Что-то ты часто заходишь сюда, но ничего не покупаешь! Не желаю с тобой иметь дела.\"";
        }
        if (this.steal_state == "" || this.steal_state == "luck_fail" || this.steal_state == "merch_fail") {
          _loc32_.steal_dial.gotoAndStop(1);
        }
        if (this.steal_state == "good_bye") {
          _loc32_.steal_dial.gotoAndStop(2);
        }
        if (this.steal_state == "fuck_off") {
          _loc32_.steal_dial.gotoAndStop(3);
        }
        if (this.steal_state == "get_off") {
          _loc32_.steal_dial.gotoAndStop(3);
        }
        if (this.steal_state == "" || this.steal_state == "luck_fail" || this.steal_state == "merch_fail") {
          if (!this.steal_try_luck) {
            _loc32_.steal_dial.try_luck.htmlText = "<font color=\"#000000\">\"Ой, нет, извините. Я случайно. Сам не заметил, как забыл оплатить товар.\" [вероятность <b>" + this.return_steal_luck_prob() + "%</b>].</font>";
          } else {
            _loc32_.steal_dial.try_luck.htmlText = "<font color=\"#666666\">\"Ой, нет, извините. Я случайно. Сам не заметил, как забыл оплатить товар.\" [вероятность <b>" + this.return_steal_luck_prob() + "%</b>].</font>";
          }
          _loc32_.steal_dial.steal_luck.visible = !this.steal_try_luck;
          if (!this.steal_try_merch) {
            _loc32_.steal_dial.try_merch.htmlText = "<font color=\"#000000\">\"А вы в курсе, что в Новом Рено продают такую же пушку в два раза дороже? Что еще остается делать, с такими-то ценами. Простите, больше не повторится.\" [вероятность <b>" + this.return_steal_merch_prob() + "</b>%].</font>";
          } else {
            _loc32_.steal_dial.try_merch.htmlText = "<font color=\"#666666\">\"А вы в курсе, что в Новом Рено продают такую же пушку в два раза дороже? Что еще остается делать, с такими-то ценами. Простите, больше не повторится.\" [вероятность <b>" + this.return_steal_merch_prob() + "</b>%].</font>";
          }
          _loc32_.steal_dial.steal_merch.visible = !this.steal_try_merch;
        }
      }
    }
    if (this.cur_screen[this.cur_screen[0]].name == "rating") {
      _loc32_.main_rating.text = "Рейтинг : " + (_loc34_.rating + _loc34_.achiev_rating_bonus);
      _loc32_.wins_yest.htmlText = "Одержано побед вчера : <b>" + _loc34_.yest_wins + "</b>";
      _loc32_.wins_today.htmlText = "Одержано побед сегодня : <b>" + _loc34_.today_wins + "</b>";
    }
    if (this.cur_screen[this.cur_screen[0]].name == "wormpedia") {
      _loc32_.articles.gotoAndStop(1);
      _loc167_ = new Array<any>({ "id": "spec", "name": "Специальность и прочие\nмодификаторы урона" }, { "id": "rate", "name": "Рейтинг и бонусы\nза высокую активность" }, { "id": "hard", "name": "Хардкорный режим" }, { "id": "crates", "name": "Посылки" }, { "id": "crit", "name": "Критический выстрел\nи осечки" }, { "id": "attack", "name": "Атака и шанс\nпробивного выстрела" }, { "id": "protect", "name": "Защита, порог урона и\nпоглощение урона броней" }, { "id": "steal", "name": "Воровство и\nПапа Джон" }, { "id": "crafting", "name": "Крафтинг" });
      if (this.wpedia_article != "") {
        for (_loc168_ of as3.keys(_loc167_)) {
          _loc169_ = _loc167_[_loc168_].name;
          if (this.wpedia_article == _loc167_[_loc168_].id) {
            _loc169_ = "<b>" + _loc167_[_loc168_].name + "</b>";
          }
          _loc32_["wpedia_" + _loc167_[_loc168_].id].htmlText = _loc169_;
          _loc32_["wpedia_" + _loc167_[_loc168_].id].textColor = this.wpedia_article == _loc167_[_loc168_].id ? 16711680 : 0;
        }
      }
      if (this.wpedia_article == "spec") {
        _loc32_.articles.gotoAndStop(2);
      }
      if (this.wpedia_article == "rate") {
        _loc32_.articles.gotoAndStop(3);
      }
      if (this.wpedia_article == "hard") {
        _loc32_.articles.gotoAndStop(4);
      }
      if (this.wpedia_article == "crates") {
        _loc32_.articles.gotoAndStop(5);
      }
      if (this.wpedia_article == "attack") {
        _loc32_.articles.gotoAndStop(6);
      }
      if (this.wpedia_article == "protect") {
        _loc32_.articles.gotoAndStop(7);
      }
      if (this.wpedia_article == "steal") {
        _loc32_.articles.gotoAndStop(8);
      }
      if (this.wpedia_article == "crit") {
        _loc32_.articles.gotoAndStop(9);
      }
      if (this.wpedia_article == "crafting") {
        _loc32_.articles.gotoAndStop(10);
      }
      // PORT: the article's hand-broken lines joined into paragraphs and wrapped clear of the beanstalk (a translation
      // PORT: ran past the panel: ui/controls.ts reflowArticle).
      reflowArticle(_loc32_.articles, _loc32_);
    }
    if (this.cur_screen[this.cur_screen[0]].name == "papa_john") {
      if (_loc32_.papa_ann) {
        _loc152_ = new Date(this.FWP.user.unix_time * 1000);
        _loc170_ = _loc152_.getHours();
        // PORT: the original displayed the hour converted to a fixed UTC+4 as "Московское время"
        // PORT: (new_interf.as:4797-4806); Papa follows the player's own time zone (FWP.modify_papa).
        _loc172_ = _loc170_;
        if (!this.papa_checked) {
          _loc32_.papa_ann.htmlText = "Сейчас Папы нет на месте. Вы можете перезайти в приложение или проверить, пришел ли Папа, нажав на эту кнопку:";
        } else {
          _loc173_ = "\nМестное время: " + _loc172_ + " ч.";
          if (this.FWP.PAPA_HERE) {
            _loc32_.papa_ann.htmlText = "<b>Вам повезло ! Папа сейчас на месте.</b>" + _loc173_;
          } else {
            _loc32_.papa_ann.htmlText = "Нет, пока Папы нет на месте." + _loc173_;
          }
        }
      } else {
        if (this.papa_state == "") {
          _loc32_.speech.text = "Привет, я Папа Джон! Очень тороплюсь, много клиентов еще надо обслужить. Чем могу помочь?";
        }
        if (this.papa_state == "time_win") {
          _loc174_ = new Date((this.FWP.user.unix_time + 86400) * 1000);
          _loc175_ = _loc174_.getDate();
          _loc176_ = this.FWP.PAPA_HOURS[_loc175_];
          // PORT: design D3 - the hour the server answered (papa.ask, in the player's calendar).
          if (this.papa_tomorrow_hour != null) {
            _loc176_ = this.papa_tomorrow_hour;
          }
          // PORT: "(по московскому времени)" -> the player's own time zone (FWP.modify_papa).
          _loc32_.speech.text = "Дай подумать. Завтра я буду здесь с " + _loc176_ + ":00 по " + (_loc176_ + 1) + ":00 (по твоему местному времени). Заходи, жду.";
        }
        if (this.papa_state == "time_fail") {
          _loc32_.speech.text = "Не знаю. Как получится.";
        }
        if (this.papa_state == "shop_fail") {
          _loc32_.speech.text = "Сегодня ты у меня уже смотрел товар. Много работы, извини, приходи завтра.";
        }
        _loc32_.papa_dial.papa_ask.visible = _loc34_.papa_asked == 0;
        if (_loc34_.papa_asked == 0) {
          _loc32_.papa_dial.papa_ask_text.htmlText = "<font color=\"#000000\">\"Во сколько ты появишься завтра?\" [вероятность <b>" + this.return_papa_ask_prob() + "%</b>].</font>";
        } else {
          _loc32_.papa_dial.papa_ask_text.htmlText = "<font color=\"#666666\">\"Во сколько ты появишься завтра?\" [вероятность <b>" + this.return_papa_ask_prob() + "%</b>].</font>";
        }
      }
    }
    if (this.cur_screen[this.cur_screen[0]].name == "papa_shop") {
      if (this.shop_type == "weapons") {
        _loc30_ = this.FWP.WEAPONS_DEF;
        _loc31_ = _loc34_.weapons;
        _loc37_ = 0.6;
      }
      if (this.shop_type == "objs") {
        _loc30_ = this.FWP.OBJ_DEF;
        _loc31_ = _loc34_.objs;
        _loc37_ = 1;
      }
      _loc177_ = this.FWP.get_papa_weapons(this.shop_type);
      _loc178_ = _loc177_[0];
      _loc179_ = [0, 0];
      _loc2_ = 1;
      while (_loc2_ <= _loc178_) {
        for (_loc180_ of as3.keys(_loc30_)) {
          if (_loc180_ == _loc177_[_loc2_]) {
            _loc179_[_loc2_] = _loc30_[_loc180_].id;
          }
        }
        _loc2_++;
      }
      if (this.shop_type == "weapons") {
        _loc32_.shop_types.gotoAndStop(1);
      }
      if (this.shop_type == "objs") {
        _loc32_.shop_types.gotoAndStop(6);
      }
      _loc54_ = 1;
      while (_loc54_ <= _loc178_) {
        _loc65_ = _loc177_[_loc54_];
        this.buttons["wp_buy_" + _loc54_].visible = true;
        this.buttons["wp_buy_" + _loc54_].name = "weapon_" + _loc65_;
        if (_loc30_[_loc65_].gold * _loc37_ < 10000) {
          this.buttons["wp_buy_" + _loc54_].gold.text = this.x3String(Math.round(_loc30_[_loc65_].gold * _loc37_));
        } else {
          this.buttons["wp_buy_" + _loc54_].gold.text = this.xKString(Math.round(_loc30_[_loc65_].gold * _loc37_));
        }
        this.buttons["wp_buy_" + _loc54_].diam.text = Math.round(_loc30_[_loc65_].diam * _loc37_);
        if (this.shop_type == "weapons") {
          _loc2_ = this.FWP.get_wpij(_loc30_[_loc65_].id).i;
          _loc3_ = this.FWP.get_wpij(_loc30_[_loc65_].id).j;
          this.bitmap_datas["shop" + _loc54_].copyPixels(this.BigWP, new Rectangle(1 + 45 * (_loc3_ - 1), 1 + 44 * (_loc2_ - 1), 44, 43), new Point(2, 2));
        } else if (this.shop_type == "objs") {
          _loc3_ = _loc30_[_loc65_].id;
          this.bitmap_datas["shop" + _loc54_].copyPixels(this.BigObjs, new Rectangle(1 + 45 * (_loc3_ - 1), 1, 44, 43), new Point(2, 2));
        }
        this.bitmap_datas["shop" + _loc54_].copyPixels(this.WPBox, new Rectangle(0, 0, 47, 46), new Point(0, 0), null, null, true);
        this.buttons["wp_buy_" + _loc54_].back.gotoAndStop(1);
        if (_loc179_[_loc54_] == this.cur_element) {
          this.buttons["wp_buy_" + _loc54_].back.gotoAndStop(2);
        } else if (_loc30_[_loc65_].level == 0 || !(Math.round(_loc30_[_loc65_].gold * _loc37_) <= _loc34_.gold.value && _loc30_[_loc65_].level <= _loc34_.level.value && this.get_req_params(_loc34_, _loc30_[_loc65_])) && Math.round(_loc30_[_loc65_].diam * _loc37_) > _loc34_.diam.value) {
          this.bitmap_datas["shop" + _loc54_].copyPixels(this.WPBlurGray, new Rectangle(0, 0, 47, 46), new Point(0, 0), null, null, true);
          this.buttons["wp_buy_" + _loc54_].back.gotoAndStop(3);
        }
        _loc54_++;
      }
      _loc54_ = _loc178_ + 1;
      while (_loc54_ <= 10) {
        this.buttons["wp_buy_" + _loc54_].visible = false;
        _loc54_++;
      }
      if (_loc30_[this.cur_weapon]) {
        _loc32_.weapon_name.text = _loc30_[this.cur_weapon].name;
        _loc101_ = "";
        if (this.shop_type != "weapons") {
          if (_loc31_[this.cur_weapon]) {
            if (_loc31_[this.cur_weapon] != 0) {
              _loc32_.weapon_name.text += " (" + _loc31_[this.cur_weapon] + ")";
            }
          }
        } else if (_loc31_[this.cur_weapon]) {
          if (_loc31_[this.cur_weapon][0] != 0) {
            _loc32_.weapon_name.text += " (" + _loc31_[this.cur_weapon][0] + ")";
          }
        }
        _loc32_.weapon_desc.htmlText = this.return_weapon_desc(this.cur_weapon, this.shop_type) + _loc101_ + (this.weapons_text[this.cur_weapon] ? this.weapons_text[this.cur_weapon] : "");
      }
      if (this.cur_element <= 0) {
        _loc32_.weapon_name.text = "Магазин Папы Джона";
        _loc32_.weapon_desc.htmlText = "Этот магазин отличается от основного тем, что скидки на оружие достигают 40%, и иногда можно найти супер-редкое оружие, которое невозможно купить в обычном магазине. Ассортимент Папы Джона меняется каждый день. С недавнего времени у Папы появились еще и предметы.";
      }
      if (this.cur_element > 0 && _loc30_[this.cur_weapon].level != 0) {
        _loc32_.buy_gold.visible = Math.round(_loc30_[this.cur_weapon].gold * _loc37_) <= _loc34_.gold.value && _loc30_[this.cur_weapon].level <= _loc34_.level.value && this.get_req_params(_loc34_, _loc30_[this.cur_weapon]);
        _loc32_.buy_diam.visible = Math.round(_loc30_[this.cur_weapon].diam * _loc37_) <= _loc34_.diam.value;
        _loc32_.weapon_gold.text = this.x3String(Math.round(_loc30_[this.cur_weapon].gold * _loc37_));
        _loc32_.weapon_diam.text = this.x3String(Math.round(_loc30_[this.cur_weapon].diam * _loc37_));
        _loc32_.weapon_gold.visible = true;
        _loc32_.weapon_diam.visible = true;
      } else {
        _loc32_.buy_gold.visible = false;
        _loc32_.buy_diam.visible = false;
        _loc32_.weapon_gold.visible = false;
        _loc32_.weapon_diam.visible = false;
      }
      if (_loc31_[this.cur_weapon]) {
        if (this.shop_type != "weapons") {
          if (_loc31_[this.cur_weapon] >= _loc30_[this.cur_weapon].limit) {
            _loc32_.buy_gold.visible = false;
            _loc32_.buy_diam.visible = false;
          }
        } else if (_loc31_[this.cur_weapon][0] >= _loc30_[this.cur_weapon].limit) {
          _loc32_.buy_gold.visible = false;
          _loc32_.buy_diam.visible = false;
        }
      }
      _loc32_.gold.text = this.x3SHString(_loc34_.gold.value);
      _loc32_.diam.text = this.x3SHString(_loc34_.diam.value);
    }
    if (this.cur_screen[this.cur_screen[0]].name == "end_game_surprise") {
      _loc181_ = this.FWP.end_game.surprise_weapons[this.cur_page];
      _loc32_.surprise_weapon.text = this.FWP.WEAPONS_DEF[_loc181_].name;
      _loc32_.surprise_weapon.y = 380 + (_loc32_.surprise_weapon.numLines == 1 ? 10 : 0);
      _loc2_ = this.FWP.get_wpij(this.FWP.WEAPONS_DEF[_loc181_].id).i;
      _loc3_ = this.FWP.get_wpij(this.FWP.WEAPONS_DEF[_loc181_].id).j;
      this.bitmap_datas["surprise_bitmap"].copyPixels(this.BigWP, new Rectangle(1 + 45 * (_loc3_ - 1), 1 + 44 * (_loc2_ - 1), 44, 43), new Point(2, 2));
      _loc32_.surprise_prev.visible = this.cur_page > 1;
      _loc32_.surprise_next.visible = this.cur_page < this.FWP.end_game.surprise_weapons[0];
    }
    if (this.cur_screen[this.cur_screen[0]].name == "upgrade_weapon") {
      _loc32_.upgrade_gold_req.text = "";
      _loc32_.upgrade_nrange.text = "-";
      _loc32_.upgrade_damage.text = "";
      _loc32_.upgrade_crit.text = "";
      _loc32_.upgrade_ap.text = "";
      _loc32_.upgrade_warning.text = "";
      _loc32_.finish_upgrade.visible = false;
      _loc182_ = Number(this.weapon_stack[this.weapon_stack[0]].range);
      _loc183_ = this.weapon_stack[this.weapon_stack[0]].id;
      _loc75_ = this.FWP.get_wpij(this.FWP.WEAPONS_DEF[_loc183_].id).i;
      _loc76_ = this.FWP.get_wpij(this.FWP.WEAPONS_DEF[_loc183_].id).j;
      this.MainBitmapData.copyPixels(this.BigWP, new Rectangle(1 + 45 * (_loc76_ - 1), 1 + 44 * (_loc75_ - 1), 44, 43), new Point(2, 2));
      this.MainBitmapData.copyPixels(this.PerkLevels[_loc182_], new Rectangle(0, 0, 47, 47), new Point(2, 2), null, null, true);
      this.MainBitmapData.copyPixels(this.WPBox, new Rectangle(0, 0, 47, 46), new Point(0, 0), null, null, true);
      if (_loc182_ == 10) {
        _loc32_.upgrade_warning.text = "Это оружие нельзя больше улучшить.";
        return;
      }
      this.MainBitmapData.copyPixels(this.BigWP, new Rectangle(1 + 45 * (_loc76_ - 1), 1 + 44 * (_loc75_ - 1), 44, 43), new Point(198, 2));
      this.MainBitmapData.copyPixels(this.PerkLevels[_loc182_ + 1], new Rectangle(0, 0, 47, 47), new Point(198, 2), null, null, true);
      this.MainBitmapData.copyPixels(this.WPBox, new Rectangle(0, 0, 47, 46), new Point(196, 0), null, null, true);
      _loc184_ = Math.round(this.FWP.get_range_upgrade(_loc182_ + 1, "price", this.FWP.WEAPONS_DEF[_loc183_].wpclass) * this.FWP.WEAPONS_DEF[_loc183_].gold);
      this.weapon_stack[this.weapon_stack[0]].upg_price = _loc184_;
      _loc32_.upgrade_gold_req.text = this.x3String(_loc184_);
      _loc32_.upgrade_nrange.text = String(_loc182_ + 1);
      _loc32_.upgrade_damage.text = String(Math.round(this.FWP.get_range_upgrade(_loc182_ + 1, "damage", 1) * 100)) + "%";
      _loc32_.upgrade_crit.text = String(Math.round(this.FWP.get_range_upgrade(_loc182_ + 1, "crit", 1))) + "%";
      _loc32_.upgrade_ap.text = String(Math.round(this.FWP.get_range_upgrade(_loc182_ + 1, "ap", 1))) + "%";
      if (_loc184_ > _loc34_.gold.value) {
        _loc32_.upgrade_warning.text = "Недостаточно золота.";
        return;
      }
      _loc125_ = 4;
      if (_loc34_.perks["crafting"]) {
        if (_loc34_.perks["crafting"] == 1) {
          _loc125_ = 6;
        }
        if (_loc34_.perks["crafting"] == 2) {
          _loc125_ = 8;
        }
        if (_loc34_.perks["crafting"] == 3) {
          _loc125_ = 10;
        }
      }
      if (_loc34_.spec == 4) {
        _loc125_ = 10;
      }
      if (_loc182_ + 1 > _loc125_) {
        _loc185_ = 1;
        if (_loc182_ + 1 > 6) {
          _loc185_ = 2;
        }
        if (_loc182_ + 1 > 8) {
          _loc185_ = 3;
        }
        _loc32_.upgrade_warning.text = "Вам необходима способность Крафтинг уровня " + _loc185_ + ".";
        return;
      }
      _loc32_.finish_upgrade.visible = true;
    }
    if (this.cur_screen[this.cur_screen[0]].name == "sell_weapon") {
      _loc32_.sell_price.text = "";
      _loc32_.sell_warning.text = "";
      _loc32_.finish_sell.visible = true;
      _loc186_ = Number(this.weapon_stack[1].range);
      _loc187_ = this.weapon_stack[1].id;
      _loc75_ = this.FWP.get_wpij(this.FWP.WEAPONS_DEF[_loc187_].id).i;
      _loc76_ = this.FWP.get_wpij(this.FWP.WEAPONS_DEF[_loc187_].id).j;
      this.MainBitmapData.copyPixels(this.BigWP, new Rectangle(1 + 45 * (_loc76_ - 1), 1 + 44 * (_loc75_ - 1), 44, 43), new Point(2, 2));
      this.MainBitmapData.copyPixels(this.PerkLevels[_loc186_], new Rectangle(0, 0, 47, 47), new Point(2, 2), null, null, true);
      this.MainBitmapData.copyPixels(this.WPBox, new Rectangle(0, 0, 47, 46), new Point(0, 0), null, null, true);
      _loc32_.sell_price.text = this.x3String(this.get_sell_price(_loc187_, _loc186_, false, this.weapon_stack[1].stat == "c"));
      if (this.weapon_stack[1].stat == "s") {
        _loc32_.sell_warning.text = "Украденное оружие продать обычным способом нельзя. Его можно только продать на запчасти за 50 монет.";
        _loc32_.sell_price.text = "50";
      } else if (this.weapon_stack[1].stat == "c") {
        _loc32_.sell_warning.text = "Скрафтенное оружие можно продавать только три раза в день. Вы продали сегодня: " + _loc34_.today_craft_sells + ".";
        if (_loc34_.today_craft_sells >= 3) {
          _loc32_.finish_sell.visible = false;
        }
      }
    }
    if (this.cur_screen[this.cur_screen[0]].name == "assault") {
      _loc32_.assault_fight.visible = false;
      // PORT: item 8 - the player's clan (clan.mine): its emblem and name (a player's text, never translated); a click on
      // PORT: them opens the clans tab (ClanHub.click).
      _loc188_ = this.FWP.clan_of_uid["id" + this.FWP.user.user_id];
      _loc32_.my_clan_icon.gotoAndStop(this.FWP.user_clan == 0 || !_loc188_ ? NO_EMBLEM_FRAME : emblemFrame(_loc188_.emblem));
      if (this.FWP.user_clan == 0 || !_loc188_) {
        _loc32_.my_clan_name.text = "нет";
      } else {
        setRawText(_loc32_.my_clan_name, _loc188_.name);
      }
      // PORT: a player's clan name of up to 20 letters in the 161 px field of the original: a smaller font when wider.
      fitText(_loc32_.my_clan_name, 1);
      if (this.cur_element > 0) {
        if (this.FWP.ASSAULT[this.cur_element].user_id != this.FWP.user.user_id && (this.FWP.return_clan(this.FWP.ASSAULT[this.cur_element].user_id) != this.FWP.user_clan || this.FWP.user_clan == 0)) {
          _loc32_.assault_fight.visible = true;
        }
        _loc189_ = "";
        _loc190_ = "";
        if (this.FWP.ASSAULT[this.cur_element].zone_stage % 10 == 2 || this.FWP.ASSAULT[this.cur_element].zone_stage % 10 == 3 || this.FWP.ASSAULT[this.cur_element].zone_stage % 10 == 4) {
          _loc190_ = "а";
        }
        _loc189_ += "<b>Территория захвачена:</b> " + this.FWP.ASSAULT[this.cur_element].zone_stage + " раз" + _loc190_ + "\n";
        _loc191_ = "<b>нет</b>";
        if (this.FWP.ASSAULT[this.cur_element].user_id != 0) {
          _loc189_ += "<b>Последний захват: </b> " + this.FWP.ret_time_format(this.FWP.assault_cur_time - this.FWP.ASSAULT[this.cur_element].last_assault) + "\n";
          for (_loc193_ of as3.keys(this.FWP.assault_names)) {
            if (this.FWP.assault_names[_loc193_].uid == this.FWP.ASSAULT[this.cur_element].user_id) {
              _loc191_ = playerName(String(this.FWP.assault_names[_loc193_].first_name)) + " " + this.FWP.assault_names[_loc193_].last_name;
            }
          }
        }
        _loc189_ += "<b>Текущий владелец:</b> " + _loc191_ + "\n";
        _loc189_ = _loc189_ + ("<b>Бонусы за захват:</b> " + this.FWP.TEAMS_DEF["assault" + this.cur_element].gold + " зол., " + this.FWP.TEAMS_DEF["assault" + this.cur_element].exp + " опыта\n");
        _loc189_ = _loc189_ + ("<b>Ежечасные выплаты:</b> " + this.FWP.TEAMS_DEF["assault" + this.cur_element].payments + " зол.\n");
        _loc189_ = _loc189_ + ("<b>Вражеская команда:</b> " + this.FWP.TEAMS_DEF["assault" + this.cur_element].name + "\n");
        if (this.FWP.ASSAULT[this.cur_element].user_id == this.FWP.user.user_id) {
          _loc189_ += "\n<b><font color=\"#009900\">Вы являетесь владельцем этой территории.</font></b>\n";
        } else if (this.FWP.return_clan(this.FWP.ASSAULT[this.cur_element].user_id) == this.FWP.user_clan && this.FWP.user_clan != 0) {
          _loc189_ += "\n<b><font color=\"#009900\">Ваш клан является владельцем этой территории.</font></b>\n";
        }
        _loc32_.assault_zones.gotoAndStop(2);
        _loc32_.assault_zones.zone_desc.htmlText = _loc189_;
        _loc192_ = this.FWP.ASSAULT[this.cur_element].zone_stage % this.FWP.TEAMS_DEF["assault" + this.cur_element].assault_limit / this.FWP.TEAMS_DEF["assault" + this.cur_element].assault_limit;
        _loc32_.assault_zones.zone_difficulty_mask.width = Math.round(_loc192_ * 200);
      } else {
        _loc32_.assault_zones.gotoAndStop(1);
        _loc32_.assault_zones.zone_common_desc.htmlText = "При захвате территории вы сражаетесь с червяками, населяющими ее. У каждой территории есть <b>\"предводитель\"</b> - мини-босс, которого нельзя сбить в воду. Более того, он <b>неуязвим</b>, пока жив хоть один червяк из его команды.\n\nПосле захвата территории вы получаете <b>ежечасные</b> бонусы золотом.\n\nЕсли территория захвачена кланом, все члены этого клана получают бонус в размере <b>10%</b> дохода с каждой территории, и это кроме, собственно, перечислений в размере <b>100%</b> золота захватившему игроку.\n\nС каждым следующим захватом территории сила ботов на ней возрастает. Поторопитесь!\n\nУровень сложности в игре и хардкорный режим здесь не учитываются.";
      }
      _loc2_ = 1;
      while (_loc2_ <= 17) {
        _loc32_["terr_zone_" + _loc2_].clan_icon.gotoAndStop(NO_EMBLEM_FRAME);
        if (this.FWP.ASSAULT[_loc2_].user_id != 0) {
          // PORT: item 8 - the emblem of the owner's clan (the zone's ownerClan, FWP.clan_of_uid).
          if (this.FWP.return_clan(this.FWP.ASSAULT[_loc2_].user_id) > 0) {
            _loc32_["terr_zone_" + _loc2_].clan_icon.gotoAndStop(emblemFrame(this.FWP.clan_of_uid["id" + this.FWP.ASSAULT[_loc2_].user_id].emblem));
          }
        }
        _loc2_++;
      }
      _loc2_ = 1;
      while (_loc2_ <= 17) {
        if (this.FWP.ASSAULT[_loc2_].user_id != 0 && this.FWP.return_clan(this.FWP.ASSAULT[_loc2_].user_id) == 0) {
          _loc32_["terr_zone_" + _loc2_].clan_icon.gotoAndStop(30);
          _loc194_ = new Bitmap();
          _loc195_ = new BitmapData(50, 50, true, 0);
          _loc195_.copyPixels(this.FWP.avdatas["id" + this.FWP.ASSAULT[_loc2_].user_id], new Rectangle(0, 0, 50, 50), new Point(0, 0));
          _loc194_.bitmapData = _loc195_;
          _loc196_ = _loc32_["terr_zone_" + _loc2_].clan_icon.avatar.addChild(_loc194_);
          _loc196_.x = 0;
          _loc196_.y = 0;
          _loc196_.width = 32;
          _loc196_.height = 32;
        }
        _loc2_++;
      }
      _loc188_ = false;
      if (this.FWP.get_tribute().my_gold != 0 || this.FWP.get_tribute().clans_gold != 0) {
        _loc188_ = true;
      }
      _loc32_.clip_assault_tribute.visible = true;
      if (!_loc188_) {
        _loc32_.clip_assault_tribute.gotoAndStop(1);
      } else if (_loc34_.next_assault_payment == 0 || _loc34_.next_assault_payment < this.FWP.fwproject_time) {
        _loc32_.clip_assault_tribute.gotoAndPlay(1);
      } else {
        _loc32_.clip_assault_tribute.visible = false;
        _loc32_.assault_next_tribute.text = "Сбор золота\n(через " + Math.ceil(this.mod(this.FWP.fwproject_time - _loc34_.next_assault_payment) / 60) + " мин.)";
      }
    }
    if (this.cur_screen[this.cur_screen[0]].name == "tribute") {
      _loc32_.finish_tribute.visible = false;
      _loc197_ = this.FWP.get_tribute();
      _loc198_ = _loc197_.terr_total;
      _loc199_ = _loc197_.my_gold;
      _loc200_ = _loc197_.clans_gold;
      _loc201_ = "Вы владете <b>" + _loc198_ + "</b> территор.\n";
      _loc201_ = _loc201_ + ("Выплата: <b>" + this.x3String(_loc199_) + "</b> зол.\n");
      _loc201_ = _loc201_ + ("Выплата от клана: <b>" + this.x3String(_loc200_) + "</b> зол.\n\n");
      _loc202_ = _loc199_ + _loc200_;
      if (_loc202_ == 0) {
        _loc201_ += "Неоткуда собирать.";
      } else {
        _loc201_ += "Можете забрать золото: <b>" + this.x3String(_loc202_) + "</b>";
        _loc32_.finish_tribute.visible = true;
      }
      _loc32_.main.htmlText = _loc201_;
    }
    if (this.cur_screen[this.cur_screen[0]].name == "choose_spec") {
      _loc32_.finish_choose_spec.visible = false;
      _loc2_ = 1;
      while (_loc2_ <= 4) {
        _loc32_["clicked_spec_" + _loc2_].visible = false;
        _loc2_++;
      }
    }
    if (this.cur_screen[this.cur_screen[0]].name == "tasks") {
      if (this.task_bonus_text == "") {
        _loc32_.task_desc.htmlText = "Выполняйте задания и получайте бонусы! При клике на каждое задание здесь появится его описание и все необходимые пояснения.";
      } else {
        _loc32_.task_desc.htmlText = this.task_bonus_text;
      }
      _loc32_.clip_get_task_bonus.visible = this.FWP.get_task_bonus().exist;
      _loc102_ = Math.min(this.FWP.player.cur_task, this.FWP.TASK_DEF[0]);
      _loc2_ = 1;
      while (_loc2_ <= this.FWP.TASK_DEF[0]) {
        this.buttons["tsk" + _loc2_].visible = _loc2_ <= _loc102_;
        if (_loc2_ <= _loc102_) {
          _loc203_ = "";
          if (_loc2_ == this.FWP.TASK_DEF[0]) {
            if (_loc2_ == this.cur_element) {
              _loc203_ += "<font color=\"#ff0000\">";
            }
            _loc203_ += "<b>" + this.FWP.TASK_DEF[_loc2_].name + "</b>";
            if (_loc2_ == this.cur_element) {
              _loc203_ += "</font>";
            }
          } else {
            if (_loc2_ == this.cur_element) {
              _loc203_ += "<font color=\"#ff0000\">";
            }
            if (_loc2_ == _loc102_) {
              _loc203_ += "Задание " + _loc2_ + ": <b>" + this.FWP.TASK_DEF[_loc2_].name + "</b>";
            } else {
              _loc203_ += "Задание " + _loc2_ + ": " + this.FWP.TASK_DEF[_loc2_].name;
            }
            if (_loc2_ == this.cur_element) {
              _loc203_ += "</font>";
            }
          }
          this.buttons["tsk" + _loc2_].task_text.htmlText = _loc203_;
        }
        _loc2_++;
      }
      if (this.cur_element >= 1 && this.cur_element <= this.FWP.TASK_DEF[0]) {
        _loc32_.task_name.text = this.FWP.TASK_DEF[this.cur_element].name;
        _loc204_ = "";
        if (this.cur_element != this.FWP.TASK_DEF[0]) {
          if (this.FWP.TASK_DEF[this.cur_element].bonus_type == "gold") {
            _loc204_ += "Награда за выполнение: <b>" + this.x3String(this.FWP.TASK_DEF[this.cur_element].bonus) + " золота</b>\n";
          }
          if (this.FWP.TASK_DEF[this.cur_element].bonus_type == "diam") {
            _loc204_ += "Награда за выполнение: <b>" + this.FWP.TASK_DEF[this.cur_element].bonus + " алм.</b>\n";
          }
          if (this.FWP.TASK_DEF[this.cur_element].bonus_type == "exp") {
            _loc204_ += "Награда за выполнение: <b>" + this.x3String(this.FWP.TASK_DEF[this.cur_element].bonus) + " опыта.</b>\n";
          }
        }
        _loc32_.task_desc.htmlText = _loc204_ + "\n\n" + this.task_texts[this.cur_element];
      }
    }
    if (this.cur_screen[this.cur_screen[0]].name == "auc") {
      // PORT: design D7 - the auction is paid in diamonds (the original: VK votes, "голос/голоса/голосов"); price,
      // PORT: holder and the time since the last purchase come from the server (auction.get, FWP.net_auction_adopt).
      _loc205_ = " алмазов";
      // PORT: fixed defect: "% 100 == 1" gave "21 голосов"; 21, 31, ... take the singular too (11 stays plural below).
      if (this.FWP.auc_info.price % 10 == 1) {
        _loc205_ = " алмаз";
      }
      if (this.FWP.auc_info.price % 10 >= 2 && this.FWP.auc_info.price % 10 <= 4) {
        _loc205_ = " алмаза";
      }
      if (this.FWP.auc_info.price % 100 >= 10 && this.FWP.auc_info.price % 100 <= 20) {
        _loc205_ = " алмазов";
      }
      _loc32_.auc_time.text = this.FWP.auc_info.holder ? this.FWP.ret_time_format(this.FWP.auc_info.cur_time - this.FWP.auc_info.last_buy) : "-";
      _loc32_.auc_price.text = this.FWP.auc_info.price + _loc205_;
      // PORT: the holder's name is data (never translated); "Никто" is game text.
      if (this.FWP.auc_info.holder) {
        setRawText(_loc32_.auc_master, playerName(String(this.FWP.auc_names[0].first_name)) + " " + this.FWP.auc_names[0].last_name);
      } else {
        _loc32_.auc_master.text = "Никто";
      }
      _loc32_.auc_buy.visible = this.FWP.auc_info.holder != this.FWP.user.player_id;
      // PORT: the holder's picture (ui/avatar.ts: the player's own specialisation, a team of worms for another player;
      // PORT: a question mark without a holder), not an empty white cell; a render after a purchase replaces it.
      showAvatar(this.FWP, _loc32_.auc_avatar_container, !this.FWP.auc_info.holder ? NOBODY : this.FWP.auc_info.holder == this.FWP.user.player_id ? _loc34_.spec : 0, AVATAR_ROW);
    }
    // PORT: design D7 - also the caption of the 'donate' button ("Пополнить баланс", a VK payment): it opens the exchange
    // PORT: of diamonds for gold.
    if (["auc_rules", "view_tutorial", "shop", "roul", "papa_shop"].indexOf(this.cur_screen[this.cur_screen[0]].name) != -1) {
      this.replace_vk_texts(_loc32_);
    }
    // PORT: VK-only controls (friends, wall posts, the auction's VK video) are hidden instead of the offline
    // PORT: build's greyed-out look; replays are enabled again (backend replay store), and so is the auction (click_auc,
    // PORT: design D7: paid in diamonds on the own server).
    // PORT: item 8 - the friends tab ('wait_fd') is the clans tab (click); the online lobby is the fight screen's sixth
    // PORT: mode (design D5).
    this.hide_named_children(_loc32_, ["post_new_level", "post_win_game", "init_friends", "open_admin", "auc_demo", "open_page"]);
    // PORT: the new level's "What is open to me?" alone in the middle of the pair it formed with the hidden wall post.
    this.centre_lone_button(_loc32_, "what_opened", "post_new_level");
    // PORT: the store and the opt-in rewarded ads of this screen (runtime/monetization-ui.ts; nothing without them).
    renderMonetization(this, this.cur_screen[this.cur_screen[0]].name, _loc32_);
    // PORT: the victory popup's "Continue" where its ad button is not offered (runtime/monetization-ui.ts).
    if (this.cur_screen[this.cur_screen[0]].name == "end_game_win") {
      renderWinContinue(this, _loc32_);
    }
    // PORT: a translation longer than the original ran under the frame's beanstalk (ui/controls.ts).
    clearOfBeanstalk(_loc32_);
  }

  /**
   * PORT: design D7 - the asset texts that still speak of VK votes (the auction rules, the tutorial page about gold and
   * PORT: diamonds) are replaced by the product texts (src/game/runtime/product-texts.ts); searched `param2` levels
   * PORT: deep. Their translations say the same, so only the original language finds the old wording.
   */
  replace_vk_texts(param1: any, param2: number = 2): void {
    for (let _loc3_: number = 0; param1 && _loc3_ < param1.numChildren; _loc3_++) {
      const t: any = param1.getChildAt(_loc3_);
      if (t instanceof TextField) {
        const text: string | null = productTextFor(t.text.replace(/\s+/g, " "));
        if (text !== null) {
          t.htmlText = text;
        }
      } else if (param2 > 1 && typeof t.numChildren == "number") {
        this.replace_vk_texts(t, param2 - 1);
      }
    }
  }

  /**
   * PORT: hides every unnamed child of `param1` (timeline decorations and captions) whose bounds' centre lies between
   * PORT: y = `param2` and y = `param3` and that is at most `param4` high (the screen's background stays).
   */
  hide_unnamed_in_band(param1: any, param2: number, param3: number, param4: number): void {
    for (let _loc5_: number = 0; param1 && _loc5_ < param1.numChildren; _loc5_++) {
      const t: any = param1.getChildAt(_loc5_);
      if (!/^instance\d+$/.test(String(t.name))) continue;
      const b = t.getBounds(param1);
      const cy = b.y + b.height / 2;
      if (cy >= param2 && cy <= param3 && b.height <= param4) t.visible = false;
    }
  }

  /**
   * PORT: hides every direct child with one of the given instance names (VK-only controls; names can repeat) and the
   * PORT: unnamed caption text the timeline places over such a button as a separate object ("На стену" over
   * PORT: post_win_game/post_new_level, "Добавиться(в новом окне)" over open_admin, ...), which would otherwise stay visible.
   */
  hide_named_children(param1: any, param2: string[], param3: number = 3): void {
    let _loc3_: number = 0;
    const hidden: Rectangle[] = [];
    while (param1 && _loc3_ < param1.numChildren) {
      const c: any = param1.getChildAt(_loc3_);
      if (param2.indexOf(c.name) != -1) {
        c.visible = false;
        hidden.push(c.getBounds(param1));
      } else if (param3 > 1 && !c.$isButton && !(c instanceof TextField) && typeof c.numChildren == "number") {
        // PORT: and in the screen's clips, `param3` levels deep (a button a timeline nests in a clip of the popup).
        this.hide_named_children(c, param2, param3 - 1);
      }
      _loc3_++;
    }
    for (_loc3_ = 0; hidden.length && _loc3_ < param1.numChildren; _loc3_++) {
      const t: any = param1.getChildAt(_loc3_);
      if (!(t instanceof TextField) || !/^instance\d+$/.test(t.name)) continue;
      const b = t.getBounds(param1);
      if (hidden.some((h) => h.width > 0 && h.contains(b.x + b.width / 2, b.y + b.height / 2))) t.visible = false;
    }
  }

  /**
   * PORT: a button of `param1` named `param2` that formed a row with the button `param3` the port hides (the new level's
   * PORT: "What is open to me?" beside the VK wall post) goes to the middle of that pair's place, with its caption (the
   * PORT: unnamed text the timeline puts over it); back to its own place while the other one is shown.
   */
  centre_lone_button(param1: any, param2: string, param3: string): void {
    const lone: any = param1 ? param1.getChildByName(param2) : null;
    const gone: any = param1 ? param1.getChildByName(param3) : null;
    if (!lone || !gone) return;
    const moved: any[] = [lone];
    const home = (o: any): number => (o.$loneX === undefined ? (o.$loneX = o.x) : o.$loneX);
    const own = lone.getBounds(param1);
    const x0 = own.x - (lone.x - home(lone));
    for (let _loc3_: number = 0; _loc3_ < param1.numChildren; _loc3_++) {
      const t: any = param1.getChildAt(_loc3_);
      if (!(t instanceof TextField) || !/^instance\d+$/.test(t.name)) continue;
      const b = t.getBounds(param1);
      const cx = b.x + b.width / 2 - (t.$loneX === undefined ? 0 : t.x - t.$loneX);
      if (cx > x0 && cx < x0 + own.width && b.y + b.height / 2 > own.y && b.y + b.height / 2 < own.y + own.height) moved.push(t);
    }
    const other = gone.getBounds(param1);
    const dx = gone.visible ? 0 : Math.round((Math.min(x0, other.x) + Math.max(x0 + own.width, other.x + other.width)) / 2 - (x0 + own.width / 2));
    for (const o of moved) o.x = home(o) + dx;
  }

  move_world_map(param1: any): any {
    if (this.map_moving == "button_down") {
      this.world_position_y -= 10;
    }
    if (this.map_moving == "button_up") {
      this.world_position_y += 10;
    }
    if (this.map_moving == "button_right") {
      this.world_position_x -= 10;
    }
    if (this.map_moving == "button_left") {
      this.world_position_x += 10;
    }
    this.render_world_map();
  }

  stop_moving(param1: any): any {
    param1.target.removeEventListener(MouseEvent.MOUSE_OUT, this.stop_moving);
    this.map_moving = "";
    this.removeEventListener(Event.ENTER_FRAME, this.move_world_map);
  }

  render_world_map(): any {
    let _loc1_: any = undefined;
    let _loc2_: any = undefined;
    let _loc3_: any = undefined;
    let _loc4_: any = undefined;
    if (this.world_position_y > 0) {
      this.world_position_y = 0;
    }
    if (this.world_position_x > 0) {
      this.world_position_x = 0;
    }
    _loc1_ = this.cur_screen[this.cur_screen[0]].link;
    _loc1_.square_container.internal.x = this.world_position_x;
    _loc1_.square_container.internal.y = this.world_position_y;
    while (_loc1_.square_container.internal.x >= 68) {
      _loc1_.square_container.internal.x -= 68;
    }
    while (_loc1_.square_container.internal.x <= -68) {
      _loc1_.square_container.internal.x += 68;
    }
    while (_loc1_.square_container.internal.y >= 68) {
      _loc1_.square_container.internal.y -= 68;
    }
    while (_loc1_.square_container.internal.y <= -68) {
      _loc1_.square_container.internal.y += 68;
    }
    this.world_left_square = Math.floor(-this.world_position_x / 68) + 1;
    this.world_top_square = Math.floor(-this.world_position_y / 68) + 1;
    _loc2_ = 0;
    _loc3_ = 1;
    while (_loc3_ <= 8) {
      _loc4_ = 1;
      while (_loc4_ <= 9) {
        _loc2_++;
        if (this.FWP.map_info[_loc3_ + this.world_left_square][_loc4_ + this.world_top_square] == 0) {
          this.squares["sq" + _loc2_].visible = true;
          this.squares["sq" + _loc2_].alpha = 0.9;
        } else if (this.FWP.map_info[_loc3_ + this.world_left_square][_loc4_ + this.world_top_square] == 1) {
          this.squares["sq" + _loc2_].visible = true;
          this.squares["sq" + _loc2_].alpha = 0.5;
        } else {
          this.squares["sq" + _loc2_].visible = false;
        }
        _loc4_++;
      }
      _loc3_++;
    }
  }

  remove(): any {
    if (this.cur_screen[this.cur_screen[0]].name in this.no_anim_def) {
      this.remove_instant();
      return;
    }
    if (this.FWP.player.settings.no_animation == 0) {
      this.FWP.animation = true;
      this.FWP.animation_y = 0;
      this.FWP.animation_mode = "hide";
      this.FWP.set_invisible_button(true);
      return;
    }
    this.remove_instant();
  }

  remove_instant(): any {
    let _loc1_: any = undefined;
    let _loc2_: any = undefined;
    let _loc3_: any = undefined;
    let _loc4_: any = undefined;
    _loc1_ = this.cur_screen[this.cur_screen[0]].link;
    --this.cur_screen[0];
    _loc2_ = this.cur_screen[this.cur_screen[0] + 1].name;
    if (Boolean(_loc1_.bitmap_container) && this.cur_screen[this.cur_screen[0] + 1].name != "game") {
      _loc1_.bitmap_container.removeChild(this.MainBitmap);
    }
    if (Boolean(_loc1_.bitmap_container) && this.cur_screen[this.cur_screen[0] + 1].name == "game") {
      _loc1_.bitmap_container.removeChild(this.SecondBitmap);
    }
    if (this.cur_screen[this.cur_screen[0] + 1].name == "settings") {
      _loc1_.worm_name1.removeEventListener(Event.CHANGE, this.check_tf);
      _loc1_.worm_name2.removeEventListener(Event.CHANGE, this.check_tf);
      _loc1_.worm_name3.removeEventListener(Event.CHANGE, this.check_tf);
      _loc1_.worm_name4.removeEventListener(Event.CHANGE, this.check_tf);
      _loc1_.worm_name5.removeEventListener(Event.CHANGE, this.check_tf);
    }
    _loc3_ = 0;
    while (_loc1_.numChildren != 0) {
      _loc3_++;
      if (_loc3_ > 100000) {
        break;
      }
      _loc1_.getChildAt(0).removeEventListener(MouseEvent.CLICK, this.click);
      _loc1_.getChildAt(0).removeEventListener(MouseEvent.MOUSE_OVER, this.mouse_event);
      _loc1_.getChildAt(0).removeEventListener(MouseEvent.MOUSE_OUT, this.mouse_event);
      _loc1_.getChildAt(0).removeEventListener(MouseEvent.MOUSE_UP, this.mouse_event);
      _loc1_.getChildAt(0).removeEventListener(MouseEvent.MOUSE_DOWN, this.mouse_event);
      _loc4_ = _loc1_.getChildAt(0);
      _loc1_.removeChildAt(0);
      _loc4_ = null;
    }
    this.removeChild(_loc1_);
    _loc1_ = null;
    if (!(_loc2_ in this.no_anim_def)) {
      _loc1_ = this.cur_screen[this.cur_screen[0]].link;
      --this.cur_screen[0];
      _loc3_ = 0;
      while (_loc1_.numChildren != 0) {
        _loc3_++;
        if (_loc3_ > 100000) {
          break;
        }
        _loc1_.getChildAt(0).removeEventListener(MouseEvent.CLICK, this.click);
        _loc1_.getChildAt(0).removeEventListener(MouseEvent.MOUSE_OVER, this.mouse_event);
        _loc1_.getChildAt(0).removeEventListener(MouseEvent.MOUSE_OUT, this.mouse_event);
        _loc1_.getChildAt(0).removeEventListener(MouseEvent.MOUSE_UP, this.mouse_event);
        _loc1_.getChildAt(0).removeEventListener(MouseEvent.MOUSE_DOWN, this.mouse_event);
        _loc4_ = _loc1_.getChildAt(0);
        _loc1_.removeChildAt(0);
        _loc4_ = null;
      }
      this.removeChild(_loc1_);
      _loc1_ = null;
    }
    if (this.cur_screen[0] != 0 && this.cur_screen[this.cur_screen[0]].name != "top" && this.cur_screen[this.cur_screen[0]].name != "clans") {
      this.render();
    }
    if (this.cur_screen[0] != 0) {
      if (this.cur_screen[this.cur_screen[0]].name == "mainframe") {
        this.FWP.interf_mainframe = true;
      }
    }
    // PORT: removed the LocalConnection double-connect garbage-collection hack (Flash Player specific; docs/architecture.md section 5).
    if (this.cur_screen[0] != 0) {
      if (this.cur_screen[this.cur_screen[0]].name == "auc" && Boolean(this.success_auc)) {
        this.remove();
      }
    }
  }

  remove_all(): any {
    while (this.cur_screen[0] != 0) {
      this.remove();
    }
  }

  click(param1: any): any {
    let _loc2_: any = undefined;
    let _loc3_: any = undefined;
    let _loc4_: any = undefined;
    let _loc5_: any = undefined;
    let _loc6_: any = undefined;
    let _loc7_: any = undefined;
    let _loc8_: any = undefined;
    let _loc9_: any = undefined;
    let _loc10_: any = undefined;
    let _loc11_: any = undefined;
    let _loc12_: any = undefined;
    let _loc13_: any = undefined;
    let _loc14_: any = undefined;
    let _loc15_: any = undefined;
    let _loc16_: any = undefined;
    let _loc17_: any = undefined;
    let _loc18_: any = undefined;
    let _loc19_: any = undefined;
    let _loc20_: any = undefined;
    let _loc21_: any = undefined;
    let _loc22_: any = undefined;
    let _loc23_: any = undefined;
    let _loc24_: any = undefined;
    let _loc25_: any = null;
    let _loc26_: any = undefined;
    let _loc27_: any = undefined;
    let _loc28_: any = undefined;
    let _loc29_: any = undefined;
    let _loc30_: any = undefined;
    let _loc31_: any = undefined;
    let _loc32_: any = undefined;
    let _loc33_: any = undefined;
    let _loc34_: any = undefined;
    let _loc35_: any = undefined;
    let _loc36_: any = undefined;
    let _loc37_: any = undefined;
    let _loc38_: any = undefined;
    let _loc39_: any = undefined;
    let _loc40_: any = undefined;
    let _loc41_: any = undefined;
    let _loc42_: any = undefined;
    let _loc43_: any = undefined;
    let _loc44_: any = undefined;
    let _loc45_: any = undefined;
    let _loc46_: any = undefined;
    let _loc47_: any = undefined;
    let _loc48_: any = undefined;
    let _loc49_: number = NaN;
    let _loc50_: any = undefined;
    let _loc51_: any = undefined;
    let _loc52_: any = undefined;
    let _loc53_: any = undefined;
    let _loc54_: any = undefined;
    let _loc55_: any = undefined;
    let _loc56_: any = undefined;
    let _loc57_: any = undefined;
    let _loc58_: any = undefined;
    let _loc59_: any = undefined;
    let _loc60_: any = undefined;
    let _loc61_: any = undefined;
    let _loc62_: any = undefined;
    let _loc63_: any = undefined;
    let _loc64_: any = undefined;
    let _loc65_: any = undefined;
    let _loc66_: any = undefined;
    let _loc67_: any = undefined;
    let _loc68_: any = undefined;
    let _loc69_: any = undefined;
    let _loc70_: any = undefined;
    let _loc71_: any = undefined;
    let _loc72_: any = undefined;
    let _loc73_: any = undefined;
    let _loc74_: any = undefined;
    let _loc75_: any = undefined;
    let _loc76_: any = undefined;
    let _loc77_: any = undefined;
    let _loc78_: any = undefined;
    let _loc79_: any = undefined;
    let _loc80_: any = undefined;
    let _loc81_: any = undefined;
    let _loc82_: any = undefined;
    let _loc83_: any = undefined;
    let _loc84_: any = undefined;
    let _loc85_: any = undefined;
    let _loc86_: any = undefined;
    let _loc87_: any = undefined;
    let _loc88_: any = undefined;
    this.FWP.deep_trace(this.cur_screen);
    _loc4_ = this.cur_screen[this.cur_screen[0]].link;
    _loc5_ = this.FWP.temp_player;
    _loc6_ = this.FWP.player;
    // PORT: design D5 - the online lobby (the fight screen's "Онлайн" mode), the online room, its result and the online
    // PORT: battle's surrender button (runtime/online-lobby.ts).
    if (this.FWP.online && this.FWP.online.click(param1)) {
      return;
    }
    // PORT: item 8 - the friends tab ('wait_fd', VK friends in the original) is the clans tab: the clans of the players
    // PORT: (runtime/clan-hub.ts); the online lobby moved to the fight screen's mode board.
    if (param1.target.name == "wait_fd") {
      this.click_proceed("init_clan_hub");
      return;
    }
    // PORT: item 8 - the clans tab, the card of a clan, its dialogs and questions, the best clans' rows, the clan line of
    // PORT: the assault map.
    if (this.FWP.clans && this.FWP.clans.click(param1)) {
      return;
    }
    // PORT: design D7 - the auction of the original is back, on the own server and paid in diamonds: click_auc loads
    // PORT: it and opens the 'auc' screen (the original returned here: the VK-votes auction was off in the offline
    // PORT: build); auc_buy is the server command auction.buy (the VK balance check and net_withdraw_auc are gone).
    if (param1.target.name == "click_auc") {
      this.FWP.net_auction_open();
      return;
    }
    if (param1.target.name == "auc_buy") {
      this.FWP.net_auction_buy();
      return;
    }
    if (param1.target.name == "my_exp") {
      this.init("skills");
      return;
    }
    if (param1.target.name == "how_tribute_calcs") {
      this.init("how_tribute_calcs");
      return;
    }
    if (param1.target.parent) {
      if (param1.target.parent.name.search("recipe_clip_") != -1) {
        _loc11_ = Number(param1.target.parent.name.split("recipe_clip_")[1]);
        _loc4_.recipes_text.visible = true;
        _loc4_.component_result.visible = true;
        _loc12_ = this.FWP.get_wpij(this.FWP.WEAPONS_DEF[this.FWP.CRAFT_DEF[_loc11_].result].id).i;
        _loc13_ = this.FWP.get_wpij(this.FWP.WEAPONS_DEF[this.FWP.CRAFT_DEF[_loc11_].result].id).j;
        this.bitmaps["rec_result"] = new Bitmap();
        this.bitmap_datas["rec_result"] = new BitmapData(50, 50, true, 0);
        this.bitmap_datas["rec_result"].copyPixels(this.BigWP, new Rectangle(1 + 45 * (_loc13_ - 1), 1 + 44 * (_loc12_ - 1), 44, 43), new Point(2, 2));
        this.bitmap_datas["rec_result"].copyPixels(this.WPBox, new Rectangle(0, 0, 47, 46), new Point(0, 0), null, null, true);
        this.bitmaps["rec_result"].bitmapData = this.bitmap_datas["rec_result"];
        _loc4_.component_result.bitmap_container.addChild(this.bitmaps["rec_result"]);
        _loc4_.component_result.wp_name.text = this.FWP.WEAPONS_DEF[this.FWP.CRAFT_DEF[_loc11_].result].name;
        _loc4_.recipes_text.craft_req.text = "";
        _loc2_ = 1;
        while (_loc2_ <= 6) {
          _loc4_["component" + String(_loc2_)].visible = false;
          _loc2_++;
        }
        if (_loc6_.recipes[_loc11_] != 1) {
          _loc4_["component1"].visible = true;
          _loc4_["component1"].wp_name.text = "?";
          this.bitmaps["rec_component1"] = new Bitmap();
          this.bitmap_datas["rec_component1"] = new BitmapData(50, 50, true, 0);
          this.bitmap_datas["rec_component1"].copyPixels(this.IconQuestion, new Rectangle(0, 0, 44, 43), new Point(2, 2));
          this.bitmap_datas["rec_component1"].copyPixels(this.WPBox, new Rectangle(0, 0, 47, 46), new Point(0, 0), null, null, true);
          this.bitmaps["rec_component1"].bitmapData = this.bitmap_datas["rec_component1"];
          _loc4_["component1"].bitmap_container.addChild(this.bitmaps["rec_component1"]);
        } else {
          if (this.FWP.CRAFT_DEF[_loc11_].req > 0) {
            _loc4_.recipes_text.craft_req.text = "(необходима способность Крафтинг уровня " + String(this.FWP.CRAFT_DEF[_loc11_].req) + ")";
          }
          _loc14_ = [0, { "id": "" }, { "id": "" }, { "id": "" }, { "id": "" }, { "id": "" }, { "id": "" }];
          _loc2_ = 1;
          while (_loc2_ <= this.FWP.CRAFT_DEF[_loc11_].ingr[0]) {
            _loc3_ = 1;
            while (_loc3_ <= 6) {
              if (_loc14_[_loc3_].id == "") {
                _loc14_[_loc3_] = { "id": this.FWP.CRAFT_DEF[_loc11_].ingr[_loc2_], "amount": 1 };
                ++_loc14_[0];
                break;
              }
              if (_loc14_[_loc3_].id == this.FWP.CRAFT_DEF[_loc11_].ingr[_loc2_]) {
                ++_loc14_[_loc3_].amount;
                break;
              }
              _loc3_++;
            }
            _loc2_++;
          }
          _loc2_ = 1;
          while (_loc2_ <= _loc14_[0]) {
            _loc4_["component" + String(_loc2_)].visible = true;
            _loc15_ = _loc14_[_loc2_].id.search("obj_") == -1 ? "weapon" : "object";
            if (_loc15_ == "weapon") {
              _loc7_ = this.FWP.WEAPONS_DEF;
            }
            if (_loc15_ == "object") {
              _loc7_ = this.FWP.OBJ_DEF;
            }
            this.bitmaps["rec_component" + _loc2_] = new Bitmap();
            this.bitmap_datas["rec_component" + _loc2_] = new BitmapData(50, 50, true, 0);
            if (_loc15_ == "weapon") {
              _loc12_ = this.FWP.get_wpij(_loc7_[_loc14_[_loc2_].id].id).i;
              _loc13_ = this.FWP.get_wpij(_loc7_[_loc14_[_loc2_].id].id).j;
              this.bitmap_datas["rec_component" + _loc2_].copyPixels(this.BigWP, new Rectangle(1 + 45 * (_loc13_ - 1), 1 + 44 * (_loc12_ - 1), 44, 43), new Point(2, 2));
            } else {
              this.bitmap_datas["rec_component" + _loc2_].copyPixels(this.BigObjs, new Rectangle(1 + 45 * (_loc7_[_loc14_[_loc2_].id].id - 1), 1, 44, 43), new Point(2, 2));
            }
            this.bitmap_datas["rec_component" + _loc2_].copyPixels(this.WPAmount, new Rectangle(0, (_loc14_[_loc2_].amount - 2) * 10, 21, 9), new Point(3 - 1 + 44 - 16 - 7, 3 - 1 + 43 - 11), null, null, true);
            this.bitmap_datas["rec_component" + _loc2_].copyPixels(this.WPBox, new Rectangle(0, 0, 47, 46), new Point(0, 0), null, null, true);
            this.bitmaps["rec_component" + _loc2_].bitmapData = this.bitmap_datas["rec_component" + _loc2_];
            _loc4_["component" + String(_loc2_)].bitmap_container.addChild(this.bitmaps["rec_component" + _loc2_]);
            _loc4_["component" + String(_loc2_)].wp_name.text = _loc7_[_loc14_[_loc2_].id].name;
            _loc2_++;
          }
        }
        return;
      }
    }
    if (param1.target.parent) {
      if (param1.target.parent.name.search("clip_achiev") != -1) {
        _loc16_ = Number(param1.target.parent.name.split("clip_achiev")[1]);
        _loc4_.achiev_name.text = this.FWP.ACHIEV_DEF[_loc16_].name;
        _loc17_ = "";
        _loc18_ = this.FWP.ACHIEV_DEF[_loc16_].id;
        _loc19_ = _loc6_.achiev[_loc18_];
        _loc20_ = this.FWP.get_achiev_level(this.FWP.ACHIEV_DEF[_loc16_].id, _loc19_);
        _loc17_ += "Уровень достижения: <b>" + _loc20_ + "/15</b>\n";
        if (_loc20_ != 15) {
          _loc17_ += "Выполнено: <b>" + this.x3String(_loc19_) + " / " + this.x3String(this.FWP.ACHIEV_DEF[_loc16_].levels[_loc20_ + 1]) + "</b>\n";
          _loc21_ = this.FWP.ACHIEV_PRISE_DEF[_loc18_].amount[_loc20_ + 1];
          if (this.FWP.ACHIEV_PRISE_DEF[_loc18_].prise == "exp") {
            _loc17_ += "Награда за след. уровень: <b>" + this.x3String(Math.round((this.FWP.LEVEL_THRESHOLD[_loc6_.level.value + 1] - this.FWP.LEVEL_THRESHOLD[_loc6_.level.value]) * _loc21_ / 100)) + " опыта</b>\n";
          }
          if (this.FWP.ACHIEV_PRISE_DEF[_loc18_].prise == "gold") {
            _loc17_ += "Награда за след. уровень: <b>" + this.x3String(_loc21_) + " золота</b>\n";
          }
          if (this.FWP.ACHIEV_PRISE_DEF[_loc18_].prise == "diam") {
            _loc17_ += "Награда за след. уровень: <b>" + _loc21_ + " алм.</b>\n";
          }
        } else {
          _loc17_ += "Выполнено: <b>" + this.FWP.ACHIEV_DEF[_loc16_].levels[_loc20_] + "/" + this.FWP.ACHIEV_DEF[_loc16_].levels[_loc20_] + "</b>\n";
        }
        _loc17_ += "\n" + this.achiev_text[_loc18_];
        _loc4_.achiev_desc.htmlText = _loc17_;
      }
    }
    if (param1.target.name == "get_achiev_bonus") {
      // PORT: design D3 - achiev.claim on the server (the prizes, the new achievement levels and check_new_level); the
      // PORT: bonus text and the level-up screens show what the server credited.
      this.FWP.net_command("achiev.claim", {}, "render", { "done": (result: any) => {
        this.achiev_bonus_text = "Вы получили следующие бонусы:\n\n";
        if (result.gold != 0) {
          this.achiev_bonus_text += "<b>" + this.x3String(result.gold) + " золота</b>\n";
        }
        if (result.diam != 0) {
          this.achiev_bonus_text += "<b>" + this.x3String(result.diam) + " алм.</b>\n";
        }
        if (result.exp != 0) {
          this.achiev_bonus_text += "<b>" + this.x3String(result.exp) + " опыта</b>\n";
        }
        this.FWP.claim_end_game(result.levelUp);
        if (this.FWP.end_game.levels_upg > 0) {
          this.FWP.execute_after = "init new level";
        }
      } });
      return;
    }
    if (param1.target.name == "get_task_bonus") {
      // PORT: design D3 - task.claim on the server (the bonuses of the finished tasks and check_new_level).
      this.FWP.net_command("task.claim", {}, "render", { "done": (result: any) => {
        this.task_bonus_text = "Вы получили следующие бонусы:\n\n";
        if (result.gold != 0) {
          this.task_bonus_text += "<b>" + this.x3String(result.gold) + " золота</b>\n";
        }
        if (result.diam != 0) {
          this.task_bonus_text += "<b>" + this.x3String(result.diam) + " алм.</b>\n";
        }
        if (result.exp != 0) {
          this.task_bonus_text += "<b>" + this.x3String(result.exp) + " опыта</b>\n";
        }
        this.FWP.claim_end_game(result.levelUp);
        this.cur_element = 0;
        if (this.FWP.end_game.levels_upg > 0) {
          this.FWP.execute_after = "init new level";
        }
      } });
      return;
    }
    if (param1.target.name == "in_game_prev_page") {
      --this.shop_page;
      this.render();
      return;
    }
    if (param1.target.name == "in_game_next_page") {
      ++this.shop_page;
      this.render();
      return;
    }
    if (param1.target.name == "craft_wp_prev_page") {
      --this.craft_wp_page;
      this.render();
      return;
    }
    if (param1.target.name == "craft_wp_next_page") {
      ++this.craft_wp_page;
      this.render();
      return;
    }
    if (param1.target.name == "craft_obj_prev_page") {
      --this.craft_obj_page;
      this.render();
      return;
    }
    if (param1.target.name == "craft_obj_next_page") {
      ++this.craft_obj_page;
      this.render();
      return;
    }
    if (param1.target.name == "craft_assemble") {
      // PORT: design D3 - craft.assemble on the server with the stack exactly as the drag & drop built it (slots 1..6;
      // PORT: check_recipe, the success and junk draws, the ingredients and the result are the server's). The screens
      // PORT: read crafting_result from the op's result.
      _loc25_ = [];
      _loc28_ = 1;
      while (_loc28_ <= 6) {
        _loc25_.push(this.craft_item_arg(this.weapon_stack[_loc28_]));
        _loc28_++;
      }
      this.FWP.net_command("craft.assemble", { "stack": _loc25_ }, "render", { "done": (result: any) => {
        this.crafting_result = this.craft_result_of(result);
        if (result.errorScreen) {
          // The early returns of the original (craft_too_diff / craft_limit): the recipe was learnt, the stack stays.
          this.FWP.execute_after = "";
          this.init("error", result.errorScreen);
          return;
        }
        this.weapon_stack = [0, {}, {}, {}, {}, {}, {}];
        this.weapon_diss = {};
        this.init("finish_crafting");
      } });
    }
    if (param1.target.name == "craft_disassemble") {
      // PORT: design D3 - craft.disassemble on the server with the weapon copy of the disassembly slot.
      this.FWP.net_command("craft.disassemble", { "item": this.craft_item_arg(this.weapon_diss) }, "render", { "done": (result: any) => {
        this.crafting_result = this.craft_result_of(result);
        this.weapon_stack = [0, {}, {}, {}, {}, {}, {}];
        this.weapon_diss = {};
        this.init("finish_crafting");
      } });
    }
    if (param1.target.name == "arsenal_sell") {
      this.cur_weapon = param1.target.parent.parent.name.split("weapon_")[1].split("%")[0];
      if (this.cur_weapon == "obj_red_book" || this.cur_weapon == "obj_orange_book" || this.cur_weapon == "obj_yellow_book" || this.cur_weapon == "obj_green_book" || this.cur_weapon == "obj_skyblue_book" || this.cur_weapon == "obj_blue_book" || this.cur_weapon == "obj_violet_book" || this.cur_weapon == "obj_white_book" || this.cur_weapon == "obj_black_book") {
        _loc7_ = this.FWP.OBJ_DEF;
        _loc8_ = _loc6_.objs;
        if (_loc6_.objs["obj_red_book"] == 1 && _loc6_.objs["obj_orange_book"] == 1 && _loc6_.objs["obj_yellow_book"] == 1 && _loc6_.objs["obj_green_book"] == 1 && _loc6_.objs["obj_skyblue_book"] == 1 && _loc6_.objs["obj_blue_book"] == 1 && _loc6_.objs["obj_violet_book"] == 1 && _loc6_.objs["obj_white_book"] == 1 && _loc6_.objs["obj_black_book"] == 1) {
          // PORT: design D3 - the collection is sold by the server (arsenal.sell of a book = the nine books).
          this.FWP.net_command("arsenal.sell", { "category": "objs", "id": this.cur_weapon }, "render");
          return;
        }
        this.init("error", "collect_all_books");
        return;
      }
      if (this.shop_type == "weapons") {
        this.weapon_stack = [
          1,
          {
            "id": this.cur_weapon,
            "stat": param1.target.parent.parent.name.split("weapon_")[1].split("%")[1],
            "range": param1.target.parent.parent.name.split("weapon_")[1].split("%")[2],
            "upg_price": 0
          },
          {},
          {},
          {},
          {},
          {}
        ];
        this.init("sell_weapon");
        return;
      }
      if (this.shop_type == "help") {
        _loc7_ = this.FWP.STIM_DEF;
        _loc8_ = _loc6_.stim_behave;
      }
      if (this.shop_type == "flags") {
        _loc7_ = this.FWP.FLAGS_DEF;
        _loc8_ = _loc6_.flags;
      }
      if (this.shop_type == "rip") {
        _loc7_ = this.FWP.RIPS_DEF;
        _loc8_ = _loc6_.rip;
      }
      if (this.shop_type == "impl") {
        _loc7_ = this.FWP.IMPL_DEF;
        _loc8_ = _loc6_.impl;
      }
      if (this.shop_type == "objs") {
        _loc7_ = this.FWP.OBJ_DEF;
        _loc8_ = _loc6_.objs;
      }
      // PORT: design D3 - arsenal.sell on the server (get_sell_price and the reset of the worn item are the server's).
      this.FWP.net_command("arsenal.sell", { "category": this.shop_type, "id": this.cur_weapon }, "render", { "done": () => {
        this.cur_element = 0;
      } });
      return;
    }
    if (param1.target.name == "finish_sell") {
      this.cur_weapon = this.weapon_stack[1].id;
      // PORT: design D3 - arsenal.sellWeapon on the server: the copy with this stat ('' / 's' / 'c') and range.
      this.FWP.net_command("arsenal.sellWeapon", { "id": this.cur_weapon, "stat": String(this.weapon_stack[1].stat || ""), "range": Number(this.weapon_stack[1].range) }, "remove");
    }
    if (param1.target.name == "arsenal_upgrade") {
      this.weapon_stack = [
        1,
        {
          "id": param1.target.parent.parent.name.split("weapon_")[1].split("%")[0],
          "stat": param1.target.parent.parent.name.split("weapon_")[1].split("%")[1],
          "range": param1.target.parent.parent.name.split("weapon_")[1].split("%")[2],
          "upg_price": 0
        },
        {},
        {},
        {},
        {},
        {}
      ];
      this.init("upgrade_weapon");
      return;
    }
    if (param1.target.name == "finish_upgrade") {
      _loc47_ = this.weapon_stack[this.weapon_stack[0]].id;
      _loc48_ = this.weapon_stack[this.weapon_stack[0]].stat;
      _loc49_ = Number(this.weapon_stack[this.weapon_stack[0]].range);
      // PORT: design D3 - arsenal.upgrade on the server (the price, the Crafting limit and the tasks are the server's);
      // PORT: the upgrade screen stays open on the upgraded copy.
      this.FWP.net_command("arsenal.upgrade", { "id": _loc47_, "stat": String(_loc48_ || ""), "range": _loc49_ }, "render", { "done": (result: any) => {
        this.weapon_stack[this.weapon_stack[0]].range = result.range;
      } });
    }
    if (param1.target.name == "arsenal_use") {
      this.cur_weapon = param1.target.parent.parent.name.split("weapon_")[1].split("%")[0];
      if (this.shop_type == "objs") {
        _loc53_ = 0;
        _loc54_ = this.FWP.get_book_recipes(this.cur_weapon, "array");
        _loc2_ = 1;
        while (_loc2_ <= _loc54_[0]) {
          if (_loc6_.recipes[_loc54_[_loc2_]] == 0) {
            _loc53_++;
          }
          _loc2_++;
        }
        if (_loc53_ > 0) {
          // PORT: design D3 - arsenal.readBook on the server (the new recipes of the book).
          this.FWP.net_command("arsenal.readBook", { "id": this.cur_weapon }, "new recipes added");
        } else {
          this.init("error", "new_recipes_fail");
        }
      } else {
        // PORT: design D3 - a stimulant into the next battle (arsenal.stimToFight) or wearing a flag / grave / implant
        // PORT: (arsenal.equip) runs on the server.
        if (this.shop_type == "help") {
          this.FWP.net_command("arsenal.stimToFight", { "id": this.cur_weapon }, "render", { "done": (result: any) => {
            if (result.left == 0) {
              this.cur_element = 0;
            }
          } });
        }
        if (this.shop_type == "flags" || this.shop_type == "rip" || this.shop_type == "impl") {
          this.FWP.net_command("arsenal.equip", { "category": this.shop_type, "id": this.cur_weapon }, "render");
        }
      }
    }
    if (param1.target.parent) {
      if (param1.target.parent.name.search("terr_zone_") != -1) {
        this.cur_element = Number(param1.target.parent.name.split("terr_zone_")[1]);
        this.render();
        return;
      }
    }
    if (param1.target.name == "assault_tribute") {
      this.init("tribute");
      return;
    }
    if (param1.target.name == "finish_tribute") {
      // PORT: design D7 - tribute.claim: the server computes the tribute of the zones (get_tribute) and credits it;
      // PORT: the amount shown is the one it credited.
      this.FWP.net_command("tribute.claim", {}, "remove", { "done": (result: any) => {
        this.FWP.net_notice(tributeCollectedText(result.gold), 4000);
      } });
      return;
    }
    if (param1.target.name.search("shop_type_") != -1) {
      this.shop_type = param1.target.name.split("shop_type_")[1];
      this.cur_weapon = "";
      this.cur_element = -1;
      this.shop_page = 1;
      if (_loc4_.arsenal_weapon_container) {
        _loc4_.arsenal_weapon_container.y = 142;
      }
      if (_loc4_.slider) {
        _loc4_.slider.y = 157;
      }
      this.render();
      return;
    }
    if (param1.target.name.search("weapon") != -1 && (this.cur_screen[this.cur_screen[0]].name == "shop" || this.cur_screen[this.cur_screen[0]].name == "papa_shop") && param1.target.name != "weapon_name" && param1.target.name != "weapon_desc") {
      this.cur_weapon = param1.target.name.split("weapon_")[1];
      if (this.shop_type == "weapons") {
        _loc7_ = this.FWP.WEAPONS_DEF;
      }
      if (this.shop_type == "help") {
        _loc7_ = this.FWP.STIM_DEF;
      }
      if (this.shop_type == "flags") {
        _loc7_ = this.FWP.FLAGS_DEF;
      }
      if (this.shop_type == "rip") {
        _loc7_ = this.FWP.RIPS_DEF;
      }
      if (this.shop_type == "impl") {
        _loc7_ = this.FWP.IMPL_DEF;
      }
      if (this.shop_type == "objs") {
        _loc7_ = this.FWP.OBJ_DEF;
      }
      for (_loc57_ of as3.keys(_loc7_)) {
        if (_loc57_ == this.cur_weapon) {
          this.cur_element = _loc7_[_loc57_].id;
        }
      }
      this.render();
    }
    if (param1.target.parent.name.search("weapon") != -1 && param1.target.parent.parent.name == "in_game_weapon_container" && this.cur_screen[this.cur_screen[0]].name == "weapon_sheet") {
      this.click_arsenal(param1.target.parent.name.split("ingame_weapon_")[1]);
      return;
    }
    if (param1.target.name == "cancel") {
      this.FWP.init_save_map();
    }
    if (param1.target.name == "try_steal") {
      this.steal();
      return;
    }
    if (param1.target.name == "steal_close") {
      this.remove();
      return;
    }
    if (param1.target.name == "steal_luck" || param1.target.name == "steal_merch") {
      // PORT: design D3 - steal.apology on the server: the draw, the forgiven penalty and which apologies are left
      // PORT: (the dialog's steal_try_luck / steal_try_merch) are the server's.
      _loc2_ = param1.target.name == "steal_luck" ? "luck" : "merch";
      this.FWP.net_command("steal.apology", { "kind": _loc2_ }, "render", { "done": (result: any) => {
        if (result.success) {
          this.steal_state = "good_bye";
          return;
        }
        this.steal_state = result.kind == "luck" ? "luck_fail" : "merch_fail";
        this.steal_try_luck = !(result.apology && result.apology.luck);
        this.steal_try_merch = !(result.apology && result.apology.merch);
      }, "refused": () => {
        this.steal_try_luck = true;
        this.steal_try_merch = true;
      } });
      return;
    }
    if (param1.target.name == "papa_ask") {
      // PORT: design D3 - papa.ask on the server (the draw against return_papa_ask_prob and tomorrow's hour).
      this.FWP.net_command("papa.ask", {}, "render", { "done": (result: any) => {
        this.papa_state = result.win ? "time_win" : "time_fail";
        this.papa_tomorrow_hour = result.tomorrowHour;
      } });
      return;
    }
    if (param1.target.name == "papa_shop") {
      if (this.FWP.player.last_papa != 0) {
        this.papa_state = "shop_fail";
        this.render();
        return;
      }
      // PORT: design D3 - papa.enter opens today's shop on the server (last_papa) and names today's assortment.
      this.FWP.net_command("papa.enter", {}, "init papa shop", { "done": (result: any) => {
        this.FWP.papa_assortment = { "weapons": result.weapons, "objs": result.objs };
      } });
      return;
    }
    if (param1.target.name == "papa_close") {
      this.FWP.PAPA_HERE = false;
      this.papa_state = "";
      this.remove();
      return;
    }
    if (param1.target.name == "save_names") {
      // PORT: design D3 - names.set with the fields the player may edit (worms + 2, render 3158-3175); the server
      // PORT: keeps the shown names of the others, as the original saved them. A field the player did not change
      // PORT: sends the name render put there (the stored one or "Червь #<n>"), not its translation the field shows.
      _loc3_ = [];
      const stored_names: any[] = [];
      _loc2_ = 1;
      while (_loc2_ <= 5 && _loc2_ <= _loc6_.worms.value + 2) {
        _loc3_.push(_loc4_["worm_name" + _loc2_].text);
        stored_names.push(_loc6_["worm_name" + _loc2_]);
        _loc2_++;
      }
      this.FWP.net_command("names.set", { "names": wormNamesArg(wormNameTexts(_loc3_, stored_names, "Червь #", as3.tr)) }, "render");
      return;
    }
    if (param1.target.name == "modify_filt") {
      this.opened_filter = !this.opened_filter;
      this.render();
      return;
    }
    if (param1.target.name == "change_music") {
      this.FWP.MUSIC = !this.FWP.MUSIC;
      this.FWP._sound.on_change("music");
      this.render();
    }
    if (param1.target.name == "change_sound") {
      this.FWP.SOUND = !this.FWP.SOUND;
      this.FWP._sound.on_change("sound");
      this.render();
    }
    if (param1.target.name == "add_team") {
      ++this.barracks.teams;
      ++this.barracks.worms;
      this.barracks["team" + this.barracks.teams].worms = 1;
      this.render();
    }
    if (param1.target.name == "remove_team") {
      this.barracks.worms -= this.barracks["team" + this.barracks.teams].worms;
      this.barracks["team" + this.barracks.teams].worms = 0;
      --this.barracks.teams;
      this.render();
    }
    if (param1.target.name.search("add_worm") != -1) {
      ++this.barracks["team" + Number(param1.target.name.split("add_worm")[1])].worms;
      ++this.barracks.worms;
      this.render();
    }
    if (param1.target.name.search("remove_worm") != -1) {
      --this.barracks["team" + Number(param1.target.name.split("remove_worm")[1])].worms;
      --this.barracks.worms;
      this.render();
    }
    if (param1.target.name == "meet_id") {
      _loc58_ = Number(_loc4_.id_to_meet.text);
      if (_loc58_ > 0 && _loc4_.id_to_meet.text != "" && !isNaN(_loc58_)) {
        this.init("user_info", _loc58_, "preload");
      }
    }
    if (param1.target.name == "rating") {
      this.init("rating");
    }
    if (param1.target.name == "view_perks") {
      this.init("view_perks");
    }
    if (param1.target.name == "open_wpsheet") {
      this.FWP._proc.call_open_wpsheet = true;
    }
    if (param1.target.name == "close_wpsheet") {
      this.FWP._proc.open_wpsheet();
    }
    if (param1.target.name == "cancel_fight") {
      this.FWP._proc.cancel_fight();
    }
    if (param1.target.name == "open_scaner") {
      this.open_scaner();
    }
    if (param1.target.name == "go") {
      // PORT: design D4 - the battle starts on the backend (battle.start), not with prepare_game's local mutations.
      this.FWP.net_battle_start(this.play_type, this.cur_element);
    }
    if (param1.target.name == "go_just") {
      _loc2_ = 1;
      while (_loc2_ <= this.barracks.teams) {
        _loc3_ = 1;
        while (_loc3_ <= this.barracks["team" + _loc2_].worms) {
          this.barracks["team" + _loc2_]["worm" + _loc3_] = {
            "attack": 0,
            "protect": 0,
            "health": 100,
            "spec": 0,
            "perks": {},
            "name": "Червь #" + _loc3_
          };
          _loc3_++;
        }
        _loc2_++;
      }
      _loc59_ = this.FWP.TEAMS_DEF["just" + this.cur_element];
      this.barracks.map = _loc59_.map;
      this.barracks.water = _loc59_.water;
      this.barracks.bg_mode = _loc59_.bg_mode;
      this.barracks.bg_type = _loc59_.bg_type;
      this.barracks.worm_limit = 8;
      this.FWP.init_just_play();
    }
    if (param1.target.name == "assault_fight") {
      // PORT: design D4 - the zone's stage comes from the server with the start (battle.start { mode: 'assault', zone }).
      this.FWP.net_battle_start("assault", this.cur_element);
    }
    if (param1.target.name == "donate") {
      // PORT: the pay screen on the store's tab the button stands for (runtime/monetization-ui.ts).
      storeTabFor(this, param1.target);
      this.init("pay");
    }
    if (param1.target.name == "top_by_level") {
      this.top_mode = 1;
      this.top_page = 1;
      this.FWP.net_get_top_members();
      return;
    }
    if (param1.target.name == "top_by_rating") {
      this.top_mode = 2;
      this.top_page = 1;
      this.FWP.net_get_top_members();
      return;
    }
    if (param1.target.name == "top_by_assault") {
      this.top_mode = 3;
      this.top_page = 1;
      this.FWP.net_get_top_members();
      return;
    }
    if (param1.target.name == "top_prev_page") {
      --this.top_page;
      this.FWP.net_get_top_members();
      return;
    }
    if (param1.target.name == "top_next_page") {
      ++this.top_page;
      this.FWP.net_get_top_members();
      return;
    }
    if (param1.target.name.search("wpslot_") != -1) {
      this.set_quick_weapon = param1.target.name.split("wpslot_")[1];
      this.render();
    }
    if (param1.target.name.search("wpclear_") != -1) {
      // PORT: design D3 - arsenal.clearQuickSlot on the server.
      this.FWP.net_command("arsenal.clearQuickSlot", { "key": param1.target.name.split("wpclear_")[1] }, "render");
    }
    if (param1.target.name.search("shop_set_") != -1) {
      this.shop_mode = param1.target.name.split("shop_set_")[1];
      this.cur_element = 0;
      this.shop_page = 1;
      this.opened_filter = false;
      this.render();
    }
    if (param1.target.name.search("perk_set_") != -1) {
      this.perks_mode = param1.target.name.split("perk_set_")[1];
      this.cur_element = 0;
      this.shop_page = 1;
      this.opened_filter = false;
      this.render();
    }
    if (param1.target.name == "learn_more_crafting") {
      this.wpedia_article = "crafting";
      this.init("wormpedia");
      return;
    }
    if (param1.target.name.search("wpedia_set_") != -1) {
      this.wpedia_article = param1.target.name.split("wpedia_set_")[1];
      this.render();
    }
    if (param1.target.name == "gsearch_button") {
      _loc60_ = param1.target.parent.name.split("gsearch_")[1];
      if (!this.graves_array[_loc60_].clicked && _loc60_ <= this.FWP.end_game.graves[0]) {
        this.clicked_grave = _loc60_;
        this.FWP.grave_searching = true;
        this.FWP.grave_process = 0;
        this.render_grave_search();
        this.FWP.set_invisible_button(true);
      }
    }
    if (param1.target.name == "next_tutorial") {
      _loc4_.nextFrame();
      // PORT: design D7 - the page about gold and diamonds no longer says diamonds are bought for VK votes.
      this.replace_vk_texts(_loc4_);
    }
    if (param1.target.name == "close_tutorial") {
      // PORT: design D3 - tutorial.close on the server; a tutorial the server already has as seen (another window)
      // PORT: just closes, like one the player opened.
      if (!this.tutor_opened_by_user && _loc6_.view_tutorial != 1) {
        this.FWP.net_command("tutorial.close", {}, "remove");
      } else {
        this.remove();
      }
    }
    if (param1.target.name == "view_tutorial") {
      this.tutor_opened_by_user = true;
      this.remove();
      this.init("view_tutorial");
    }
    if (param1.target.name == "view_tutorial_mf") {
      this.tutor_opened_by_user = true;
      this.init("view_tutorial");
    }
    if (param1.target.name == "gold_add") {
      ++this.DIAM_TO_TRANS;
      this.render();
    }
    if (param1.target.name == "gold_all") {
      this.DIAM_TO_TRANS = this.PLAYER_DIAM;
      this.render();
    }
    // PORT: VK removed: donate1..donate100 (diamonds for VK "votes"; free in the offline build). They buy the packs of
    // PORT: the game's own store where it has one (runtime/monetization-ui.ts).
    if (storeClick(this, param1.target.name)) {
      return;
    }
    if (param1.target.name == "gold_pay") {
      // PORT: design D3 - bank.exchange on the server (diamonds -> gold at 1:1100).
      this.FWP.net_command("bank.exchange", { "diamonds": this.DIAM_TO_TRANS }, "remove");
    }
    if (param1.target.name == "close_win_game") {
      this.remove();
      if (this.FWP.end_game.levels_upg != 0) {
        if (this.FWP.player.settings.no_animation == 0) {
          this.FWP.execute_after_animation = "new level";
        } else {
          this.init_new_level();
        }
      }
    }
    if (param1.target.name == "surprise_prev") {
      --this.cur_page;
      this.render();
    }
    if (param1.target.name == "surprise_next") {
      ++this.cur_page;
      this.render();
    }
    if (param1.target.name == "what_opened") {
      this.init_what_opened();
    }
    if (param1.target.name == "grave_search") {
      this.init_grave_search();
    }
    // PORT: VK removed: post_new_level / post_win_game (VK wall posts; the buttons stay hidden).
    if (param1.target.name == "close_present") {
      // PORT: design D3 - present.claim: the server knows whether today's present is due (the session entry of
      // PORT: profile.load) and credits it once; the x2 of the original's social build is gone (always x1).
      this.FWP.net_command("present.claim", {}, "remove", { "done": () => {
        this.FWP.get_present = 0;
      }, "refused": () => {
        // Claimed in another window meanwhile: the screen closes without a present.
        this.FWP.get_present = 0;
        this.remove();
      } });
    }
    // PORT: VK removed: open_admin (the developer's VK page) and auc_demo (a VK video of the auction); both stay hidden.
    // PORT: fixed defect: every control whose name contains "skill" set the difficulty (a click on the skill screen's
    // PORT: 'skill_attack' text field stored NaN); only the five difficulty buttons skill0..skill4 do.
    if (/^skill[0-4]$/.test(param1.target.name)) {
      this.click_proceed("skill", Number(param1.target.name.split("skill")[1]));
    }
    if (param1.target.name == "change_hardcore") {
      // PORT: design D3 - settings.set with the target mode (the toggle of the original: skill -/+ 10).
      this.FWP.net_command("settings.set", { "hardcore": !(_loc6_.settings.skill >= 10) }, "render");
      return;
    }
    if (param1.target.name == "change_animation") {
      // PORT: design D3 - settings.set with the target mode (the toggle of no_animation).
      this.FWP.net_command("settings.set", { "animation": _loc6_.settings.no_animation != 0 }, "render");
      return;
    }
    if (param1.target.name == "wormpedia") {
      this.init("wormpedia");
      return;
    }
    if (param1.target.name == "null_all" || param1.target.name == "reset_perks") {
      this.init("question", param1.target.name);
    }
    if (param1.target.name.search("init") != -1) {
      this.click_proceed(param1.target.name);
    }
    if (param1.target.name.search("upg_perk") != -1) {
      this.click_proceed("upg_perk", Number(param1.target.name.split("upg_perk")[1]));
    }
    if (param1.target.name.search("choose_perk") != -1) {
      this.click_proceed("choose_perk", Number(param1.target.parent.name));
    }
    if (param1.target.name.search("stim_to_fight") != -1) {
      this.click_proceed("stim_to_fight", param1.target.name.split("stim_to_fight_")[1]);
    }
    if (param1.target.name.search("add_perk") != -1) {
      this.click_proceed("init_choose_perk");
    }
    if (param1.target.name.search("buy_perk") != -1) {
      this.click_proceed("init_buy_perk");
    }
    if (param1.target.name.search("choose_task_button") != -1) {
      this.click_proceed("choose_task_button", Number(param1.target.parent.name));
    }
    if (param1.target.name == "click_task") {
      this.cur_element = Number(param1.target.parent.name);
      this.render();
      return;
    }
    if (param1.target.name == "choose_spec") {
      this.init("choose_spec");
      return;
    }
    if (param1.target.name == "spec_learn_more") {
      this.init("spec_learn_more");
      return;
    }
    if (param1.target.name.search("click_spec_") != -1) {
      // PORT: design D3 - the choice stays in the interface until finish_choose_spec sends it (spec.choose).
      this.spec_choice = Number(param1.target.name.split("click_spec_")[1]);
      _loc4_.finish_choose_spec.visible = true;
      _loc2_ = 1;
      while (_loc2_ <= 4) {
        _loc4_["clicked_spec_" + _loc2_].visible = _loc2_ == this.spec_choice;
        _loc2_++;
      }
      return;
    }
    if (param1.target.name == "finish_choose_spec") {
      // PORT: design D3 - spec.choose on the server (improve_spec: the two perks of the specialization are refunded).
      this.FWP.net_command("spec.choose", { "spec": this.spec_choice }, "remove");
      return;
    }
    if (param1.target.name == "career") {
      this.remove();
      this.init("fight", "career");
    }
    if (param1.target.name == "missions") {
      this.remove();
      this.init("fight", "missions");
    }
    if (param1.target.name == "survival") {
      this.remove();
      this.init("fight", "survival");
    }
    if (param1.target.name == "boss") {
      this.remove();
      this.init("fight", "boss");
    }
    // PORT: design D5 - the sixth mode of the mode board: the online lobby.
    if (param1.target.name == "online") {
      this.remove();
      this.init("fight", "online");
    }
    if (param1.target.name.search("page") != -1) {
      this.shop_page = Number(param1.target.name.split("page")[1]);
      this.cur_element = 0;
      this.render();
    }
    if (param1.target.name.search("clickperk") != -1) {
      this.cur_weapon = param1.target.name.split("clickperk_")[1];
      for (_loc62_ of as3.keys(this.FWP.PERKS_DEF)) {
        if (_loc62_ == this.cur_weapon) {
          this.cur_element = this.FWP.PERKS_DEF[_loc62_].id;
        }
      }
      this.render();
      return;
    }
    if (param1.target.name == "close") {
      this.remove();
    }
    if (param1.target.name == "close_to_mf") {
      this.remove();
      this.init("mainframe");
    }
    if (param1.target.name == "close_to_assault") {
      this.remove_all();
      this.init("assault");
    }
    if (param1.target.name == "scaner_teams") {
      this.remove();
      this.init("scaner", "teams");
    }
    if (param1.target.name == "scaner_worms") {
      this.remove();
      this.init("scaner", "worms");
    }
    if (param1.target.name == "close_scaner") {
      this.remove();
      this.FWP._proc.GAME_FREEZE = false;
      this.FWP.stage_focus();
    }
    if (param1.target.name == "restore") {
      this.FWP.refresh_temp_params();
      this.render();
    }
    if (param1.target.name == "save") {
      // PORT: design D3 - the editor (temp_player) stays local; 'save' commits its target values, perks and perk slot
      // PORT: purchases on the server (skills.commit recomputes every cost; save_temp_params and the tasks are the
      // PORT: server's), and the editor is rebuilt from the adopted state.
      this.FWP.net_command("skills.commit", this.FWP.skills_commit_args(), "render");
    }
    if (param1.target.name == "refresh") {
      this.FWP.execute_after = "render";
      this.FWP.init_refresh();
    }
    if (param1.target.name == "refresh_papa") {
      this.papa_checked = true;
      this.FWP.execute_after = "render";
      this.FWP.init_refresh();
    }
    if (param1.target.name == "add_attack") {
      _loc5_.attack.value += 1;
      _loc5_.skill_pts.value -= this.FWP.get_attack_cost(_loc5_.attack.value - 1);
      this.changes_made = true;
      this.render();
    }
    if (param1.target.name == "add_protect") {
      _loc5_.protect.value += 1;
      _loc5_.skill_pts.value -= this.FWP.get_attack_cost(_loc5_.protect.value - 1);
      this.changes_made = true;
      this.render();
    }
    if (param1.target.name == "add_health") {
      _loc5_.health.value += 1;
      _loc5_.skill_pts.value -= 30;
      this.changes_made = true;
      this.render();
    }
    if (param1.target.name == "add_team_worm") {
      _loc5_.worms.value += 1;
      _loc5_.skill_pts.value -= 150;
      this.changes_made = true;
      this.render();
    }
    if (param1.target.name == "buy_gold" || param1.target.name == "buy_diam") {
      if (this.cur_screen[this.cur_screen[0]].name == "buy_perk") {
        _loc9_ = 0;
        _loc10_ = 0;
        if (_loc5_.perk_slots == 2) {
          _loc9_ = 500;
          _loc10_ = 1;
        }
        if (_loc5_.perk_slots == 3) {
          _loc9_ = 1000;
          _loc10_ = 1;
        }
        if (_loc5_.perk_slots == 4) {
          _loc9_ = 5000;
          _loc10_ = 5;
        }
        if (_loc5_.perk_slots == 5) {
          _loc9_ = 10000;
          _loc10_ = 10;
        }
        if (_loc5_.perk_slots == 6) {
          _loc9_ = 20000;
          _loc10_ = 20;
        }
        if (_loc5_.perk_slots == 7) {
          _loc9_ = 40000;
          _loc10_ = 40;
        }
        if (_loc5_.perk_slots == 8) {
          _loc9_ = 60000;
          _loc10_ = 60;
        }
        ++_loc5_.perk_slots;
        if (param1.target.name == "buy_gold") {
          _loc5_.gold.value -= _loc9_;
        }
        if (param1.target.name == "buy_diam") {
          _loc5_.diam.value -= _loc10_;
        }
        // PORT: design D3 - the purchase is part of the editor session that 'save' commits (skills.commit slots).
        this.FWP.temp_slot_buys.push(param1.target.name == "buy_gold" ? "gold" : "diam");
        this.changes_made = true;
        this.remove();
      }
      if (this.cur_screen[this.cur_screen[0]].name == "shop") {
        // PORT: design D3 - shop.buy on the server (price with the Merchant perk, the item, auto-equip, achievements
        // PORT: and tasks are the server's); a first weapon copy is shown as FWP.new_weapon ("post new weapon").
        const bought: any = this.cur_weapon;
        this.FWP.net_command("shop.buy", { "category": this.shop_type, "id": bought, "currency": param1.target.name == "buy_gold" ? "gold" : "diam" }, "render", { "done": (result: any) => {
          if (result.category == "weapons" && result.newWeapon) {
            this.FWP.new_weapon = bought;
            this.FWP.execute_after = "post new weapon";
          }
        } });
      }
      if (this.cur_screen[this.cur_screen[0]].name == "papa_shop") {
        // PORT: design D3 - papa.buy on the server (today's assortment and session, the price x0.6 / x1, achiev.buys).
        const bought: any = this.cur_weapon;
        this.FWP.net_command("papa.buy", { "category": this.shop_type, "id": bought, "currency": param1.target.name == "buy_gold" ? "gold" : "diam" }, "render", { "done": (result: any) => {
          if (result.category == "weapons" && result.newWeapon) {
            this.FWP.new_weapon = bought;
            this.FWP.execute_after = "post new weapon";
          }
        } });
      }
    }
    if (param1.target.name == "add_p") {
      for (_loc66_ of as3.keys(this.FWP.PERKS_DEF)) {
        if (_loc66_ == this.cur_weapon) {
          break;
        }
      }
      _loc5_.perks[_loc66_] = 1;
      _loc5_.perk_pts.value -= this.FWP.PERKS_DEF[_loc66_].upg[0];
      this.changes_made = true;
      this.remove();
    }
    if (param1.target.name == "proceed") {
      // PORT: design D3 - perks.reset (FWP.reset_perks) and progress.startOver (create_new_params("null")) on the server.
      if (this.question_mode == "reset_perks") {
        this.FWP.net_command("perks.reset", {}, "remove");
      }
      if (this.question_mode == "null_all") {
        this.FWP.net_command("progress.startOver", {}, "remove");
      }
    }
    if (param1.target.name == "check_replay") {
      this.temp_replay_string = _loc4_.replay_text.text;
      _loc4_.caution.text = "Запись повреждена, проиграть невозможно.";
      if (this.FWP.check_replay_string(this.temp_replay_string).state) {
        _loc4_.go_replay.visible = true;
        _loc4_.replay_info_zone.visible = true;
        this.bitmap_datas["replay_weapons"].fillRect(new Rectangle(0, 0, this.bitmap_datas["replay_weapons"].width, this.bitmap_datas["replay_weapons"].height), 0);
        _loc67_ = this.FWP.check_replay_string(this.temp_replay_string);
        _loc4_.replay_info_zone.attack.text = _loc67_.params.attack;
        _loc4_.replay_info_zone.protect.text = _loc67_.params.protect;
        _loc4_.replay_info_zone.health.text = _loc67_.params.health;
        _loc4_.replay_info_zone.worms.text = _loc67_.params.worms;
        _loc2_ = 0;
        _loc68_ = 0;
        _loc69_ = new Array();
        _loc70_ = 1;
        for (_loc88_ of as3.keys(_loc67_.params.weapons)) {
          if (_loc67_.params.weapons[_loc88_] > 0 && _loc88_ != "skip_go") {
            _loc69_[_loc68_] = {
              "id": _loc88_,
              "diam": (this.FWP.WEAPONS_DEF[_loc88_].diam == 0 ? 30 : this.FWP.WEAPONS_DEF[_loc88_].diam)
            };
            if (this.FWP.WEAPONS_DEF[_loc88_].wpclass > _loc70_) {
              _loc70_ = this.FWP.WEAPONS_DEF[_loc88_].wpclass;
            }
            _loc68_++;
          }
        }
        _loc4_.replay_info_zone.wpclass.text = _loc70_;
        _loc4_.replay_info_zone.turns.text = _loc67_.params.turns;
        _loc4_.replay_info_zone.skill_level.text = _loc67_.params.skill_level;
        as3.sortOn(_loc69_, "diam", as3.ArrayFlags.DESCENDING | as3.ArrayFlags.NUMERIC);
        _loc71_ = 0;
        while (_loc71_ < _loc68_) {
          _loc88_ = _loc69_[_loc71_].id;
          if (_loc67_.params.weapons[_loc88_] > 0) {
            _loc2_++;
            if (_loc2_ > 10) {
              break;
            }
            if (_loc2_ < 6) {
              _loc76_ = 2 + (_loc2_ - 1) * 50;
              _loc77_ = 2;
            } else {
              _loc76_ = 2 + (_loc2_ - 6) * 50;
              _loc77_ = 52;
            }
            _loc78_ = this.FWP.get_wpij(this.FWP.WEAPONS_DEF[_loc88_].id).i;
            _loc79_ = this.FWP.get_wpij(this.FWP.WEAPONS_DEF[_loc88_].id).j;
            this.bitmap_datas["replay_weapons"].copyPixels(this.BigWP, new Rectangle(1 + 45 * (_loc79_ - 1), 1 + 44 * (_loc78_ - 1), 43, 42), new Point(_loc76_, _loc77_));
            this.bitmap_datas["replay_weapons"].copyPixels(this.WPBox, new Rectangle(0, 0, 47, 46), new Point(_loc76_ - 2, _loc77_ - 2), null, null, true);
          }
          _loc71_++;
        }
        _loc72_ = _loc67_.play_type;
        _loc73_ = Number(_loc67_.play_id);
        if (_loc72_ == "career") {
          _loc74_ = this.FWP.TEAMS_DEF["career" + _loc73_];
        }
        if (_loc72_ == "missions") {
          _loc74_ = this.FWP.TEAMS_DEF["mission" + _loc73_];
        }
        if (_loc72_ == "survival") {
          _loc74_ = this.FWP.TEAMS_DEF["survival" + _loc73_];
        }
        if (_loc72_ == "boss") {
          _loc74_ = this.FWP.TEAMS_DEF["boss" + _loc73_];
        }
        // PORT: the original passed this.cur_element, which init_instant("replay") resets to -1, so the TEAMS_DEF lookup
        // PORT: threw (the screen was disabled in the offline build). The replay's own stage (play_id) is used instead.
        _loc75_ = this.get_minimap_coords(_loc72_, _loc73_);
        this.MainBitmapData.copyPixels(_loc75_, new Rectangle(0, 0, 342, 154), new Point(0, 0));
        _loc75_.dispose();
        _loc75_ = null;
        _loc4_.replay_text.type = TextFieldType.DYNAMIC;
        _loc4_.replay_text.textColor = 6710886;
        _loc4_.replay_text.selectable = false;
        if (_loc72_ == "career") {
          _loc4_.caution.text = "Карьера №" + _loc73_ + " . Нажмите кнопку \"Вперед !\"";
        } else if (_loc72_ == "missions") {
          _loc4_.caution.text = "Миссия №" + _loc73_ + " . Нажмите кнопку \"Вперед !\"";
        } else if (_loc72_ == "survival") {
          _loc4_.caution.text = "Выживание №" + _loc73_ + " . Нажмите кнопку \"Вперед !\"";
        } else {
          _loc4_.caution.text = "Босс №" + _loc73_ + " . Нажмите кнопку \"Вперед !\"";
        }
      }
    }
    if (param1.target.name == "go_replay") {
      this.FWP.REPLAY_STRING = this.temp_replay_string;
      this.FWP.prepare_replay();
      return;
    }
    if (param1.target.parent) {
      if (param1.target.parent.name == "get_replay_clip") {
        // PORT: the offer's window (Accept saves the battle's replay once, Decline drops the offer for good).
        openReplayOffer(this);
        return;
      }
    }
    if (param1.target.name == "open_note") {
      _loc4_.replay_text.text = this.FWP.USER_NOTES[Number(param1.target.parent.name)].text;
      _loc4_.replay_text.type = TextFieldType.INPUT;
      _loc4_.replay_text.textColor = 0;
      _loc4_.replay_text.selectable = true;
      _loc4_.caution.text = "";
      this.MainBitmapData.fillRect(new Rectangle(0, 0, this.MainBitmap.width, this.MainBitmap.height), 0);
      _loc4_.go_replay.visible = false;
      _loc4_.replay_info_zone.visible = false;
    }
    // PORT: a row of the tops opens the card of its player (the game's own user_info screen, from the server's public
    // PORT: profile; the original's offline build returned here, its VK build opened the player's VK page).
    if (param1.target.name == "user_info") {
      _loc58_ = param1.target.parent && param1.target.parent.id_container ? Number(param1.target.parent.id_container.text) : 0;
      if (_loc58_ > 0 && this.FWP.player_ids[_loc58_]) {
        this.init("user_info", _loc58_, "preload");
      }
      return;
    }
    // PORT: VK removed: open_page (the player's VK profile page; the button stays hidden).
    if (param1.target.name.search("bet") != -1) {
      _loc81_ = param1.target.name.split("_")[1];
      _loc82_ = Number(param1.target.name.split("_")[2]);
      if (_loc6_[_loc81_].value >= _loc82_) {
        // PORT: design D3 - roulette.bet on the server (the bet, the class and weapon draws, the prize); the result
        // PORT: screen shows the server's prize (get_roul, roul_weapon).
        this.FWP.net_command("roulette.bet", { "currency": _loc81_, "amount": _loc82_ }, "init roul result", { "done": (result: any) => {
          this.FWP.get_roul = result.prizeClass;
          this.FWP.roul_weapon = result.weapon;
        } });
      }
    }
  }

  click_proceed(param1: any, param2: any = 0): any {
    param1 = as3.str(param1);
    let _loc4_: any = undefined;
    let _loc5_: any = undefined;
    let _loc6_: any = undefined;
    let _loc7_: any = undefined;
    let _loc8_: any = undefined;
    let _loc9_: any = undefined;
    let _loc3_: any = this.cur_screen[this.cur_screen[0]].link;
    _loc4_ = this.FWP.temp_player;
    _loc5_ = this.FWP.player;
    if (param1.search("init") != -1) {
      // PORT: the offline build disabled the replay screen (replays were VK notes); it is enabled again. It is a tab
      // PORT: screen (it has the tab bar), so it replaces the current tab like the others: stacked on another tab, both
      // PORT: screens would hold the shared MainBitmap and remove_all would fail with #2025 on the second one.
      if (param1 == "init_arsenal" || param1 == "init_crafting" || param1 == "init_skills" || param1 == "init_perks" || param1 == "init_achiev" || param1 == "init_skills_main" || param1 == "init_fight" || param1 == "init_shop" || param1 == "init_clan_hub" || param1 == "init_roul" || param1 == "init_top" || param1 == "init_assault" || param1 == "init_tasks" || param1 == "init_replay") {
        this.remove_all();
      }
      this.init(param1.split("init_")[1], "career");
    }
    if (param1 == "upg_perk") {
      _loc6_ = param2;
      _loc7_ = _loc4_.perks[this.perk_places[_loc6_]];
      if (_loc7_ >= 1 && _loc7_ < this.FWP.PERKS_DEF[this.perk_places[_loc6_]].max_lim && _loc4_.perk_pts.value >= this.FWP.PERKS_DEF[this.perk_places[_loc6_]].upg[_loc7_]) {
        _loc4_.perk_pts.value -= this.FWP.PERKS_DEF[this.perk_places[_loc6_]].upg[_loc7_];
        ++_loc4_.perks[this.perk_places[_loc6_]];
        this.changes_made = true;
        this.render();
      }
    }
    if (param1 == "skill" && _loc5_.settings.skill != param2) {
      // PORT: design D3 - settings.set { difficulty } on the server (the hardcore mode is kept).
      this.FWP.net_command("settings.set", { "difficulty": param2 }, "render");
    }
    if (param1 == "choose_spec") {
      _loc4_.spec = this.FWP.wptype_to_spec(param2);
      this.render();
    }
    if (param1 == "choose_perk") {
      for (_loc9_ of as3.keys(this.FWP.PERKS_DEF)) {
        if (this.FWP.PERKS_DEF[_loc9_].id == Number(param2)) {
          break;
        }
      }
      _loc4_.perks[_loc9_] = 1;
      _loc4_.perk_pts.value -= this.FWP.PERKS_DEF[_loc9_].upg[0];
      this.changes_made = true;
      this.remove();
    }
    if (param1 == "choose_task_button") {
      this.cur_element = param2;
      this.render();
    }
    if (param1 == "stim_to_fight") {
      // PORT: design D3 - arsenal.stimToFight on the server.
      this.FWP.net_command("arsenal.stimToFight", { "id": param2 }, "render");
    }
  }

  click_arsenal(param1: any): any {
    param1 = as3.str(param1);
    let _loc3_: any = undefined;
    let _loc4_: any = undefined;
    let _loc5_: any = undefined;
    let _loc6_: any = undefined;
    let _loc7_: any = undefined;
    let _loc8_: any = undefined;
    let _loc9_: any = undefined;
    let _loc10_: any = undefined;
    let _loc11_: any = undefined;
    let _loc2_: any = this.cur_screen[this.cur_screen[0]].link;
    _loc4_ = this.FWP.player;
    if (this.FWP._proc.mousecontrol) {
      return;
    }
    _loc5_ = Number(this.FWP.WEAPONS_DEF[param1.split("%")[0]].id);
    _loc6_ = Number(param1.split("%")[2]);
    _loc7_ = this.FWP._proc.teams;
    _loc8_ = this.FWP._proc.cur_team;
    _loc9_ = 0;
    if (_loc4_.perks["fast_temp"]) {
      _loc9_ = this.FWP.get_perk_effect("fast_temp", _loc4_.perks.fast_temp, "");
    }
    for (_loc10_ of as3.keys(this.FWP.WEAPONS_DEF)) {
      if (this.FWP.WEAPONS_DEF[_loc10_].id == _loc5_) {
        _loc11_ = _loc10_;
      }
    }
    if (this.FWP.WEAPONS_DEF[_loc11_].delay - _loc9_ - _loc7_[_loc8_].turns > 0) {
      return;
    }
    this.FWP._proc.close_wpsheet(_loc5_, _loc6_);
  }

  mouse_event(param1: any): any {
    let _loc3_: any = undefined;
    let _loc2_: any = undefined;
    let _loc4_: any = undefined;
    let _loc5_: any = undefined;
    let _loc6_: any = undefined;
    let _loc7_: any = undefined;
    let _loc8_: any = undefined;
    let _loc9_: any = undefined;
    let _loc10_: any = undefined;
    let _loc11_: any = undefined;
    let _loc12_: any = undefined;
    let _loc13_: any = undefined;
    let _loc14_: any = undefined;
    let _loc15_: any = undefined;
    let _loc16_: any = undefined;
    let _loc17_: any = undefined;
    let _loc18_: any = undefined;
    let _loc19_: any = undefined;
    let _loc20_: any = undefined;
    let _loc21_: any = undefined;
    let _loc22_: any = undefined;
    let _loc23_: any = undefined;
    let _loc24_: any = undefined;
    let _loc25_: any = undefined;
    let _loc26_: any = undefined;
    let _loc27_: any = undefined;
    let _loc28_: any = undefined;
    let _loc29_: any = undefined;
    _loc2_ = this.cur_screen[this.cur_screen[0]].link;
    _loc3_ = this.FWP.temp_player;
    _loc4_ = this.FWP.player;
    if (param1.target.name == "button_down" || param1.target.name == "button_up" || param1.target.name == "button_left" || param1.target.name == "button_right") {
      if (param1.type == "mouseDown") {
        this.map_moving = param1.target.name;
        this.addEventListener(Event.ENTER_FRAME, this.move_world_map, false, 0, true);
        param1.target.addEventListener(MouseEvent.MOUSE_OUT, this.stop_moving, false, 0, true);
      }
      if (param1.type == "mouseUp") {
        this.map_moving = "";
        this.removeEventListener(Event.ENTER_FRAME, this.move_world_map);
      }
    }
    _loc5_ = {
      "my_level": 0,
      "init_tired": 0,
      "my_exp": 0,
      "my_rating": 0,
      "skill_pts": 0,
      "perk_pts": 0,
      "sell": 0,
      "donate": 0,
      "gold_add": 0,
      "gold_all": 0,
      "view_perks": 0,
      "award_magnet": 0,
      "award_contest": 0,
      "award_tester": 0,
      "try_steal": 0,
      "career": 0,
      "missions": 0,
      "survival": 0,
      "boss": 0,
      "init_just_play": 0,
      "online": 0,
      "skill_attack": 0,
      "skill_protect": 0,
      "skill_health": 0,
      "open_wpsheet": 0,
      "cancel_fight": 0,
      "open_scaner": 0,
      "hardcore_popup": 0,
      "achiev_range_popup": 0,
      "assault_diff_popup": 0,
      "clans_rating": 0,
      "click_auc": 0,
      "wait_fd": 0,
      "my_nickname": 0,
      "donate1": 0,
      "donate3": 0,
      "donate10": 0,
      "donate25": 0,
      "donate50": 0,
      "donate100": 0
    };
    _loc6_ = param1.target.name;
    _loc8_ = "";
    if (_loc6_ == "init_tasks" && param1.target.parent.name == "announcement_task") {
      _loc8_ = "announcement_task";
    }
    if (_loc6_ == "init_achiev" && param1.target.parent.name == "announcement_achiev") {
      _loc8_ = "announcement_achiev";
    }
    if (_loc6_ in _loc5_ || _loc8_ != "" || _loc6_.search("buy_perk") != -1 || _loc6_.search("add_perk") != -1 || _loc6_.search("upg_perk") != -1 || _loc6_.search("upg_inact_perk") != -1 || _loc6_.search("perk_box") != -1 || _loc6_.search("stim_desc") != -1) {
      _loc7_ = this.popup_modify(_loc8_ != "" ? _loc8_ : param1.target.name);
      if ((Boolean(_loc7_)) && param1.type == "mouseOver") {
        this.popup_anchor = param1.target;
        this.popup_displace();
        this.addEventListener(Event.ENTER_FRAME, this.popup_displace);
        this.popup.visible = true;
      }
      if (param1.type == "mouseOut") {
        this.removeEventListener(Event.ENTER_FRAME, this.popup_displace);
        this.popup.visible = false;
      }
    }
    if (param1.target.parent.name == "get_replay_clip") {
      _loc7_ = this.popup_modify(param1.target.parent.name);
      if ((Boolean(_loc7_)) && param1.type == "mouseOver") {
        this.popup_anchor = param1.target.parent;
        this.popup_displace();
        this.addEventListener(Event.ENTER_FRAME, this.popup_displace, false, 0, true);
        this.popup.visible = true;
      }
      if (param1.type == "mouseOut") {
        this.removeEventListener(Event.ENTER_FRAME, this.popup_displace);
        this.popup.visible = false;
      }
    }
    if (param1.target.parent) {
      if (param1.target.parent.parent) {
        if (param1.target.parent.name.search("weapon") != -1 && (param1.target.parent.parent.name == "arsenal_weapon_container" || param1.target.parent.parent.name == "in_game_weapon_container") || param1.target.parent.name == "weapon_functions") {
          if (param1.target.parent.name == "weapon_functions") {
            _loc9_ = param1.target.parent.parent;
          } else {
            _loc9_ = param1.target.parent;
          }
          _loc12_ = 1;
          if (this.shop_type == "weapons") {
            _loc10_ = this.FWP.WEAPONS_DEF;
            _loc11_ = _loc4_.weapons;
          }
          if (this.shop_type == "help") {
            _loc10_ = this.FWP.STIM_DEF;
            _loc11_ = _loc4_.stim_behave;
          }
          if (this.shop_type == "flags") {
            _loc10_ = this.FWP.FLAGS_DEF;
            _loc11_ = _loc4_.flags;
          }
          if (this.shop_type == "rip") {
            _loc10_ = this.FWP.RIPS_DEF;
            _loc11_ = _loc4_.rip;
          }
          if (this.shop_type == "impl") {
            _loc10_ = this.FWP.IMPL_DEF;
            _loc11_ = _loc4_.impl;
          }
          if (this.shop_type == "objs") {
            _loc10_ = this.FWP.OBJ_DEF;
            _loc11_ = _loc4_.objs;
          }
          if (this.cur_screen[this.cur_screen[0]].name == "weapon_sheet") {
            _loc10_ = this.FWP.WEAPONS_DEF;
          }
          if (param1.type == "mouseOver") {
            this.cur_weapon = _loc9_.name.split("weapon_")[1].split("%")[0];
            _loc12_ = _loc9_.name.split("weapon_")[1].split("%")[2];
            for (_loc13_ of as3.keys(_loc10_)) {
              if (_loc13_ == this.cur_weapon) {
                this.cur_element = _loc10_[_loc13_].id;
              }
            }
            _loc9_.weapon_functions.visible = true;
          } else if (param1.type == "mouseOut") {
            this.cur_weapon = "";
            this.cur_element = 0;
            _loc9_.weapon_functions.visible = false;
          }
          if (param1.type == "mouseOver" || param1.type == "mouseOut") {
            _loc14_ = 0;
            if (_loc4_.perks["stims"]) {
              _loc14_ = this.FWP.get_perk_effect("stims", _loc4_.perks.stims, "");
            }
            _loc15_ = 0;
            for (_loc16_ of as3.keys(this.FWP.STIM_DEF)) {
              if (_loc4_.stim_to_fight[_loc16_]) {
                _loc15_ += _loc4_.stim_to_fight[_loc16_];
              }
            }
            if (Boolean(_loc10_[this.cur_weapon]) && this.cur_element > 0) {
              _loc17_ = 0;
              if (_loc11_[this.cur_weapon]) {
                if (this.shop_type == "weapons") {
                  _loc17_ = _loc11_[this.cur_weapon][0];
                } else {
                  _loc17_ = _loc11_[this.cur_weapon];
                }
              }
              if (this.cur_screen[this.cur_screen[0]].name != "weapon_sheet") {
                _loc2_.weapon_name.text = _loc10_[this.cur_weapon].name + (" (" + _loc17_ + ")");
              } else {
                _loc2_.weapon_name.text = _loc10_[this.cur_weapon].name;
              }
              if (this.shop_type != "weapons" && this.cur_screen[this.cur_screen[0]].name != "weapon_sheet") {
                _loc2_.weapon_desc.htmlText = this.return_weapon_desc(this.cur_weapon, this.shop_type, _loc12_) + (this.weapons_text[this.cur_weapon] ? this.weapons_text[this.cur_weapon] : "");
                if (this.shop_type == "help") {
                  _loc2_.weapon_desc.htmlText += "\nИспользовано стимуляторов: <b>" + _loc15_ + " / " + (this.MAX_STIM + _loc14_) + "</b>.";
                }
              } else {
                _loc18_ = {
                  "attack": _loc4_.attack.value,
                  "protect": _loc4_.protect.value,
                  "health": 100 + 50 * _loc4_.health.value,
                  "worms": 2 + _loc4_.worms.value,
                  "tired": _loc4_.tired,
                  "stim_to_fight": _loc4_.stim_to_fight,
                  "impl": _loc4_.cur_impl
                };
                _loc19_ = this.FWP.get_affected_skills(_loc18_);
                _loc20_ = this.FWP.get_peachful_bonus({
                  "spec": _loc4_.spec,
                  "wptype": this.FWP.WEAPONS_DEF[this.cur_weapon].wptype,
                  "attack": _loc19_.attack,
                  "perks": _loc4_.perks,
                  "spec_mod": this.FWP.WEAPONS_DEF[this.cur_weapon].spec_mod,
                  "wpclass": this.FWP.WEAPONS_DEF[this.cur_weapon].wpclass
                });
                _loc21_ = 1 + _loc20_.damage;
                _loc22_ = this.FWP.get_bullet_amount(this.cur_weapon);
                _loc23_ = { "dmg_mult": _loc21_, "shots_add": _loc22_ };
                _loc2_.weapon_desc.htmlText = this.return_weapon_desc(this.cur_weapon, this.shop_type, _loc12_, true, _loc23_, true) + (this.weapons_text[this.cur_weapon] ? this.weapons_text[this.cur_weapon] : "");
              }
            } else if (this.cur_screen[this.cur_screen[0]].name == "weapon_sheet" && typeof this.FWP.touch_zones == "function") {
              // PORT (touch screens): the worm's weapon, not the shop's help (sheet_idle_text).
              this.sheet_idle_text(_loc2_);
            } else {
              if (_loc2_.weapon_name) {
                _loc2_.weapon_name.text = "Арсенал";
              }
              if (_loc2_.weapon_desc) {
                _loc2_.weapon_desc.htmlText = "Здесь вы можете посмотреть, какие оружия, стимуляторы, флаги и т.п. имеются у вас в наличии, а также собрать из составляющих компонентов новые типы вооружения (кнопка Крафтинг). Однако, для крафтинга вам необходима одноименная способность Крафтинг.\n\nДля использования стимулятора выберите его и нажмите внизу кнопку Использовать. Под описанием каждого стимулятора будет показано, сколько вы уже использовали стимуляторов и лимит на использование. По умолчанию вы можете использовать 4 стимулятора перед боем. Это число можно увеличить, взяв способность Стимуляторы.\n\nВ разделе Флаги и Гробики галочкой отмечен текущий выбранный флаг/гроб. Чтобы поменять свое решение, выделите объект и нажмите Использовать.\n\nТакже любую вещь из арсенала вы можете продать.";
              }
            }
          }
        }
      }
    }
    if (param1.type == "mouseUp" && (_loc6_ == "slider" || _loc6_ == "slider2")) {
      this.last_slider_clicked = _loc6_;
      param1.stopImmediatePropagation();
      this.removeEventListener(Event.ENTER_FRAME, this.slider_proceed);
      param1.target.stage.removeEventListener(MouseEvent.MOUSE_UP, this.slider_outside);
      this.slider_control = false;
    }
    if (param1.type == "mouseDown" && (_loc6_ == "slider" || _loc6_ == "slider2")) {
      this.last_slider_clicked = _loc6_;
      this.init_slider(this.cur_screen[this.cur_screen[0]].name, _loc6_);
      this.addEventListener(Event.ENTER_FRAME, this.slider_proceed, false, 0, true);
      param1.target.stage.addEventListener(MouseEvent.MOUSE_UP, this.slider_outside, false, 0, true);
      this.slider_control = true;
    }
    if (param1.type == "mouseDown" && (param1.target.parent.name.search("craft_weapon") != -1 || param1.target.parent.name.search("craft_object") != -1 || param1.target.parent.name.search("craft_stack") != -1 || param1.target.parent.name == "craft_diss")) {
      this.addEventListener(Event.ENTER_FRAME, this.floating_weapon_proceed, false, 0, true);
      param1.target.stage.addEventListener(MouseEvent.MOUSE_UP, this.floating_outside, false, 0, true);
      this.floating_control = true;
      _loc24_ = "";
      this.bitmaps["float"] = new Bitmap();
      this.bitmap_datas["float"] = new BitmapData(50, 50, true, 0);
      if (param1.target.parent.name.search("craft_stack") == -1 && param1.target.parent.name != "craft_diss") {
        if (param1.target.parent.name.search("craft_weapon") != -1) {
          _loc24_ = param1.target.parent.name.split("craft_weapon_")[1];
        }
        if (param1.target.parent.name.search("craft_object") != -1) {
          _loc24_ = param1.target.parent.name.split("craft_object_")[1];
        }
        _loc25_ = false;
        _loc26_ = false;
        if (_loc24_.split("%")[1] == "c") {
          _loc26_ = true;
        }
        if (_loc24_.split("%")[1] == "s") {
          _loc25_ = true;
        }
        this.floating_weapon = {
          "id": _loc24_.split("%")[0],
          "stolen": _loc25_,
          "crafted": _loc26_,
          "range": _loc24_.split("%")[2],
          "tp": (param1.target.parent.name.search("craft_weapon") != -1 ? "weapon" : "object")
        };
      } else if (param1.target.parent.name == "craft_diss") {
        this.floating_weapon = {
          "id": this.weapon_diss.id,
          "stolen": this.weapon_diss.stolen,
          "crafted": this.weapon_diss.crafted,
          "range": this.weapon_diss.range,
          "tp": this.weapon_diss.tp
        };
        _loc24_ = String(this.floating_weapon.id + "%%" + this.floating_weapon.range);
        this.weapon_diss = {};
      } else {
        _loc27_ = Number(param1.target.parent.name.split("craft_stack_")[1]);
        this.floating_weapon = {
          "id": this.weapon_stack[_loc27_].id,
          "stolen": this.weapon_stack[_loc27_].stolen,
          "crafted": this.weapon_stack[_loc27_].crafted,
          "range": this.weapon_stack[_loc27_].range,
          "tp": this.weapon_stack[_loc27_].tp
        };
        _loc24_ = String(this.floating_weapon.id + "%%" + this.floating_weapon.range);
        this.weapon_stack[_loc27_] = {};
      }
      if (this.floating_weapon.tp == "weapon") {
        _loc28_ = this.FWP.get_wpij(this.FWP.WEAPONS_DEF[_loc24_.split("%")[0]].id).i;
        _loc29_ = this.FWP.get_wpij(this.FWP.WEAPONS_DEF[_loc24_.split("%")[0]].id).j;
        this.bitmap_datas["float"].copyPixels(this.BigWP, new Rectangle(1 + 45 * (_loc29_ - 1), 1 + 44 * (_loc28_ - 1), 44, 43), new Point(2, 2));
        this.bitmap_datas["float"].copyPixels(this.PerkLevels[_loc24_.split("%")[2]], new Rectangle(0, 0, 47, 47), new Point(0, 0), null, null, true);
        this.bitmap_datas["float"].copyPixels(this.WPBox, new Rectangle(0, 0, 47, 46), new Point(0, 0), null, null, true);
      } else {
        this.bitmap_datas["float"].copyPixels(this.BigObjs, new Rectangle(1 + 45 * (this.FWP.OBJ_DEF[_loc24_.split("%")[0]].id - 1), 0, 44, 43), new Point(2, 2));
        this.bitmap_datas["float"].copyPixels(this.WPBox, new Rectangle(0, 0, 47, 46), new Point(0, 0), null, null, true);
      }
      this.bitmaps["float"].bitmapData = this.bitmap_datas["float"];
      _loc2_.floating_container.addChild(this.bitmaps["float"]);
      _loc2_.floating_container.visible = true;
      this.render();
    }
  }

  init_slider(param1: any, param2: any = ""): any {
    param1 = as3.str(param1);
    param2 = as3.str(param2);
    if (param1 == "choose_perk" || param1 == "view_perks" || param1 == "crafting") {
      this.slider_top = 138;
      this.slider_bottom = 448;
    }
    if (param1 == "achiev") {
      this.slider_top = 108;
      this.slider_bottom = 557;
    }
    // PORT: item 8 - the lists of the clans tab and of the card of a clan (runtime/clan-hub.ts: beside their masks).
    if ((param1 == "clan_hub" || param1 == "clan_card") && this.FWP.clans) {
      this.slider_top = this.FWP.clans.sliderRange(param1).top;
      this.slider_bottom = this.FWP.clans.sliderRange(param1).bottom;
    }
    if (param1 == "top") {
      this.slider_top = 181;
      this.slider_bottom = 560;
    }
    if (param1 == "fight" && param2 == "slider") {
      this.slider_top = 213;
      this.slider_bottom = 512;
    }
    if (param1 == "fight" && param2 == "slider2") {
      this.slider_top = 421;
      this.slider_bottom = 569;
    }
    if (param1 == "scaner") {
      this.slider_top = 133;
      this.slider_bottom = 523;
    }
    if (param1 == "arsenal") {
      this.slider_top = 157;
      this.slider_bottom = 567;
    }
    if (param1 == "recipes") {
      this.slider_top = 84;
      this.slider_bottom = 543;
    }
    if (param1 == "weapon_sheet") {
      this.slider_top = 66;
      this.slider_bottom = 561;
    }
    if (param1 == "tasks") {
      this.slider_top = 132;
      this.slider_bottom = 553;
    }
    // PORT: design D5 - the map list of an online room (menu_just_play in room mode, src/game/runtime/online-room-maps.ts:
    // PORT: MAP_SLIDER) scrolls with the fight screen's slider, beside the list's mask (y 182..433).
    if (param1 == "just_play") {
      this.slider_top = 191;
      this.slider_bottom = 421;
    }
  }

  slider_outside(param1: any): any {
    this.removeEventListener(Event.ENTER_FRAME, this.slider_proceed);
    param1.target.stage.removeEventListener(MouseEvent.MOUSE_UP, this.slider_outside);
    this.slider_control = false;
  }

  slider_proceed(param1: any): any {
    let _loc2_: any = undefined;
    let _loc3_: any = undefined;
    let _loc4_: any = undefined;
    let _loc5_: any = undefined;
    _loc2_ = this.cur_screen[this.cur_screen[0]].link;
    _loc3_ = this.cur_screen[this.cur_screen[0]].name;
    if (this.slider_control) {
      // PORT: the finger in the screen's own coordinates (the slider's range is the screen's): a popup a phone shows
      // PORT: larger (ui/wide-popups.ts) is scaled; the original read this.mouseY, the same where it is not.
      _loc4_ = _loc2_.mouseY;
      if (_loc4_ < this.slider_top) {
        _loc4_ = this.slider_top;
      }
      if (_loc4_ > this.slider_bottom) {
        _loc4_ = this.slider_bottom;
      }
      _loc2_[this.last_slider_clicked].y = _loc4_;
      if (_loc3_ == "choose_perk" || _loc3_ == "view_perks") {
        _loc5_ = Math.round(1000 * (_loc4_ - this.slider_top) / (this.slider_bottom - this.slider_top)) / 1000;
        _loc2_.perks_container.y = 140 - _loc5_ * (_loc2_.perks_container.height - (this.slider_bottom - this.slider_top));
      }
      if (_loc3_ == "achiev") {
        _loc5_ = Math.round(1000 * (_loc4_ - this.slider_top) / (this.slider_bottom - this.slider_top)) / 1000;
        _loc2_.achiev_container.y = 92 - _loc5_ * (_loc2_.achiev_container.height - (this.slider_bottom - this.slider_top));
      }
      // PORT: item 8 - the list of the clans tab / of the card of a clan scrolls over its whole height (the original's
      // PORT: formula for the friends list started 46 px below its container, new_interf.as slider_proceed).
      if ((_loc3_ == "clan_hub" || _loc3_ == "clan_card") && this.FWP.clans) {
        _loc5_ = Math.round(1000 * (_loc4_ - this.slider_top) / (this.slider_bottom - this.slider_top)) / 1000;
        this.FWP.clans.slide(_loc3_, _loc2_, _loc5_);
      }
      if (_loc3_ == "top") {
        _loc5_ = Math.round(1000 * (_loc4_ - this.slider_top) / (this.slider_bottom - this.slider_top)) / 1000;
        _loc2_.top_container.y = 166 - _loc5_ * (_loc2_.top_container.height - (this.slider_bottom - this.slider_top));
      }
      if (_loc3_ == "crafting") {
        _loc5_ = Math.round(1000 * (_loc4_ - this.slider_top) / (this.slider_bottom - this.slider_top)) / 1000;
        _loc2_.craft_container.y = 140 - _loc5_ * (_loc2_.craft_container.height + 20 - (this.slider_bottom - this.slider_top));
      }
      if (_loc3_ == "fight" && this.last_slider_clicked == "slider") {
        _loc5_ = Math.round(1000 * (_loc4_ - this.slider_top) / (this.slider_bottom - this.slider_top)) / 1000;
        _loc2_.choose_container.y = 200 - _loc5_ * (_loc2_.choose_container.height - 20 - (this.slider_bottom - this.slider_top));
      }
      if (_loc3_ == "fight" && this.last_slider_clicked == "slider2") {
        _loc5_ = Math.round(1000 * (_loc4_ - this.slider_top) / (this.slider_bottom - this.slider_top)) / 1000;
        _loc2_.text_desc_container.y = 406 - _loc5_ * ((_loc2_.text_desc_container.field.numLines + 1) * 14 - 20 - (this.slider_bottom - this.slider_top));
      }
      if (_loc3_ == "scaner") {
        _loc5_ = Math.round(1000 * (_loc4_ - this.slider_top) / (this.slider_bottom - this.slider_top)) / 1000;
        _loc2_.scaner_container.y = 118 - _loc5_ * (_loc2_.scaner_container.height - (this.slider_bottom - this.slider_top));
      }
      if (_loc3_ == "arsenal") {
        _loc5_ = Math.round(1000 * (_loc4_ - this.slider_top) / (this.slider_bottom - this.slider_top)) / 1000;
        _loc2_.arsenal_weapon_container.y = 142 - _loc5_ * (_loc2_.arsenal_weapon_container.height - (this.slider_bottom - this.slider_top));
      }
      if (_loc3_ == "recipes") {
        _loc5_ = Math.round(1000 * (_loc4_ - this.slider_top) / (this.slider_bottom - this.slider_top)) / 1000;
        _loc2_.recipes_container.y = 69 - _loc5_ * (_loc2_.recipes_container.height - (this.slider_bottom - this.slider_top));
      }
      if (_loc3_ == "weapon_sheet") {
        _loc5_ = Math.round(1000 * (_loc4_ - this.slider_top) / (this.slider_bottom - this.slider_top)) / 1000;
        _loc2_.arsenal_weapon_container.y = 51 - _loc5_ * (_loc2_.arsenal_weapon_container.height - (this.slider_bottom - this.slider_top));
      }
      if (_loc3_ == "tasks") {
        _loc5_ = Math.round(1000 * (_loc4_ - this.slider_top) / (this.slider_bottom - this.slider_top)) / 1000;
        _loc2_.tasks_container.y = 118 - _loc5_ * (_loc2_.tasks_container.height - 20 - (this.slider_bottom - this.slider_top));
      }
      // PORT: design D5 - the map list of an online room: the fight screen's formula on just_play_container (y 182).
      if (_loc3_ == "just_play" && this.last_slider_clicked == "slider") {
        _loc5_ = Math.round(1000 * (_loc4_ - this.slider_top) / (this.slider_bottom - this.slider_top)) / 1000;
        _loc2_.just_play_container.y = 182 - _loc5_ * (_loc2_.just_play_container.height - 20 - (this.slider_bottom - this.slider_top));
      }
    }
  }

  floating_outside(param1: any): any {
    this.removeEventListener(Event.ENTER_FRAME, this.floating_weapon_proceed);
    param1.target.stage.removeEventListener(MouseEvent.MOUSE_UP, this.floating_outside);
    this.floating_control = false;
    this.cur_screen[this.cur_screen[0]].link.floating_container.visible = false;
    this.check_crafting_target();
    this.floating_weapon = {};
    this.render();
  }

  check_crafting_target(): any {
    let _loc1_: any = undefined;
    let _loc2_: any = undefined;
    let _loc3_: any = undefined;
    let _loc4_: any = undefined;
    let _loc5_: any = undefined;
    let _loc6_: any = undefined;
    let _loc7_: any = undefined;
    let _loc8_: any = undefined;
    let _loc9_: any = undefined;
    let _loc10_: any = undefined;
    let _loc11_: any = undefined;
    _loc1_ = this.cur_screen[this.cur_screen[0]].link;
    _loc2_ = this.FWP.player;
    _loc3_ = "";
    _loc4_ = _loc1_.crafting_stack_container.x;
    _loc5_ = _loc1_.crafting_stack_container.y;
    _loc6_ = _loc5_ + 60;
    _loc7_ = _loc1_.crafting_diss_container.x;
    _loc8_ = _loc1_.crafting_diss_container.y;
    if (this.mouseX > _loc4_ - 10 && this.mouseX < _loc4_ + 47 + 10 && this.mouseY > _loc5_ - 10 && this.mouseY < _loc5_ + 46 + 10) {
      _loc3_ = "stack1";
    }
    if (this.mouseX > _loc4_ + 60 - 10 && this.mouseX < _loc4_ + 60 + 47 + 10 && this.mouseY > _loc5_ - 10 && this.mouseY < _loc5_ + 46 + 10) {
      _loc3_ = "stack2";
    }
    if (this.mouseX > _loc4_ + 60 + 60 - 10 && this.mouseX < _loc4_ + 60 + 60 + 47 + 10 && this.mouseY > _loc5_ - 10 && this.mouseY < _loc5_ + 46 + 10) {
      _loc3_ = "stack3";
    }
    if (this.mouseX > _loc4_ - 10 && this.mouseX < _loc4_ + 47 + 10 && this.mouseY > _loc6_ - 10 && this.mouseY < _loc6_ + 46 + 10) {
      _loc3_ = "stack4";
    }
    if (this.mouseX > _loc4_ + 60 - 10 && this.mouseX < _loc4_ + 60 + 47 + 10 && this.mouseY > _loc6_ - 10 && this.mouseY < _loc6_ + 46 + 10) {
      _loc3_ = "stack5";
    }
    if (this.mouseX > _loc4_ + 60 + 60 - 10 && this.mouseX < _loc4_ + 60 + 60 + 47 + 10 && this.mouseY > _loc6_ - 10 && this.mouseY < _loc6_ + 46 + 10) {
      _loc3_ = "stack6";
    }
    if (this.mouseX > _loc7_ - 10 && this.mouseX < _loc7_ + 47 + 10 && this.mouseY > _loc8_ - 10 && this.mouseY < _loc8_ + 46 + 10) {
      _loc3_ = "diss";
    }
    if (_loc3_ == "diss" && this.floating_weapon.tp == "weapon") {
      _loc9_ = false;
      _loc10_ = false;
      _loc11_ = 1;
      while (_loc11_ <= this.FWP.CRAFT_DEF[0]) {
        if (this.FWP.CRAFT_DEF[_loc11_].result == this.floating_weapon.id) {
          _loc10_ = true;
          if (_loc2_.recipes[_loc11_] == 1) {
            _loc9_ = true;
          }
          break;
        }
        _loc11_++;
      }
      if (_loc10_) {
        this.weapon_diss = {
          "id": this.floating_weapon.id,
          "stolen": this.floating_weapon.stolen,
          "crafted": this.floating_weapon.crafted,
          "range": this.floating_weapon.range,
          "tp": "weapon"
        };
      }
      if (!_loc10_) {
        _loc1_.craft_error_mc.gotoAndPlay(2);
        _loc1_.craft_error_mc.anim.craft_error.text = "Это оружие базовое, его нельзя разобрать.";
      }
      if (_loc9_) {
        _loc1_.craft_error_mc.gotoAndPlay(2);
        _loc1_.craft_error_mc.anim.craft_error.text = "Вы уже знаете рецепт для этого оружия.";
      }
    }
    if (_loc3_ == "diss" && this.floating_weapon.tp != "weapon") {
      _loc1_.craft_error_mc.gotoAndPlay(2);
      _loc1_.craft_error_mc.anim.craft_error.text = "Предметы нельзя разбирать.";
    }
    if (_loc3_.search("stack") != -1) {
      this.weapon_stack[Number(_loc3_.split("stack")[1])] = {
        "id": this.floating_weapon.id,
        "stolen": this.floating_weapon.stolen,
        "crafted": this.floating_weapon.crafted,
        "range": this.floating_weapon.range,
        "tp": this.floating_weapon.tp
      };
    }
  }

  floating_weapon_proceed(param1: any): any {
    this.cur_screen[this.cur_screen[0]].link.floating_container.x = this.mouseX - 25;
    this.cur_screen[this.cur_screen[0]].link.floating_container.y = this.mouseY - 25;
  }

  popup_displace(...rest: any[]): any {
    let _loc2_: any = undefined;
    let _loc3_: any = undefined;
    _loc2_ = this.mouseX;
    _loc3_ = this.mouseY;
    // PORT (wide screens): on a phone the hint is shown larger, within the shown area, clear of the finger and of what
    // PORT: it tells about (ui/wide-popups.ts placeHint); without a wide host as the original placed it.
    if (placeHint(this, this.popup, this.popup_anchor, _loc2_, _loc3_)) {
      return;
    }
    this.popup.x = _loc2_;
    this.popup.y = _loc3_;
    if (_loc2_ + this.popup.popup_bg.width > 807 - 12 - 5) {
      this.popup.x = _loc2_ - this.popup.popup_bg.width - 12;
    } else {
      this.popup.x = _loc2_ + 12;
    }
    if (_loc3_ + this.popup.popup_bg.height > 600 - 12 - 5) {
      this.popup.y = _loc3_ - this.popup.popup_bg.height - 12;
    } else {
      this.popup.y = _loc3_ + 12;
    }
  }

  popup_modify(param1: any): boolean {
    param1 = as3.str(param1);
    let _loc3_: any = undefined;
    let _loc4_: any = undefined;
    let _loc5_: any = undefined;
    let _loc6_: any = undefined;
    let _loc7_: any = undefined;
    let _loc8_: any = undefined;
    let _loc9_: any = undefined;
    let _loc10_: any = undefined;
    let _loc11_: any = undefined;
    let _loc12_: any = undefined;
    let _loc13_: any = undefined;
    let _loc2_: any = this.cur_screen[this.cur_screen[0]].link;
    _loc3_ = this.FWP.temp_player;
    _loc4_ = this.FWP.player;
    _loc5_ = {
      "attack": _loc4_.attack.value,
      "protect": _loc4_.protect.value,
      "health": 100 + 50 * _loc4_.health.value,
      "worms": 2 + _loc4_.worms.value,
      "tired": _loc4_.tired,
      "stim_to_fight": _loc4_.stim_to_fight,
      "impl": _loc4_.cur_impl
    };
    _loc6_ = this.FWP.get_affected_skills(_loc5_);
    if (this.shop_type == "weapons") {
      _loc7_ = this.FWP.WEAPONS_DEF;
    }
    if (this.shop_type == "help") {
      _loc7_ = this.FWP.STIM_DEF;
    }
    if (this.shop_type == "flags") {
      _loc7_ = this.FWP.FLAGS_DEF;
    }
    if (this.shop_type == "rip") {
      _loc7_ = this.FWP.RIPS_DEF;
    }
    if (this.shop_type == "impl") {
      _loc7_ = this.FWP.IMPL_DEF;
    }
    if (this.shop_type == "objs") {
      _loc7_ = this.FWP.OBJ_DEF;
    }
    if (param1 == "click_auc") {
      this.popup.header.text = "Аукцион";
      this.popup.main_text.text = "";
    }
    if (param1 == "career") {
      this.popup.header.text = "Карьера";
      this.popup.main_text.text = "";
    }
    if (param1 == "missions") {
      this.popup.header.text = "Миссии";
      this.popup.main_text.text = "";
    }
    if (param1 == "survival") {
      this.popup.header.text = "Выживание";
      this.popup.main_text.text = "";
    }
    if (param1 == "boss") {
      this.popup.header.text = "Боссы";
      this.popup.main_text.text = "";
    }
    if (param1 == "init_just_play") {
      this.popup.header.text = "Просто играть";
      this.popup.main_text.text = "";
    }
    // PORT: design D5 - the sixth mode of the mode board: the online lobby.
    if (param1 == "online") {
      this.popup.header.text = MSG_ONLINE;
      this.popup.main_text.text = MSG_ONLINE_HINT;
    }
    // PORT: item 8 - the friends tab is the clans tab.
    if (param1 == "wait_fd") {
      this.popup.header.text = MSG_CLANS;
      this.popup.main_text.text = MSG_CLANS_HINT;
    }
    if (param1 == "hardcore_popup") {
      this.popup.header.text = "Хардкорный режим";
      this.popup.main_text.text = "В этом режиме вам дается меньше времени на ход, и утилита \"Дополнительное время\" не так эфективна, зато при победе предоставляется увеличенное количество золота и опыта. Подробнее - в Вормпедии.";
    }
    if (param1 == "achiev_range_popup") {
      this.popup.header.text = "Ранг достижений";
      this.popup.main_text.text = "За каждые 10 уровней любого достижения вы получаете +1 к рангу достижений. За каждый ранг достижений вам дается определенное количество очков к рейтингу. Например, на 5 ранге: +1000 к рейтингу, на 15: +5000 к рейтингу, и т.д.";
    }
    if (param1 == "assault_diff_popup") {
      this.popup.header.text = "Сложность территории";
      this.popup.main_text.text = "С каждым захватом сложность территории увеличивается (растут показатели Атаки, Защиты и Здоровья врагов). Однако, сложность меняется циклически, то есть, когда сложность доходит до определенного предела, она снова сбрасывается в ноль, и показатели Атаки, Защиты и Здоровья становятся существенно меньше. Это сделано для того, чтобы не только топовые игроки могли захватывать территории.";
    }
    if (param1 == "clans_rating") {
      this.popup.header.text = "Рейтинг кланов";
      this.popup.main_text.text = "Рейтинг каждого клана - количество успешных захватов территорий всех игроков, входящих в клан.";
    }
    if (param1 == "open_wpsheet") {
      this.popup.header.text = "Арсенал";
      this.popup.main_text.text = "";
    }
    if (param1 == "cancel_fight") {
      this.popup.header.text = this.FWP.REPLAY ? "Выход" : "Завершить бой";
      this.popup.main_text.text = "";
    }
    if (param1 == "open_scaner") {
      this.popup.header.text = "Сканер";
      this.popup.main_text.text = "";
    }
    if (param1 == "my_nickname") {
      // PORT: the profile plate of the main screen: the full nickname, as the player typed it (never translated).
      this.popup.header.text = MSG_NICKNAME_POPUP;
      setRawText(this.popup.main_text, _loc2_ && _loc2_.$profile_badge ? _loc2_.$profile_badge.fullNickname : String(this.FWP.user.name));
    }
    if (param1 == "my_level") {
      this.popup.header.text = "Уровень";
      this.popup.main_text.text = "В зависимсти от уровня вам открывается новое оружие и задания. Уровень зависит от набранного опыта (зеленая шкала).";
    }
    if (param1 == "init_tired") {
      this.popup.header.text = "Уровень усталости";
      this.popup.main_text.text = "Показывает, насколько устала ваша команда. Усталость начисляется каждый бой. При усталости выше 80% начинают проявляться негативные эффекты. Чтобы снизить усталость, используйте стимуляторы в разделе Арсенал или кликните по этой шкале.\n\nУсталость: " + _loc6_.tired + "%";
    }
    if (param1 == "my_exp") {
      this.popup.header.text = "Опыт";
      this.popup.main_text.text = "Опыт выдается за победы в бою. Чем больше опыта, тем выше ваш уровень. С каждым уровнем вы получаете очки навыков и способностей, которые можно использовать в разделе Развитие (нажмите на эту шкалу для быстрого перехода).\n\nОпыта набрано:\n" + this.x3String(_loc4_.exp.value) + " / " + this.x3String(this.FWP.LEVEL_THRESHOLD[_loc4_.level.value + 1]);
    }
    if (param1 == "my_rating") {
      this.popup.header.text = "Ваш рейтинг";
      this.popup.main_text.text = "Рейтинг определяет ваше влияние и авторитет в игре, от него зависит, в какой лиге и на каком месте вы будете в списке лучших игроков. Рейтинг дается за победы, в некоторых случаях предусмотрены бонусы.";
    }
    if (param1 == "skill_pts") {
      this.popup.header.text = "Очки навыков";
      this.popup.main_text.text = "Очки навыков выдаются при получении нового уровня - по 15 очков за каждый.";
    }
    if (param1 == "perk_pts") {
      this.popup.header.text = "Очки способностей";
      this.popup.main_text.text = "Очки способностей выдаются при получении нового уровня - по 20 очков за каждый.";
    }
    // PORT: VK removed: the hints of diam_add / diam_all ("+1 голос", "Все голоса": VK votes to transfer). The donate
    // PORT: buttons open the exchange of diamonds for gold; diamonds are not bought (design D7), and the hint says so.
    if (param1 == "donate") {
      this.popup.header.text = "Алмазы";
      this.popup.main_text.text = "Обмен алмазов на золото: 1 алмаз = 1100 золота. Алмазы дают за новые уровни, достижения и задания.";
    }
    if (param1 == "gold_add") {
      this.popup.header.text = "+1 алмаз";
      this.popup.main_text.text = "";
    }
    if (param1 == "gold_all") {
      this.popup.header.text = "Все алмазы";
      this.popup.main_text.text = "";
    }
    if (param1 == "get_replay_clip") {
      this.popup.header.text = "Повтор боя";
      // PORT: the record is stored on the game server (the original: the player's VK notes), after the offer's window.
      this.popup.main_text.text = MSG_REPLAY_HINT;
    }
    if (param1 == "award_magnet") {
      this.popup.header.text = "Алмазный магнат";
      // PORT: diamonds are not sold (the original: a single purchase of 100+ diamonds for VK votes); the operator awards it.
      this.popup.main_text.text = "Особая награда от администрации игры.";
    }
    if (param1 == "award_contest") {
      this.popup.header.text = "Победитель конкурсов";
      this.popup.main_text.text = "";
    }
    if (param1 == "award_tester") {
      this.popup.header.text = "Почетный тестер";
      this.popup.main_text.text = "";
    }
    if (param1.search("buy_perk") != -1) {
      this.popup.header.text = "Добавить место";
      this.popup.main_text.text = "";
    }
    if (param1.search("add_perk") != -1) {
      this.popup.header.text = "Добавить способность";
      this.popup.main_text.text = "";
    }
    if (param1.search("view_perks") != -1) {
      this.popup.header.text = "Просмотр способностей";
      this.popup.main_text.text = "";
    }
    if (param1 == "try_steal") {
      this.popup.header.text = "Украсть";
      this.popup.main_text.text = "Вероятность: " + this.return_steal_prob(this.cur_weapon) + "%";
    }
    if (param1.search("upg_perk") != -1) {
      _loc8_ = this.perk_places[Number(param1.split("upg_perk")[1])];
      this.popup.header.text = "Улучшить способность";
      this.popup.main_text.text = "Стоимость: " + this.FWP.PERKS_DEF[_loc8_].upg[_loc3_.perks[_loc8_]] + " очков способностей.";
    }
    if (param1.search("upg_inact_perk") != -1) {
      _loc8_ = this.perk_places[Number(param1.split("upg_inact_perk")[1])];
      this.popup.header.text = "Улучшить способность";
      if (_loc3_.perks[_loc8_] == this.FWP.PERKS_DEF[_loc8_].max_lim) {
        this.popup.main_text.text = "На макс. уровне.";
      } else {
        this.popup.main_text.text = "Стоимость: " + this.FWP.PERKS_DEF[_loc8_].upg[_loc3_.perks[_loc8_]] + " очков способностей.";
      }
    }
    if (param1.search("perk_box") != -1) {
      _loc8_ = this.perk_places[Number(param1.split("perk_box")[1])];
      if (!_loc8_) {
        return false;
      }
      this.popup.header.text = this.FWP.PERKS_DEF[_loc8_].name;
      this.popup.main_text.text = "Уровень: " + String(_loc3_.perks[_loc8_]);
    }
    if (param1.search("stim_desc") != -1) {
      _loc11_ = param1.split("stim_desc_")[1];
      if (!_loc11_) {
        return false;
      }
      _loc12_ = this.FWP.STIM_DEF[_loc11_];
      this.popup.header.text = _loc12_.name;
      _loc13_ = "";
      if (_loc12_.tired != 0) {
        _loc13_ += "Усталость " + _loc12_.tired + "%\n";
      }
      if (_loc12_.attack != 0) {
        _loc13_ += "Атака " + (_loc12_.attack > 0 ? "+" + _loc12_.attack : _loc12_.attack) + "\n";
      }
      if (_loc12_.protect != 0) {
        _loc13_ += "Защита " + (_loc12_.protect > 0 ? "+" + _loc12_.protect : _loc12_.protect) + "\n";
      }
      if (_loc12_.health != 0) {
        _loc13_ += "Здоровье " + (_loc12_.health > 0 ? "+" + _loc12_.health : _loc12_.health) + "\n";
      }
      _loc13_ += "\nСтоимость:\n";
      if (_loc12_.gold != 0) {
        _loc13_ += _loc12_.gold + " золота\nили ";
      }
      _loc13_ += _loc12_.diam + " алмаз" + (_loc12_.diam == 1 ? "" : (_loc12_.diam < 5 ? "а" : "ов"));
      this.popup.main_text.text = _loc13_;
    }
    _loc9_ = {
      "attack": _loc3_.attack.value,
      "protect": _loc3_.protect.value,
      "health": 100 + 50 * _loc3_.health.value,
      "worms": 2 + _loc3_.worms.value,
      "tired": _loc4_.tired,
      "stim_to_fight": _loc4_.stim_to_fight,
      "impl": _loc4_.cur_impl
    };
    _loc10_ = this.FWP.get_affected_skills(_loc9_);
    if (param1 == "skill_attack") {
      this.popup.header.text = "Модификаторы Атаки";
      if (_loc10_.desc_attack.tired == 0 && _loc10_.desc_attack.stim == 0 && _loc10_.desc_attack.impl == 0) {
        this.popup.main_text.text = "нет модификаторов";
      } else {
        this.popup.main_text.text = "";
        if (_loc10_.desc_attack.tired != 0) {
          this.popup.main_text.text += "Эффект усталости: " + _loc10_.desc_attack.tired + "\n";
        }
        if (_loc10_.desc_attack.stim != 0) {
          this.popup.main_text.text += "Стимуляторы: " + (_loc10_.desc_attack.stim > 0 ? "+" : "") + _loc10_.desc_attack.stim + "\n";
        }
        if (_loc10_.desc_attack.impl != 0) {
          this.popup.main_text.text += "Имплантанты: +" + _loc10_.desc_attack.impl + "\n";
        }
      }
    }
    if (param1 == "skill_protect") {
      this.popup.header.text = "Модификаторы Защиты";
      if (_loc10_.desc_protect.tired == 0 && _loc10_.desc_protect.stim == 0 && _loc10_.desc_protect.impl == 0) {
        this.popup.main_text.text = "нет модификаторов";
      } else {
        this.popup.main_text.text = "";
        if (_loc10_.desc_protect.tired != 0) {
          this.popup.main_text.text += "Эффект усталости: " + _loc10_.desc_protect.tired + "\n";
        }
        if (_loc10_.desc_protect.stim != 0) {
          this.popup.main_text.text += "Стимуляторы: " + (_loc10_.desc_protect.stim > 0 ? "+" : "") + _loc10_.desc_protect.stim + "\n";
        }
        if (_loc10_.desc_protect.impl != 0) {
          this.popup.main_text.text += "Имплантанты: +" + _loc10_.desc_protect.impl + "\n";
        }
      }
    }
    if (param1 == "skill_health") {
      this.popup.header.text = "Модификаторы Здоровья";
      if (_loc10_.desc_health.tired == 1 && _loc10_.desc_health.stim == 0 && _loc10_.desc_health.impl == 0) {
        this.popup.main_text.text = "нет модификаторов";
      } else {
        this.popup.main_text.text = "";
        if (_loc10_.desc_health.tired != 1) {
          this.popup.main_text.text += "Эффект усталости: -" + Math.round((1 - _loc10_.desc_health.tired) * 100) + "%\n";
        }
        if (_loc10_.desc_health.stim != 0) {
          this.popup.main_text.text += "Стимуляторы: " + (_loc10_.desc_health.stim > 0 ? "+" : "") + _loc10_.desc_health.stim + "\n";
        }
        if (_loc10_.desc_health.impl != 0) {
          this.popup.main_text.text += "Имплантанты: +" + _loc10_.desc_health.impl + "\n";
        }
      }
    }
    if (param1 == "announcement_task") {
      this.popup.header.text = "Журнал заданий";
      if (this.FWP.get_task_bonus().exist) {
        this.popup.main_text.text = "Есть новые!";
      } else {
        this.popup.main_text.text = "";
      }
    }
    if (param1 == "announcement_achiev") {
      this.popup.header.text = "Достижения";
      this.popup.main_text.text = "Получите награду!";
    }
    // PORT: what a pack of the store gives (runtime/monetization-ui.ts).
    const _store: any = storePopup(this, param1);
    if (_store) {
      this.popup.header.text = _store.header;
      this.popup.main_text.text = _store.text;
    }
    this.popup_set_height();
    return true;
  }

  popup_set_height(): any {
    let _loc1_: any = undefined;
    _loc1_ = this.popup.main_text.numLines;
    if (this.popup.main_text.text == "") {
      this.popup.popup_bg.height = 32;
    } else {
      this.popup.popup_bg.height = 40 + _loc1_ * 15;
    }
  }

  return_damage_desc(param1: any, param2: number, param3: number, param4: number = 1): any {
    param1 = as3.str(param1);
    param2 = Number(param2);
    param3 = Number(param3);
    param4 = Number(param4);
    let _loc5_: any = undefined;
    let _loc6_: any = undefined;
    let _loc7_: any = undefined;
    let _loc8_: any = undefined;
    _loc5_ = this.FWP.WEAPONS_DEF[param1].add_damage.mode != "none" ? this.FWP.WEAPONS_DEF[param1].add_damage.amount + param3 : 0;
    _loc6_ = Math.round(this.FWP.WEAPONS_DEF[param1].damage * param2 * this.FWP.get_range_upgrade(param4, "damage"));
    _loc7_ = -1;
    if (this.FWP.WEAPONS_DEF[param1].add_damage.a_dmg) {
      _loc7_ = Math.round(this.FWP.WEAPONS_DEF[param1].add_damage.a_dmg * param2);
    }
    _loc8_ = "";
    if (this.FWP.WEAPONS_DEF[param1].damage == -3) {
      _loc8_ = "50% ОЗ или 300 ОЗ";
    } else if (this.FWP.WEAPONS_DEF[param1].damage == -2) {
      _loc8_ = "50% ОЗ или 200 ОЗ";
    } else if (this.FWP.WEAPONS_DEF[param1].damage == -1 || this.FWP.WEAPONS_DEF[param1].damage == 0) {
      _loc8_ = "-";
    } else if (_loc5_ == 0 || _loc5_ == 1) {
      _loc8_ = _loc6_ + " ОЗ";
    } else if (this.FWP.WEAPONS_DEF[param1].add_damage.mode == "shots") {
      _loc8_ = String(_loc5_) + " выстрел" + (_loc5_ < 5 ? "а" : "ов") + " по " + _loc6_ + " ОЗ";
    } else if (this.FWP.WEAPONS_DEF[param1].add_damage.mode == "multi_shots") {
      _loc8_ = String(_loc5_) + " выстрел" + (_loc5_ < 5 ? "а" : "ов") + " по " + _loc6_ + " ОЗ";
    } else if (this.FWP.WEAPONS_DEF[param1].add_damage.mode == "cluster") {
      _loc8_ = "1 + " + String(_loc5_) + " разрывн. по " + (_loc7_ == -1 ? _loc6_ : _loc7_) + " ОЗ";
    } else if (this.FWP.WEAPONS_DEF[param1].add_damage.mode == "mines") {
      _loc8_ = _loc6_ + " + " + String(_loc5_) + " мин по " + Math.round(50 * param2) + " ОЗ";
    } else if (this.FWP.WEAPONS_DEF[param1].add_damage.mode == "pmines") {
      _loc8_ = _loc6_ + " + " + String(_loc5_) + " мин по " + Math.round(110 * param2) + " ОЗ";
    } else if (this.FWP.WEAPONS_DEF[param1].add_damage.mode == "airstrike") {
      _loc8_ = String(_loc5_) + " снарядов по " + _loc6_ + " ОЗ";
    } else if (this.FWP.WEAPONS_DEF[param1].add_damage.mode == "ap") {
      _loc8_ = String(_loc5_) + " x " + _loc6_ + " ОЗ";
    } else if (this.FWP.WEAPONS_DEF[param1].add_damage.mode == "banana") {
      _loc8_ = "1 + " + String(_loc5_) + " банано-бомб по " + (_loc7_ == -1 ? _loc6_ : _loc7_) + " ОЗ";
    }
    return as3.str(_loc8_);
  }

  return_weapon_desc(param1: any, param2: any = "weapons", param3: number = 1, param4: boolean = false, param5: any = 0, param6: boolean = false): any {
    param1 = as3.str(param1);
    param2 = as3.str(param2);
    param3 = Number(param3);
    param4 = Boolean(param4);
    param6 = Boolean(param6);
    let _loc7_: any = undefined;
    let _loc8_: any = undefined;
    let _loc9_: any = undefined;
    let _loc10_: any = undefined;
    let _loc11_: any = undefined;
    let _loc12_: any = undefined;
    let _loc13_: any = undefined;
    let _loc14_: any = undefined;
    let _loc15_: any = undefined;
    let _loc16_: any = undefined;
    let _loc17_: any = undefined;
    let _loc18_: any = undefined;
    let _loc19_: any = undefined;
    _loc7_ = "";
    if (param2 == "weapons" || param6) {
      _loc8_ = "";
      switch (this.FWP.WEAPONS_DEF[param1].wptype) {
        case "p":
          _loc8_ = "Снаряд";
          break;
        case "e":
          _loc8_ = "Взрывчатка";
          break;
        case "a":
          _loc8_ = "Авиаудар";
          break;
        case "c":
          _loc8_ = "Ближний бой";
          break;
        case "h":
          _loc8_ = "Энергетическое";
          break;
        case "f":
          _loc8_ = "Огнестрельное";
          break;
        case "u":
          _loc8_ = "Утилита";
          break;
        case "l":
          _loc8_ = "Живая бомба";
      }
      if (!param4 || this.last_call_game_mode == "just") {
        _loc9_ = this.return_damage_desc(param1, 1, 0, param3);
      } else {
        _loc9_ = this.return_damage_desc(param1, param5.dmg_mult, param5.shots_add, param3);
      }
      _loc10_ = Math.min(100, this.FWP.WEAPONS_DEF[param1].crit + this.FWP.get_range_upgrade(param3, "crit"));
      _loc11_ = Math.min(100, this.FWP.WEAPONS_DEF[param1].ap_mod + this.FWP.get_range_upgrade(param3, "ap"));
      _loc12_ = this.FWP.WEAPONS_DEF[param1].limit == 0 ? "Нет" : String(this.FWP.WEAPONS_DEF[param1].limit);
      _loc13_ = this.FWP.WEAPONS_DEF[param1].delay == 0 ? "Нет" : String(this.FWP.WEAPONS_DEF[param1].delay) + " ход" + (this.FWP.WEAPONS_DEF[param1].delay == 1 ? "" : (this.FWP.WEAPONS_DEF[param1].delay < 5 ? "а" : "ов"));
      _loc14_ = _loc10_ == 0 ? "Нет" : "+" + String(_loc10_) + "%";
      _loc15_ = _loc11_ == 0 ? "Нет" : "+" + String(_loc11_) + "%";
      switch (this.FWP.WEAPONS_DEF[param1].wpclass) {
        case 0:
          _loc16_ = "не опред.";
          break;
        case 1:
          _loc16_ = "Первый";
          break;
        case 2:
          _loc16_ = "Второй";
          break;
        case 3:
          _loc16_ = "Третий";
          break;
        case 4:
          _loc16_ = "Четвертый";
          break;
        case 5:
          _loc16_ = "Пятый";
          break;
        case 6:
          _loc16_ = "Шестой";
          break;
        case 7:
          _loc16_ = "Седьмой";
          break;
        case 8:
          _loc16_ = "Восьмой";
      }
      if (this.FWP.WEAPONS_DEF[param1].level != 0) {
        _loc7_ = "<b>Требуемый уровень: </b>" + this.FWP.WEAPONS_DEF[param1].level;
      } else {
        _loc7_ = "<b>Только крафтинг</b>";
      }
      _loc7_ += "\n<b>Урон: </b>" + _loc9_ + "\n<b>Класс: </b>" + _loc16_ + "\n<b>Тип: </b>" + _loc8_ + "\n<b>Макс. количество: </b>" + _loc12_;
      if (this.FWP.WEAPONS_DEF[param1].delay != 0 && this.FWP.WEAPONS_DEF[param1].delay != Number.POSITIVE_INFINITY) {
        _loc7_ += "\n<b>Задержка: </b>" + _loc13_;
      }
      if (_loc10_ != 0) {
        _loc7_ += "\n<b>Бонус к шансу крит. выстрела: </b>" + _loc14_;
      }
      if (_loc11_ != 0) {
        _loc7_ += "\n<b>Бонус к шансу проб. выстрела: </b>" + _loc15_;
      }
      if (this.FWP.WEAPONS_DEF[param1].unfail == 150) {
        _loc7_ += "\n<b>Бонус безотказности: нет осечек</b>";
      }
      if (this.FWP.WEAPONS_DEF[param1].add_damage.mode == "multi_shots") {
        _loc7_ += "\n<b>Бонус мультивыстрела</b>";
      }
      _loc7_ += "\n\n";
    } else if (param2 == "help") {
      _loc17_ = this.FWP.STIM_DEF[param1];
      _loc7_ += "<b>Эффекты:</b>\n\n";
      if (_loc17_.tired != 0) {
        _loc7_ += "<b>Усталость:</b> " + _loc17_.tired + "%\n";
      }
      if (_loc17_.attack != 0) {
        _loc7_ += "<b>Атака:</b> " + (_loc17_.attack > 0 ? "+" + _loc17_.attack : _loc17_.attack) + "\n";
      }
      if (_loc17_.protect != 0) {
        _loc7_ += "<b>Защита:</b> " + (_loc17_.protect > 0 ? "+" + _loc17_.protect : _loc17_.protect) + "\n";
      }
      if (_loc17_.health != 0) {
        _loc7_ += "<b>Здоровье:</b> " + (_loc17_.health > 0 ? "+" + _loc17_.health : _loc17_.health) + " ОЗ\n";
      }
      _loc7_ += "\n";
    } else if (param2 == "flags" || param2 == "rip") {
      if (param2 == "flags") {
        _loc18_ = this.FWP.FLAGS_DEF[param1];
      }
      if (param2 == "rip") {
        _loc18_ = this.FWP.RIPS_DEF[param1];
      }
      _loc7_ += "<b>Требования:</b>\n";
      if (_loc18_.req == "none") {
        _loc7_ += "Нет\n";
      }
      if (_loc18_.req == "level") {
        _loc7_ += "<b>Уровень:</b> " + _loc18_.req_amnt + "\n";
      }
      if (_loc18_.req == "achiev") {
        _loc7_ += "<b>Ранг достижений:</b> " + _loc18_.req_amnt + "\n";
      }
      if (_loc18_.req == "career") {
        _loc7_ += "<b>Ранг карьеры:</b> " + _loc18_.req_amnt + "\n";
      }
      if (_loc18_.req == "mission") {
        _loc7_ += "<b>Пройденных миссий:</b> " + _loc18_.req_amnt + "\n";
      }
      _loc7_ += "\n";
    } else if (param2 == "impl") {
      _loc19_ = this.FWP.IMPL_DEF[param1];
      _loc7_ += "<b>Эффекты:</b>\n\n";
      if (_loc19_.attack != 0) {
        _loc7_ += "<b>Атака:</b> " + (_loc19_.attack > 0 ? "+" + _loc19_.attack : _loc19_.attack) + "\n";
      }
      if (_loc19_.protect != 0) {
        _loc7_ += "<b>Защита:</b> " + (_loc19_.protect > 0 ? "+" + _loc19_.protect : _loc19_.protect) + "\n";
      }
      if (_loc19_.health != 0) {
        _loc7_ += "<b>Здоровье:</b> " + (_loc19_.health > 0 ? "+" + _loc19_.health : _loc19_.health) + " ОЗ\n";
      }
      if (_loc19_.special.fire_res) {
        _loc7_ += "<b>Сопротивление огню +100%</b>\n";
      }
      if (_loc19_.special.poison_res) {
        _loc7_ += "<b>Сопротивление яду/радиации +100%</b>\n";
      }
      if (_loc19_.special.para_res) {
        _loc7_ += "<b>Сопротивление парализации +100%</b>\n";
      }
      _loc7_ += "\n";
    }
    return as3.str(_loc7_);
  }

  get_req_params(param1: any, param2: any): boolean {
    if (!param2.req) {
      return true;
    }
    if (param2.req == "none") {
      return true;
    }
    if (param2.req == "level" && param1.level.value >= param2.req_amnt) {
      return true;
    }
    if (param2.req == "achiev" && this.FWP.get_achiev_rank(param1.achiev) >= param2.req_amnt) {
      return true;
    }
    if (param2.req == "career" && param1.career_max >= param2.req_amnt) {
      return true;
    }
    if (param2.req == "mission" && param1.missions_max >= param2.req_amnt) {
      return true;
    }
    return false;
  }

  return_steal_prob(param1: any): number {
    param1 = as3.str(param1);
    let _loc2_: any = undefined;
    let _loc3_: any = undefined;
    _loc2_ = 0;
    if (this.FWP.player.perks["steal"]) {
      _loc2_ = this.FWP.player.perks.steal;
    }
    _loc3_ = 0;
    if (this.FWP.player.perks["pe"]) {
      _loc3_ = this.FWP.player.perks.pe;
    }
    return Number(this.FWP.get_steal_prob(this.FWP.player.level.value, this.FWP.WEAPONS_DEF[param1].level, _loc2_, _loc3_));
  }

  return_steal_luck_prob(): number {
    let _loc1_: any = undefined;
    let _loc2_: any = undefined;
    let _loc3_: any = undefined;
    _loc1_ = 0;
    if (this.FWP.player.perks["luck"]) {
      _loc1_ = this.FWP.player.perks.luck;
    }
    _loc2_ = 0;
    if (this.FWP.player.perks["luck2"]) {
      _loc2_ = this.FWP.player.perks.luck2;
    }
    _loc3_ = 0;
    if (this.FWP.player.perks["education"]) {
      _loc3_ = this.FWP.player.perks.education;
    }
    return Math.round(_loc3_ * 10 + _loc1_ * 2 + _loc2_ * 3);
  }

  return_steal_merch_prob(): number {
    let _loc1_: any = undefined;
    let _loc2_: any = undefined;
    _loc1_ = 0;
    if (this.FWP.player.perks["merchant"]) {
      _loc1_ = this.FWP.player.perks.merchant;
    }
    _loc2_ = 0;
    if (this.FWP.player.perks["bar"]) {
      _loc2_ = this.FWP.player.perks.bar;
    }
    return Math.round((_loc1_ + _loc2_) * 8);
  }

  return_papa_ask_prob(): number {
    let _loc1_: any = undefined;
    let _loc2_: any = undefined;
    let _loc3_: any = undefined;
    _loc1_ = 0;
    if (this.FWP.player.perks["luck"]) {
      _loc1_ = this.FWP.player.perks.luck;
    }
    _loc2_ = 0;
    if (this.FWP.player.perks["luck2"]) {
      _loc2_ = this.FWP.player.perks.luck2;
    }
    _loc3_ = 0;
    if (this.FWP.player.perks["education"]) {
      _loc3_ = this.FWP.player.perks.education;
    }
    return Math.round(_loc3_ * 4 + _loc1_ + _loc2_);
  }

  check_recipe(param1: any, param2: any, param3: number): any {
    param3 = Number(param3);
    let _loc4_: any = undefined;
    let _loc5_: any = undefined;
    let _loc6_: any = undefined;
    let _loc7_: any = undefined;
    let _loc8_: any = undefined;
    let _loc9_: any = undefined;
    let _loc10_: any = undefined;
    let _loc11_: any = undefined;
    let _loc12_: any = undefined;
    let _loc13_: any = undefined;
    _loc4_ = "";
    _loc5_ = 1;
    _loc6_ = "";
    _loc7_ = 5;
    _loc8_ = 0;
    _loc9_ = 1;
    _loc10_ = 1;
    while (_loc10_ <= this.FWP.CRAFT_DEF[0]) {
      _loc11_ = [0, false, false, false, false, false, false];
      _loc12_ = 1;
      while (_loc12_ <= this.FWP.CRAFT_DEF[_loc10_].ingr[0]) {
        _loc9_ = 1;
        while (_loc9_ <= 6) {
          if (!_loc11_[_loc9_] && param1[_loc9_].id == this.FWP.CRAFT_DEF[_loc10_].ingr[_loc12_]) {
            _loc11_[_loc9_] = true;
            ++_loc11_[0];
            break;
          }
          _loc9_++;
        }
        _loc12_++;
      }
      if (_loc11_[0] == this.FWP.CRAFT_DEF[_loc10_].ingr[0]) {
        _loc8_ = _loc10_;
        break;
      }
      _loc10_++;
    }
    if (_loc8_ != 0) {
      _loc4_ = this.FWP.CRAFT_DEF[_loc8_].result;
      if (param3 < this.FWP.CRAFT_DEF[_loc8_].req) {
        _loc6_ = "req" + String(this.FWP.CRAFT_DEF[_loc8_].req);
      }
      _loc13_ = 10;
      _loc9_ = 1;
      while (_loc9_ <= 6) {
        if (param1[_loc9_].tp == "weapon") {
          if (Number(param1[_loc9_].range) < _loc13_) {
            _loc13_ = Number(param1[_loc9_].range);
          }
        }
        _loc9_++;
      }
      _loc5_ = _loc13_ > 5 ? 5 : _loc13_;
      if (!this.FWP.WEAPONS_DEF[this.FWP.CRAFT_DEF[_loc8_].result].allow_upg) {
        _loc5_ = 1;
      }
      if (param2[_loc8_]) {
        if (param2[_loc8_] == 1) {
          _loc7_ = 100;
        }
      } else {
        _loc7_ += param3 * 15;
      }
    }
    return { "id": _loc4_, "range": _loc5_, "error": _loc6_, "prob": _loc7_ };
  }

  steal(): any {
    let _loc1_: any = undefined;
    _loc1_ = this.cur_weapon;
    this.success_steal = false;
    this.steal_try_luck = false;
    this.steal_try_merch = false;
    this.steal_state = "";
    // PORT: design D3 - steal.attempt on the server: the draw, the stolen copy or the penalty, and the apologies the
    // PORT: dialog may still offer (kept by the server until they are used).
    this.FWP.net_command("steal.attempt", { "id": _loc1_ }, "steal proceed", { "done": (result: any) => {
      this.success_steal = result.success;
      if (result.success) {
        this.succ_steal_weapon = _loc1_;
      } else {
        this.steal_try_luck = !(result.apology && result.apology.luck);
        this.steal_try_merch = !(result.apology && result.apology.merch);
      }
    } });
  }

  /** PORT: design D3 - one crafting slot (weapon_stack[n] / weapon_diss) as the craft ops take it; null = empty. */
  craft_item_arg(param1: any): any {
    if (!param1 || !param1.tp) {
      return null;
    }
    if (param1.tp == "weapon") {
      return { "id": String(param1.id), "tp": "weapon", "range": Number(param1.range), "stolen": Boolean(param1.stolen), "crafted": Boolean(param1.crafted) };
    }
    return { "id": String(param1.id), "tp": "object" };
  }

  /** PORT: design D3 - crafting_result (what finish_crafting and the craft error screens read) from a craft op's result. */
  craft_result_of(param1: any): any {
    return {
      "id": param1.id,
      "range": Number(param1.range),
      "error": param1.error,
      "new_recipe": param1.new_recipe,
      "junk": param1.junk,
      "new_object": param1.new_object,
      "mode": param1.mode,
      "success": param1.success
    };
  }

  check_tf(param1: any): any {
    let _loc2_: any = undefined;
    let _loc3_: any = undefined;
    let _loc4_: any = undefined;
    _loc2_ = param1.target.text;
    _loc3_ = "";
    _loc4_ = 0;
    while (_loc4_ <= _loc2_.length - 1) {
      // PORT: the letters of the game's languages (Ukrainian і ї є ґ, the apostrophe of "Черв'як"): isAllowedNameChar.
      if (isAllowedNameChar(_loc2_.charCodeAt(_loc4_))) {
        _loc3_ = _loc3_.concat(_loc2_.charAt(_loc4_));
      }
      _loc4_++;
    }
    param1.target.text = _loc3_;
  }

  mod(param1: number): number {
    param1 = Number(param1);
    return Math.abs(param1);
  }

  sign(param1: number): number {
    param1 = Number(param1);
    return param1 >= 0 ? 1 : -1;
  }

  init_win_or_lose(): any {
    let _loc1_: any = undefined;
    let _loc2_: any = undefined;
    let _loc3_: any = undefined;
    _loc1_ = this.FWP.end_game;
    this.graves_array = [];
    _loc2_ = 1;
    while (_loc2_ <= 16) {
      this.graves_array[_loc2_] = { "clicked": false };
      _loc2_++;
    }
    if (_loc1_.win) {
      this.init("end_game_win");
      _loc3_ = this.cur_screen[this.cur_screen[0]].link;
      _loc3_.exp_bonus.text = "Опыт\n+ " + this.x3String(_loc1_.exp_bonus);
      _loc3_.gold_bonus.text = "Золото\n+ " + this.x3String(_loc1_.gold_bonus);
      _loc3_.rating_bonus.text = "Рейтинг \n+ " + this.x3String(_loc1_.rating_bonus);
    } else {
      this.init("end_game_lose");
    }
  }

  init_new_level(): any {
    let _loc1_: any = undefined;
    let _loc2_: any = undefined;
    let _loc3_: any = undefined;
    _loc1_ = this.FWP.end_game;
    this.FWP.player.level.value = this.FWP.get_player_level(this.FWP.player.exp.value);
    if (_loc1_.surprise_weapons[0] == 0) {
      this.init("end_game_new_lvl");
    } else {
      this.init("end_game_surprise");
    }
    _loc2_ = this.cur_screen[this.cur_screen[0]].link;
    _loc2_.new_level_number.htmlText = "Поздравляем вас с переходом на новый уровень <b>(" + this.FWP.player.level.value + ")</b>.";
    _loc3_ = "Вы получаете <b>+" + _loc1_.levels_upg * 100 + "</b> к рейтингу, а также : \n";
    if (_loc1_.diam_bonus != 0) {
      _loc3_ += "<b>+" + _loc1_.diam_bonus + "</b> алмазов, ";
    }
    _loc3_ += "<b>+" + _loc1_.perk_pts + "</b> очк. навыков, ";
    _loc3_ += "<b>+" + _loc1_.skill_pts + "</b> очк. способностей.";
    _loc2_.new_level_goods.htmlText = _loc3_;
    if (_loc1_.surprise_weapons[0] != 0) {
      this.bitmaps["surprise_bitmap"] = new Bitmap();
      this.bitmap_datas["surprise_bitmap"] = new BitmapData(50, 50, true, 0);
      this.bitmaps["surprise_bitmap"].bitmapData = this.bitmap_datas["surprise_bitmap"];
      _loc2_.surprise_weapon_icon.addChild(this.bitmaps["surprise_bitmap"]);
      this.bitmaps["surprise_bitmap"].x = 0;
      this.bitmaps["surprise_bitmap"].y = 0;
      this.cur_page = 1;
      this.render();
    }
    this.FWP._sound.play_sound("new_level", 1, false, true);
  }

  init_what_opened(): any {
    let _loc1_: any = undefined;
    let _loc2_: any = undefined;
    let _loc3_: any = undefined;
    let _loc4_: any = undefined;
    let _loc5_: any = undefined;
    let _loc6_: any = undefined;
    let _loc7_: any = undefined;
    _loc1_ = new Array<any>(12);
    _loc2_ = 0;
    _loc3_ = 0;
    for (_loc4_ of as3.keys(this.FWP.WEAPONS_DEF)) {
      if (this.FWP.WEAPONS_DEF[_loc4_].level == this.FWP.player.level.value && this.FWP.WEAPONS_DEF[_loc4_].id <= 200) {
        _loc1_[_loc2_] = new Array<any>("W", _loc4_);
        _loc2_++;
      }
    }
    if (_loc2_ == 0) {
      this.init("error", "what_opened");
      return;
    }
    this.init("what_opened");
    _loc5_ = this.cur_screen[this.cur_screen[0]].link;
    _loc3_ = 0;
    while (_loc3_ <= 9) {
      if (_loc3_ > _loc2_ - 1) {
        this.buttons["what_op_" + (_loc3_ + 1)].gain.text = "";
      } else if (_loc1_[_loc3_][0] == "W") {
        _loc6_ = this.FWP.get_wpij(this.FWP.WEAPONS_DEF[_loc1_[_loc3_][1]].id).i;
        _loc7_ = this.FWP.get_wpij(this.FWP.WEAPONS_DEF[_loc1_[_loc3_][1]].id).j;
        this.bitmap_datas["what_op_" + (_loc3_ + 1)].copyPixels(this.BigWP, new Rectangle(1 + 45 * (_loc7_ - 1), 1 + 44 * (_loc6_ - 1), 43, 42), new Point(2, 2));
        this.bitmap_datas["what_op_" + (_loc3_ + 1)].copyPixels(this.WPBox, new Rectangle(0, 0, 47, 46), new Point(0, 0), null, null, true);
        this.buttons["what_op_" + (_loc3_ + 1)].gain.text = this.FWP.WEAPONS_DEF[_loc1_[_loc3_][1]].name;
        if (this.buttons["what_op_" + (_loc3_ + 1)].gain.numLines == 1) {
          this.buttons["what_op_" + (_loc3_ + 1)].gain.y += 10;
        }
      }
      _loc3_++;
    }
  }

  init_grave_search(): any {
    let _loc1_: any = undefined;
    let _loc2_: any = undefined;
    if (this.FWP.end_game.game_mode == "assault") {
      this.init("error", "grave_search_assault");
      return;
    }
    if (this.FWP.end_game.graves[0] == 0) {
      this.init("error", "grave_search");
      return;
    }
    this.init("grave_search");
    _loc1_ = this.cur_screen[this.cur_screen[0]].link;
    _loc2_ = 1;
    while (_loc2_ <= 16) {
      this.buttons["gsearch_" + _loc2_].pbar.visible = false;
      if (_loc2_ > this.FWP.end_game.graves[0]) {
        this.buttons["gsearch_" + _loc2_].visible = false;
      } else {
        this.buttons["gsearch_" + _loc2_].worm_name.text = this.FWP.end_game.graves[_loc2_].name;
      }
      _loc2_++;
    }
    this.render_grave_search();
  }

  render_grave_search(): any {
    let _loc1_: any = undefined;
    let _loc2_: any = undefined;
    if (this.clicked_grave != 0) {
      _loc1_ = 1;
      if (this.FWP.player.perks["gsearch"]) {
        _loc1_ = this.FWP.get_perk_effect("gsearch", this.FWP.player.perks.gsearch, "");
      }
      this.buttons["gsearch_" + this.clicked_grave].pbar.visible = true;
      this.buttons["gsearch_" + this.clicked_grave].pbar.gotoAndStop(Math.ceil(this.FWP.grave_process * 60 / (this.FWP.GSEARCHTIME * _loc1_)));
    } else {
      _loc2_ = 1;
      while (_loc2_ <= 16) {
        this.buttons["gsearch_" + _loc2_].pbar.visible = false;
        this.buttons["gsearch_" + _loc2_].alpha = this.graves_array[_loc2_].clicked ? 0.5 : 1;
        this.buttons["gsearch_" + _loc2_].gsearch_button.visible = !this.graves_array[_loc2_].clicked;
        _loc2_++;
      }
    }
  }

  finish_grave_search(): any {
    let _loc1_: any = undefined;
    _loc1_ = this.clicked_grave;
    this.graves_array[this.clicked_grave].clicked = true;
    this.clicked_grave = 0;
    this.render_grave_search();
    // PORT: design D4 - the search is the backend's grave.search { index }: the server draws the find
    // PORT: (FWP.get_grave_result's rule) from the graves of the last won battle it keeps, adds it to the canonical
    // PORT: state (a weapon up to its limit, an object or a stimulator below 50, gold, diamonds; tired += 3) and allows
    // PORT: one search per grave; the game shows the find it returns (grave_found / grave_found_type -> grave_result).
    this.FWP.net_grave_search(_loc1_);
  }

  init_game_menu(): any {
    this.init("game");
  }

  init_mainframe(): any {
    this.init("mainframe");
  }

  init_weapon_sheet(param1: any): any {
    param1 = as3.str(param1);
    this.shop_page = 1;
    this.last_call_game_mode = param1;
    this.init("weapon_sheet");
  }

  render_game_menu(): any {
    let _loc1_: any = undefined;
    let _loc2_: any = undefined;
    let _loc3_: any = undefined;
    let _loc4_: any = undefined;
    let _loc5_: any = undefined;
    this.SecondBitmapData.fillRect(new Rectangle(0, 0, this.MainBitmap.width, this.MainBitmap.height), 0);
    _loc1_ = this.cur_screen[this.cur_screen[0]].link;
    if (this.cur_screen[this.cur_screen[0]].name == "game") {
      // PORT: a battle replayed from a command log (ScriptedInput) takes no interface input: its buttons are hidden.
      const _scripted: boolean = Boolean(this.FWP._proc.battle_input && !this.FWP._proc.battle_input.interactive);
      if (!this.FWP._proc.teams[1].weapons["ultra_scaner"] || this.FWP._proc.teams[1].weapons["ultra_scaner"][1] == 0 || Boolean(this.FWP.REPLAY) || _scripted) {
        _loc1_.open_scaner.visible = false;
      } else {
        _loc1_.open_scaner.visible = true;
      }
      _loc1_.open_wpsheet.visible = !this.FWP.REPLAY && !_scripted;
      // PORT: design D5 - an online battle's surrender button works in every turn (session.forfeit, runtime/online-lobby.ts).
      const _online: boolean = Boolean(this.FWP._proc.battle_input && this.FWP._proc.battle_input.source && this.FWP._proc.battle_input.source.kind == "lockstep");
      _loc1_.cancel_fight.visible = !_scripted || _online;
    }
    _loc2_ = 1;
    while (_loc2_ <= this.FWP._proc.teams[0]) {
      if (_loc2_ == 1 && this.FWP.player.cur_flag != 0) {
        this.SecondBitmapData.copyPixels(this.BigFlags, new Rectangle(10 + 45 * (this.FWP.player.cur_flag - 1), 14, 26, 17), new Point(0, 22 * (_loc2_ - 1)));
      } else {
        this.SecondBitmapData.copyPixels(this.CPUFlags, new Rectangle(20 * this.FWP._proc.teams[_loc2_].cpu_level, 0, 19, 17), new Point(3, 22 * (_loc2_ - 1)));
      }
      _loc3_ = 0;
      _loc4_ = 1;
      while (_loc4_ <= this.FWP._proc.worms[0]) {
        if (this.FWP._proc.worms[_loc4_].state == "ok") {
          if (this.FWP._obj[this.FWP._proc.worms[_loc4_].fid].wteam == _loc2_) {
            _loc3_ += this.FWP._obj[this.FWP._proc.worms[_loc4_].fid].vars.health;
          }
        }
        _loc4_++;
      }
      _loc5_ = Math.ceil(_loc3_ / this.FWP._proc.max_team_hp * this.MAX_HP_WIDTH);
      if (_loc5_ > this.MAX_HP_WIDTH) {
        _loc5_ = this.MAX_HP_WIDTH;
      }
      if (_loc5_ > 0) {
        this.SecondBitmapData.fillRect(new Rectangle(30, 1 + 22 * (_loc2_ - 1), _loc5_, 14), this.interface_get_color(this.FWP._proc.teams[_loc2_].color, 0));
        _loc4_ = 1;
        while (_loc4_ <= _loc5_) {
          this.SecondBitmapData.setPixel32(30 + _loc4_, 1 + 22 * (_loc2_ - 1), this.interface_get_color(this.FWP._proc.teams[_loc2_].color, 1));
          _loc4_++;
        }
        _loc4_ = 1;
        while (_loc4_ <= _loc5_) {
          this.SecondBitmapData.setPixel32(30 + _loc4_, 1 + 22 * (_loc2_ - 1) + 14, this.interface_get_color(this.FWP._proc.teams[_loc2_].color, -1));
          _loc4_++;
        }
        _loc4_ = 0;
        while (_loc4_ <= 14) {
          this.SecondBitmapData.setPixel32(30, 1 + 22 * (_loc2_ - 1) + _loc4_, this.interface_get_color(this.FWP._proc.teams[_loc2_].color, 1));
          _loc4_++;
        }
        _loc4_ = 1;
        while (_loc4_ <= 14) {
          this.SecondBitmapData.setPixel32(30 + _loc5_, 1 + 22 * (_loc2_ - 1) + _loc4_, this.interface_get_color(this.FWP._proc.teams[_loc2_].color, -1));
          _loc4_++;
        }
      }
      _loc2_++;
    }
  }

  open_scaner(): any {
    // PORT: a battle replayed from a command log (ScriptedInput) takes no interface input, like REPLAY.
    if (this.FWP.REPLAY || Boolean(this.FWP._proc.battle_input && !this.FWP._proc.battle_input.interactive)) {
      return;
    }
    if (this.FWP._proc.cur_worm != 0) {
      if (Boolean(this.FWP._proc.game_control) && this.FWP._proc.worms[this.FWP._proc.cur_worm].state == "ok") {
        if (this.FWP._proc.teams[1].weapons["ultra_scaner"][1] != 100) {
          --this.FWP._proc.teams[1].weapons["ultra_scaner"][1];
        }
        this.render_game_menu();
        // PORT: an online battle is not paused by the scanner (proc.menus_freeze).
        this.FWP._proc.GAME_FREEZE = this.FWP._proc.menus_freeze();
        this.init("scaner", "teams");
      }
    }
  }

  /**
   * PORT (touch screens): weapons per page of the weapon sheet for `total` weapons: the original's 80 (8 x 10), or the
   * cells of its touch layout's grid (FWP.sheet_layout), whose last two then hold the page arrows when there are more.
   */
  sheet_page_size(param1: number): number {
    const _l: any = this.FWP.sheet_layout();
    if (!_l) {
      return 80;
    }
    const _n: number = Math.max(1, _l.grid.cols * _l.grid.rows);
    return param1 <= _n ? _n : Math.max(1, _n - 2);
  }

  /**
   * PORT (touch screens): the weapon sheet's description while no weapon is held (the game's hover): the current worm's
   * weapon, its name and description as a finger held on it shows them, or, without one, what a tap does; not the
   * shop's arsenal help (crafting, stimulators, flags, selling: none of it is in a battle), nor the static text the
   * screen was made with (a weapon the player may not have). The desktop keeps the original's texts.
   */
  sheet_idle_text(param1: any): any {
    if (!param1 || !param1.weapon_name || !param1.weapon_desc || typeof this.FWP.touch_zones != "function") {
      return;
    }
    const _p: any = this.FWP._proc;
    const _w: any = _p && _p.cur_worm && _p.worms[_p.cur_worm] ? this.FWP._obj[_p.worms[_p.cur_worm].fid] : null;
    const _name: string = _w && _w.weapon_name && this.FWP.WEAPONS_DEF[_w.weapon_name] ? String(_w.weapon_name) : "";
    if (!_name) {
      param1.weapon_name.text = "Арсенал";
      param1.weapon_desc.htmlText = TT_SHEET_PICK;
      return;
    }
    const _pl: any = this.FWP.player;
    const _skills: any = this.FWP.get_affected_skills({
      "attack": _pl.attack.value,
      "protect": _pl.protect.value,
      "health": 100 + 50 * _pl.health.value,
      "worms": 2 + _pl.worms.value,
      "tired": _pl.tired,
      "stim_to_fight": _pl.stim_to_fight,
      "impl": _pl.cur_impl
    });
    const _bonus: any = this.FWP.get_peachful_bonus({
      "spec": _pl.spec,
      "wptype": this.FWP.WEAPONS_DEF[_name].wptype,
      "attack": _skills.attack,
      "perks": _pl.perks,
      "spec_mod": this.FWP.WEAPONS_DEF[_name].spec_mod,
      "wpclass": this.FWP.WEAPONS_DEF[_name].wpclass
    });
    param1.weapon_name.text = this.FWP.WEAPONS_DEF[_name].name;
    param1.weapon_desc.htmlText = this.return_weapon_desc(_name, this.shop_type, _w.weapon_range || 1, true, { "dmg_mult": 1 + _bonus.damage, "shots_add": this.FWP.get_bullet_amount(_name) }, true) + (this.weapons_text[_name] ? this.weapons_text[_name] : "");
  }

  click_game_invisible(param1: any): any {
    if (param1.type == "mouseDown") {
      this.FWP._proc.mouse_down = true;
      // PORT: the camera is held from this press on (proc.check_displace: click_coords), not from where an earlier
      // hold ended; the press ends with the button's release anywhere on the stage (release_game_invisible), not only
      // over the map: a finger lifted over the HUD or beyond the map left the camera held, and the next touch moved it
      // by the whole way from the old hold's point. The camera only (presentation).
      this.FWP._proc.click_coords = {};
      if (this.FWP.stage) {
        this.FWP.stage.addEventListener(MouseEvent.MOUSE_UP, this.release_game_invisible, false, 0, true);
      }
    }
    if (param1.type == "mouseUp") {
      this.FWP._proc.mouse_down = false;
    }
    if (param1.type == "doubleClick") {
      this.FWP._proc.double_clicked();
    }
  }

  /** PORT: the mouse button released anywhere on the stage ends the battle map's press (click_game_invisible). */
  release_game_invisible(param1: any): any {
    if (this.FWP.stage) {
      this.FWP.stage.removeEventListener(MouseEvent.MOUSE_UP, this.release_game_invisible, false);
    }
    if (this.FWP._proc) {
      this.FWP._proc.mouse_down = false;
    }
  }

  show_cursor(param1: any): any {
    param1 = as3.str(param1);
    if (param1 == "cursor") {
      this.CursorClip.visible = true;
      this.modify_cursor("");
      Mouse.hide();
    }
    if (param1 == "girder") {
      this.GirderClip.visible = true;
    }
  }

  modify_cursor(param1: any): any {
    param1 = as3.str(param1);
    switch (param1) {
      case "":
        this.CursorClip.gotoAndStop(1);
        break;
      case "from left":
        this.CursorClip.gotoAndStop(2);
        break;
      case "from right":
        this.CursorClip.gotoAndStop(3);
    }
  }

  add_distance_box(param1: number, param2: any): any {
    param1 = Number(param1);
    param2 = as3.str(param2);
    let _loc3_: any = undefined;
    let _loc4_: any = undefined;
    this.distance_boxes["box" + param1] = this.FWP.container_interf.get_object("clip_distance");
    this.distance_box_container.addChild(this.distance_boxes["box" + param1]);
    this.distance_boxes["box" + param1].visible = false;
    _loc3_ = 1;
    _loc4_ = 13421772;
    switch (param2) {
      case "P":
        _loc3_ = 1;
        _loc4_ = 13421772;
        break;
      case "M":
        _loc3_ = 1;
        _loc4_ = 13421772;
        break;
      case "C":
        _loc3_ = 2;
        _loc4_ = 16763904;
        break;
      case "W":
        _loc3_ = 3;
        _loc4_ = 16751103;
    }
    this.distance_boxes["box" + param1].distance_box.gotoAndStop(_loc3_);
    this.distance_boxes["box" + param1].distance.text = "";
    this.distance_boxes["box" + param1].distance.textColor = _loc4_;
  }

  modify_girder_cursor(param1: number): any {
    param1 = Number(param1);
    this.GirderClip.gotoAndStop(param1);
  }

  hide_cursor(param1: any): any {
    param1 = as3.str(param1);
    if (param1 == "cursor") {
      this.CursorClip.visible = false;
      Mouse.show();
    }
    if (param1 == "girder") {
      this.GirderClip.visible = false;
    }
  }

  x3String(param1: number): any {
    param1 = Number(param1);
    let _loc3_: any = undefined;
    let _loc2_: any = undefined;
    _loc2_ = String(param1);
    _loc3_ = "";
    if (_loc2_.length == 4) {
      return _loc2_.charAt(0) + " " + _loc2_.substr(1, 3);
    }
    if (_loc2_.length == 5) {
      return _loc2_.substr(0, 2) + " " + _loc2_.substr(2, 3);
    }
    if (_loc2_.length == 6) {
      return _loc2_.substr(0, 3) + " " + _loc2_.substr(3, 3);
    }
    if (_loc2_.length == 7) {
      return _loc2_.charAt(0) + " " + _loc2_.substr(1, 3) + " " + _loc2_.substr(4, 3);
    }
    if (_loc2_.length == 8) {
      return _loc2_.substr(0, 2) + " " + _loc2_.substr(2, 3) + " " + _loc2_.substr(5, 3);
    }
    if (_loc2_.length == 9) {
      return _loc2_.substr(0, 3) + " " + _loc2_.substr(3, 3) + " " + _loc2_.substr(6, 3);
    }
    return as3.str(_loc2_);
  }

  x3SHString(param1: number): any {
    param1 = Number(param1);
    if (param1 < 1000000) {
      return this.x3String(param1);
    }
    return this.x3String(Math.floor(param1 / 1000)) + " k";
  }

  xKString(param1: number): any {
    param1 = Number(param1);
    let _loc2_: any = undefined;
    if (param1 < 1000) {
      _loc2_ = String(param1);
    } else if (param1 < 10000) {
      _loc2_ = String(Math.floor(param1 / 100) / 10) + "k";
    } else if (param1 < 100000) {
      _loc2_ = String(Math.floor(param1 / 100) / 10) + "k";
    } else if (param1 < 1000000) {
      _loc2_ = String(Math.floor(param1 / 1000)) + "k";
    } else {
      _loc2_ = String(Math.floor(param1 / 100000) / 10) + "m";
    }
    return as3.str(_loc2_);
  }

  compare_rcolor(param1: number, param2: number): number {
    param1 = Number(param1);
    param2 = Number(param2);
    if (param1 < param2) {
      return 16731648;
    }
    if (param1 > param2) {
      return 10026752;
    }
    return 16763904;
  }

  interface_get_color(param1: number, param2: number): number {
    param1 = Number(param1);
    param2 = Number(param2);
    if (param2 == 1) {
      switch (param1) {
        case 1:
          return 4294947506;
        case 2:
          return 4291941119;
        case 3:
          return 4294967295;
        case 4:
          return 4294967295;
        case 5:
          return 4293263359;
        case 6:
          return 4294947583;
        case 7:
          return 4294967295;
        default:
          return 4294967295;
      }
    } else if (param2 == 0) {
      switch (param1) {
        case 1:
          return 4294934399;
        case 2:
          return 4288520191;
        case 3:
          return 4286644096;
        case 4:
          return 4294967168;
        case 5:
          return 4286644223;
        case 6:
          return 4294934783;
        case 7:
          return 4293914607;
        default:
          return 4294967295;
      }
    } else {
      switch (param1) {
        case 1:
          return 4294921292;
        case 2:
          return 4285361919;
        case 3:
          return 4283301708;
        case 4:
          return 4292466966;
        case 5:
          return 4281263589;
        case 6:
          return 4293215717;
        case 7:
          return 4289967027;
        default:
          return 4294967295;
      }
    }
  }

  game_get_color(param1: number): number {
    param1 = Number(param1);
    switch (param1) {
      case 1:
        return 16744319;
      case 2:
        return 10330111;
      case 3:
        return 8454016;
      case 4:
        return 16777088;
      case 5:
        return 8454143;
      case 6:
        return 16744703;
      case 7:
        return 15724527;
      default:
        return 16777215;
    }
  }

  get_minimap_coords(param1: any, param2: number, param3: boolean = false): any {
    param1 = as3.str(param1);
    param2 = Number(param2);
    param3 = Boolean(param3);
    let _loc4_: any = null;
    let _loc5_: any = null;
    let _loc6_: any = undefined;
    let _loc7_: any = null;
    let _loc8_: any = null;
    let _loc9_: any = undefined;
    _loc4_ = new BitmapData(314, 115, true, 0);
    _loc5_ = param1 + param2;
    if (param1 == "missions") {
      _loc5_ = "mission" + param2;
    }
    if (param3) {
      _loc5_ = "just" + param2;
    }
    _loc6_ = this.FWP.TEAMS_DEF[_loc5_].map;
    _loc7_ = /(\d+)/;
    _loc8_ = _loc6_.split(_loc7_);
    _loc9_ = this.minimaps[_loc8_[0]];
    _loc4_.copyPixels(_loc9_, new Rectangle(0, (Number(_loc8_[1]) - 1) * 115, 314, 115), new Point(0, 0), null, null, true);
    return _loc4_;
  }

  get_episode(param1: number): any {
    param1 = Number(param1);
    if (param1 <= 5) {
      return "Эпизод 1 : Вормвилль";
    }
    if (param1 <= 10) {
      return "Эпизод 2 : Заброшенная шахта";
    }
    if (param1 <= 16) {
      return "Эпизод 3 : Альпы";
    }
    if (param1 <= 21) {
      return "Эпизод 4 : Потерянный остров";
    }
    if (param1 <= 26) {
      return "Эпизод 5 : Верхний мир";
    }
    if (param1 <= 31) {
      return "Эпизод 6 : Отражение";
    }
    return "";
  }

  get_popup_height(param1: number): number {
    param1 = Number(param1);
    return 61 + (param1 - 1) * 14;
  }

  get_sell_price(param1: any, param2: number = 1, param3: boolean = false, param4: boolean = false): number {
    param1 = as3.str(param1);
    param2 = Number(param2);
    param3 = Boolean(param3);
    param4 = Boolean(param4);
    let _loc5_: any = undefined;
    let _loc6_: any = undefined;
    let _loc7_: any = undefined;
    if (this.shop_type == "weapons") {
      _loc5_ = this.FWP.WEAPONS_DEF;
    }
    if (this.shop_type == "help") {
      _loc5_ = this.FWP.STIM_DEF;
    }
    if (this.shop_type == "flags") {
      _loc5_ = this.FWP.FLAGS_DEF;
    }
    if (this.shop_type == "rip") {
      _loc5_ = this.FWP.RIPS_DEF;
    }
    if (this.shop_type == "impl") {
      _loc5_ = this.FWP.IMPL_DEF;
    }
    if (this.shop_type == "objs") {
      _loc5_ = this.FWP.OBJ_DEF;
    }
    _loc6_ = 0;
    if (this.FWP.player.perks["bar"]) {
      _loc6_ = this.FWP.get_perk_effect("bar", this.FWP.player.perks.bar, "");
    }
    if (param4) {
      _loc6_ -= 0.1;
    }
    if (this.shop_type == "impl") {
      return Number(_loc5_[param1].gold);
    }
    if (param1 == "kenton_bazooka" || param1 == "kenton_grenade" || param1 == "void_melody") {
      return Number(_loc5_[param1].gold);
    }
    _loc7_ = 1;
    if (this.shop_type == "weapons" && param2 > 1) {
      _loc7_ = this.FWP.get_range_upgrade(param2, "sell_price", 1);
    }
    if (param3) {
      return 50;
    }
    if (_loc5_[param1].gold == 0) {
      return 3000;
    }
    return Math.floor(_loc7_ * _loc5_[param1].gold * (0.3 + _loc6_));
  }

  get_ending(param1: any, param2: number): any {
    param1 = as3.str(param1);
    param2 = Number(param2);
    if (param1 == "level") {
      if (param2 == 1) {
        return "ень";
      }
      if (param2 < 5) {
        return "ня";
      }
      return "ней";
    }
    return "";
  }
}
